
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("9WUwc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $88be5913d6623123$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $bNe1g = parcelRequire("bNe1g");

var $kCywN = parcelRequire("kCywN");

var $iGRaI = parcelRequire("iGRaI");
const $88be5913d6623123$var$ProformaProjectFormsSettingsPage = ()=>{
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    if (!projectContextData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCywN.ProjectSettingsController), {
        projectKey: projectContextData.projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwce8.ThemeProvider), {
        theme: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iGRaI.default), {
        projectContext: projectContextData
    })));
};
var $88be5913d6623123$export$2e2bcd8739ae039 = $88be5913d6623123$var$ProformaProjectFormsSettingsPage;

});
parcelRegister("kCywN", function(module, exports) {

$parcel$export(module.exports, "ProjectSettingsController", () => $d103d2cdc5840880$export$9e38610dc1164d7d);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $bAQOb = parcelRequire("bAQOb");

var $dnJL9 = parcelRequire("dnJL9");

var $eI64M = parcelRequire("eI64M");

var $bhwgQ = parcelRequire("bhwgQ");

var $gd0Sp = parcelRequire("gd0Sp");

var $lB25E = parcelRequire("lB25E");

var $3hSJ4 = parcelRequire("3hSJ4");
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID = 'projectSettingsController';
const $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME = 'jiraSpaAppsSoftwareProjectSettingsController';
const $d103d2cdc5840880$export$2164d5fb3f070c32 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, children)));
const $d103d2cdc5840880$export$6d6f90026f9508a7 = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children, packageId: packageId = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID, packageName: packageName = $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME, teamName: teamName = 'morphinecake' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_ID,
        teamName: "morphinecake",
        packageName: $d103d2cdc5840880$var$ERROR_REPORTING_PACKAGE_NAME,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bhwgQ.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects, {
        projectKey: projectKey,
        isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: packageId,
        teamName: teamName,
        packageName: packageName,
        sendToPrivacyUnsafeSplunk: true
    }, children))));
const $d103d2cdc5840880$export$9e38610dc1164d7d = (0, $dnJL9.componentWithFG)('projectsettingscontroller_error_boundary', $d103d2cdc5840880$export$6d6f90026f9508a7, $d103d2cdc5840880$export$2164d5fb3f070c32);
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew = ({ projectKey: projectKey, isRouteAllowedForNonAdmins: isRouteAllowedForNonAdmins, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin || isRouteAllowedForNonAdmins && isRouteAllowedForNonAdmins()) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld = ({ projectKey: projectKey, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if (!projectKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: "/jira/projects"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3hSJ4.ProjectContextSubscriber), null, (projectContext)=>{
            if (projectContext.isProjectArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.RedirectToArchivedPage), null);
            if (tenantContext.isAdmin || projectContext.isProjectAdmin) return children;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
                to: `/projects/${projectContext.projectKey}`
            });
        });
    });
const $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjects = (0, $bAQOb.componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsNew, $d103d2cdc5840880$var$RedirectNonAdminsAndArchivedProjectsOld);

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("3hSJ4", function(module, exports) {

$parcel$export(module.exports, "ProjectContextSubscriber", () => $21ed2776f26316f6$export$b6f3f3997ca8a783);

var $ixwgj = parcelRequire("ixwgj");

var $lB25E = parcelRequire("lB25E");
const $21ed2776f26316f6$export$b6f3f3997ca8a783 = ({ children: children })=>{
    const { data: data } = (0, $lB25E.useResource)((0, $ixwgj.projectContextResourceWithCache));
    if (!data) return null;
    return children(data);
};

});


parcelRegister("iGRaI", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a425f6b2d8c463$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5By6c = parcelRequire("5By6c");

var $ifUq1 = parcelRequire("ifUq1");

var $7GKdq = parcelRequire("7GKdq");

var $jK1pm = parcelRequire("jK1pm");
const $61a425f6b2d8c463$var$ProformaProjectFormsSettingsWrapper = ({ projectContext: projectContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "proforma-project-forms-settings-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7GKdq.SharedSettingsDocumentTitle), {
        projectName: projectContext.projectName,
        section: "proformaForms",
        projectType: projectContext.projectType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ifUq1.default), {
        baseUrl: "",
        projectKey: projectContext.projectKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5By6c.default), null)));
var $61a425f6b2d8c463$export$2e2bcd8739ae039 = $61a425f6b2d8c463$var$ProformaProjectFormsSettingsWrapper;

});
parcelRegister("5By6c", function(module, exports) {

$parcel$export(module.exports, "default", () => $c073c32bbfe67e84$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $3QLcd = parcelRequire("3QLcd");

var $4ksts = parcelRequire("4ksts");

var $8WuJm = parcelRequire("8WuJm");

var $dWzSL = parcelRequire("dWzSL");

var $9mNxE = parcelRequire("9mNxE");

var $a8Ur2 = parcelRequire("a8Ur2");

var $bNe1g = parcelRequire("bNe1g");

var $be3PE = parcelRequire("be3PE");

var $iJHZm = parcelRequire("iJHZm");

var $dWLk9 = parcelRequire("dWLk9");

var $3e9vj = parcelRequire("3e9vj");

var $iJQ8v = parcelRequire("iJQ8v");

var $jvRd3 = parcelRequire("jvRd3");

var $9b9Za = parcelRequire("9b9Za");

var $iosa4 = parcelRequire("iosa4");
const $c073c32bbfe67e84$var$ProformaProjectFormsSettings = ()=>{
    const { locale: locale } = (0, $4ksts.useIntlV2)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const { projectId: projectId, projectKey: projectKey, projectType: projectType, isProjectAdmin: isProjectAdmin, simplified: simplified } = projectContext ?? {};
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $3e9vj.useEnvironment)();
    const onOpenInProductHelpArticle = (0, $eUqFw.useRef)((0, $3QLcd.useHelpPanelLink)());
    const [settings, setSettings] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        if (projectId && projectKey && projectType && simplified !== undefined) setSettings({
            analytics: {
                channel: (0, $dWzSL.ANALYTICS_CHANNEL)
            },
            flags: {},
            urls: (0, $dWzSL.getUrls)(environment, cloudId),
            environment: (0, $a8Ur2.toProformaEnvironment)(environment),
            context: {
                projectId: projectId,
                projectKey: projectKey,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                projectType: projectType,
                userIsProjectAdmin: isProjectAdmin,
                inProductHelpData: {
                    simplifiedProject: simplified,
                    onOpenInProductHelpArticle: (articleId)=>{
                        if (onOpenInProductHelpArticle.current) onOpenInProductHelpArticle.current(articleId);
                    }
                },
                intlLocale: locale
            }
        });
    }, [
        environment,
        cloudId,
        projectId,
        isProjectAdmin,
        projectType,
        simplified,
        onOpenInProductHelpArticle,
        locale,
        projectKey
    ]);
    return projectContext !== null && projectId && settings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "proformaJiraProjectForms",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            projectId: projectId,
            projectType: projectType,
            isSimplified: simplified
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvRd3.TemplateLibraryContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJQ8v.JiraProjectFormsApp), {
        settings: settings
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iosa4.FormSettingsTemplateLibrary), {
        projectId: projectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $be3PE.JsmPageInteractiveEvent), null), !(0, $9mNxE.isSyntheticTenant)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9b9Za.AsyncBenefitModal), null), (0, $eI5EY.fg)('jsm_simplified_project_settings_navigation') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageReady), null)) : null;
};
var $c073c32bbfe67e84$export$2e2bcd8739ae039 = $c073c32bbfe67e84$var$ProformaProjectFormsSettings;

});
parcelRegister("3QLcd", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $82adde900735644c$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "default", () => $82adde900735644c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $cEaY5 = parcelRequire("cEaY5");

var $zcJ0y = parcelRequire("zcJ0y");

var $1ybV0 = parcelRequire("1ybV0");

var $f2Poq = parcelRequire("f2Poq");

var $1zRTT = parcelRequire("1zRTT");

var $bUi2Q = parcelRequire("bUi2Q");
const $82adde900735644c$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $bUi2Q.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $1zRTT.useHelpPanelActions)();
    const isIphEnabled = (0, $1ybV0.ff)('iph.enabled') && !(0, $zcJ0y.isIE11)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $f2Poq.HELP_PANEL_ID), (0, $f2Poq.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: (0, $cEaY5.ARTICLE_TYPE)[type]
            }
        });
    };
    return isIphEnabled ? handleOnClick : undefined;
};
const $82adde900735644c$var$HelpPanelLink = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, fallbackComponent: fallbackComponent = null, onClick: onClick, ...props })=>{
    const onOpenInProductHelpArticle = $82adde900735644c$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle?.(articleId, (0, $cEaY5.ARTICLE_TYPE)[type]);
    };
    return onOpenInProductHelpArticle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1"
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fallbackComponent);
};
var $82adde900735644c$export$2e2bcd8739ae039 = $82adde900735644c$var$HelpPanelLink;
const $82adde900735644c$var$buttonWrapperStyles = null;

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("dWzSL", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $506138c8184003c6$export$85183a312807388d);
$parcel$export(module.exports, "getUrls", () => $506138c8184003c6$export$c69765bbdb1543ad);





const $506138c8184003c6$export$85183a312807388d = 'productAnalytics';
const $506138c8184003c6$export$c69765bbdb1543ad = (environment, cloudId)=>({
        api: `/gateway/api/proforma/cloudid/${cloudId}`,
        jira: '',
        templatesService: environment === 'prod' ? 'https://proforma-templates.services.atlassian.com' : 'https://proforma-templates.stg.services.atlassian.com',
        analyticsService: environment === 'prod' ? 'https://proforma-analytics.services.atlassian.com' : 'https://proforma-analytics.stg.services.atlassian.com'
    });

});

parcelRegister("9mNxE", function(module, exports) {

$parcel$export(module.exports, "isSyntheticTenant", () => $c000479b419b6556$export$f7ab30339d40bcd);

var $6rW04 = parcelRequire("6rW04");
const $c000479b419b6556$export$f7ab30339d40bcd = ()=>(0, $6rW04.default)('ajs-is-synthetic') === 'true';

});

parcelRegister("a8Ur2", function(module, exports) {

$parcel$export(module.exports, "toProformaEnvironment", () => $cc59932036a181d8$export$81a9ecf6b01a04d4);

var $f9abZ = parcelRequire("f9abZ");
const $cc59932036a181d8$export$81a9ecf6b01a04d4 = (environment)=>{
    switch(environment){
        case 'dev':
            return (0, $f9abZ.Environment).DEVELOPMENT;
        case 'staging':
            return (0, $f9abZ.Environment).STAGING;
        case 'prod':
            return (0, $f9abZ.Environment).PRODUCTION;
        case 'local':
        default:
            return (0, $f9abZ.Environment).LOCAL;
    }
};

});
parcelRegister("f9abZ", function(module, exports) {

$parcel$export(module.exports, "Environment", () => $b06f9a4868552860$export$7dc6752a22ab011a);
let $b06f9a4868552860$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["PRODUCTION"] = "prod";
    Environment["STAGING"] = "staging";
    Environment["DEVELOPMENT"] = "dev";
    Environment["LOCAL"] = "local";
    return Environment;
}({});

});


parcelRegister("be3PE", function(module, exports) {

$parcel$export(module.exports, "JsmPageInteractiveEvent", () => $695cc37a0df2f37c$export$c4ba40c380ee9a11);

var $eUqFw = parcelRequire("eUqFw");

var $7vf5z = parcelRequire("7vf5z");
const $695cc37a0df2f37c$export$c4ba40c380ee9a11 = (args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), args);
$695cc37a0df2f37c$export$c4ba40c380ee9a11.defaultProps = {
    isExpectedToHaveSsr: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    withMarks: [],
    extra: {}
};
$695cc37a0df2f37c$export$c4ba40c380ee9a11.displayName = 'JsmPageInteractiveEvent';

});
parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});



parcelRegister("iJQ8v", function(module, exports) {

$parcel$export(module.exports, "JiraProjectFormsApp", () => $da44df1fb0557892$export$922aa0b8de5897ae);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $f86rB = parcelRequire("f86rB");

var $dxopF = parcelRequire("dxopF");

var $a1ivA = parcelRequire("a1ivA");
var $2UZ8t = parcelRequire("2UZ8t");

var $am2F3 = parcelRequire("am2F3");

var $lSi60 = parcelRequire("lSi60");
var $hRZeM = parcelRequire("hRZeM");
var $g6ewf = parcelRequire("g6ewf");

var $kpjvc = parcelRequire("kpjvc");

var $ilpVd = parcelRequire("ilpVd");

var $5RM2s = parcelRequire("5RM2s");

var $bu1Yj = parcelRequire("bu1Yj");

var $tJCsl = parcelRequire("tJCsl");
var $9SGXg = parcelRequire("9SGXg");

var $8x5lY = parcelRequire("8x5lY");
var $i7vgA = parcelRequire("i7vgA");

var $5zR2s = parcelRequire("5zR2s");
var $aXZh9 = parcelRequire("aXZh9");

var $9Td3m = parcelRequire("9Td3m");
var $f1O3r = parcelRequire("f1O3r");

var $bJ6Ty = parcelRequire("bJ6Ty");
var $kCDeN = parcelRequire("kCDeN");

var $1M84e = parcelRequire("1M84e");
const $da44df1fb0557892$var$JiraProjectFormsBaseApp = ({ settings: settings })=>{
    var _settings$context$use;
    const { showFlag: showFlag } = (0, $f86rB.useFlags)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [moduleContext, setModuleContext] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const utils = (0, $kpjvc.createUtils)(settings, 'ProjectForms', showFlag, createAnalyticsEvent, settings.context.intlLocale);
        setModuleContext({
            apis: {
                issueFormsApi: new (0, $9SGXg.LiveIssueFormsApi)(settings.context.projectId, utils.apiUtil),
                projectFormApi: new (0, $5zR2s.LiveProjectFormApi)(settings.context.projectId, utils.apiUtil),
                templateFormApi: new (0, $bJ6Ty.LiveTemplateFormApi)(utils.apiUtil),
                projectApi: new (0, $8x5lY.LiveProjectApi)(utils.apiUtil),
                requestTypeApi: new (0, $9Td3m.LiveRequestTypeApi)(settings.context.projectId, utils.apiUtil)
            },
            utils: {
                errorUtils: utils.errorUtils
            }
        });
    }, [
        createAnalyticsEvent,
        settings,
        showFlag
    ]);
    if (!moduleContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $am2F3.ErrorBoundary), {
        errorUtils: moduleContext.utils.errorUtils
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hRZeM.PfFlagsProvider), {
        flags: settings.flags
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g6ewf.UtilsProvider), {
        utils: moduleContext.utils
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i7vgA.ProjectApiProvider), {
        projectApi: moduleContext.apis.projectApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aXZh9.ProjectFormApiProvider), {
        projectFormApi: moduleContext.apis.projectFormApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCDeN.TemplateFormApiProvider), {
        templateFormApi: moduleContext.apis.templateFormApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f1O3r.RequestTypeApiProvider), {
        requestTypeApi: moduleContext.apis.requestTypeApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSi60.InProductHelpProvider), {
        inProductHelpData: settings.context.inProductHelpData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $tJCsl.IssueFormsApiProvider), {
        issueFormsApi: moduleContext.apis.issueFormsApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bu1Yj.ProjectFormsContainer), {
        errorUtils: moduleContext.utils.errorUtils,
        projectFormApi: moduleContext.apis.projectFormApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1M84e.ProjectForms), {
        projectId: settings.context.projectId,
        projectKey: settings.context.projectKey,
        projectType: settings.context.projectType,
        simplifiedProject: settings.context.inProductHelpData.simplifiedProject,
        userIsProjectAdmin: (_settings$context$use = settings.context.userIsProjectAdmin) !== null && _settings$context$use !== void 0 ? _settings$context$use : false
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2UZ8t.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "pf-dialog-container"
    }))))))));
};
const $da44df1fb0557892$export$922aa0b8de5897ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ilpVd.AnalyticsProvider), props.settings.analytics, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1ivA.ContextWrapper), {
        sourceName: "proformaJiraProjectForms",
        sourceType: (0, $e779cc169fd2a347$export$f636b5b56f1d624a),
        attributes: $da44df1fb0557892$var$getAnalyticsAttributes(props.settings.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RM2s.PackageIntlProvider), {
        locale: props.settings.context.intlLocale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f86rB.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($da44df1fb0557892$var$JiraProjectFormsBaseApp, props)))));
/* eslint-enable react/destructuring-assignment */ const $da44df1fb0557892$var$getAnalyticsAttributes = (settings)=>{
    const { projectId: projectId, projectType: projectType } = settings;
    return {
        projectId: projectId,
        projectType: projectType
    };
};

});
parcelRegister("a1ivA", function(module, exports) {

$parcel$export(module.exports, "ContextWrapper", () => $0fc3fc62a7811fbb$export$34282a1f95511a11);

var $eUqFw = parcelRequire("eUqFw");

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");

var $aw5Sy = parcelRequire("aw5Sy");
const $0fc3fc62a7811fbb$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};
const $0fc3fc62a7811fbb$export$34282a1f95511a11 = (props)=>{
    const data = $0fc3fc62a7811fbb$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children));
};

});

parcelRegister("2UZ8t", function(module, exports) {

$parcel$export(module.exports, "FireUIAnalytics", () => $8c82c5c0e8ce27fb$export$1f3555c9be6c5e08);
$parcel$export(module.exports, "FireTrackAnalytics", () => $8c82c5c0e8ce27fb$export$5f0d7aae8dfa8b86);
$parcel$export(module.exports, "FireOperationalAnalytics", () => $8c82c5c0e8ce27fb$export$b71c3ada5d4ec5da);
$parcel$export(module.exports, "FireScreenAnalytics", () => $8c82c5c0e8ce27fb$export$2ccf161b817b43b);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");


var $gWxA1 = parcelRequire("gWxA1");
const $8c82c5c0e8ce27fb$var$getFixedActionAndActionSubject = (props)=>{
    const { eventName: eventName, action: action, actionSubject: actionSubject } = props;
    if (eventName && (action || actionSubject)) throw new Error('eventName is an alias for action & actionSubject, provide only one of those');
    const eventNameSplit = eventName ? eventName.split(' ') : [];
    const fixedAction = action || eventNameSplit[1];
    const fixedActionSubject = actionSubject || eventNameSplit[0];
    if (!fixedAction || !fixedActionSubject) throw new Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
    return {
        action: fixedAction,
        actionSubject: fixedActionSubject
    };
};
const $8c82c5c0e8ce27fb$var$getFixedActionSubjectId = (props)=>{
    const { componentName: componentName, actionSubjectId: actionSubjectId } = props;
    if (componentName && actionSubjectId) throw new Error('componentName is an alias for actionSubjectId, provide only one of those');
    const fixedActionSubjectId = actionSubjectId || componentName;
    return {
        actionSubjectId: fixedActionSubjectId
    };
};
class $8c82c5c0e8ce27fb$var$FireComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { type: type, attributes: attributes } = this.props;
        if (!this.props.createAnalyticsEvent) throw new Error('Invalid use of component; must be wrapped by withAnalyticsEvents HOC');
        const { action: action, actionSubject: actionSubject } = $8c82c5c0e8ce27fb$var$getFixedActionAndActionSubject(this.props);
        const { actionSubjectId: actionSubjectId } = $8c82c5c0e8ce27fb$var$getFixedActionSubjectId(this.props);
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: action
        });
        (0, $gWxA1.fireAnalytics)(analyticsEvent, type, {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
    }
    render() {
        return null;
    }
}
const $8c82c5c0e8ce27fb$var$WithAnalytics = (0, $2jDha.default)()($8c82c5c0e8ce27fb$var$FireComponent);
const $8c82c5c0e8ce27fb$export$1f3555c9be6c5e08 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$a1562d08625f5d7e)
    });
const $8c82c5c0e8ce27fb$export$5f0d7aae8dfa8b86 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$947dac6c72b26f81)
    });
const $8c82c5c0e8ce27fb$export$b71c3ada5d4ec5da = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$12346a674644c156)
    });
const $8c82c5c0e8ce27fb$export$2ccf161b817b43b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8c82c5c0e8ce27fb$var$WithAnalytics, {
        ...props,
        type: (0, $e779cc169fd2a347$export$f1d537d508d2945a),
        eventName: "screen viewed"
    });

});
const $e779cc169fd2a347$export$f636b5b56f1d624a = 'Screen';
const $e779cc169fd2a347$export$9d2de6eebf7462b5 = 'Drawer';
const $e779cc169fd2a347$export$1171103ea9083ffa = 'Modal';
const $e779cc169fd2a347$export$cae2783c9279926 = 'InlineDialog';
const $e779cc169fd2a347$export$d1123261ca8831d2 = 'Dropdown';
const $e779cc169fd2a347$export$a1562d08625f5d7e = 'UI';
const $e779cc169fd2a347$export$947dac6c72b26f81 = 'TRACK';
const $e779cc169fd2a347$export$f1d537d508d2945a = 'SCREEN';
const $e779cc169fd2a347$export$12346a674644c156 = 'OPERATIONAL';
const $e779cc169fd2a347$export$2ceccf177fae277c = 'analyticsBridge';

parcelRegister("gWxA1", function(module, exports) {

$parcel$export(module.exports, "fireAnalytics", () => $b7eea2a826f748b2$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $b7eea2a826f748b2$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $b7eea2a826f748b2$export$13990ad4625571ed);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $b7eea2a826f748b2$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireScreenAnalytics", () => $b7eea2a826f748b2$export$6f46fb37ad7d962b);

var $iTvqy = parcelRequire("iTvqy");


var $bJASI = parcelRequire("bJASI");
const $b7eea2a826f748b2$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $e779cc169fd2a347$export$2ceccf177fae277c));
};
const $b7eea2a826f748b2$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $b7eea2a826f748b2$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $b7eea2a826f748b2$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b7eea2a826f748b2$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$947dac6c72b26f81), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b7eea2a826f748b2$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$12346a674644c156), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $b7eea2a826f748b2$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $bJASI.getImperativeAnalyticsDataFromArguments)(rest);
    $b7eea2a826f748b2$export$34ac71ce24cddec2(event, (0, $e779cc169fd2a347$export$f1d537d508d2945a), {
        attributes: attributes
    });
};

});
parcelRegister("bJASI", function(module, exports) {

$parcel$export(module.exports, "getImperativeAnalyticsDataFromArguments", () => $c312bbf32bff530f$export$e6baab532ef8c6bf);
const $c312bbf32bff530f$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $c312bbf32bff530f$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $c312bbf32bff530f$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $c312bbf32bff530f$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $c312bbf32bff530f$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $c312bbf32bff530f$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $c312bbf32bff530f$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $c312bbf32bff530f$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $c312bbf32bff530f$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};

});



parcelRegister("am2F3", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $01f2085a70013fc4$export$e926676385687eaf);
/* eslint-disable react/destructuring-assignment */ 
var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $lRvnl = parcelRequire("lRvnl");

var $7xF7k = parcelRequire("7xF7k");
class $01f2085a70013fc4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false,
            errorInfo: null,
            error: null
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo.componentStack
        });
        this.props.errorUtils.reportError(error, {
            actionSubject: (0, $7xF7k.ActionSubject).PROFORMA_UI,
            id: 'errorBoundary',
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.hasError) {
            // Render error UI here
            const { renderError: renderError } = this.props;
            return renderError ? renderError({
                error: this.state.error
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01f2085a70013fc4$var$ErrorPage, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01f2085a70013fc4$var$ErrorPageSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
                appearance: "error",
                title: "Something went wrong"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "Refresh the page and try again. ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), "If the error persists,", ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://support.thinktilt.com",
                target: "_blank",
                rel: "noopener noreferrer"
            }, "contact support"), "."))));
        }
        return this.props.children;
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $01f2085a70013fc4$var$ErrorPage = (0, $exJuA.default).div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const $01f2085a70013fc4$var$ErrorPageSection = (0, $exJuA.default).div({});

});
parcelRegister("exJuA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9676f90260fc6cf$export$2e2bcd8739ae039);
parcelRequire("kU09D");
parcelRequire("eUqFw");
parcelRequire("kXwvz");

var $joBf7 = parcelRequire("joBf7");

parcelRequire("lDjMI");
parcelRequire("b9Xoy");
parcelRequire("T3JCe");
var $a9676f90260fc6cf$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $a9676f90260fc6cf$var$newStyled = (0, $joBf7.default).bind();
$a9676f90260fc6cf$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $a9676f90260fc6cf$var$newStyled[tagName] = $a9676f90260fc6cf$var$newStyled(tagName);
});
var $a9676f90260fc6cf$export$2e2bcd8739ae039 = $a9676f90260fc6cf$var$newStyled;

});

parcelRegister("7xF7k", function(module, exports) {

$parcel$export(module.exports, "ActionSubject", () => $57db827cbea9e8d0$export$7f97440769de1377);
$parcel$export(module.exports, "Action", () => $57db827cbea9e8d0$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "FormUpdateType", () => $57db827cbea9e8d0$export$d7867a52899740a0);
/* Read https://hello.atlassian.net/wiki/spaces/DQ/pages/786078865 on how to instrument well. */ // These are entities in ProForma. Reuse as much as possible.
// Think carefully when making a new ActionSubject about whether you can reuse an existing one.
let $57db827cbea9e8d0$export$7f97440769de1377 = /*#__PURE__*/ function(ActionSubject) {
    ActionSubject["FORM"] = "form";
    ActionSubject["FORM_SETTINGS_LANGUAGE"] = "formSettingsLanguage";
    ActionSubject["FORM_SETTINGS_SUBMIT"] = "formSettingsSubmit";
    ActionSubject["FORM_SETTINGS_ISSUE_CREATE"] = "formSettingsIssueCreate";
    ActionSubject["FORM_SETTINGS_ISSUE_FORMS_TYPES"] = "formSettingsIssueFormsTypes";
    ActionSubject["FORM_SETTINGS_RECOMMENDED_FORMS_TYPES"] = "formSettingsRecommendedFormsTypes";
    ActionSubject["FORM_SETTINGS_REQUEST_CREATE_TYPES"] = "formSettingsRequestCreateTypes";
    ActionSubject["QUESTION_ANSWER"] = "questionAnswer";
    ActionSubject["TEMPLATE_FORM"] = "templateForm";
    ActionSubject["EXAMPLE_TEMPLATE"] = "exampleTemplate";
    ActionSubject["BUTTON"] = "button";
    ActionSubject["DROPDOWN_ITEM"] = "dropdownItem";
    ActionSubject["SELECT_ITEM"] = "selectItem";
    ActionSubject["FILTER"] = "filter";
    ActionSubject["LIST"] = "list";
    ActionSubject["PANEL"] = "panel";
    ActionSubject["SECTION"] = "section";
    ActionSubject["TABLE"] = "table";
    ActionSubject["MODAL"] = "modal";
    ActionSubject["PROFORMA_API"] = "proformaAPI";
    ActionSubject["PROFORMA_UI"] = "proformaUI";
    ActionSubject["SECTION_MESSAGE"] = "sectionMessage";
    ActionSubject["ATTACHMENT"] = "proformaAttachment";
    ActionSubject["ATTACHMENT_UPLOAD"] = "proformaAttachmentUpload";
    ActionSubject["ATTACHMENT_VIEWER"] = "proformaAttachmentViewer";
    ActionSubject["ATTACHMENT_VIEWER_CARD"] = "proformaAttachmentViewerCard";
    ActionSubject["REQUEST_TYPE"] = "requestType";
    ActionSubject["DUPLICATE_REQUEST_TYPE_LINKED_FIELDS_WARNING_MODAL"] = "duplicateRequestTypeLinkedFieldsWarningModal";
    ActionSubject["TRANSLATIONS_EDITOR"] = "translationsEditor";
    ActionSubject["ADF_NODE_INSERT"] = "adfNodeInsert";
    ActionSubject["FORM_VALIDATION"] = "formValidation";
    ActionSubject["FORM_EDIT"] = "formEdit";
    ActionSubject["FORM_SAVE"] = "formSave";
    ActionSubject["SEARCH_ASYNC_CHOICES"] = "searchAsyncChoices";
    ActionSubject["FETCH_FORM_ATTACHMENTS"] = "fetchFormAttachments";
    ActionSubject["UPLOAD_ISSUE_FORM_ATTACHMENTS"] = "uploadFormAttachments";
    ActionSubject["TRANSLATIONS_LANGUAGES_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_LOAD"] = "translationsLoad";
    ActionSubject["TRANSLATIONS_SAVE"] = "translationsSave";
    ActionSubject["TRANSLATIONS_DELETE"] = "translationsDelete";
    return ActionSubject;
}({});
let $57db827cbea9e8d0$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["ADDED"] = "added";
    Action["CLICKED"] = "clicked";
    Action["CREATED"] = "created";
    Action["DELETED"] = "deleted";
    Action["DOWNLOADED"] = "downloaded";
    Action["EXPORTED"] = "exported";
    Action["UPDATED"] = "updated";
    Action["VIEWED"] = "viewed";
    Action["SELECTED"] = "selected";
    Action["FAILED"] = "failed";
    Action["FINISHED"] = "finished";
    Action["STARTED"] = "started";
    Action["STOPPED"] = "stopped";
    return Action;
}({});
let $57db827cbea9e8d0$export$d7867a52899740a0 = /*#__PURE__*/ function(FormUpdateType) {
    FormUpdateType["REOPEN"] = "REOPEN";
    FormUpdateType["SAVE"] = "SAVE";
    FormUpdateType["SET_EXTERNAL"] = "SET_EXTERNAL";
    FormUpdateType["SET_INTERNAL"] = "SET_INTERNAL";
    FormUpdateType["SUBMIT"] = "SUBMIT";
    FormUpdateType["CLOSE"] = "CLOSE";
    return FormUpdateType;
}({}); // Similar to SUBMIT, used in "Close customer edits" option in form card meatball menu

});


parcelRegister("lSi60", function(module, exports) {

$parcel$export(module.exports, "InProductHelpProvider", () => $feccad91d2585694$export$a61d77bd8effd79e);
$parcel$export(module.exports, "useInProductHelp", () => $feccad91d2585694$export$804f42d1448e5b9);

var $eUqFw = parcelRequire("eUqFw");

var $jie0I = parcelRequire("jie0I");
const $feccad91d2585694$var$InProductHelpContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $feccad91d2585694$export$a61d77bd8effd79e = ({ inProductHelpData: inProductHelpData, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($feccad91d2585694$var$InProductHelpContext.Provider, {
        value: inProductHelpData
    }, children);
};
function $feccad91d2585694$export$804f42d1448e5b9() {
    const inProductHelpData = (0, $eUqFw.useContext)($feccad91d2585694$var$InProductHelpContext);
    if (inProductHelpData === undefined) throw new Error(`useInProductHelp() must be used within an InProductHelpProvider. ${(0, $jie0I.errorMessageDuplicateCommonCore)}`);
    return inProductHelpData;
}

});
parcelRegister("jie0I", function(module, exports) {

$parcel$export(module.exports, "errorMessageDuplicateCommonCore", () => $e0ba90f305245422$export$202e68bc03a230f);
const $e0ba90f305245422$export$202e68bc03a230f = "Please check that the yarn.lock file contains only 1 version of proforma-common-core. You should bump all Proforma packages to their latest version";

});


parcelRegister("hRZeM", function(module, exports) {

$parcel$export(module.exports, "PfFlagsProvider", () => $d026e35be18443e8$export$33dbaef47fd9c29b);

var $eUqFw = parcelRequire("eUqFw");

var $jie0I = parcelRequire("jie0I");
const $d026e35be18443e8$var$PfFlagsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $d026e35be18443e8$export$33dbaef47fd9c29b = ({ flags: flags, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d026e35be18443e8$var$PfFlagsContext.Provider, {
        value: flags
    }, children);
};
function $d026e35be18443e8$export$a37d68d19485eb11() {
    const flags = (0, $eUqFw.useContext)($d026e35be18443e8$var$PfFlagsContext);
    if (flags === undefined) throw new Error(`usePfFlags must be used within a PfFlagsProvider. ${(0, $jie0I.errorMessageDuplicateCommonCore)}`);
    return flags;
}

});

parcelRegister("g6ewf", function(module, exports) {

$parcel$export(module.exports, "UtilsProvider", () => $bb88781554f33d1b$export$df5be093c1f55d13);

var $eUqFw = parcelRequire("eUqFw");

var $fmOEh = parcelRequire("fmOEh");
const $bb88781554f33d1b$export$df5be093c1f55d13 = ({ utils: utils, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmOEh.PfErrorUtilsProvider), {
        errorUtils: utils.errorUtils
    }, children);
};

});
parcelRegister("fmOEh", function(module, exports) {

$parcel$export(module.exports, "PfErrorUtilsProvider", () => $b30032de05ab062f$export$b71d28c58577f663);
$parcel$export(module.exports, "usePfErrorUtils", () => $b30032de05ab062f$export$19d62bf1891c25ff);

var $eUqFw = parcelRequire("eUqFw");

var $jie0I = parcelRequire("jie0I");
const $b30032de05ab062f$var$PfErrorUtilsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $b30032de05ab062f$export$b71d28c58577f663 = ({ errorUtils: errorUtils, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b30032de05ab062f$var$PfErrorUtilsContext.Provider, {
        value: errorUtils
    }, children);
};
function $b30032de05ab062f$export$19d62bf1891c25ff() {
    const errorUtils = (0, $eUqFw.useContext)($b30032de05ab062f$var$PfErrorUtilsContext);
    if (errorUtils === undefined) throw new Error(`usePfErrorUtils() must be used within a PfErrorUtilsProvider. ${(0, $jie0I.errorMessageDuplicateCommonCore)}`);
    return errorUtils;
}

});


parcelRegister("kpjvc", function(module, exports) {

$parcel$export(module.exports, "createErrorUtils", () => $edb545311cb2dbb1$export$7a2f0d878b08650d);
$parcel$export(module.exports, "createUtils", () => $edb545311cb2dbb1$export$b6881d4b4863cacc);
$parcel$export(module.exports, "createUtils2", () => $edb545311cb2dbb1$export$e4e37e88de17afb6);

var $eknFc = parcelRequire("eknFc");

var $eM64G = parcelRequire("eM64G");

var $3wply = parcelRequire("3wply");
function $edb545311cb2dbb1$export$7a2f0d878b08650d(errorUtilsModuleName, environment, createAnalyticsEvent, showFlag = ()=>()=>{}) {
    return new (0, $3wply.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
}
function $edb545311cb2dbb1$export$b6881d4b4863cacc(settings, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $3wply.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, settings.environment);
    (0, $eM64G.setNoticeLocale)(locale);
    const apiUtil = new (0, $eknFc.ApiUtil)(settings.urls.jira, settings.urls.api, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}
function $edb545311cb2dbb1$export$e4e37e88de17afb6(jiraUrl, apiUrl, environment, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
    const errorUtils = new (0, $3wply.LiveErrorUtils)(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
    (0, $eM64G.setNoticeLocale)(locale);
    const apiUtil = new (0, $eknFc.ApiUtil)(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);
    return {
        apiUtil: apiUtil,
        errorUtils: errorUtils
    };
}

});
parcelRegister("eknFc", function(module, exports) {

$parcel$export(module.exports, "AcceptedResponseType", () => $a6e54a04d43a73c5$export$9126c50ecfe2a46d);
$parcel$export(module.exports, "ApiUtil", () => $a6e54a04d43a73c5$export$baa861b25a2283a4);

var $b8H1q = parcelRequire("b8H1q");

var $7xF7k = parcelRequire("7xF7k");

var $hDku9 = parcelRequire("hDku9");

var $6O9iv = parcelRequire("6O9iv");
let $a6e54a04d43a73c5$export$9126c50ecfe2a46d = /*#__PURE__*/ function(AcceptedResponseType) {
    AcceptedResponseType["Json"] = "json";
    AcceptedResponseType["Blob"] = "blob";
    return AcceptedResponseType;
}({});
class $a6e54a04d43a73c5$export$baa861b25a2283a4 {
    constructor(jiraUrl, proformaUrl, errorUtils, createAnalyticsEvent){
        this.errorUtils = void 0;
        this.jiraUrl = void 0;
        this.proformaUrl = void 0;
        this.createAnalyticsEvent = void 0;
        this.jiraUrl = jiraUrl;
        this.proformaUrl = proformaUrl;
        this.errorUtils = errorUtils;
        this.createAnalyticsEvent = createAnalyticsEvent;
    }
    get(path, requestName, responseType = $a6e54a04d43a73c5$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'GET', path, responseType, requestName);
    }
    jiraGet(path, requestName, responseType = $a6e54a04d43a73c5$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'GET', path, responseType, requestName);
    }
    put(path, body, requestName, responseType = $a6e54a04d43a73c5$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'PUT', path, responseType, requestName, body);
    }
    jiraPut(path, body, requestName, responseType = $a6e54a04d43a73c5$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'PUT', path, responseType, requestName, body);
    }
    post(path, body, requestName, responseType = $a6e54a04d43a73c5$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(true, 'POST', path, responseType, requestName, body);
    }
    jiraPost(path, body, requestName, responseType = $a6e54a04d43a73c5$export$9126c50ecfe2a46d.Json) {
        return this.fetchApi(false, 'POST', path, responseType, requestName, body);
    }
    delete(path, body, requestName, responseType = 'none') {
        return this.fetchApi(true, 'DELETE', path, responseType, requestName, body);
    }
    /** Converts the `relativePath` into an absolute ProForma API URI. */ createApiUrl(relativePath) {
        return this.proformaUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    /** Converts the `relativePath` into an absolute Jira URI. */ createJiraUrl(relativePath) {
        return this.jiraUrl + (relativePath.charAt(0) === '/' ? '' : '/') + relativePath;
    }
    getAnalyticsSource() {
        try {
            var _analyticsData$payloa, _analyticsData$payloa2;
            const analyticsEvent = this.createAnalyticsEvent({});
            const analyticsData = (0, $b8H1q.extractAWCDataFromEvent)(analyticsEvent);
            return (_analyticsData$payloa = analyticsData === null || analyticsData === void 0 ? void 0 : (_analyticsData$payloa2 = analyticsData.payload) === null || _analyticsData$payloa2 === void 0 ? void 0 : _analyticsData$payloa2.source) !== null && _analyticsData$payloa !== void 0 ? _analyticsData$payloa : 'unknown';
        } catch (e) {
            return 'unknown';
        }
    }
    fetchApi(proForma, method, path, responseType, requestName, body) {
        const analyticsSource = this.getAnalyticsSource();
        return fetch(proForma ? this.createApiUrl(path) : this.createJiraUrl(path), {
            method: method,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Experimental-Experience': analyticsSource,
                ...responseType === $a6e54a04d43a73c5$export$9126c50ecfe2a46d.Json ? {
                    Accept: 'application/json'
                } : {}
            },
            ...body && {
                body: JSON.stringify(body)
            }
        }).catch((error)=>{
            const message = `No response from API: ${error.message || ''}`;
            const apiError = $a6e54a04d43a73c5$var$toApiError(0, {
                error: message
            }, true, requestName);
            this.errorUtils.reportError(error, {
                actionSubject: (0, $7xF7k.ActionSubject).PROFORMA_API,
                id: 'fetchApi',
                attributes: {
                    path: path,
                    method: method,
                    responseType: responseType,
                    requestName: requestName,
                    apiError: JSON.stringify(apiError),
                    isClientFetchError: true
                }
            });
            return Promise.reject(apiError);
        }).then((response)=>{
            let errorObj = new Error(response.statusText);
            if (!response.ok) {
                var _ref, _response$headers$get;
                const traceId = (_ref = (_response$headers$get = response.headers.get('x-trace-id')) !== null && _response$headers$get !== void 0 ? _response$headers$get : response.headers.get('atl-traceid')) !== null && _ref !== void 0 ? _ref : undefined;
                let apiErrorPromise;
                try {
                    // Try to parse response error details
                    const responseJsonApiError = responseType !== 'json' ? undefined : response.json().then((responseJson)=>$a6e54a04d43a73c5$var$toApiError(response.status, responseJson, false, requestName, traceId)).catch((error)=>{
                        const message = `Failed to parse error response as JSON from API: ${error.message || ''}`;
                        errorObj = error;
                        return $a6e54a04d43a73c5$var$toApiError(response.status, {
                            error: message
                        }, false, requestName, traceId);
                    });
                    if (response.status === 401) this.errorUtils.notifyUser((0, $hDku9.NoticeType).ErrorApiUnauthorised);
                    if (response.status === 403) this.errorUtils.notifyUser((0, $hDku9.NoticeType).ErrorApiMissingPermissions);
                    if (responseJsonApiError !== undefined) apiErrorPromise = responseJsonApiError.then((apiError)=>Promise.reject(apiError));
                    else // Create error object with error response body
                    apiErrorPromise = Promise.reject($a6e54a04d43a73c5$var$toApiError(response.status, {
                        error: response.body || ''
                    }, false, requestName, traceId));
                } catch (error) {
                    const message = `Unexpected response from API: ${response.body || ''}`;
                    errorObj = error;
                    apiErrorPromise = Promise.reject($a6e54a04d43a73c5$var$toApiError(response.status, {
                        error: message
                    }, false, requestName, traceId));
                }
                apiErrorPromise.catch((apiError)=>{
                    this.errorUtils.reportError(errorObj, {
                        actionSubject: (0, $7xF7k.ActionSubject).PROFORMA_API,
                        id: 'fetchApi',
                        attributes: {
                            status: response.status,
                            statusGroup: `${Math.floor(response.status / 100)}xx`,
                            traceId: traceId,
                            path: path,
                            method: method,
                            responseType: responseType,
                            requestName: requestName,
                            apiError: JSON.stringify(apiError),
                            isClientFetchError: false
                        }
                    });
                });
                return apiErrorPromise;
            }
            if (response.status === 204) return '';
            switch(responseType){
                case 'json':
                    return response.json();
                case 'blob':
                    return response.blob();
                case 'text':
                    return response.text();
                case 'none':
                    return '';
                default:
                    return response;
            }
        });
    }
}
function $a6e54a04d43a73c5$var$toApiError(status, responseJson, isClientFetchError, requestName, traceId) {
    if (Object.keys(responseJson).length === 0) return (0, $6O9iv.constructApiError)(`Unexpected API reply (HTTP/${status})`, status, responseJson, requestName);
    const error = responseJson['error'] || `Unexpected API reply (HTTP/${status})`;
    const context = responseJson['context'];
    const contextId = responseJson['contextId'];
    const details = responseJson['details'];
    return (0, $6O9iv.constructApiError)(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId);
}

});
parcelRegister("b8H1q", function(module, exports) {

$parcel$export(module.exports, "extractAWCDataFromEvent", () => $e05a2371d0a41288$export$1c850cf68c053906);

var $kkgbD = parcelRequire("kkgbD");

var $i7Fym = parcelRequire("i7Fym");


var $dI4J1 = parcelRequire("dI4J1");
const $e05a2371d0a41288$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $dI4J1.getAnalyticsType)(castedEvent);
    const attributes = (0, $dI4J1.getAttributes)(castedEvent);
    const source = (0, $dI4J1.getSource)(castedEvent);
    const actionSubject = (0, $dI4J1.getActionSubject)(castedEvent);
    if (analyticsType === (0, $e779cc169fd2a347$export$f1d537d508d2945a)) return {
        type: (0, $e779cc169fd2a347$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $e779cc169fd2a347$export$a1562d08625f5d7e:
        case 0, $e779cc169fd2a347$export$947dac6c72b26f81:
        case 0, $e779cc169fd2a347$export$12346a674644c156:
            {
                const action = (0, $dI4J1.getAction)(castedEvent);
                const actionSubjectId = (0, $dI4J1.getActionSubjectId)(castedEvent);
                const containerId = (0, $dI4J1.getContainerId)(castedEvent);
                const containerType = (0, $dI4J1.getContainerType)(castedEvent);
                const objectId = (0, $dI4J1.getObjectId)(castedEvent);
                const objectType = (0, $dI4J1.getObjectType)(castedEvent);
                const tags = (0, $dI4J1.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};

});
parcelRegister("dI4J1", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsType", () => $3ca2da368a81a168$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $3ca2da368a81a168$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $3ca2da368a81a168$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $3ca2da368a81a168$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $3ca2da368a81a168$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $3ca2da368a81a168$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $3ca2da368a81a168$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $3ca2da368a81a168$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $3ca2da368a81a168$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $3ca2da368a81a168$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $3ca2da368a81a168$export$af63d7414243dad3);

var $6ZDS2 = parcelRequire("6ZDS2");

var $kkgbD = parcelRequire("kkgbD");

var $iTvqy = parcelRequire("iTvqy");

var $2vzCR = parcelRequire("2vzCR");

var $i7Fym = parcelRequire("i7Fym");

var $MdoH4 = parcelRequire("MdoH4");
const $3ca2da368a81a168$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $3ca2da368a81a168$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $3ca2da368a81a168$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $3ca2da368a81a168$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $3ca2da368a81a168$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($i7Fym)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kkgbD))));
};
const $3ca2da368a81a168$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'source').filter(Boolean));
const $3ca2da368a81a168$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $3ca2da368a81a168$export$6ca3170acb89054 = (event)=>event.payload.action;
const $3ca2da368a81a168$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $3ca2da368a81a168$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'containerId').filter(Boolean));
const $3ca2da368a81a168$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'containerType').filter(Boolean));
const $3ca2da368a81a168$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'objectId').filter(Boolean));
const $3ca2da368a81a168$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($iTvqy)))($3ca2da368a81a168$var$extractFromContext(event, 'objectType').filter(Boolean));
const $3ca2da368a81a168$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))((0, (/*@__PURE__*/$parcel$interopDefault($6ZDS2)))($3ca2da368a81a168$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};

});


parcelRegister("hDku9", function(module, exports) {

$parcel$export(module.exports, "NoticeType", () => $cd65f82541e30cb2$export$3b5003ffe8119af2);
$parcel$export(module.exports, "Notices", () => $cd65f82541e30cb2$export$ba15f0a357d713fd);

var $eOBWq = parcelRequire("eOBWq");

var $faV5W = parcelRequire("faV5W");
let $cd65f82541e30cb2$export$3b5003ffe8119af2 = /*#__PURE__*/ function(NoticeType) {
    NoticeType["ConfirmDeleteForm"] = "ConfirmDeleteForm";
    NoticeType["ConfirmChangeFormAvailabilityToInternal"] = "ConfirmChangeFormAvailabilityToInternal";
    NoticeType["ConfirmChangeFormToInternal"] = "ConfirmChangeFormToInternal";
    NoticeType["ConfirmChangeFormToExternal"] = "ConfirmChangeFormToExternal";
    NoticeType["ConfirmChangeFormAvailabilityToExternal"] = "ConfirmChangeFormAvailabilityToExternal";
    NoticeType["ConfirmCancelEdit"] = "ConfirmCancelEdit";
    NoticeType["ConfirmSubmitForm"] = "ConfirmSubmitForm";
    NoticeType["ConfirmSubmitFormPdf"] = "ConfirmSubmitFormPdf";
    NoticeType["ConfirmSubmitFormLock"] = "ConfirmSubmitFormLock";
    NoticeType["ConfirmSubmitFormPdfLock"] = "ConfirmSubmitFormPdfLock";
    NoticeType["ConfirmReopenForm"] = "ConfirmReopenForm";
    NoticeType["ErrorApiUnauthorised"] = "ErrorApiUnauthorised";
    NoticeType["ErrorApiMissingPermissions"] = "ErrorApiMissingPermissions";
    NoticeType["ErrorApiAddConnectionFailed"] = "ErrorApiAddConnectionFailed";
    NoticeType["ErrorApiUpdateConnectionFailed"] = "ErrorApiUpdateConnectionFailed";
    NoticeType["ErrorApiSubmitFormFailed"] = "ErrorApiSubmitFormFailed";
    NoticeType["ErrorApiSaveFormFailed"] = "ErrorApiSaveFormFailed";
    NoticeType["ErrorApiSaveFormFailedOnConflict"] = "ErrorApiSaveFormFailedOnConflict";
    NoticeType["ErrorApiSaveFormInvalidAnswersFailed"] = "ErrorApiSaveFormInvalidAnswersFailed";
    NoticeType["ErrorApiSaveTemplateFormFailed"] = "ErrorApiSaveTemplateFormFailed";
    NoticeType["ErrorApiLoadTemplateFormFailed"] = "ErrorApiLoadTemplateFormFailed";
    NoticeType["ErrorApiLoadJiraFieldsFailed"] = "ErrorApiLoadJiraFieldsFailed";
    NoticeType["ErrorApiLoadDataConnectionsFailed"] = "ErrorApiLoadDataConnectionsFailed";
    NoticeType["ErrorApiLoadSettingsRefDataFailed"] = "ErrorApiLoadSettingsRefDataFailed";
    return NoticeType;
}({});
const $cd65f82541e30cb2$export$ba15f0a357d713fd = {
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmDeleteForm]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).DeleteFormTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).DeleteFormMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Delete],
        isWarningNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmChangeFormAvailabilityToInternal]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormAvailabilityTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormAvailabilityToInternalMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Change]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmChangeFormToInternal]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormToInternalHeader],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormToInternalMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).MakeInternal]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmChangeFormAvailabilityToExternal]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormAvailabilityTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormAvailabilityToExternalMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Change]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmChangeFormToExternal]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormToExternalHeader],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ChangeFormToExternalMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).MakeExternal]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmCancelEdit]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).CancelEditFormTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).CancelEditFormMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Confirm]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmSubmitForm]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Submit]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmSubmitFormPdf]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormPdfMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Submit]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmSubmitFormLock]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormLockMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Submit]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmSubmitFormPdfLock]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).SubmitFormPdfLockMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Submit]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ConfirmReopenForm]: {
        title: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ReopenFormTitle],
        message: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ReopenFormMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Reopen]
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiUnauthorised]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).UnauthorisedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).UnauthorisedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiMissingPermissions]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).MissingPermissionsTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).MissingPermissionsMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiAddConnectionFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).AddConnectionFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).AddConnectionFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiUpdateConnectionFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).UpdateConnectionFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).UpdateConnectionFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiSubmitFormFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SubmitFormFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SubmitFormFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiSaveFormFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveFormFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiSaveFormInvalidAnswersFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveFormInvalidAnswersMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiSaveFormFailedOnConflict]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveFormFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveFormFailedOnConflictMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiSaveTemplateFormFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveTemplateFormFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).SaveTemplateFormFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiLoadTemplateFormFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadTemplateFormFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadTemplateFormFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiLoadJiraFieldsFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadJiraFieldsFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadJiraFieldsFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiLoadDataConnectionsFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadDataConnectionsFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadDataConnectionsFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    },
    [$cd65f82541e30cb2$export$3b5003ffe8119af2.ErrorApiLoadSettingsRefDataFailed]: {
        title: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadSettingsRefDataFailedTitle],
        message: (0, $eOBWq.IntlApiErrorMessages)[(0, $eOBWq.ApiErrorMessage).LoadSettingsRefDataFailedMsg],
        confirmText: (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close],
        isErrorNotice: true
    }
};

});
parcelRegister("eOBWq", function(module, exports) {

$parcel$export(module.exports, "ApiErrorMessage", () => $ac932a91fc6ac5c5$export$231e36d3eb058aab);
$parcel$export(module.exports, "IntlApiErrorMessages", () => $ac932a91fc6ac5c5$export$4a210a14fc5cbd69);

var $90IgZ = parcelRequire("90IgZ");
let $ac932a91fc6ac5c5$export$231e36d3eb058aab = /*#__PURE__*/ function(ApiErrorMessage) {
    ApiErrorMessage["UnauthorisedTitle"] = "UnauthorisedTitle";
    ApiErrorMessage["UnauthorisedMsg"] = "UnauthorisedMsg";
    ApiErrorMessage["MissingPermissionsTitle"] = "MissingPermissionsTitle";
    ApiErrorMessage["MissingPermissionsMsg"] = "MissingPermissionsMsg";
    ApiErrorMessage["AddConnectionFailedTitle"] = "AddConnectionFailedTitle";
    ApiErrorMessage["AddConnectionFailedMsg"] = "AddConnectionFailedMsg";
    ApiErrorMessage["UpdateConnectionFailedTitle"] = "UpdateConnectionFailedTitle";
    ApiErrorMessage["UpdateConnectionFailedMsg"] = "UpdateConnectionFailedMsg";
    ApiErrorMessage["SubmitFormFailedTitle"] = "SubmitFormFailedTitle";
    ApiErrorMessage["SubmitFormFailedMsg"] = "SubmitFormFailedMsg";
    ApiErrorMessage["SaveFormFailedTitle"] = "SaveFormFailedTitle";
    ApiErrorMessage["SaveFormFailedMsg"] = "SaveFormFailedMsg";
    ApiErrorMessage["SaveFormInvalidAnswersMsg"] = "SaveFormInvalidAnswersMsg";
    ApiErrorMessage["SaveFormFailedOnConflictMsg"] = "SaveFormFailedOnConflictMsg";
    ApiErrorMessage["SaveTemplateFormFailedTitle"] = "SaveTemplateFormFailedTitle";
    ApiErrorMessage["SaveTemplateFormFailedMsg"] = "SaveTemplateFormFailedMsg";
    ApiErrorMessage["LoadTemplateFormFailedTitle"] = "LoadTemplateFormFailedTitle";
    ApiErrorMessage["LoadTemplateFormFailedMsg"] = "LoadTemplateFormFailedMsg";
    ApiErrorMessage["LoadJiraFieldsFailedTitle"] = "LoadJiraFieldsFailedTitle";
    ApiErrorMessage["LoadJiraFieldsFailedMsg"] = "LoadJiraFieldsFailedMsg";
    ApiErrorMessage["LoadDataConnectionsFailedTitle"] = "LoadDataConnectionsFailedTitle";
    ApiErrorMessage["LoadDataConnectionsFailedMsg"] = "LoadDataConnectionsFailedMsg";
    ApiErrorMessage["LoadSettingsRefDataFailedTitle"] = "LoadSettingsRefDataFailedTitle";
    ApiErrorMessage["LoadSettingsRefDataFailedMsg"] = "LoadSettingsRefDataFailedMsg";
    return ApiErrorMessage;
}({});
const $ac932a91fc6ac5c5$export$4a210a14fc5cbd69 = (0, $90IgZ.defineMessages)({
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.UnauthorisedTitle]: {
        id: 'ui-notices.apiError.title.UnauthorisedTitle',
        defaultMessage: 'Error: User Unauthorised'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.UnauthorisedMsg]: {
        id: 'ui-notices.apiError.msg.UnauthorisedMsg',
        defaultMessage: 'Try refreshing your page or logging into Jira again.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.MissingPermissionsTitle]: {
        id: 'ui-notices.apiError.title.MissingPermissionsTitle',
        defaultMessage: 'Error: User is not allowed this action'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.MissingPermissionsMsg]: {
        id: 'ui-notices.apiError.msg.MissingPermissionsMsg',
        defaultMessage: 'You do not have the necessary permissions to perform this action. Please contact your Jira Administrator.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.AddConnectionFailedTitle]: {
        id: 'ui-notices.apiError.title.AddConnectionFailedTitle',
        defaultMessage: 'Error: Adding data connection failed'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.AddConnectionFailedMsg]: {
        id: 'ui-notices.apiError.msg.AddConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to add the data connection.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.UpdateConnectionFailedTitle]: {
        id: 'ui-notices.apiError.title.UpdateConnectionFailedTitle',
        defaultMessage: 'Error: Updating data connection failed'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.UpdateConnectionFailedMsg]: {
        id: 'ui-notices.apiError.msg.UpdateConnectionFailedMsg',
        defaultMessage: 'A server error occurred while trying to update the data connection.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SubmitFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SubmitFormFailedTitle',
        defaultMessage: 'Error: Submitting form failed'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SubmitFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SubmitFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to submit the form.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SaveFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SaveFormFailedTitle',
        defaultMessage: "We couldn\u2019t save your changes",
        description: 'The title on the error flag informing customers that their form failed to save.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SaveFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the form.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SaveFormInvalidAnswersMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormInvalidAnswersMsg',
        defaultMessage: 'Resolve any invalid answers and check all required fields are complete.',
        description: 'The error message on the error flag informing customers that their form failed to save due to invalid answers.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SaveFormFailedOnConflictMsg]: {
        id: 'ui-notices.apiError.msg.SaveFormFailedOnConflictMsg',
        defaultMessage: 'The settings for this form have been changed. If you believe this was an error, leave a comment on the request.',
        description: "The error message on error flag informing customers about what happened and what to do when saving form answers request was rejected because the form state doesn't allow the customer to do so."
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SaveTemplateFormFailedTitle]: {
        id: 'ui-notices.apiError.title.SaveTemplateFormFailedTitle',
        defaultMessage: 'Error: Saving template form failed'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.SaveTemplateFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.SaveTemplateFormFailedMsg',
        defaultMessage: 'A server error occurred while trying to save the template form.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadTemplateFormFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadTemplateFormFailedTitle',
        defaultMessage: "We couldn\u2019t load your form"
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadTemplateFormFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadTemplateFormFailedMsg',
        defaultMessage: 'Refresh the page to try again'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadJiraFieldsFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadJiraFieldsFailedTitle',
        defaultMessage: 'Error: Loading Jira fields failed'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadJiraFieldsFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadJiraFieldsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load Jira fields on the template form.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadDataConnectionsFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadDataConnectionsFailedTitle',
        defaultMessage: 'Error: Loading data connections failed.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadDataConnectionsFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadDataConnectionsFailedMsg',
        defaultMessage: 'A server error occurred while trying to load data connections on the template form.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadSettingsRefDataFailedTitle]: {
        id: 'ui-notices.apiError.title.LoadSettingsRefDataFailedTitle',
        defaultMessage: 'Error: Loading form settings reference data failed.'
    },
    [$ac932a91fc6ac5c5$export$231e36d3eb058aab.LoadSettingsRefDataFailedMsg]: {
        id: 'ui-notices.apiError.msg.LoadSettingsRefDataFailedMsg',
        defaultMessage: "A server error occurred while trying to load the reference for the template form's settings."
    }
});

});

parcelRegister("faV5W", function(module, exports) {

$parcel$export(module.exports, "NoticeMessage", () => $b0c4140cf9cfc869$export$cd61f3d27ce0e442);
$parcel$export(module.exports, "IntlNoticeMessages", () => $b0c4140cf9cfc869$export$5f3ce93e2cd01692);

var $90IgZ = parcelRequire("90IgZ");
let $b0c4140cf9cfc869$export$cd61f3d27ce0e442 = /*#__PURE__*/ function(NoticeMessage) {
    NoticeMessage["Delete"] = "Delete";
    NoticeMessage["Discard"] = "Discard";
    NoticeMessage["Change"] = "Change";
    NoticeMessage["Confirm"] = "Confirm";
    NoticeMessage["Submit"] = "Submit";
    NoticeMessage["Reopen"] = "Reopen";
    NoticeMessage["Close"] = "Close";
    NoticeMessage["Cancel"] = "Cancel";
    NoticeMessage["UpgradeNow"] = "UpgradeNow";
    NoticeMessage["MakeInternal"] = "MakeInternal";
    NoticeMessage["MakeExternal"] = "MakeExternal";
    NoticeMessage["DeleteFormTitle"] = "DeleteFormTitle";
    NoticeMessage["DeleteFormMsg"] = "DeleteFormMsg";
    NoticeMessage["ChangeFormAvailabilityTitle"] = "ChangeFormAvailabilityTitle";
    NoticeMessage["ChangeFormAvailabilityToInternalMsg"] = "ChangeFormAvailabilityToInternalMsg";
    NoticeMessage["ChangeFormAvailabilityToExternalMsg"] = "ChangeFormAvailabilityToExternalMsg";
    NoticeMessage["ChangeFormToInternalHeader"] = "ChangeFormToInternalHeader";
    NoticeMessage["ChangeFormToInternalMsg"] = "ChangeFormToInternalMsg";
    NoticeMessage["ChangeFormToExternalHeader"] = "ChangeFormToExternalHeader";
    NoticeMessage["ChangeFormToExternalMsg"] = "ChangeFormToExternalMsg";
    NoticeMessage["CancelEditFormTitle"] = "CancelEditFormTitle";
    NoticeMessage["CancelEditFormMsg"] = "CancelEditFormMsg";
    NoticeMessage["SubmitFormTitle"] = "SubmitFormTitle";
    NoticeMessage["SubmitFormMsg"] = "SubmitFormMsg";
    NoticeMessage["SubmitFormPdfMsg"] = "SubmitFormPdfMsg";
    NoticeMessage["SubmitFormLockMsg"] = "SubmitFormLockMsg";
    NoticeMessage["SubmitFormPdfLockMsg"] = "SubmitFormPdfLockMsg";
    NoticeMessage["ReopenFormTitle"] = "ReopenFormTitle";
    NoticeMessage["ReopenFormMsg"] = "ReopenFormMsg";
    NoticeMessage["ErrorExplanations1"] = "ErrorExplanations1";
    NoticeMessage["ErrorExplanations2"] = "ErrorExplanations2";
    NoticeMessage["ErrorExplanations3"] = "ErrorExplanations3";
    NoticeMessage["ErrorExplanations4"] = "ErrorExplanations4";
    return NoticeMessage;
}({});
const $b0c4140cf9cfc869$export$5f3ce93e2cd01692 = (0, $90IgZ.defineMessages)({
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Delete]: {
        id: 'ui-notices.confirmText.Delete',
        defaultMessage: 'Delete'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Discard]: {
        id: 'ui-notices.confirmText.Discard',
        defaultMessage: 'Discard'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Change]: {
        id: 'ui-notices.confirmText.Change',
        defaultMessage: 'Change'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Confirm]: {
        id: 'ui-notices.confirmText.Confirm',
        defaultMessage: 'Confirm'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Submit]: {
        id: 'ui-notices.confirmText.Submit',
        defaultMessage: 'Submit'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Reopen]: {
        id: 'ui-notices.confirmText.Reopen',
        defaultMessage: 'Reopen'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Close]: {
        id: 'ui-notices.confirmText.Close',
        defaultMessage: 'Close'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.Cancel]: {
        id: 'ui-notices.confirmText.Cancel',
        defaultMessage: 'Cancel'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.UpgradeNow]: {
        id: 'ui-notices.confirmText.UpgradeNow',
        defaultMessage: 'Upgrade Now'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.MakeInternal]: {
        id: 'ui-notices.confirmText.MakeInternal',
        defaultMessage: 'Make internal'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.MakeExternal]: {
        id: 'ui-notices.confirmText.MakeExternal',
        defaultMessage: 'Make external'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.DeleteFormTitle]: {
        id: 'ui-notices.title.DeleteFormTitle',
        defaultMessage: 'Confirm Deleting Form'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.DeleteFormMsg]: {
        id: 'ui-notices.msg.DeleteFormMsg',
        defaultMessage: "Are you sure you want to delete the \u201C{formName}\u201D form? This cannot be undone."
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ChangeFormAvailabilityTitle]: {
        id: 'ui-notices.title.ChangeFormAvailabilityTitle',
        defaultMessage: 'Confirm Changing Form Availability'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ChangeFormAvailabilityToInternalMsg]: {
        id: 'ui-notices.msg.ChangeFormAvailabilityToInternalMsg',
        defaultMessage: 'Please confirm you want to change the form so that it is only accessible through the Jira issue, and not through the Customer Portal.'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ChangeFormAvailabilityToExternalMsg]: {
        id: 'ui-notices.msg.ChangeFormAvailabilityToExternalMsg',
        defaultMessage: 'Please confirm you want to change the form so that it is accessible through the Jira issue and the Customer Portal.'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ChangeFormToInternalHeader]: {
        id: 'ui-notices.title.ChangeFormInternalHeader',
        defaultMessage: 'Make form internal only and hide from customer'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ChangeFormToInternalMsg]: {
        id: 'ui-notices.msg.ChangeFormInternalMsg',
        defaultMessage: 'Any forms made internal will only be seen by agents and hidden in the portal from customers.'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ChangeFormToExternalHeader]: {
        id: 'ui-notices.title.ChangeFormToExternalHeader',
        defaultMessage: 'Make form external and show to customer'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ChangeFormToExternalMsg]: {
        id: 'ui-notices.msg.ChangeFormToExternalMsg',
        defaultMessage: 'Customers will be able to view this form in the portal and it will no longer be internal only.'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.CancelEditFormTitle]: {
        id: 'ui-notices.title.CancelEditFormTitle',
        defaultMessage: 'Confirm Discarding Changes'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.CancelEditFormMsg]: {
        id: 'ui-notices.msg.CancelEditFormMsg',
        defaultMessage: 'There are changes to answers on the \u201C{formName}\u201D form that will be lost if you choose "Confirm". Are you sure you want to continue?'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.SubmitFormTitle]: {
        id: 'ui-notices.title.SubmitFormTitle',
        defaultMessage: 'Confirm Form Submission'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.SubmitFormMsg]: {
        id: 'ui-notices.msg.SubmitFormMsg',
        defaultMessage: 'Are you sure you want to submit this form ?'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.SubmitFormPdfMsg]: {
        id: 'ui-notices.msg.SubmitFormPdfMsg',
        defaultMessage: 'Submitting this form will also attach a PDF of the form to the issue/request. Are you sure you want to submit this form ?'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.SubmitFormLockMsg]: {
        id: 'ui-notices.msg.SubmitFormLockMsg',
        defaultMessage: 'Are you sure you want to submit this form ? Once submitted no further changes can be made.'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.SubmitFormPdfLockMsg]: {
        id: 'ui-notices.msg.SubmitFormPdfLockMsg',
        defaultMessage: 'Submitting this form will also attach a PDF of the form to the issue/request. Are you sure you want to submit this form ? Once submitted no further changes can be made.'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ReopenFormTitle]: {
        id: 'ui-notices.title.ReopenFormTitle',
        defaultMessage: 'Confirm Reopening Form'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ReopenFormMsg]: {
        id: 'ui-notices.msg.ReopenFormMsg',
        defaultMessage: 'Are you sure you want to reopen the submitted form for editing?'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ErrorExplanations1]: {
        id: 'ui-notices.msg.ErrorExplanations1',
        defaultMessage: 'Please refer to our'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ErrorExplanations2]: {
        id: 'ui-notices.msg.ErrorExplanations2',
        defaultMessage: 'Error Explanations'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ErrorExplanations3]: {
        id: 'ui-notices.msg.ErrorExplanations3',
        defaultMessage: 'page for more details or contact'
    },
    [$b0c4140cf9cfc869$export$cd61f3d27ce0e442.ErrorExplanations4]: {
        id: 'ui-notices.msg.ErrorExplanations4',
        defaultMessage: 'ThinkTilt Support'
    }
});

});


parcelRegister("6O9iv", function(module, exports) {

$parcel$export(module.exports, "constructApiError", () => $4f4e9fdce76b1967$export$4fb8f0e1418096d0);
$parcel$export(module.exports, "isUnknownApiError", () => $4f4e9fdce76b1967$export$a072859f46abbb91);
$parcel$export(module.exports, "getFormSaveErrors", () => $4f4e9fdce76b1967$export$ed98b2247c52f4f6);

var $in1uz = parcelRequire("in1uz");

var $aYB6L = parcelRequire("aYB6L");
function $4f4e9fdce76b1967$export$4fb8f0e1418096d0(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
    switch(error){
        case (0, $in1uz.ApiErrorType).client:
            return {
                error: (0, $in1uz.ApiErrorType).client,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $in1uz.ApiErrorType).clientWithDetails:
            return {
                error: (0, $in1uz.ApiErrorType).clientWithDetails,
                context: (0, $aYB6L.ErrorContextOf)(context),
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $in1uz.ApiErrorType).json:
            return {
                error: (0, $in1uz.ApiErrorType).json,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        case (0, $in1uz.ApiErrorType).jwt:
            return {
                error: (0, $in1uz.ApiErrorType).jwt,
                details: details || '',
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                status: status,
                requestName: requestName
            };
        default:
            return {
                error: (0, $in1uz.ApiErrorType).unknown,
                message: error,
                status: status,
                responseJson: responseJson,
                isClientFetchError: isClientFetchError,
                traceId: traceId,
                requestName: requestName
            };
    }
}
const $4f4e9fdce76b1967$export$a072859f46abbb91 = (apiError)=>apiError.error === (0, $in1uz.ApiErrorType).unknown;
const $4f4e9fdce76b1967$export$ed98b2247c52f4f6 = (apiError)=>{
    if ($4f4e9fdce76b1967$export$a072859f46abbb91(apiError) && apiError.status === 400) return {
        generalErrors: [],
        errorsByQuestionId: {},
        ...apiError.responseJson
    };
    return undefined;
};

});
parcelRegister("in1uz", function(module, exports) {

$parcel$export(module.exports, "ApiErrorType", () => $d5fb884472b2123e$export$eb26b24d7b7bab09);
let $d5fb884472b2123e$export$eb26b24d7b7bab09 = /*#__PURE__*/ function(ApiErrorType) {
    ApiErrorType["client"] = "client";
    ApiErrorType["clientWithDetails"] = "clientWithDetails";
    ApiErrorType["json"] = "json";
    ApiErrorType["jwt"] = "jwt";
    ApiErrorType["unknown"] = "unknown";
    ApiErrorType["timeout"] = "timeout";
    return ApiErrorType;
}({});

});

parcelRegister("aYB6L", function(module, exports) {

$parcel$export(module.exports, "ErrorContextOf", () => $7fdc4ad97fc564d0$export$2c172aed648e926c);
let $7fdc4ad97fc564d0$export$21818dff4f4f7174 = /*#__PURE__*/ function(ErrorContext) {
    ErrorContext["I18nAccessPathKey"] = "err.access.path";
    ErrorContext["I18nEntityConnectionKey"] = "err.entity.connection";
    ErrorContext["I18nEntityFormKey"] = "err.entity.form";
    ErrorContext["I18nEntityIssueKey"] = "err.entity.issue";
    ErrorContext["I18nEntityIssueCreateKey"] = "err.entity.issue.create";
    ErrorContext["I18nEntityPreferredFormKey"] = "err.entity.preferredform";
    ErrorContext["I18nEntityProjectKey"] = "err.entity.project";
    ErrorContext["I18nEntityRequestTypeKey"] = "err.entity.requesttype";
    ErrorContext["I18nEntityServiceDeskKey"] = "err.entity.servicedesk";
    ErrorContext["I18nJwtParseKey"] = "err.jwt.parse";
    ErrorContext["I18nJwtSignatureKey"] = "err.jwt.signed";
    ErrorContext["I18nJwtVerifyKey"] = "err.jwt.verify";
    ErrorContext["I18nInternalServerError"] = "err.server.internal";
    ErrorContext["I18nUnknownContextError"] = "err.context.unknown";
    return ErrorContext;
}({});
function $7fdc4ad97fc564d0$export$2c172aed648e926c(context) {
    switch(context){
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nAccessPathKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nAccessPathKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityConnectionKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityConnectionKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityFormKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityFormKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityIssueKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityIssueKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityIssueCreateKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityIssueCreateKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityPreferredFormKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityPreferredFormKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityProjectKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityProjectKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityRequestTypeKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityRequestTypeKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityServiceDeskKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nEntityServiceDeskKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nJwtParseKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nJwtParseKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nJwtSignatureKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nJwtSignatureKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nJwtVerifyKey:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nJwtVerifyKey;
        case $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nInternalServerError:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nInternalServerError;
        default:
            return $7fdc4ad97fc564d0$export$21818dff4f4f7174.I18nUnknownContextError;
    }
}

});



parcelRegister("eM64G", function(module, exports) {

$parcel$export(module.exports, "setNoticeLocale", () => $ac1a42ae2277c444$export$caf904df61b5b10d);
$parcel$export(module.exports, "showNotice", () => $ac1a42ae2277c444$export$b25305d7fdb340d7);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $tMEwY = parcelRequire("tMEwY");
let $ac1a42ae2277c444$var$locale = 'en-US';
function $ac1a42ae2277c444$export$caf904df61b5b10d(newLocale) {
    $ac1a42ae2277c444$var$locale = newLocale;
}
function $ac1a42ae2277c444$export$b25305d7fdb340d7(noticeType, intlValues, errorDetails) {
    return new Promise((resolve)=>{
        const dialogTargetNode = document.getElementById('pf-dialog-container');
        if (!dialogTargetNode) {
            // eslint-disable-next-line no-console
            console.error(`Could not show notice ${noticeType}. The target Node for the dialog is not available`);
            resolve(false);
        }
        const handleClose = (confirmed)=>{
            resolve(!!confirmed);
            $ac1a42ae2277c444$var$closeNotice();
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $tMEwY.Notice), {
            noticeType: noticeType,
            handleClose: handleClose,
            settings: {
                intlValues: intlValues,
                errorDetails: errorDetails,
                customLocale: $ac1a42ae2277c444$var$locale
            }
        }), dialogTargetNode);
    });
}
function $ac1a42ae2277c444$var$closeNotice() {
    const dialogTargetNode = document.getElementById('pf-dialog-container');
    if (!dialogTargetNode) {
        // eslint-disable-next-line no-console
        console.error(`Could not close notice. The target Node for the dialog is not available`);
        return false;
    }
    const closed = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).unmountComponentAtNode(dialogTargetNode);
    if (!closed) // eslint-disable-next-line no-console
    console.error(`Could not close notice. There is no dialog to unmount`);
    return closed;
}

});
parcelRegister("tMEwY", function(module, exports) {

$parcel$export(module.exports, "Notice", () => $059872f7186b0bae$export$71802e30fd294f61);

var $eUqFw = parcelRequire("eUqFw");

var $iylhS = parcelRequire("iylhS");

var $jYxIw = parcelRequire("jYxIw");

var $9xJv6 = parcelRequire("9xJv6");

var $hDku9 = parcelRequire("hDku9");
const $059872f7186b0bae$export$71802e30fd294f61 = ({ noticeType: noticeType, handleClose: handleClose, settings: { customLocale: customLocale = (0, $jYxIw.DEFAULT_LOCALE), intlValues: intlValues, errorDetails: errorDetails, overrideZIndex: overrideZIndex } })=>{
    const notice = (0, $hDku9.Notices)[noticeType];
    if (!notice) {
        // eslint-disable-next-line no-console
        console.error(`Could not show notice, notice type ${noticeType} does not exist`);
        handleClose();
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iylhS.PackageIntlProvider), {
        locale: customLocale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9xJv6.NoticeDialog), {
        title: notice.title,
        titleVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.titleVars,
        message: notice.message,
        messageVars: intlValues === null || intlValues === void 0 ? void 0 : intlValues.msgVars,
        confirmText: notice.confirmText,
        confirmLink: notice.confirmLink,
        handleClose: handleClose,
        isErrorNotice: notice.isErrorNotice,
        errorDetails: errorDetails,
        isWarningNotice: notice.isWarningNotice,
        overrideZIndex: overrideZIndex
    }));
};

});
parcelRegister("iylhS", function(module, exports) {

$parcel$export(module.exports, "PackageIntlProvider", () => $d81bea308b109d96$export$dfce9acc1b75df7a);
$parcel$export(module.exports, "withPackageIntlProvider", () => $d81bea308b109d96$export$38662a78c6a3a7ce);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $h6VKi = parcelRequire("h6VKi");

var $a7jEh = parcelRequire("a7jEh");
const $d81bea308b109d96$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h6VKi.ProformaIntlProvider), {
        locale: locale,
        messages: (0, $a7jEh.default)
    }, children);
const $d81bea308b109d96$export$38662a78c6a3a7ce = (WrappedComponent)=>(props)=>{
        const intl = (0, $5JgJ2.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d81bea308b109d96$export$dfce9acc1b75df7a, {
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props));
    };

});
parcelRegister("h6VKi", function(module, exports) {

$parcel$export(module.exports, "ProformaIntlProvider", () => $c74fca473dc5902a$export$f345b4b8e42e419e);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $jCDe4 = parcelRequire("jCDe4");
const $c74fca473dc5902a$export$f345b4b8e42e419e = ({ children: children, locale: locale, messages: messages })=>{
    var _getCodesFromLocale;
    const { language: language, country: country } = (_getCodesFromLocale = (0, $jCDe4.getCodesFromLocale)(locale)) !== null && _getCodesFromLocale !== void 0 ? _getCodesFromLocale : {};
    const lazyMessages = (0, $jCDe4.useLazyMessages)(messages, language !== null && language !== void 0 ? language : (0, $jCDe4.DEFAULT_LOCALE), country);
    if (lazyMessages === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        messages: lazyMessages,
        locale: country && `${language}-${country}` || language || locale.replace('_', '-'),
        defaultLocale: (0, $jCDe4.DEFAULT_LOCALE),
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }
    }, children);
};

});
parcelRegister("jCDe4", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $e48ffe5e350c82bd$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "getCodesFromLocale", () => $e48ffe5e350c82bd$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyMessages", () => $e48ffe5e350c82bd$export$7ddce3b5511cfaa8);

var $eUqFw = parcelRequire("eUqFw");
const $e48ffe5e350c82bd$export$1af4c7e47ad72f44 = 'en';
const $e48ffe5e350c82bd$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $e48ffe5e350c82bd$export$4d25b49b6dc1b540 = (locale)=>{
    const match = $e48ffe5e350c82bd$var$localeRegex.exec(locale);
    if (match) {
        const [, language, country] = match;
        return {
            language: language.toLowerCase(),
            country: country === null || country === void 0 ? void 0 : country.toUpperCase()
        };
    }
    // TODO: Use error service to log:
    // eslint-disable-next-line no-console
    console.error('Unable to determine language and country from invalid locale.');
    return undefined;
};
const $e48ffe5e350c82bd$var$loadLazyMessages = async (lazyMessages, language, country)=>{
    var _await$default, _await, _ref;
    return (_await$default = (_await = await ((_ref = country && lazyMessages[`${language}_${country}`] || lazyMessages[language] || lazyMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
};
const $e48ffe5e350c82bd$export$7ddce3b5511cfaa8 = (lazyMessages, language, country)=>{
    const [messages, setMessages] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        $e48ffe5e350c82bd$var$loadLazyMessages(lazyMessages, language, country).catch(()=>({})).then(setMessages);
    }, [
        country,
        language,
        lazyMessages,
        setMessages
    ]);
    return messages;
};

});


parcelRegister("a7jEh", function(module, exports) {

$parcel$export(module.exports, "default", () => $75d9ccac57b04e25$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 
























const $75d9ccac57b04e25$var$lazyMessages = {
    cs: ()=>(parcelRequire("6DvBT")),
    da: ()=>(parcelRequire("hZgP4")),
    de: ()=>(parcelRequire("8w9k6")),
    en: ()=>(parcelRequire("3tJ1M")),
    en_GB: ()=>(parcelRequire("7E5bd")),
    en_ZZ: ()=>(parcelRequire("55ddx")),
    es: ()=>(parcelRequire("ayTEE")),
    fi: ()=>(parcelRequire("99vfJ")),
    fr: ()=>(parcelRequire("aO0iD")),
    hu: ()=>(parcelRequire("63tn4")),
    it: ()=>(parcelRequire("iFZVC")),
    ja: ()=>(parcelRequire("gbeHx")),
    ko: ()=>(parcelRequire("dvVSy")),
    nb: ()=>(parcelRequire("bEFkB")),
    nl: ()=>(parcelRequire("c8ybF")),
    pl: ()=>(parcelRequire("dx4S9")),
    pt_BR: ()=>(parcelRequire("gJeXH")),
    ru: ()=>(parcelRequire("3iTLc")),
    sv: ()=>(parcelRequire("ggzoN")),
    th: ()=>(parcelRequire("kW4S8")),
    tr: ()=>(parcelRequire("3uuxx")),
    uk: ()=>(parcelRequire("j0yzi")),
    vi: ()=>(parcelRequire("cGdBZ")),
    zh: ()=>(parcelRequire("3AkSr")),
    zh_TW: ()=>(parcelRequire("eqgwQ"))
};
var $75d9ccac57b04e25$export$2e2bcd8739ae039 = $75d9ccac57b04e25$var$lazyMessages;

});
parcelRegister("6DvBT", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9dYSF").then(()=>parcelRequire('9tEut'));

});

parcelRegister("hZgP4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2EGaF").then(()=>parcelRequire('jiV9L'));

});

parcelRegister("8w9k6", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("VZ7l6").then(()=>parcelRequire('2DpFZ'));

});

parcelRegister("3tJ1M", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lVmHs").then(()=>parcelRequire('lXsTQ'));

});

parcelRegister("7E5bd", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3V2bL").then(()=>parcelRequire('5jk3O'));

});

parcelRegister("55ddx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ca3XM").then(()=>parcelRequire('9neB2'));

});

parcelRegister("ayTEE", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("ekfkS").then(()=>parcelRequire('3UP6r'));

});

parcelRegister("99vfJ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("39EGj").then(()=>parcelRequire('bgepK'));

});

parcelRegister("aO0iD", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fkx5L").then(()=>parcelRequire('6LLXK'));

});

parcelRegister("63tn4", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("lHEXs").then(()=>parcelRequire('5RFX8'));

});

parcelRegister("iFZVC", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("3MUih").then(()=>parcelRequire('lhj0a'));

});

parcelRegister("gbeHx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("2VbZN").then(()=>parcelRequire('loXbg'));

});

parcelRegister("dvVSy", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dNDlz").then(()=>parcelRequire('jDi7A'));

});

parcelRegister("bEFkB", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gS1TY").then(()=>parcelRequire('6pPaN'));

});

parcelRegister("c8ybF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9qTWN").then(()=>parcelRequire('5zilm'));

});

parcelRegister("dx4S9", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("dYz1z").then(()=>parcelRequire('7XLWC'));

});

parcelRegister("gJeXH", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aH9Xg").then(()=>parcelRequire('zY0em'));

});

parcelRegister("3iTLc", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("208NI").then(()=>parcelRequire('jSzMG'));

});

parcelRegister("ggzoN", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fC7jj").then(()=>parcelRequire('6Albd'));

});

parcelRegister("kW4S8", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("7n1Ua").then(()=>parcelRequire('2dci1'));

});

parcelRegister("3uuxx", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b7Sdb").then(()=>parcelRequire('38N1K'));

});

parcelRegister("j0yzi", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bl9OV").then(()=>parcelRequire('971Qc'));

});

parcelRegister("cGdBZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6JAvc").then(()=>parcelRequire('f3oSa'));

});

parcelRegister("3AkSr", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("fdghO").then(()=>parcelRequire('c649t'));

});

parcelRegister("eqgwQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("g00kT").then(()=>parcelRequire('2Rz7q'));

});



parcelRegister("jYxIw", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_LOCALE", () => $e8adc6695690094f$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "ProFormaIntlProvider", () => $e8adc6695690094f$export$23e25b3437f9c000);
$parcel$export(module.exports, "withProFormaIntlProvider", () => $e8adc6695690094f$export$a98a2d834cadecf0);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $a7jEh = parcelRequire("a7jEh");

var $ehar5 = parcelRequire("ehar5");
const $e8adc6695690094f$export$1af4c7e47ad72f44 = 'en-US';
const $e8adc6695690094f$export$23e25b3437f9c000 = ({ children: children, i18nMessages: i18nMessages, locale: locale })=>{
    var _ref, _ref2;
    // `commonCoreI18nMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const commonCoreI18nMessages = (0, $ehar5.useLazyI18nMessages)(locale, (0, $a7jEh.default));
    if (!commonCoreI18nMessages) return null;
    const { language: language, country: country } = (0, $ehar5.getCodesFromLocale)(locale);
    const messages = (_ref = (_ref2 = country && i18nMessages[`${language}_${country}`]) !== null && _ref2 !== void 0 ? _ref2 : i18nMessages[language]) !== null && _ref !== void 0 ? _ref : i18nMessages.en;
    // `aggregateMessages` is a temporary variable required only while we need to maintain
    // access to the 'proforma-common-core' translations for other packages. Once the translations
    // are properly per package, this can be removed.
    const aggregateMessages = {
        ...commonCoreI18nMessages,
        ...messages
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        messages: aggregateMessages,
        locale: country ? `${language}-${country}` : language,
        defaultLocale: $e8adc6695690094f$export$1af4c7e47ad72f44,
        defaultRichTextElements: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }
    }, children);
};
const $e8adc6695690094f$export$a98a2d834cadecf0 = (i18nMessages, WrappedComponent)=>(props)=>{
        const intl = (0, $5JgJ2.default)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e8adc6695690094f$export$23e25b3437f9c000, {
            i18nMessages: i18nMessages,
            locale: intl.locale
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, props));
    };

});
parcelRegister("ehar5", function(module, exports) {

$parcel$export(module.exports, "getCodesFromLocale", () => $a64abf9687315596$export$4d25b49b6dc1b540);
$parcel$export(module.exports, "useLazyI18nMessages", () => $a64abf9687315596$export$30a7082641f381ea);

var $eUqFw = parcelRequire("eUqFw");

var $jYxIw = parcelRequire("jYxIw");
const $a64abf9687315596$var$localeRegex = /([a-z]+)(?:[-_]([A-Z]+))?/i;
const $a64abf9687315596$export$4d25b49b6dc1b540 = (locale)=>{
    let match = $a64abf9687315596$var$localeRegex.exec(locale);
    if (!match) {
        // eslint-disable-next-line no-console
        console.error('Unable to get language and country from invalid locale, falling back to default locale.');
        match = $a64abf9687315596$var$localeRegex.exec((0, $jYxIw.DEFAULT_LOCALE));
    }
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country === null || country === void 0 ? void 0 : country.toUpperCase()
    };
};
const $a64abf9687315596$var$loadLazyI18nMessages = async (locale, lazyI18nMessages)=>{
    var _await$default, _await, _ref;
    const { language: language, country: country } = $a64abf9687315596$export$4d25b49b6dc1b540(locale);
    return (_await$default = (_await = await ((_ref = country && lazyI18nMessages[`${language}_${country}`] || lazyI18nMessages[language] || lazyI18nMessages.en) === null || _ref === void 0 ? void 0 : _ref())) === null || _await === void 0 ? void 0 : _await.default) !== null && _await$default !== void 0 ? _await$default : {};
};
const $a64abf9687315596$export$30a7082641f381ea = (locale, lazyI18nMessages)=>{
    const [messages, setMessages] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        $a64abf9687315596$var$loadLazyI18nMessages(locale, lazyI18nMessages).catch(()=>({})).then(setMessages);
    }, [
        locale,
        setMessages,
        lazyI18nMessages
    ]);
    return messages;
};

});


parcelRegister("9xJv6", function(module, exports) {

$parcel$export(module.exports, "NoticeDialog", () => $6f2a7d9d83c8fb2f$export$7ccde09c2c5f5940);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $362r9 = parcelRequire("362r9");

var $jzySp = parcelRequire("jzySp");

var $faV5W = parcelRequire("faV5W");

var $eS0xg = parcelRequire("eS0xg");
const $6f2a7d9d83c8fb2f$export$7ccde09c2c5f5940 = ({ title: title, titleVars: titleVars, message: message, messageVars: messageVars, confirmText: confirmText, confirmLink: confirmLink, handleClose: handleClose, isErrorNotice: isErrorNotice, errorDetails: errorDetails, isWarningNotice: isWarningNotice, overrideZIndex: overrideZIndex })=>{
    const appearance = isErrorNotice ? 'danger' : isWarningNotice ? 'warning' : undefined;
    const actions = [];
    if (isErrorNotice) ;
    else if (confirmLink) actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Close]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    else actions.push({
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).Cancel]),
        onClick: ()=>handleClose(false),
        appearance: 'subtle'
    });
    const primaryButtonAppearance = appearance || 'primary';
    if (confirmLink) actions.push({
        // @ts-ignore
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), confirmText),
        href: confirmLink,
        target: '_blank',
        rel: 'noopener noreferrer',
        appearance: primaryButtonAppearance
    });
    else actions.push({
        // @ts-ignore
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), confirmText),
        onClick: ()=>handleClose(true),
        appearance: primaryButtonAppearance
    });
    let onOpenCompleteF;
    if (overrideZIndex) onOpenCompleteF = (node, isAppearing)=>{
        overrideZIndex && node.parentElement ? node.parentElement.style.zIndex = '5000' : undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onOpenComplete: onOpenCompleteF,
        onClose: ()=>handleClose(),
        shouldCloseOnOverlayClick: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eS0xg.ModalTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: appearance
    }, /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, title, {
        values: titleVars
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, message, {
        values: messageVars
    }))), isErrorNotice && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ErrorExplanations1]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $362r9.PfLink), {
        href: "http://links.thinktilt.net/error-explanations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ErrorExplanations2])), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ErrorExplanations3]), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $362r9.PfLink), {
        href: "https://support.thinktilt.com/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $faV5W.IntlNoticeMessages)[(0, $faV5W.NoticeMessage).ErrorExplanations4])), "."), !!errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzySp.ErrorSection), {
        errorDetails: errorDetails
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, actions.map(({ text: text, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), props, text))));
};

});
parcelRegister("362r9", function(module, exports) {

$parcel$export(module.exports, "PfLink", () => $2413d28d78702735$export$9522c077a5f2be27);

var $eUqFw = parcelRequire("eUqFw");
const $2413d28d78702735$export$9522c077a5f2be27 = ({ href: href, onClick: onClick, id: id, popup: popup = true, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: href,
        id: id,
        rel: popup ? 'noreferrer noopener' : undefined,
        target: popup ? '_blank' : undefined,
        onClick: onClick
    }, children);
};

});

parcelRegister("jzySp", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $e3fc56f72c9be71a$export$b0bceea2ea86179a);

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");


var $e270j = parcelRequire("e270j");
const $e3fc56f72c9be71a$export$b0bceea2ea86179a = ({ errorDetails: errorDetails })=>{
    const [showErrorDetails, setShowErrorDetails] = (0, $eUqFw.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3fc56f72c9be71a$var$ErrorSectionLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, "Show error details:"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        isChecked: showErrorDetails,
        onChange: ()=>{
            setShowErrorDetails(!showErrorDetails);
        }
    })), showErrorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3fc56f72c9be71a$var$ErrorDetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("code", null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e3fc56f72c9be71a$var$ErrorSectionLabel = (0, $exJuA.default).div({
    display: 'flex',
    marginTop: "var(--ds-space-250, 20px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> p': {
        marginTop: "var(--ds-space-025, 2px)"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e3fc56f72c9be71a$var$ErrorDetailsWrapper = (0, $exJuA.default).div({
    backgroundColor: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    padding: "var(--ds-space-100, 8px)",
    fontSize: '12px'
});

});
var $73a5c9d720aa66e1$exports = {};

$parcel$export($73a5c9d720aa66e1$exports, "R50", () => $73a5c9d720aa66e1$export$4b84fd0e2c617bd);
$parcel$export($73a5c9d720aa66e1$exports, "R75", () => $73a5c9d720aa66e1$export$b34b069eff244586);
$parcel$export($73a5c9d720aa66e1$exports, "R100", () => $73a5c9d720aa66e1$export$be802dd0d8b57f35);
$parcel$export($73a5c9d720aa66e1$exports, "R200", () => $73a5c9d720aa66e1$export$60847d42f9da92a6);
$parcel$export($73a5c9d720aa66e1$exports, "R300", () => $73a5c9d720aa66e1$export$4a7404f376229999);
$parcel$export($73a5c9d720aa66e1$exports, "R400", () => $73a5c9d720aa66e1$export$2010d0fb4295b346);
$parcel$export($73a5c9d720aa66e1$exports, "R500", () => $73a5c9d720aa66e1$export$2837b5a1a71d5c02);
$parcel$export($73a5c9d720aa66e1$exports, "Y50", () => $73a5c9d720aa66e1$export$8d9596b529bbb9cf);
$parcel$export($73a5c9d720aa66e1$exports, "Y75", () => $73a5c9d720aa66e1$export$41060a744ab0b7ae);
$parcel$export($73a5c9d720aa66e1$exports, "Y100", () => $73a5c9d720aa66e1$export$1cc05bbbf340e559);
$parcel$export($73a5c9d720aa66e1$exports, "Y200", () => $73a5c9d720aa66e1$export$5aae31392d72caaa);
$parcel$export($73a5c9d720aa66e1$exports, "Y300", () => $73a5c9d720aa66e1$export$c6930421db9fa514);
$parcel$export($73a5c9d720aa66e1$exports, "Y400", () => $73a5c9d720aa66e1$export$59619663aa6500fb);
$parcel$export($73a5c9d720aa66e1$exports, "Y500", () => $73a5c9d720aa66e1$export$874739ea9e379ab6);
$parcel$export($73a5c9d720aa66e1$exports, "G50", () => $73a5c9d720aa66e1$export$8a6341c32b6a3ee6);
$parcel$export($73a5c9d720aa66e1$exports, "G75", () => $73a5c9d720aa66e1$export$69a3bf21b9686c2b);
$parcel$export($73a5c9d720aa66e1$exports, "G100", () => $73a5c9d720aa66e1$export$afbce1382ec95f73);
$parcel$export($73a5c9d720aa66e1$exports, "G200", () => $73a5c9d720aa66e1$export$747d86715d4175de);
$parcel$export($73a5c9d720aa66e1$exports, "G300", () => $73a5c9d720aa66e1$export$940e1f69e873f202);
$parcel$export($73a5c9d720aa66e1$exports, "G400", () => $73a5c9d720aa66e1$export$a49394138f7b8e85);
$parcel$export($73a5c9d720aa66e1$exports, "G500", () => $73a5c9d720aa66e1$export$6fa04827ac68a4fb);
$parcel$export($73a5c9d720aa66e1$exports, "B50", () => $73a5c9d720aa66e1$export$226de0355ed012f8);
$parcel$export($73a5c9d720aa66e1$exports, "B75", () => $73a5c9d720aa66e1$export$8c13c2ee36917869);
$parcel$export($73a5c9d720aa66e1$exports, "B100", () => $73a5c9d720aa66e1$export$ecfc1dff386a3e7a);
$parcel$export($73a5c9d720aa66e1$exports, "B200", () => $73a5c9d720aa66e1$export$215b7063051591f1);
$parcel$export($73a5c9d720aa66e1$exports, "B300", () => $73a5c9d720aa66e1$export$e62e8919cca44969);
$parcel$export($73a5c9d720aa66e1$exports, "B400", () => $73a5c9d720aa66e1$export$b3de0ae08da2ce64);
$parcel$export($73a5c9d720aa66e1$exports, "B500", () => $73a5c9d720aa66e1$export$a6ee3d71bc067634);
$parcel$export($73a5c9d720aa66e1$exports, "P50", () => $73a5c9d720aa66e1$export$363e4475840015bb);
$parcel$export($73a5c9d720aa66e1$exports, "P75", () => $73a5c9d720aa66e1$export$4b0a4417ed59760f);
$parcel$export($73a5c9d720aa66e1$exports, "P100", () => $73a5c9d720aa66e1$export$6011520a64d9a187);
$parcel$export($73a5c9d720aa66e1$exports, "P200", () => $73a5c9d720aa66e1$export$a7175d4e9206bc80);
$parcel$export($73a5c9d720aa66e1$exports, "P300", () => $73a5c9d720aa66e1$export$b48405b95304b5a1);
$parcel$export($73a5c9d720aa66e1$exports, "P400", () => $73a5c9d720aa66e1$export$c71e4279dd54a18d);
$parcel$export($73a5c9d720aa66e1$exports, "P500", () => $73a5c9d720aa66e1$export$147899de772240ec);
$parcel$export($73a5c9d720aa66e1$exports, "T50", () => $73a5c9d720aa66e1$export$2cf711fe14c66f06);
$parcel$export($73a5c9d720aa66e1$exports, "T75", () => $73a5c9d720aa66e1$export$7a8f4d33f6f9772c);
$parcel$export($73a5c9d720aa66e1$exports, "T100", () => $73a5c9d720aa66e1$export$776c9c497ef08533);
$parcel$export($73a5c9d720aa66e1$exports, "T200", () => $73a5c9d720aa66e1$export$69cb3ca10c1e330e);
$parcel$export($73a5c9d720aa66e1$exports, "T300", () => $73a5c9d720aa66e1$export$9dc1ef0f3f48059b);
$parcel$export($73a5c9d720aa66e1$exports, "T400", () => $73a5c9d720aa66e1$export$7c835c78b6fcdef8);
$parcel$export($73a5c9d720aa66e1$exports, "T500", () => $73a5c9d720aa66e1$export$6036577f95c3877e);
$parcel$export($73a5c9d720aa66e1$exports, "N0", () => $73a5c9d720aa66e1$export$29a4f05edc054374);
$parcel$export($73a5c9d720aa66e1$exports, "N10", () => $73a5c9d720aa66e1$export$e655ef011c4aa1a2);
$parcel$export($73a5c9d720aa66e1$exports, "N20", () => $73a5c9d720aa66e1$export$9fdfb749e33cdf97);
$parcel$export($73a5c9d720aa66e1$exports, "N30", () => $73a5c9d720aa66e1$export$3e51e8f1440314ba);
$parcel$export($73a5c9d720aa66e1$exports, "N40", () => $73a5c9d720aa66e1$export$1ce2d1575d444ceb);
$parcel$export($73a5c9d720aa66e1$exports, "N50", () => $73a5c9d720aa66e1$export$8754fc7e6d8b3000);
$parcel$export($73a5c9d720aa66e1$exports, "N60", () => $73a5c9d720aa66e1$export$c2e91cbeada39b8b);
$parcel$export($73a5c9d720aa66e1$exports, "N70", () => $73a5c9d720aa66e1$export$5f71e19f3a7ad9de);
$parcel$export($73a5c9d720aa66e1$exports, "N80", () => $73a5c9d720aa66e1$export$eaa8c8a70ac22806);
$parcel$export($73a5c9d720aa66e1$exports, "N90", () => $73a5c9d720aa66e1$export$7c87d337fb91a97d);
$parcel$export($73a5c9d720aa66e1$exports, "N100", () => $73a5c9d720aa66e1$export$d6447c357493214f);
$parcel$export($73a5c9d720aa66e1$exports, "N200", () => $73a5c9d720aa66e1$export$f563ee71e9ee74cd);
$parcel$export($73a5c9d720aa66e1$exports, "N300", () => $73a5c9d720aa66e1$export$e2ef2124cf4024b1);
$parcel$export($73a5c9d720aa66e1$exports, "N400", () => $73a5c9d720aa66e1$export$eece5f492e429f08);
$parcel$export($73a5c9d720aa66e1$exports, "N500", () => $73a5c9d720aa66e1$export$c39c0fe0f26207ae);
$parcel$export($73a5c9d720aa66e1$exports, "N600", () => $73a5c9d720aa66e1$export$7090862dc3038a9f);
$parcel$export($73a5c9d720aa66e1$exports, "N700", () => $73a5c9d720aa66e1$export$ad0bacf983b7ddaa);
$parcel$export($73a5c9d720aa66e1$exports, "N800", () => $73a5c9d720aa66e1$export$7d61b15e0da132af);
$parcel$export($73a5c9d720aa66e1$exports, "N900", () => $73a5c9d720aa66e1$export$fbda843f0a27fe96);
$parcel$export($73a5c9d720aa66e1$exports, "N10A", () => $73a5c9d720aa66e1$export$791e57b27ca738ef);
$parcel$export($73a5c9d720aa66e1$exports, "N20A", () => $73a5c9d720aa66e1$export$8d43898f60b96a82);
$parcel$export($73a5c9d720aa66e1$exports, "N30A", () => $73a5c9d720aa66e1$export$920c0d5c49070351);
$parcel$export($73a5c9d720aa66e1$exports, "N40A", () => $73a5c9d720aa66e1$export$46987b49aab6d1a8);
$parcel$export($73a5c9d720aa66e1$exports, "N50A", () => $73a5c9d720aa66e1$export$7d3359664e8bb0e5);
$parcel$export($73a5c9d720aa66e1$exports, "N60A", () => $73a5c9d720aa66e1$export$d2d3bedfb276cac0);
$parcel$export($73a5c9d720aa66e1$exports, "N70A", () => $73a5c9d720aa66e1$export$6e5e7499ff054f6d);
$parcel$export($73a5c9d720aa66e1$exports, "N80A", () => $73a5c9d720aa66e1$export$59264b346c877fa7);
$parcel$export($73a5c9d720aa66e1$exports, "N90A", () => $73a5c9d720aa66e1$export$d092757d7c64925c);
$parcel$export($73a5c9d720aa66e1$exports, "N100A", () => $73a5c9d720aa66e1$export$486ab785e4bac3c6);
$parcel$export($73a5c9d720aa66e1$exports, "N200A", () => $73a5c9d720aa66e1$export$fba592bbc6419fea);
$parcel$export($73a5c9d720aa66e1$exports, "N300A", () => $73a5c9d720aa66e1$export$13609db0e6812ab8);
$parcel$export($73a5c9d720aa66e1$exports, "N400A", () => $73a5c9d720aa66e1$export$fbae4efaa892d883);
$parcel$export($73a5c9d720aa66e1$exports, "N500A", () => $73a5c9d720aa66e1$export$f13946d26f440ce6);
$parcel$export($73a5c9d720aa66e1$exports, "N600A", () => $73a5c9d720aa66e1$export$19f58225ac52a306);
$parcel$export($73a5c9d720aa66e1$exports, "N700A", () => $73a5c9d720aa66e1$export$6384f09da70e7b62);
$parcel$export($73a5c9d720aa66e1$exports, "N800A", () => $73a5c9d720aa66e1$export$d0dccc730683edc2);
$parcel$export($73a5c9d720aa66e1$exports, "DN900", () => $73a5c9d720aa66e1$export$2f6319cf7d736c2a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800", () => $73a5c9d720aa66e1$export$95126bc8884d6634);
$parcel$export($73a5c9d720aa66e1$exports, "DN700", () => $73a5c9d720aa66e1$export$8338d8c35d44ff1);
$parcel$export($73a5c9d720aa66e1$exports, "DN600", () => $73a5c9d720aa66e1$export$5368d76ae4fbbda7);
$parcel$export($73a5c9d720aa66e1$exports, "DN500", () => $73a5c9d720aa66e1$export$9f0a771d16ec8d36);
$parcel$export($73a5c9d720aa66e1$exports, "DN400", () => $73a5c9d720aa66e1$export$abcf8c38338b4aa5);
$parcel$export($73a5c9d720aa66e1$exports, "DN300", () => $73a5c9d720aa66e1$export$97e81faa16a182c7);
$parcel$export($73a5c9d720aa66e1$exports, "DN200", () => $73a5c9d720aa66e1$export$bfe21c59123ecf33);
$parcel$export($73a5c9d720aa66e1$exports, "DN100", () => $73a5c9d720aa66e1$export$ee82aa2ea6a1558);
$parcel$export($73a5c9d720aa66e1$exports, "DN90", () => $73a5c9d720aa66e1$export$682927c6ed76be02);
$parcel$export($73a5c9d720aa66e1$exports, "DN80", () => $73a5c9d720aa66e1$export$91fd9994c5be9757);
$parcel$export($73a5c9d720aa66e1$exports, "DN70", () => $73a5c9d720aa66e1$export$d281fbfe3cff2df6);
$parcel$export($73a5c9d720aa66e1$exports, "DN60", () => $73a5c9d720aa66e1$export$3902c91d8b98a753);
$parcel$export($73a5c9d720aa66e1$exports, "DN50", () => $73a5c9d720aa66e1$export$8e8133c1ba5845b5);
$parcel$export($73a5c9d720aa66e1$exports, "DN40", () => $73a5c9d720aa66e1$export$33ff357f6620b39);
$parcel$export($73a5c9d720aa66e1$exports, "DN30", () => $73a5c9d720aa66e1$export$633847cf062b69e0);
$parcel$export($73a5c9d720aa66e1$exports, "DN20", () => $73a5c9d720aa66e1$export$9776a6e503bdbf76);
$parcel$export($73a5c9d720aa66e1$exports, "DN10", () => $73a5c9d720aa66e1$export$6c813d5160dff5db);
$parcel$export($73a5c9d720aa66e1$exports, "DN0", () => $73a5c9d720aa66e1$export$3d4f271a500072a);
$parcel$export($73a5c9d720aa66e1$exports, "DN800A", () => $73a5c9d720aa66e1$export$fe151285c22759ec);
$parcel$export($73a5c9d720aa66e1$exports, "DN700A", () => $73a5c9d720aa66e1$export$a101c6190d0da34);
$parcel$export($73a5c9d720aa66e1$exports, "DN600A", () => $73a5c9d720aa66e1$export$4b16f52932fda51);
$parcel$export($73a5c9d720aa66e1$exports, "DN500A", () => $73a5c9d720aa66e1$export$a74bcd7b9845b0d8);
$parcel$export($73a5c9d720aa66e1$exports, "DN400A", () => $73a5c9d720aa66e1$export$9209c179316d1751);
$parcel$export($73a5c9d720aa66e1$exports, "DN300A", () => $73a5c9d720aa66e1$export$88f55133f636c8dd);
$parcel$export($73a5c9d720aa66e1$exports, "DN200A", () => $73a5c9d720aa66e1$export$51126f85d1009512);
$parcel$export($73a5c9d720aa66e1$exports, "DN100A", () => $73a5c9d720aa66e1$export$a069b547bd23af78);
$parcel$export($73a5c9d720aa66e1$exports, "DN90A", () => $73a5c9d720aa66e1$export$40cce05af3b2600a);
$parcel$export($73a5c9d720aa66e1$exports, "DN80A", () => $73a5c9d720aa66e1$export$b78942185925a0d);
$parcel$export($73a5c9d720aa66e1$exports, "DN70A", () => $73a5c9d720aa66e1$export$e058fb44b8eaafca);
$parcel$export($73a5c9d720aa66e1$exports, "DN60A", () => $73a5c9d720aa66e1$export$92b0b8de26920c18);
$parcel$export($73a5c9d720aa66e1$exports, "DN50A", () => $73a5c9d720aa66e1$export$67564f7459d3fc9e);
$parcel$export($73a5c9d720aa66e1$exports, "DN40A", () => $73a5c9d720aa66e1$export$77868e1ca884ffa3);
$parcel$export($73a5c9d720aa66e1$exports, "DN30A", () => $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5);
$parcel$export($73a5c9d720aa66e1$exports, "DN20A", () => $73a5c9d720aa66e1$export$f2a0acaab9972c70);
$parcel$export($73a5c9d720aa66e1$exports, "DN10A", () => $73a5c9d720aa66e1$export$9ab70e67d6475361);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $73a5c9d720aa66e1$export$4b84fd0e2c617bd = '#FFEBE6';
const $73a5c9d720aa66e1$export$b34b069eff244586 = '#FFBDAD';
const $73a5c9d720aa66e1$export$be802dd0d8b57f35 = '#FF8F73';
const $73a5c9d720aa66e1$export$60847d42f9da92a6 = '#FF7452';
const $73a5c9d720aa66e1$export$4a7404f376229999 = '#FF5630';
const $73a5c9d720aa66e1$export$2010d0fb4295b346 = '#DE350B';
const $73a5c9d720aa66e1$export$2837b5a1a71d5c02 = '#BF2600';
const $73a5c9d720aa66e1$export$8d9596b529bbb9cf = '#FFFAE6';
const $73a5c9d720aa66e1$export$41060a744ab0b7ae = '#FFF0B3';
const $73a5c9d720aa66e1$export$1cc05bbbf340e559 = '#FFE380';
const $73a5c9d720aa66e1$export$5aae31392d72caaa = '#FFC400';
const $73a5c9d720aa66e1$export$c6930421db9fa514 = '#FFAB00';
const $73a5c9d720aa66e1$export$59619663aa6500fb = '#FF991F';
const $73a5c9d720aa66e1$export$874739ea9e379ab6 = '#FF8B00';
const $73a5c9d720aa66e1$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $73a5c9d720aa66e1$export$69a3bf21b9686c2b = '#ABF5D1';
const $73a5c9d720aa66e1$export$afbce1382ec95f73 = '#79F2C0';
const $73a5c9d720aa66e1$export$747d86715d4175de = '#57D9A3';
const $73a5c9d720aa66e1$export$940e1f69e873f202 = '#36B37E';
const $73a5c9d720aa66e1$export$a49394138f7b8e85 = '#00875A';
const $73a5c9d720aa66e1$export$6fa04827ac68a4fb = '#006644';
const $73a5c9d720aa66e1$export$226de0355ed012f8 = '#DEEBFF';
const $73a5c9d720aa66e1$export$8c13c2ee36917869 = '#B3D4FF';
const $73a5c9d720aa66e1$export$ecfc1dff386a3e7a = '#4C9AFF';
const $73a5c9d720aa66e1$export$215b7063051591f1 = '#2684FF';
const $73a5c9d720aa66e1$export$e62e8919cca44969 = '#0065FF';
const $73a5c9d720aa66e1$export$b3de0ae08da2ce64 = '#0052CC';
const $73a5c9d720aa66e1$export$a6ee3d71bc067634 = '#0747A6';
const $73a5c9d720aa66e1$export$363e4475840015bb = '#EAE6FF';
const $73a5c9d720aa66e1$export$4b0a4417ed59760f = '#C0B6F2';
const $73a5c9d720aa66e1$export$6011520a64d9a187 = '#998DD9';
const $73a5c9d720aa66e1$export$a7175d4e9206bc80 = '#8777D9';
const $73a5c9d720aa66e1$export$b48405b95304b5a1 = '#6554C0';
const $73a5c9d720aa66e1$export$c71e4279dd54a18d = '#5243AA';
const $73a5c9d720aa66e1$export$147899de772240ec = '#403294';
const $73a5c9d720aa66e1$export$2cf711fe14c66f06 = '#E6FCFF';
const $73a5c9d720aa66e1$export$7a8f4d33f6f9772c = '#B3F5FF';
const $73a5c9d720aa66e1$export$776c9c497ef08533 = '#79E2F2';
const $73a5c9d720aa66e1$export$69cb3ca10c1e330e = '#00C7E6';
const $73a5c9d720aa66e1$export$9dc1ef0f3f48059b = '#00B8D9';
const $73a5c9d720aa66e1$export$7c835c78b6fcdef8 = '#00A3BF';
const $73a5c9d720aa66e1$export$6036577f95c3877e = '#008DA6';
const $73a5c9d720aa66e1$export$29a4f05edc054374 = '#FFFFFF';
const $73a5c9d720aa66e1$export$e655ef011c4aa1a2 = '#FAFBFC';
const $73a5c9d720aa66e1$export$9fdfb749e33cdf97 = '#F4F5F7';
const $73a5c9d720aa66e1$export$3e51e8f1440314ba = '#EBECF0';
const $73a5c9d720aa66e1$export$1ce2d1575d444ceb = '#DFE1E6';
const $73a5c9d720aa66e1$export$8754fc7e6d8b3000 = '#C1C7D0';
const $73a5c9d720aa66e1$export$c2e91cbeada39b8b = '#B3BAC5';
const $73a5c9d720aa66e1$export$5f71e19f3a7ad9de = '#A5ADBA';
const $73a5c9d720aa66e1$export$eaa8c8a70ac22806 = '#97A0AF';
const $73a5c9d720aa66e1$export$7c87d337fb91a97d = '#8993A4';
const $73a5c9d720aa66e1$export$d6447c357493214f = '#7A869A';
const $73a5c9d720aa66e1$export$f563ee71e9ee74cd = '#6B778C';
const $73a5c9d720aa66e1$export$e2ef2124cf4024b1 = '#5E6C84';
const $73a5c9d720aa66e1$export$eece5f492e429f08 = '#505F79';
const $73a5c9d720aa66e1$export$c39c0fe0f26207ae = '#42526E';
const $73a5c9d720aa66e1$export$7090862dc3038a9f = '#344563';
const $73a5c9d720aa66e1$export$ad0bacf983b7ddaa = '#253858';
const $73a5c9d720aa66e1$export$7d61b15e0da132af = '#172B4D';
const $73a5c9d720aa66e1$export$fbda843f0a27fe96 = '#091E42';
const $73a5c9d720aa66e1$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $73a5c9d720aa66e1$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $73a5c9d720aa66e1$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $73a5c9d720aa66e1$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $73a5c9d720aa66e1$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $73a5c9d720aa66e1$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $73a5c9d720aa66e1$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $73a5c9d720aa66e1$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $73a5c9d720aa66e1$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $73a5c9d720aa66e1$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $73a5c9d720aa66e1$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $73a5c9d720aa66e1$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $73a5c9d720aa66e1$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $73a5c9d720aa66e1$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $73a5c9d720aa66e1$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $73a5c9d720aa66e1$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $73a5c9d720aa66e1$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $73a5c9d720aa66e1$export$2f6319cf7d736c2a = '#E6EDFA';
const $73a5c9d720aa66e1$export$95126bc8884d6634 = '#DCE5F5';
const $73a5c9d720aa66e1$export$8338d8c35d44ff1 = '#CED9EB';
const $73a5c9d720aa66e1$export$5368d76ae4fbbda7 = '#B8C7E0';
const $73a5c9d720aa66e1$export$9f0a771d16ec8d36 = '#ABBBD6';
const $73a5c9d720aa66e1$export$abcf8c38338b4aa5 = '#9FB0CC';
const $73a5c9d720aa66e1$export$97e81faa16a182c7 = '#8C9CB8';
const $73a5c9d720aa66e1$export$bfe21c59123ecf33 = '#7988A3';
const $73a5c9d720aa66e1$export$ee82aa2ea6a1558 = '#67758F';
const $73a5c9d720aa66e1$export$682927c6ed76be02 = '#56637A';
const $73a5c9d720aa66e1$export$91fd9994c5be9757 = '#455166';
const $73a5c9d720aa66e1$export$d281fbfe3cff2df6 = '#3B475C';
const $73a5c9d720aa66e1$export$3902c91d8b98a753 = '#313D52';
const $73a5c9d720aa66e1$export$8e8133c1ba5845b5 = '#283447';
const $73a5c9d720aa66e1$export$33ff357f6620b39 = '#202B3D';
const $73a5c9d720aa66e1$export$633847cf062b69e0 = '#1B2638';
const $73a5c9d720aa66e1$export$9776a6e503bdbf76 = '#121A29';
const $73a5c9d720aa66e1$export$6c813d5160dff5db = '#0E1624';
const $73a5c9d720aa66e1$export$3d4f271a500072a = '#0D1424';
const $73a5c9d720aa66e1$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $73a5c9d720aa66e1$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $73a5c9d720aa66e1$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $73a5c9d720aa66e1$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $73a5c9d720aa66e1$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $73a5c9d720aa66e1$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $73a5c9d720aa66e1$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $73a5c9d720aa66e1$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $73a5c9d720aa66e1$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $73a5c9d720aa66e1$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $73a5c9d720aa66e1$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $73a5c9d720aa66e1$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $73a5c9d720aa66e1$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $73a5c9d720aa66e1$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $73a5c9d720aa66e1$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $73a5c9d720aa66e1$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $73a5c9d720aa66e1$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';

parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $ki32l = parcelRequire("ki32l");

var $hnob3 = parcelRequire("hnob3");

var $fbOgz = parcelRequire("fbOgz");

var $2wLr6 = parcelRequire("2wLr6");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4d3122f1d9f9fa05$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const legacyIconSize = $4d3122f1d9f9fa05$var$iconSizeMap[size];
    const labelId = (0, $ki32l.useId)();
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: labelId,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? labelId : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: !shouldChecked,
        position: "left"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hnob3))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-check-icon`
    })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2wLr6.default), {
        size: size,
        isHidden: shouldChecked,
        position: "right"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fbOgz))), {
        label: "",
        color: "currentColor",
        LEGACY_size: legacyIconSize,
        testId: testId && `${testId}--toggle-cross-icon`
    }))));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("hnob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::116024720ac5bfd6b5d0b476c677b799>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca6756bf734aa598$var$_react = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ca6756bf734aa598$var$_checkMark = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("7RK9I")));

var $ca6756bf734aa598$var$_done = $ca6756bf734aa598$var$_interopRequireDefault((parcelRequire("k9Z3M")));
function $ca6756bf734aa598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca6756bf734aa598$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ca6756bf734aa598$var$_react.default.createElement($ca6756bf734aa598$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ca6756bf734aa598$var$_done.default
    }, props));
$ca6756bf734aa598$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ca6756bf734aa598$var$_default = module.exports.default = $ca6756bf734aa598$var$CheckMarkIcon;

});
parcelRegister("7RK9I", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d905e7dc6c2480f22f2a9081c36a5712>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5ba14938eb17fe40$var$_react = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5ba14938eb17fe40$var$_UNSAFE_baseNew = $5ba14938eb17fe40$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $5ba14938eb17fe40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5ba14938eb17fe40$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5ba14938eb17fe40$var$_react.default.createElement($5ba14938eb17fe40$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 6 2.75 3.5 6.25-7"/>`,
        type: 'utility'
    }, props));
$5ba14938eb17fe40$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $5ba14938eb17fe40$var$_default = module.exports.default = $5ba14938eb17fe40$var$CheckMarkIcon;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $ead4032469749d51$var$_checkMark = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("j52dF")));
function $ead4032469749d51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $ead4032469749d51$var$_checkMark.default
    }));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = module.exports.default = $ead4032469749d51$var$EditorDoneIcon;

});
parcelRegister("j52dF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $de4034a95f8a9e06$var$_react = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $de4034a95f8a9e06$var$_UNSAFE_baseNew = $de4034a95f8a9e06$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $de4034a95f8a9e06$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $de4034a95f8a9e06$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $de4034a95f8a9e06$var$_react.default.createElement($de4034a95f8a9e06$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$de4034a95f8a9e06$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $de4034a95f8a9e06$var$_default = module.exports.default = $de4034a95f8a9e06$var$CheckMarkIcon;

});



parcelRegister("fbOgz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0eedfeb10f4bac1$var$_react = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b0eedfeb10f4bac1$var$_cross = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("adUQx")));

var $b0eedfeb10f4bac1$var$_close = $b0eedfeb10f4bac1$var$_interopRequireDefault((parcelRequire("je5kZ")));
function $b0eedfeb10f4bac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0eedfeb10f4bac1$var$CrossIcon = (props)=>/*#__PURE__*/ $b0eedfeb10f4bac1$var$_react.default.createElement($b0eedfeb10f4bac1$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $b0eedfeb10f4bac1$var$_close.default
    }, props));
$b0eedfeb10f4bac1$var$CrossIcon.Name = 'CrossIconMigration';
var $b0eedfeb10f4bac1$var$_default = module.exports.default = $b0eedfeb10f4bac1$var$CrossIcon;

});
parcelRegister("adUQx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $771736c5909ba4b4$var$_react = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $771736c5909ba4b4$var$_UNSAFE_baseNew = $771736c5909ba4b4$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $771736c5909ba4b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $771736c5909ba4b4$var$CrossIcon = (props)=>/*#__PURE__*/ $771736c5909ba4b4$var$_react.default.createElement($771736c5909ba4b4$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$771736c5909ba4b4$var$CrossIcon.displayName = 'CrossIcon';
var $771736c5909ba4b4$var$_default = module.exports.default = $771736c5909ba4b4$var$CrossIcon;

});

parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $dff3771012ed2785$var$_close = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("02Sz7")));
function $dff3771012ed2785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $dff3771012ed2785$var$_close.default
    }));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = module.exports.default = $dff3771012ed2785$var$EditorCloseIcon;

});


parcelRegister("2wLr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3035e6738b21544f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $3035e6738b21544f$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'opacity 0.2s ease',
    position: 'absolute',
    insetBlockStart: 'space.025'
});
const $3035e6738b21544f$var$iconContainerRegularStyles = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px'
});
const $3035e6738b21544f$var$iconContainerLargeStyles = (0, $1ZAYh.xcss)({
    width: '20px',
    height: '20px'
});
const $3035e6738b21544f$var$hiddenStyles = (0, $1ZAYh.xcss)({
    opacity: 0
});
const $3035e6738b21544f$var$leftStyles = (0, $1ZAYh.xcss)({
    insetInlineStart: '3px'
});
const $3035e6738b21544f$var$rightStyles = (0, $1ZAYh.xcss)({
    insetInlineEnd: '3px'
});
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $3035e6738b21544f$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: [
            $3035e6738b21544f$var$iconContainerStyles,
            isHidden && (0, $XHGTv.fg)('platform-visual-refresh-icons') && $3035e6738b21544f$var$hiddenStyles,
            size === 'regular' && $3035e6738b21544f$var$iconContainerRegularStyles,
            size === 'large' && $3035e6738b21544f$var$iconContainerLargeStyles,
            position === 'left' && $3035e6738b21544f$var$leftStyles,
            position === 'right' && $3035e6738b21544f$var$rightStyles
        ]
    }, children);
};
var $3035e6738b21544f$export$2e2bcd8739ae039 = $3035e6738b21544f$var$IconContainer;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // Remove during new icon flag cleanup. This is required to maintain the size of legacy icons.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        !(0, $XHGTv.fg)('platform-visual-refresh-icons') && {
            '> span > span': {
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$a49394138f7b8e85)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $73a5c9d720aa66e1$export$6fa04827ac68a4fb)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $73a5c9d720aa66e1$export$eece5f492e429f08)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});




parcelRegister("eS0xg", function(module, exports) {

$parcel$export(module.exports, "ModalTitleContainer", () => $ad36862a5c0c0206$export$8bbe98d958a85a9d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");
const $ad36862a5c0c0206$export$8bbe98d958a85a9d = (0, $exJuA.default).span({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'h1, h1 > span': {
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1
    }
});

});




parcelRegister("3wply", function(module, exports) {

$parcel$export(module.exports, "LiveErrorUtils", () => $2908058dcbcaf4bf$export$f2a509cffb92cb9c);
/* eslint-disable no-console */ 
var $eUqFw = parcelRequire("eUqFw");

var $lqM6q = parcelRequire("lqM6q");
var $OArqR = parcelRequire("OArqR");
var $i1gqQ = parcelRequire("i1gqQ");

var $8uD7Y = parcelRequire("8uD7Y");

var $96IgR = parcelRequire("96IgR");


var $gWxA1 = parcelRequire("gWxA1");

var $dfBCt = parcelRequire("dfBCt");

var $dt0h6 = parcelRequire("dt0h6");

var $7xF7k = parcelRequire("7xF7k");

var $hDku9 = parcelRequire("hDku9");

var $f9abZ = parcelRequire("f9abZ");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $2908058dcbcaf4bf$var$TAGS = [
    'module',
    'actionSubject',
    'url'
];
// From https://sentry.io/settings/atlassian-2y/projects/proforma/keys/
const $2908058dcbcaf4bf$var$SENTRY_PUBLIC_KEY = 'c6ac6cc7ef554e3286ec09d412c9c1f4';
const $2908058dcbcaf4bf$var$SENTRY_PROJECT_ID = '6388218';
const $2908058dcbcaf4bf$var$SENTRY_COMMERCIAL_DSN = `https://${$2908058dcbcaf4bf$var$SENTRY_PUBLIC_KEY}@o55978.ingest.sentry.io/${$2908058dcbcaf4bf$var$SENTRY_PROJECT_ID}`;
const $2908058dcbcaf4bf$var$SENTRY_FEDRAMP_DSN = `https://${$2908058dcbcaf4bf$var$SENTRY_PUBLIC_KEY}@sentry.atlassian-us-gov-mod.com/${$2908058dcbcaf4bf$var$SENTRY_PROJECT_ID}`;
const $2908058dcbcaf4bf$var$PROFORMA_SENTRY_PROJECT_DSN = (0, $dfBCt.isFedRamp)() ? $2908058dcbcaf4bf$var$SENTRY_FEDRAMP_DSN : $2908058dcbcaf4bf$var$SENTRY_COMMERCIAL_DSN;
class $2908058dcbcaf4bf$export$f2a509cffb92cb9c {
    constructor(moduleName, showFlag, createAnalyticsEvent, environment){
        this.moduleName = void 0;
        this.showFlag = void 0;
        this.createAnalyticsEvent = void 0;
        this.sentryHub = void 0;
        this.environment = void 0;
        this.moduleName = moduleName;
        this.showFlag = showFlag;
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.environment = environment;
        this.sentryHub = this.getSentryHub(environment);
    }
    reportError(error, options) {
        var _options$actionSubjec;
        const errorPrefix = `Proforma(${this.moduleName}): `;
        const severity = options !== null && options !== void 0 && options.severity ? options.severity : (0, $i1gqQ.Severity).Error;
        // 1) Log error in console
        switch(severity){
            case (0, $i1gqQ.Severity).Warning:
                console.warn(errorPrefix, error);
                break;
            case (0, $i1gqQ.Severity).Info:
                console.info(errorPrefix, error);
                break;
            default:
                console.error(errorPrefix, error);
                break;
        }
        const actionSubject = (_options$actionSubjec = options === null || options === void 0 ? void 0 : options.actionSubject) !== null && _options$actionSubjec !== void 0 ? _options$actionSubjec : (0, $7xF7k.ActionSubject).PROFORMA_UI;
        const attributes = (options === null || options === void 0 ? void 0 : options.attributes) && Object.fromEntries(Object.entries(options.attributes).map(([key, value])=>[
                key,
                typeof value === 'string' ? (0, $dt0h6.maskEmailIds)(value) : value
            ]));
        // Todo: add user agent, package version, url,
        const details = {
            actionSubject: actionSubject,
            errorId: options === null || options === void 0 ? void 0 : options.id,
            severity: severity,
            module: this.moduleName,
            errorMsg: error.message,
            errorInfo: options === null || options === void 0 ? void 0 : options.errorInfo,
            isClientFetchError: error.isClientFetchError,
            requestName: error.requestName,
            traceId: error.traceId,
            status: error.status,
            userAgent: this.getBrowserUserAgent(),
            url: this.getUrl(),
            ...attributes
        };
        // 2) Send error to Atlassian analytics pipeline (GasV3)
        (0, $gWxA1.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $7xF7k.Action).FAILED}`, details);
        // 3) Send error to Sentry
        if (this.environment === (0, $f9abZ.Environment).LOCAL || this.sentryHub === undefined) return;
        const sentryHub = this.sentryHub;
        sentryHub.withScope((scope)=>{
            scope.setLevel(severity);
            Object.keys(details).forEach((key)=>{
                const value = details[key];
                if (value) {
                    if ($2908058dcbcaf4bf$var$TAGS.includes(key)) scope.setTag(key, value.toString());
                    else scope.setExtra(key, value);
                }
            });
            sentryHub.captureException(error);
        });
    }
    /**
   * @private
   * @deprecated notifyUser has been deprecated. Please use the `useFlags()` hook directly instead.
   */ notifyUser(errorNotice, customDescription) {
        const notice = (0, $hDku9.Notices)[errorNotice];
        if (notice) {
            this.showFlag({
                appearance: 'error',
                isAutoDismiss: true,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                    label: "",
                    primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), notice.title),
                description: customDescription ? customDescription : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), notice.message)
            });
            return Promise.resolve();
        } else {
            console.error(`Could not show error, notice type ${errorNotice} does not exist`);
            return Promise.reject();
        }
    }
    getSentryHub(environment) {
        try {
            const client = new (0, $lqM6q.BrowserClient)({
                environment: environment,
                dsn: $2908058dcbcaf4bf$var$PROFORMA_SENTRY_PROJECT_DSN
            });
            return new (0, $OArqR.Hub)(client);
        } catch (error) {
            const actionSubject = 'getProformaSentryHub';
            const details = {
                actionSubject: actionSubject,
                severity: (0, $i1gqQ.Severity).Error,
                module: this.moduleName,
                errorMsg: error.message,
                userAgent: this.getBrowserUserAgent(),
                url: this.getUrl()
            };
            (0, $gWxA1.fireOperationalAnalytics)(this.createAnalyticsEvent({}), `${actionSubject} ${(0, $7xF7k.Action).FAILED}`, details);
        }
    }
    getBrowserUserAgent() {
        var _window$navigator$use, _window, _window$navigator;
        return (_window$navigator$use = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent) !== null && _window$navigator$use !== void 0 ? _window$navigator$use : 'unknown';
    }
    getUrl() {
        var _window$document$loca, _window2, _window2$document, _window2$document$loc;
        return (_window$document$loca = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$document = _window2.document) === null || _window2$document === void 0 ? void 0 : (_window2$document$loc = _window2$document.location) === null || _window2$document$loc === void 0 ? void 0 : _window2$document$loc.host) !== null && _window$document$loca !== void 0 ? _window$document$loca : 'unknown';
    }
}

});
parcelRegister("lqM6q", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", () => $f9a156de744deb5e$export$1df9218a526d318d);

var $fKE23 = parcelRequire("fKE23");

var $ciwRK = parcelRequire("ciwRK");
var $5NSnG = parcelRequire("5NSnG");
parcelRequire("RA7oj");
var $elIfN = parcelRequire("elIfN");
var $iACIJ = parcelRequire("iACIJ");

var $4BUI5 = parcelRequire("4BUI5");

var $f9zWM = parcelRequire("f9zWM");

var $ig9bH = parcelRequire("ig9bH");

var $fw28U = parcelRequire("fw28U");
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $f9a156de744deb5e$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $fKE23.__extends)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: (0, $5NSnG.SDK_VERSION)
                }
            ],
            version: (0, $5NSnG.SDK_VERSION)
        };
        _this = _super.call(this, (0, $4BUI5.BrowserBackend), options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $elIfN.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        (0, $ig9bH.injectReportDialog)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $fw28U.Breadcrumbs));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $ciwRK.BaseClient));

});
parcelRegister("ciwRK", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $8f40a8fbca33811c$export$4f22f74eddb7716a);

var $fKE23 = parcelRequire("fKE23");

var $87JfJ = parcelRequire("87JfJ");
parcelRequire("RA7oj");
var $d6buR = parcelRequire("d6buR");
var $kVqeH = parcelRequire("kVqeH");
var $hiXkV = parcelRequire("hiXkV");
var $iACIJ = parcelRequire("iACIJ");
var $6Hxbo = parcelRequire("6Hxbo");
var $2PLr7 = parcelRequire("2PLr7");
var $5PjAl = parcelRequire("5PjAl");
var $XSd2U = parcelRequire("XSd2U");
var $X8Ykq = parcelRequire("X8Ykq");

var $tP6AM = parcelRequire("tP6AM");

var $c1oMD = parcelRequire("c1oMD");
var $8f40a8fbca33811c$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $8f40a8fbca33811c$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of calls being processed */ this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = (0, $6Hxbo.makeDsn)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if ((0, $d6buR.checkOrSetAlreadyCaught)(exception)) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).log($8f40a8fbca33811c$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $hiXkV.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $d6buR.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).log($8f40a8fbca33811c$var$ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!this._isEnabled()) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('Discarded session because of missing or non-string release');
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({
                init: false
            });
        }
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getTransport = function() {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
            return _this.getTransport().close(timeout).then(function(transportFlushed) {
                return clientFinished && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled() && !this._integrations.initialized) this._integrations = (0, $c1oMD.setupIntegrations)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $fKE23.__values)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            session.update((0, $fKE23.__assign)((0, $fKE23.__assign)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */ BaseClient.prototype._isClientDoneProcessing = function(timeout) {
        var _this = this;
        return new (0, $5PjAl.SyncPromise)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $d6buR.uuid4)()),
            timestamp: event.timestamp || (0, $kVqeH.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $87JfJ.Scope).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $5PjAl.resolvedSyncPromise)(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (evt) // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
            // it is only attached as extra data to the event if the event somehow skips being normalized
            evt.sdkProcessingMetadata = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, evt.sdkProcessingMetadata), {
                normalizeDepth: (0, $2PLr7.normalize)(normalizeDepth) + " (" + typeof normalizeDepth + ")"
            });
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth, maxBreadth) {
        if (!event) return null;
        var normalized = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, b), b.data && {
                    data: (0, $2PLr7.normalize)(b.data, depth, maxBreadth)
                });
            })
        }), event.user && {
            user: (0, $2PLr7.normalize)(event.user, depth, maxBreadth)
        }), event.contexts && {
            contexts: (0, $2PLr7.normalize)(event.contexts, depth, maxBreadth)
        }), event.extra && {
            extra: (0, $2PLr7.normalize)(event.extra, depth, maxBreadth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        normalized.sdkProcessingMetadata = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, normalized.sdkProcessingMetadata), {
            baseClientNormalized: true
        });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) event.environment = 'environment' in options ? environment : 'production';
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $X8Ykq.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $X8Ykq.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $X8Ykq.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0, $fKE23.__spread)(event.sdk.integrations || [], integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) transport.recordLostEvent(outcome, category);
        }
        if (!this._isEnabled()) return (0, $5PjAl.rejectedSyncPromise)(new (0, $XSd2U.SentryError)('SDK not enabled, will not capture event.'));
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return (0, $5PjAl.rejectedSyncPromise)(new (0, $XSd2U.SentryError)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new (0, $XSd2U.SentryError)('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            return $8f40a8fbca33811c$var$_ensureBeforeSendRv(beforeSendResult);
        }).then(function(processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new (0, $XSd2U.SentryError)('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $XSd2U.SentryError)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $XSd2U.SentryError)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._numProcessing += 1;
        promise.then(function(value) {
            _this._numProcessing -= 1;
            return value;
        }, function(reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */ function $8f40a8fbca33811c$var$_ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if ((0, $hiXkV.isThenable)(rv)) return rv.then(function(event) {
        if (!((0, $hiXkV.isPlainObject)(event) || event === null)) throw new (0, $XSd2U.SentryError)(nullErr);
        return event;
    }, function(e) {
        throw new (0, $XSd2U.SentryError)("beforeSend rejected with " + e);
    });
    else if (!((0, $hiXkV.isPlainObject)(rv) || rv === null)) throw new (0, $XSd2U.SentryError)(nullErr);
    return rv;
}

});
parcelRegister("87JfJ", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $5ea2146d67bf681a$export$775b6bb06e53a214);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $5ea2146d67bf681a$export$8e4e25f54d456511);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4rc7U");
var $kVqeH = parcelRequire("kVqeH");
var $elIfN = parcelRequire("elIfN");
var $hiXkV = parcelRequire("hiXkV");
var $5PjAl = parcelRequire("5PjAl");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $5ea2146d67bf681a$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $5ea2146d67bf681a$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $fKE23.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $fKE23.__assign)({}, scope._tags);
            newScope._extra = (0, $fKE23.__assign)({}, scope._extra);
            newScope._contexts = (0, $fKE23.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $fKE23.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $hiXkV.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, $5ea2146d67bf681a$var$MAX_BREADCRUMBS) : $5ea2146d67bf681a$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $fKE23.__assign)({
            timestamp: (0, $kVqeH.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $fKE23.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $fKE23.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $fKE23.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $fKE23.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $fKE23.__spread)($5ea2146d67bf681a$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $5PjAl.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                var result = processor((0, $fKE23.__assign)({}, event), hint);
                if ((0, $hiXkV.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $5ea2146d67bf681a$var$getGlobalEventProcessors() {
    return (0, $elIfN.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
function $5ea2146d67bf681a$export$8e4e25f54d456511(callback) {
    $5ea2146d67bf681a$var$getGlobalEventProcessors().push(callback);
}

});
parcelRegister("4rc7U", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("elIfN")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("elIfN")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("hiXkV")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("hiXkV")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("iACIJ")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("iACIJ")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("d6buR")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("8Ydiu")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("5PjAl")).SyncPromise);





parcelRequire("elIfN");

parcelRequire("hiXkV");
parcelRequire("iACIJ");

parcelRequire("d6buR");

var $cbZpL = parcelRequire("cbZpL");

parcelRequire("8Ydiu");







parcelRequire("5PjAl");

var $kVqeH = parcelRequire("kVqeH");





$parcel$exportWildcard(module.exports, $cbZpL);
$parcel$exportWildcard(module.exports, $kVqeH);

});
parcelRegister("elIfN", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", () => $a7255abf53d9628a$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $a7255abf53d9628a$export$7e223ec222791509);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $cbZpL = parcelRequire("cbZpL");
var $a7255abf53d9628a$var$fallbackGlobalObject = {};
function $a7255abf53d9628a$export$256479dc0cea61c4() {
    return (0, $cbZpL.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $a7255abf53d9628a$var$fallbackGlobalObject;
}
function $a7255abf53d9628a$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $a7255abf53d9628a$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("cbZpL", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $9DHLK = parcelRequire("9DHLK");

var $2fFJv = parcelRequire("2fFJv");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $9DHLK.isBrowserBundle)() && Object.prototype.toString.call(typeof $2fFJv !== 'undefined' ? $2fFJv : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("9DHLK", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $7049b5388f3bc16b$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $7049b5388f3bc16b$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

});



parcelRegister("hiXkV", function(module, exports) {

$parcel$export(module.exports, "isError", () => $c992251c3cf6d112$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $c992251c3cf6d112$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $c992251c3cf6d112$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $c992251c3cf6d112$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $c992251c3cf6d112$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $c992251c3cf6d112$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $c992251c3cf6d112$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $c992251c3cf6d112$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $c992251c3cf6d112$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $c992251c3cf6d112$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $c992251c3cf6d112$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $c992251c3cf6d112$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $c992251c3cf6d112$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $c992251c3cf6d112$export$c9f5652083b8129d);
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c992251c3cf6d112$var$objectToString = Object.prototype.toString;
function $c992251c3cf6d112$export$e6127cc7fe7395c3(wat) {
    switch($c992251c3cf6d112$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c992251c3cf6d112$export$49034edbe6b62415(wat, Error);
    }
}
function $c992251c3cf6d112$var$isBuiltin(wat, ty) {
    return $c992251c3cf6d112$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c992251c3cf6d112$export$9f9636d330b71954(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'ErrorEvent');
}
function $c992251c3cf6d112$export$ef9e2056653f0c8e(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'DOMError');
}
function $c992251c3cf6d112$export$12e869b2a583f783(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'DOMException');
}
function $c992251c3cf6d112$export$844ec244b1367d54(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'String');
}
function $c992251c3cf6d112$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c992251c3cf6d112$export$53b83ca8eaab0383(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'Object');
}
function $c992251c3cf6d112$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c992251c3cf6d112$export$49034edbe6b62415(wat, Event);
}
function $c992251c3cf6d112$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c992251c3cf6d112$export$49034edbe6b62415(wat, Element);
}
function $c992251c3cf6d112$export$49841c62b9eff15(wat) {
    return $c992251c3cf6d112$var$isBuiltin(wat, 'RegExp');
}
function $c992251c3cf6d112$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c992251c3cf6d112$export$bc2894c7158efbac(wat) {
    return $c992251c3cf6d112$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c992251c3cf6d112$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c992251c3cf6d112$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("iACIJ", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $d8899fddf2254d3f$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $d8899fddf2254d3f$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $d8899fddf2254d3f$export$af88d00dbe7f521);

var $fKE23 = parcelRequire("fKE23");

var $e1VHv = parcelRequire("e1VHv");

var $elIfN = parcelRequire("elIfN");
// TODO: Implement different loggers for different environments
var $d8899fddf2254d3f$var$global = (0, $elIfN.getGlobalObject)();
/** Prefix for logging strings */ var $d8899fddf2254d3f$var$PREFIX = 'Sentry Logger ';
var $d8899fddf2254d3f$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $d8899fddf2254d3f$export$cda52e2a8927a2ca(callback) {
    var global = (0, $elIfN.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $d8899fddf2254d3f$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $d8899fddf2254d3f$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $e1VHv.IS_DEBUG_BUILD) $d8899fddf2254d3f$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $d8899fddf2254d3f$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $d8899fddf2254d3f$var$global.console)[name].apply(_a, (0, $fKE23.__spread)([
                    $d8899fddf2254d3f$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $d8899fddf2254d3f$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $d8899fddf2254d3f$export$af88d00dbe7f521;
if (0, $e1VHv.IS_DEBUG_BUILD) $d8899fddf2254d3f$export$af88d00dbe7f521 = (0, $elIfN.getGlobalSingleton)('logger', $d8899fddf2254d3f$var$makeLogger);
else $d8899fddf2254d3f$export$af88d00dbe7f521 = $d8899fddf2254d3f$var$makeLogger();

});
parcelRegister("e1VHv", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $a36dead3698ec8cd$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $a36dead3698ec8cd$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});


parcelRegister("d6buR", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $9894c0f0631e8740$export$19f53698e68b2496);
$parcel$export(module.exports, "parseUrl", () => $9894c0f0631e8740$export$7a5253c0f62e0150);
$parcel$export(module.exports, "getEventDescription", () => $9894c0f0631e8740$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $9894c0f0631e8740$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $9894c0f0631e8740$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $9894c0f0631e8740$export$6de4ffac6a2f1098);

var $fKE23 = parcelRequire("fKE23");

var $elIfN = parcelRequire("elIfN");

var $8Ydiu = parcelRequire("8Ydiu");

var $X8Ykq = parcelRequire("X8Ykq");
function $9894c0f0631e8740$export$19f53698e68b2496() {
    var global = (0, $elIfN.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $9894c0f0631e8740$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $9894c0f0631e8740$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $9894c0f0631e8740$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $9894c0f0631e8740$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
function $9894c0f0631e8740$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
function $9894c0f0631e8740$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $9894c0f0631e8740$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $9894c0f0631e8740$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $9894c0f0631e8740$export$d364f2020ab30578(input) {
    var match = input.match($9894c0f0631e8740$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $9894c0f0631e8740$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $X8Ykq.snipLine)(line, 0);
    });
    frame.context_line = (0, $X8Ykq.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $X8Ykq.snipLine)(line, 0);
    });
}
function $9894c0f0631e8740$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $9894c0f0631e8740$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $8Ydiu.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("8Ydiu", function(module, exports) {

$parcel$export(module.exports, "fill", () => $687e3de4b8c7d568$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $687e3de4b8c7d568$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $687e3de4b8c7d568$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $687e3de4b8c7d568$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $687e3de4b8c7d568$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $687e3de4b8c7d568$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $687e3de4b8c7d568$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $687e3de4b8c7d568$export$d25f2688db1bb433);

var $fKE23 = parcelRequire("fKE23");

var $lCbG4 = parcelRequire("lCbG4");

var $hiXkV = parcelRequire("hiXkV");

var $X8Ykq = parcelRequire("X8Ykq");
function $687e3de4b8c7d568$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $687e3de4b8c7d568$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $687e3de4b8c7d568$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $687e3de4b8c7d568$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $687e3de4b8c7d568$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $687e3de4b8c7d568$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $687e3de4b8c7d568$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $687e3de4b8c7d568$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $hiXkV.isError)(value)) newObj = (0, $fKE23.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $687e3de4b8c7d568$var$getOwnProperties(value));
    else if ((0, $hiXkV.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fKE23.__assign)({
            type: event_1.type,
            target: $687e3de4b8c7d568$var$serializeEventTarget(event_1.target),
            currentTarget: $687e3de4b8c7d568$var$serializeEventTarget(event_1.currentTarget)
        }, $687e3de4b8c7d568$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $hiXkV.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $687e3de4b8c7d568$var$serializeEventTarget(target) {
    try {
        return (0, $hiXkV.isElement)(target) ? (0, $lCbG4.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $687e3de4b8c7d568$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $687e3de4b8c7d568$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($687e3de4b8c7d568$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $X8Ykq.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $X8Ykq.truncate)(serialized, maxLength);
    }
    return '';
}
function $687e3de4b8c7d568$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $hiXkV.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fKE23.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $687e3de4b8c7d568$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($687e3de4b8c7d568$export$d25f2688db1bb433);
    return val;
}
function $687e3de4b8c7d568$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $hiXkV.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("lCbG4", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $fbc63483f1d5e9fb$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $fbc63483f1d5e9fb$export$1cfafeee2987818b);

var $elIfN = parcelRequire("elIfN");

var $hiXkV = parcelRequire("hiXkV");
function $fbc63483f1d5e9fb$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fbc63483f1d5e9fb$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fbc63483f1d5e9fb$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $hiXkV.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fbc63483f1d5e9fb$export$1cfafeee2987818b() {
    var global = (0, $elIfN.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}

});

parcelRegister("X8Ykq", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $0b1c78768d09f615$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $0b1c78768d09f615$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $0b1c78768d09f615$export$465e9d514283d4fd);
$parcel$export(module.exports, "isMatchingPattern", () => $0b1c78768d09f615$export$cdded5b28a5f8c6d);

var $hiXkV = parcelRequire("hiXkV");
function $0b1c78768d09f615$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $0b1c78768d09f615$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $0b1c78768d09f615$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $0b1c78768d09f615$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $hiXkV.isString)(value)) return false;
    if ((0, $hiXkV.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $0b1c78768d09f615$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

});



parcelRegister("5PjAl", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", () => $43e0e860a18e4b11$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $43e0e860a18e4b11$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $43e0e860a18e4b11$export$78e43115b553f358);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $hiXkV = parcelRequire("hiXkV");
function $43e0e860a18e4b11$export$1fda8aa4d135f8aa(value) {
    return new $43e0e860a18e4b11$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $43e0e860a18e4b11$export$78e43115b553f358(reason) {
    return new $43e0e860a18e4b11$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $43e0e860a18e4b11$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $hiXkV.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("kVqeH", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds, (v) => dateTimestampInSeconds = v);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds, (v) => timestampInSeconds = v);

var $elIfN = parcelRequire("elIfN");

var $cbZpL = parcelRequire("cbZpL");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $elIfN.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $cbZpL.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $cbZpL.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $elIfN.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});



parcelRegister("RA7oj", function(module, exports) {
$parcel$export(module.exports, "forget", () => (parcelRequire("kznRN")).forget);
$parcel$export(module.exports, "getLocationHref", () => (parcelRequire("lCbG4")).getLocationHref);
$parcel$export(module.exports, "htmlTreeAsString", () => (parcelRequire("lCbG4")).htmlTreeAsString);
$parcel$export(module.exports, "dsnToString", () => (parcelRequire("6Hxbo")).dsnToString);
$parcel$export(module.exports, "makeDsn", () => (parcelRequire("6Hxbo")).makeDsn);
$parcel$export(module.exports, "SentryError", () => (parcelRequire("XSd2U")).SentryError);
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("elIfN")).getGlobalObject);
$parcel$export(module.exports, "addInstrumentationHandler", () => (parcelRequire("iXghA")).addInstrumentationHandler);
$parcel$export(module.exports, "isDOMError", () => (parcelRequire("hiXkV")).isDOMError);
$parcel$export(module.exports, "isDOMException", () => (parcelRequire("hiXkV")).isDOMException);
$parcel$export(module.exports, "isError", () => (parcelRequire("hiXkV")).isError);
$parcel$export(module.exports, "isErrorEvent", () => (parcelRequire("hiXkV")).isErrorEvent);
$parcel$export(module.exports, "isEvent", () => (parcelRequire("hiXkV")).isEvent);
$parcel$export(module.exports, "isInstanceOf", () => (parcelRequire("hiXkV")).isInstanceOf);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("hiXkV")).isPlainObject);
$parcel$export(module.exports, "isPrimitive", () => (parcelRequire("hiXkV")).isPrimitive);
$parcel$export(module.exports, "isString", () => (parcelRequire("hiXkV")).isString);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("hiXkV")).isThenable);
$parcel$export(module.exports, "logger", () => (parcelRequire("iACIJ")).logger);
$parcel$export(module.exports, "addExceptionMechanism", () => (parcelRequire("d6buR")).addExceptionMechanism);
$parcel$export(module.exports, "addExceptionTypeValue", () => (parcelRequire("d6buR")).addExceptionTypeValue);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => (parcelRequire("d6buR")).checkOrSetAlreadyCaught);
$parcel$export(module.exports, "getEventDescription", () => (parcelRequire("d6buR")).getEventDescription);
$parcel$export(module.exports, "parseUrl", () => (parcelRequire("d6buR")).parseUrl);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("d6buR")).uuid4);
$parcel$export(module.exports, "normalize", () => (parcelRequire("2PLr7")).normalize);
$parcel$export(module.exports, "normalizeToSize", () => (parcelRequire("2PLr7")).normalizeToSize);
$parcel$export(module.exports, "addNonEnumerableProperty", () => (parcelRequire("8Ydiu")).addNonEnumerableProperty);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => (parcelRequire("8Ydiu")).extractExceptionKeysForMessage);
$parcel$export(module.exports, "fill", () => (parcelRequire("8Ydiu")).fill);
$parcel$export(module.exports, "getOriginalFunction", () => (parcelRequire("8Ydiu")).getOriginalFunction);
$parcel$export(module.exports, "markFunctionWrapped", () => (parcelRequire("8Ydiu")).markFunctionWrapped);
$parcel$export(module.exports, "urlEncode", () => (parcelRequire("8Ydiu")).urlEncode);
$parcel$export(module.exports, "makePromiseBuffer", () => (parcelRequire("bf8FM")).makePromiseBuffer);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("bgSaY")).severityFromString);
$parcel$export(module.exports, "createStackParser", () => (parcelRequire("gXzKg")).createStackParser);
$parcel$export(module.exports, "getFunctionName", () => (parcelRequire("gXzKg")).getFunctionName);
$parcel$export(module.exports, "eventStatusFromHttpCode", () => (parcelRequire("c2XaX")).eventStatusFromHttpCode);
$parcel$export(module.exports, "isMatchingPattern", () => (parcelRequire("X8Ykq")).isMatchingPattern);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("X8Ykq")).safeJoin);
$parcel$export(module.exports, "truncate", () => (parcelRequire("X8Ykq")).truncate);
$parcel$export(module.exports, "isNativeFetch", () => (parcelRequire("3et7T")).isNativeFetch);
$parcel$export(module.exports, "supportsFetch", () => (parcelRequire("3et7T")).supportsFetch);
$parcel$export(module.exports, "supportsReferrerPolicy", () => (parcelRequire("3et7T")).supportsReferrerPolicy);
$parcel$export(module.exports, "rejectedSyncPromise", () => (parcelRequire("5PjAl")).rejectedSyncPromise);
$parcel$export(module.exports, "resolvedSyncPromise", () => (parcelRequire("5PjAl")).resolvedSyncPromise);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("5PjAl")).SyncPromise);
$parcel$export(module.exports, "createEnvelope", () => (parcelRequire("2Uqu4")).createEnvelope);
$parcel$export(module.exports, "getEnvelopeType", () => (parcelRequire("2Uqu4")).getEnvelopeType);
$parcel$export(module.exports, "serializeEnvelope", () => (parcelRequire("2Uqu4")).serializeEnvelope);
$parcel$export(module.exports, "createClientReportEnvelope", () => (parcelRequire("hSAIU")).createClientReportEnvelope);
$parcel$export(module.exports, "disabledUntil", () => (parcelRequire("jKRLi")).disabledUntil);
$parcel$export(module.exports, "isRateLimited", () => (parcelRequire("jKRLi")).isRateLimited);
$parcel$export(module.exports, "updateRateLimits", () => (parcelRequire("jKRLi")).updateRateLimits);
parcelRequire("kznRN");
parcelRequire("lCbG4");
parcelRequire("6Hxbo");

parcelRequire("XSd2U");
parcelRequire("elIfN");
parcelRequire("iXghA");
parcelRequire("hiXkV");
parcelRequire("iACIJ");

parcelRequire("d6buR");

var $cbZpL = parcelRequire("cbZpL");
parcelRequire("2PLr7");
parcelRequire("8Ydiu");

parcelRequire("bf8FM");
parcelRequire("bgSaY");
parcelRequire("gXzKg");
parcelRequire("c2XaX");
parcelRequire("X8Ykq");
parcelRequire("3et7T");
parcelRequire("5PjAl");

var $kVqeH = parcelRequire("kVqeH");


parcelRequire("2Uqu4");
parcelRequire("hSAIU");
parcelRequire("jKRLi");
$parcel$exportWildcard(module.exports, $cbZpL);
$parcel$exportWildcard(module.exports, $kVqeH);

});
parcelRegister("kznRN", function(module, exports) {

$parcel$export(module.exports, "forget", () => $ef9996f3163877fa$export$93c25f2590a5b540);
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ef9996f3163877fa$export$93c25f2590a5b540(promise) {
    promise.then(null, function(e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

});

parcelRegister("6Hxbo", function(module, exports) {

$parcel$export(module.exports, "dsnToString", () => $4e107f9dba1c017f$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $4e107f9dba1c017f$export$128827c3562ec0cb);

var $fKE23 = parcelRequire("fKE23");

var $XSd2U = parcelRequire("XSd2U");

var $e1VHv = parcelRequire("e1VHv");
/** Regular expression used to parse a Dsn. */ var $4e107f9dba1c017f$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $4e107f9dba1c017f$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
function $4e107f9dba1c017f$export$44d472fbb931a776(dsn, withPassword) {
    if (withPassword === void 0) withPassword = false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') + ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId);
}
function $4e107f9dba1c017f$var$dsnFromString(str) {
    var match = $4e107f9dba1c017f$var$DSN_REGEX.exec(str);
    if (!match) throw new (0, $XSd2U.SentryError)("Invalid Sentry Dsn: " + str);
    var _a = (0, $fKE23.__read)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $4e107f9dba1c017f$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $4e107f9dba1c017f$var$dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) components.publicKey = components.user;
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $4e107f9dba1c017f$var$validateDsn(dsn) {
    if (!(0, $e1VHv.IS_DEBUG_BUILD)) return;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    requiredComponents.forEach(function(component) {
        if (!dsn[component]) throw new (0, $XSd2U.SentryError)("Invalid Sentry Dsn: " + component + " missing");
    });
    if (!projectId.match(/^\d+$/)) throw new (0, $XSd2U.SentryError)("Invalid Sentry Dsn: Invalid projectId " + projectId);
    if (!$4e107f9dba1c017f$var$isValidProtocol(protocol)) throw new (0, $XSd2U.SentryError)("Invalid Sentry Dsn: Invalid protocol " + protocol);
    if (port && isNaN(parseInt(port, 10))) throw new (0, $XSd2U.SentryError)("Invalid Sentry Dsn: Invalid port " + port);
    return true;
}
function $4e107f9dba1c017f$export$128827c3562ec0cb(from) {
    var components = typeof from === 'string' ? $4e107f9dba1c017f$var$dsnFromString(from) : $4e107f9dba1c017f$var$dsnFromComponents(from);
    $4e107f9dba1c017f$var$validateDsn(components);
    return components;
}

});
parcelRegister("XSd2U", function(module, exports) {

$parcel$export(module.exports, "SentryError", () => $0b3f8fa9f26ff871$export$5949942ba2a7c0e2);

var $fKE23 = parcelRequire("fKE23");

var $4vFQ8 = parcelRequire("4vFQ8");
/** An error emitted by Sentry SDKs and related utilities. */ var $0b3f8fa9f26ff871$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $4vFQ8.setPrototypeOf)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);

});
parcelRegister("4vFQ8", function(module, exports) {

$parcel$export(module.exports, "setPrototypeOf", () => $348a8336802f4136$export$1cb0d91350beb6cc);
var $348a8336802f4136$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $348a8336802f4136$var$setProtoOf : $348a8336802f4136$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $348a8336802f4136$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $348a8336802f4136$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!Object.prototype.hasOwnProperty.call(obj, prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}

});



parcelRegister("iXghA", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $dcca5e142952a7b7$export$285b9172a3741fb7);

var $fKE23 = parcelRequire("fKE23");

var $e1VHv = parcelRequire("e1VHv");

var $elIfN = parcelRequire("elIfN");

var $hiXkV = parcelRequire("hiXkV");

var $iACIJ = parcelRequire("iACIJ");

var $8Ydiu = parcelRequire("8Ydiu");

var $gXzKg = parcelRequire("gXzKg");

var $3et7T = parcelRequire("3et7T");
var $dcca5e142952a7b7$var$global = (0, $elIfN.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $dcca5e142952a7b7$var$handlers = {};
var $dcca5e142952a7b7$var$instrumented = {};
/** Instruments given API */ function $dcca5e142952a7b7$var$instrument(type) {
    if ($dcca5e142952a7b7$var$instrumented[type]) return;
    $dcca5e142952a7b7$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $dcca5e142952a7b7$var$instrumentConsole();
            break;
        case 'dom':
            $dcca5e142952a7b7$var$instrumentDOM();
            break;
        case 'xhr':
            $dcca5e142952a7b7$var$instrumentXHR();
            break;
        case 'fetch':
            $dcca5e142952a7b7$var$instrumentFetch();
            break;
        case 'history':
            $dcca5e142952a7b7$var$instrumentHistory();
            break;
        case 'error':
            $dcca5e142952a7b7$var$instrumentError();
            break;
        case 'unhandledrejection':
            $dcca5e142952a7b7$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $e1VHv.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
function $dcca5e142952a7b7$export$285b9172a3741fb7(type, callback) {
    $dcca5e142952a7b7$var$handlers[type] = $dcca5e142952a7b7$var$handlers[type] || [];
    $dcca5e142952a7b7$var$handlers[type].push(callback);
    $dcca5e142952a7b7$var$instrument(type);
}
/** JSDoc */ function $dcca5e142952a7b7$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$dcca5e142952a7b7$var$handlers[type]) return;
    try {
        for(var _b = (0, $fKE23.__values)($dcca5e142952a7b7$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $e1VHv.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $gXzKg.getFunctionName)(handler) + "\nError:", e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $dcca5e142952a7b7$var$instrumentConsole() {
    if (!('console' in $dcca5e142952a7b7$var$global)) return;
    (0, $iACIJ.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $dcca5e142952a7b7$var$global.console)) return;
        (0, $8Ydiu.fill)($dcca5e142952a7b7$var$global.console, level, function(originalConsoleMethod) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $dcca5e142952a7b7$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($dcca5e142952a7b7$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $dcca5e142952a7b7$var$instrumentFetch() {
    if (!(0, $3et7T.supportsNativeFetch)()) return;
    (0, $8Ydiu.fill)($dcca5e142952a7b7$var$global, 'fetch', function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $dcca5e142952a7b7$var$getFetchMethod(args),
                    url: $dcca5e142952a7b7$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $dcca5e142952a7b7$var$triggerHandlers('fetch', (0, $fKE23.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($dcca5e142952a7b7$var$global, args).then(function(response) {
                $dcca5e142952a7b7$var$triggerHandlers('fetch', (0, $fKE23.__assign)((0, $fKE23.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $dcca5e142952a7b7$var$triggerHandlers('fetch', (0, $fKE23.__assign)((0, $fKE23.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $dcca5e142952a7b7$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ('Request' in $dcca5e142952a7b7$var$global && (0, $hiXkV.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return 'GET';
}
/** Extract `url` from fetch call arguments */ function $dcca5e142952a7b7$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === 'string') return fetchArgs[0];
    if ('Request' in $dcca5e142952a7b7$var$global && (0, $hiXkV.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $dcca5e142952a7b7$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $dcca5e142952a7b7$var$global)) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, $8Ydiu.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $hiXkV.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $hiXkV.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    $dcca5e142952a7b7$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') (0, $8Ydiu.fill)(xhr, 'onreadystatechange', function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $8Ydiu.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $dcca5e142952a7b7$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $dcca5e142952a7b7$var$lastHref;
/** JSDoc */ function $dcca5e142952a7b7$var$instrumentHistory() {
    if (!(0, $3et7T.supportsHistory)()) return;
    var oldOnPopState = $dcca5e142952a7b7$var$global.onpopstate;
    $dcca5e142952a7b7$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $dcca5e142952a7b7$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $dcca5e142952a7b7$var$lastHref;
        $dcca5e142952a7b7$var$lastHref = to;
        $dcca5e142952a7b7$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $dcca5e142952a7b7$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $dcca5e142952a7b7$var$lastHref = to;
                $dcca5e142952a7b7$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $8Ydiu.fill)($dcca5e142952a7b7$var$global.history, 'pushState', historyReplacementFunction);
    (0, $8Ydiu.fill)($dcca5e142952a7b7$var$global.history, 'replaceState', historyReplacementFunction);
}
var $dcca5e142952a7b7$var$debounceDuration = 1000;
var $dcca5e142952a7b7$var$debounceTimerID;
var $dcca5e142952a7b7$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $dcca5e142952a7b7$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $dcca5e142952a7b7$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        var target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $dcca5e142952a7b7$var$makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) globalListener = false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $dcca5e142952a7b7$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($dcca5e142952a7b7$var$shouldSkipDOMEvent(event)) return;
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($dcca5e142952a7b7$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $dcca5e142952a7b7$var$lastCapturedEvent = event;
        } else if ($dcca5e142952a7b7$var$shouldShortcircuitPreviousDebounce($dcca5e142952a7b7$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $dcca5e142952a7b7$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($dcca5e142952a7b7$var$debounceTimerID);
        $dcca5e142952a7b7$var$debounceTimerID = $dcca5e142952a7b7$var$global.setTimeout(function() {
            $dcca5e142952a7b7$var$debounceTimerID = undefined;
        }, $dcca5e142952a7b7$var$debounceDuration);
    };
}
/** JSDoc */ function $dcca5e142952a7b7$var$instrumentDOM() {
    if (!('document' in $dcca5e142952a7b7$var$global)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = $dcca5e142952a7b7$var$triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = $dcca5e142952a7b7$var$makeDOMEventHandler(triggerDOMHandler, true);
    $dcca5e142952a7b7$var$global.document.addEventListener('click', globalDOMEventHandler, false);
    $dcca5e142952a7b7$var$global.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = $dcca5e142952a7b7$var$global[target] && $dcca5e142952a7b7$var$global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $8Ydiu.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_1 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_1[type] = handlers_1[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = $dcca5e142952a7b7$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount += 1;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $8Ydiu.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers_2[type];
                    if (handlerForType) {
                        handlerForType.refCount -= 1;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers_2).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var $dcca5e142952a7b7$var$_oldOnErrorHandler = null;
/** JSDoc */ function $dcca5e142952a7b7$var$instrumentError() {
    $dcca5e142952a7b7$var$_oldOnErrorHandler = $dcca5e142952a7b7$var$global.onerror;
    $dcca5e142952a7b7$var$global.onerror = function(msg, url, line, column, error) {
        $dcca5e142952a7b7$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($dcca5e142952a7b7$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $dcca5e142952a7b7$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $dcca5e142952a7b7$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $dcca5e142952a7b7$var$instrumentUnhandledRejection() {
    $dcca5e142952a7b7$var$_oldOnUnhandledRejectionHandler = $dcca5e142952a7b7$var$global.onunhandledrejection;
    $dcca5e142952a7b7$var$global.onunhandledrejection = function(e) {
        $dcca5e142952a7b7$var$triggerHandlers('unhandledrejection', e);
        if ($dcca5e142952a7b7$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $dcca5e142952a7b7$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}

});
parcelRegister("gXzKg", function(module, exports) {

$parcel$export(module.exports, "createStackParser", () => $c58de24ac78efef7$export$a5739666fb2d03d4);
$parcel$export(module.exports, "getFunctionName", () => $c58de24ac78efef7$export$aad197c7121a6651);

var $fKE23 = parcelRequire("fKE23");
var $c58de24ac78efef7$var$STACKTRACE_LIMIT = 50;
function $c58de24ac78efef7$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fKE23.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fKE23.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $c58de24ac78efef7$export$c55c24c0eeba0205(frames);
    };
}
function $c58de24ac78efef7$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $c58de24ac78efef7$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $c58de24ac78efef7$var$defaultFunctionName = '<anonymous>';
function $c58de24ac78efef7$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $c58de24ac78efef7$var$defaultFunctionName;
        return fn.name || $c58de24ac78efef7$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $c58de24ac78efef7$var$defaultFunctionName;
    }
}

});

parcelRegister("3et7T", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", () => $25a945ca9d1447a9$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $25a945ca9d1447a9$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $25a945ca9d1447a9$export$c82d238e23c40b21);
$parcel$export(module.exports, "supportsReferrerPolicy", () => $25a945ca9d1447a9$export$2d308b428295192f);
$parcel$export(module.exports, "supportsHistory", () => $25a945ca9d1447a9$export$67fc34576016d6ec);

var $e1VHv = parcelRequire("e1VHv");

var $elIfN = parcelRequire("elIfN");

var $iACIJ = parcelRequire("iACIJ");
function $25a945ca9d1447a9$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
function $25a945ca9d1447a9$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
function $25a945ca9d1447a9$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
function $25a945ca9d1447a9$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in (0, $elIfN.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function $25a945ca9d1447a9$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $25a945ca9d1447a9$export$c82d238e23c40b21() {
    if (!$25a945ca9d1447a9$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $elIfN.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($25a945ca9d1447a9$export$18cf36ed71d733e7(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $25a945ca9d1447a9$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $e1VHv.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
function $25a945ca9d1447a9$export$531055a6c684a70a() {
    return 'ReportingObserver' in (0, $elIfN.getGlobalObject)();
}
function $25a945ca9d1447a9$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$25a945ca9d1447a9$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $25a945ca9d1447a9$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $elIfN.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("2PLr7", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $21052412f49ad267$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $21052412f49ad267$export$23fbbb20bed71033);

var $fKE23 = parcelRequire("fKE23");

var $hiXkV = parcelRequire("hiXkV");

var $jbcN7 = parcelRequire("jbcN7");

var $8Ydiu = parcelRequire("8Ydiu");

var $gXzKg = parcelRequire("gXzKg");
function $21052412f49ad267$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $21052412f49ad267$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $21052412f49ad267$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $21052412f49ad267$export$a3295358bff77e(object, depth);
    if ($21052412f49ad267$var$jsonSize(normalized) > maxSize) return $21052412f49ad267$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $21052412f49ad267$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $jbcN7.memoBuilder)();
    var _a = (0, $fKE23.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $hiXkV.isNaN)(value)) return value;
    var stringified = $21052412f49ad267$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $hiXkV.isError)(value) || (0, $hiXkV.isEvent)(value) ? (0, $8Ydiu.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $21052412f49ad267$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $21052412f49ad267$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $hiXkV.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $gXzKg.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $21052412f49ad267$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $21052412f49ad267$var$jsonSize(value) {
    return $21052412f49ad267$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("jbcN7", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $df68f77600f04c56$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $df68f77600f04c56$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("bf8FM", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", () => $82f7d2b22f8894c8$export$85a4f67f852183e6);

var $XSd2U = parcelRequire("XSd2U");

var $5PjAl = parcelRequire("5PjAl");
function $82f7d2b22f8894c8$export$85a4f67f852183e6(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */ function add(taskProducer) {
        if (!isReady()) return (0, $5PjAl.rejectedSyncPromise)(new (0, $XSd2U.SentryError)('Not adding Promise due to buffer limit reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */ function drain(timeout) {
        return new (0, $5PjAl.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, $5PjAl.resolvedSyncPromise)(item).then(function() {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("bgSaY", function(module, exports) {

$parcel$export(module.exports, "severityFromString", () => $834b368ebcda8a07$export$e01cef29b4327697);

var $i1gqQ = parcelRequire("i1gqQ");

var $kmOtZ = parcelRequire("kmOtZ");
function $834b368ebcda8a07$var$isSupportedSeverity(level) {
    return (0, $kmOtZ.SeverityLevels).indexOf(level) !== -1;
}
function $834b368ebcda8a07$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $i1gqQ.Severity).Warning;
    if ($834b368ebcda8a07$var$isSupportedSeverity(level)) return level;
    return (0, $i1gqQ.Severity).Log;
}

});
parcelRegister("i1gqQ", function(module, exports) {

$parcel$export(module.exports, "Severity", () => $d1e5110cc370f7a9$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $d1e5110cc370f7a9$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($d1e5110cc370f7a9$export$918a9776c0a3cf27 || ($d1e5110cc370f7a9$export$918a9776c0a3cf27 = {}));
var $d1e5110cc370f7a9$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});

parcelRegister("kmOtZ", function(module, exports) {

$parcel$export(module.exports, "SeverityLevels", () => $ed3d058e2c0fd2bc$export$484b1ea9aec914c);
var $ed3d058e2c0fd2bc$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];

});


parcelRegister("c2XaX", function(module, exports) {

$parcel$export(module.exports, "eventStatusFromHttpCode", () => $8c5393015b2a69c4$export$82713360d763c449);
/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */ function $8c5393015b2a69c4$export$82713360d763c449(code) {
    if (code >= 200 && code < 300) return 'success';
    if (code === 429) return 'rate_limit';
    if (code >= 400 && code < 500) return 'invalid';
    if (code >= 500) return 'failed';
    return 'unknown';
}

});

parcelRegister("2Uqu4", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", () => $21e55ae40a7a9eb4$export$f93f7f385160c44e);
$parcel$export(module.exports, "getEnvelopeType", () => $21e55ae40a7a9eb4$export$d84939284bbafcd4);
$parcel$export(module.exports, "serializeEnvelope", () => $21e55ae40a7a9eb4$export$32f9b428425aac85);

var $fKE23 = parcelRequire("fKE23");

var $hiXkV = parcelRequire("hiXkV");
function $21e55ae40a7a9eb4$export$f93f7f385160c44e(headers, items) {
    if (items === void 0) items = [];
    return [
        headers,
        items
    ];
}
function $21e55ae40a7a9eb4$export$d650323442802f6f(envelope, newItem) {
    var _a = (0, $fKE23.__read)(envelope, 2), headers = _a[0], items = _a[1];
    return [
        headers,
        (0, $fKE23.__spread)(items, [
            newItem
        ])
    ];
}
function $21e55ae40a7a9eb4$export$d84939284bbafcd4(envelope) {
    var _a = (0, $fKE23.__read)(envelope, 2), _b = (0, $fKE23.__read)(_a[1], 1), _c = (0, $fKE23.__read)(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
function $21e55ae40a7a9eb4$export$32f9b428425aac85(envelope) {
    var _a = (0, $fKE23.__read)(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function(acc, item) {
        var _a = (0, $fKE23.__read)(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = (0, $hiXkV.isPrimitive)(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

});

parcelRegister("hSAIU", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", () => $d043f749a5a9f775$export$f3b9ed77c03eeb00);

var $2Uqu4 = parcelRequire("2Uqu4");

var $kVqeH = parcelRequire("kVqeH");
function $d043f749a5a9f775$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $kVqeH.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $2Uqu4.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("jKRLi", function(module, exports) {

$parcel$export(module.exports, "disabledUntil", () => $e61c04327cc6f372$export$b89fc7b2e4c799e7);
$parcel$export(module.exports, "isRateLimited", () => $e61c04327cc6f372$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $e61c04327cc6f372$export$699aff705e0d49d4);

var $fKE23 = parcelRequire("fKE23");
var $e61c04327cc6f372$export$b09ce39faaeb1e7c = 60000; // 60 seconds
function $e61c04327cc6f372$export$615352e17ed7741(header, now) {
    if (now === void 0) now = Date.now();
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $e61c04327cc6f372$export$b09ce39faaeb1e7c;
}
function $e61c04327cc6f372$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
function $e61c04327cc6f372$export$6c91fec22056810a(limits, category, now) {
    if (now === void 0) now = Date.now();
    return $e61c04327cc6f372$export$b89fc7b2e4c799e7(limits, category) > now;
}
function $e61c04327cc6f372$export$699aff705e0d49d4(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) now = Date.now();
    var updatedRateLimits = (0, $fKE23.__assign)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) try {
        /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */ for(var _c = (0, $fKE23.__values)(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()){
            var limit = _d.value;
            var parameters = limit.split(':', 2);
            var headerDelay = parseInt(parameters[0], 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            if (!parameters[1]) updatedRateLimits.all = now + delay;
            else try {
                for(var _e = (e_2 = void 0, (0, $fKE23.__values)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()){
                    var category = _f.value;
                    updatedRateLimits[category] = now + delay;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $e61c04327cc6f372$export$615352e17ed7741(retryAfterHeader, now);
    return updatedRateLimits;
}

});


parcelRegister("tP6AM", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $059a5a0059b9100e$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $059a5a0059b9100e$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("c1oMD", function(module, exports) {

$parcel$export(module.exports, "setupIntegrations", () => $8c08cd84b9f222cc$export$51abed9797baa598);

var $fKE23 = parcelRequire("fKE23");

var $87JfJ = parcelRequire("87JfJ");
var $OArqR = parcelRequire("OArqR");
parcelRequire("RA7oj");
var $8Ydiu = parcelRequire("8Ydiu");
var $iACIJ = parcelRequire("iACIJ");

var $tP6AM = parcelRequire("tP6AM");
var $8c08cd84b9f222cc$export$b14a8888f80a0b3e = [];
/**
 * @private
 */ function $8c08cd84b9f222cc$var$filterDuplicates(integrations) {
    return integrations.reduce(function(acc, integrations) {
        if (acc.every(function(accIntegration) {
            return integrations.name !== accIntegration.name;
        })) acc.push(integrations);
        return acc;
    }, []);
}
function $8c08cd84b9f222cc$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $fKE23.__spread)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = (0, $fKE23.__spread)($8c08cd84b9f222cc$var$filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) // Filter out integrations that are also included in user options
    integrations = (0, $fKE23.__spread)(integrations.filter(function(integrations) {
        return userIntegrations.every(function(userIntegration) {
            return userIntegration.name !== integrations.name;
        });
    }), $8c08cd84b9f222cc$var$filterDuplicates(userIntegrations));
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $fKE23.__spread)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $8c08cd84b9f222cc$export$e7390a03b70a6f2f(integration) {
    if ($8c08cd84b9f222cc$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $87JfJ.addGlobalEventProcessor), (0, $OArqR.getCurrentHub));
    $8c08cd84b9f222cc$export$b14a8888f80a0b3e.push(integration.name);
    (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).log("Integration installed: " + integration.name);
}
function $8c08cd84b9f222cc$export$51abed9797baa598(options) {
    var integrations = {};
    $8c08cd84b9f222cc$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $8c08cd84b9f222cc$export$e7390a03b70a6f2f(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    (0, $8Ydiu.addNonEnumerableProperty)(integrations, 'initialized', true);
    return integrations;
}

});
parcelRegister("OArqR", function(module, exports) {

$parcel$export(module.exports, "Hub", () => $0980f023f6699809$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $0980f023f6699809$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getHubFromCarrier", () => $0980f023f6699809$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $0980f023f6699809$export$a07cdf6544bbd7c);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4rc7U");
var $iACIJ = parcelRequire("iACIJ");
var $kVqeH = parcelRequire("kVqeH");
var $elIfN = parcelRequire("elIfN");
var $cbZpL = parcelRequire("cbZpL");
var $d6buR = parcelRequire("d6buR");

var $dp7ee = parcelRequire("dp7ee");

var $87JfJ = parcelRequire("87JfJ");

var $cTyWz = parcelRequire("cTyWz");
var $0980f023f6699809$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $0980f023f6699809$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $0980f023f6699809$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $87JfJ.Scope)();
        if (_version === void 0) _version = $0980f023f6699809$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $87JfJ.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $d6buR.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureException', exception, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $d6buR.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient('captureMessage', message, level, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $d6buR.uuid4)();
        if (event.type !== 'transaction') this._lastEventId = eventId;
        this._invokeClient('captureEvent', event, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $0980f023f6699809$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $kVqeH.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $fKE23.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $iACIJ.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $0980f023f6699809$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $0980f023f6699809$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $dp7ee.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $elIfN.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $cTyWz.Session)((0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') currentSession.update({
                status: 'exited'
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $fKE23.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $0980f023f6699809$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $dp7ee.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $0980f023f6699809$export$19eade501500c6c1() {
    var carrier = (0, $elIfN.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $0980f023f6699809$export$4188a14ad302d1bc(hub) {
    var registry = $0980f023f6699809$export$19eade501500c6c1();
    var oldHub = $0980f023f6699809$export$bfa8a924a84a76b7(registry);
    $0980f023f6699809$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $0980f023f6699809$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $0980f023f6699809$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$0980f023f6699809$var$hasHubOnCarrier(registry) || $0980f023f6699809$export$bfa8a924a84a76b7(registry).isOlderThan($0980f023f6699809$export$24a86ef7798177e4)) $0980f023f6699809$export$849f05434e95d2f2(registry, new $0980f023f6699809$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $cbZpL.isNodeEnv)()) return $0980f023f6699809$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $0980f023f6699809$export$bfa8a924a84a76b7(registry);
}
function $0980f023f6699809$export$1c4d656130202699() {
    (0, $dp7ee.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('Function `getActiveDomain` is deprecated and will be removed in a future version.');
    var sentry = $0980f023f6699809$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $0980f023f6699809$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $0980f023f6699809$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $0980f023f6699809$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$0980f023f6699809$var$hasHubOnCarrier(activeDomain) || $0980f023f6699809$export$bfa8a924a84a76b7(activeDomain).isOlderThan($0980f023f6699809$export$24a86ef7798177e4)) {
            var registryHubTopStack = $0980f023f6699809$export$bfa8a924a84a76b7(registry).getStackTop();
            $0980f023f6699809$export$849f05434e95d2f2(activeDomain, new $0980f023f6699809$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $87JfJ.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $0980f023f6699809$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $0980f023f6699809$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $0980f023f6699809$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $0980f023f6699809$export$bfa8a924a84a76b7(carrier) {
    return (0, $elIfN.getGlobalSingleton)('hub', function() {
        return new $0980f023f6699809$export$8c41bb232f1008b1();
    }, carrier);
}
function $0980f023f6699809$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("dp7ee", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $9c23379fa9385e05$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $9c23379fa9385e05$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("cTyWz", function(module, exports) {

$parcel$export(module.exports, "Session", () => $9635ba30690c682e$export$1fb4852a55678982);
parcelRequire("4rc7U");
var $8Ydiu = parcelRequire("8Ydiu");
var $kVqeH = parcelRequire("kVqeH");
var $d6buR = parcelRequire("d6buR");
/**
 * @inheritdoc
 */ var $9635ba30690c682e$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $d6buR.uuid4)();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $kVqeH.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $kVqeH.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $d6buR.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === 'number') this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === 'number') this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === 'number') this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === 'ok') this.update({
            status: 'exited'
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $8Ydiu.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});




parcelRegister("5NSnG", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", () => $439bb649cd606b51$export$31499a9cd224b78c);
var $439bb649cd606b51$export$31499a9cd224b78c = '6.19.7';

});

parcelRegister("4BUI5", function(module, exports) {

$parcel$export(module.exports, "BrowserBackend", () => $35b69b92bc5150dd$export$2526e21aec9d0ce7);

var $fKE23 = parcelRequire("fKE23");

var $cRBBS = parcelRequire("cRBBS");
var $l0qan = parcelRequire("l0qan");

var $i1gqQ = parcelRequire("i1gqQ");
parcelRequire("RA7oj");
var $3et7T = parcelRequire("3et7T");

var $ksT2Z = parcelRequire("ksT2Z");

var $cUw0d = parcelRequire("cUw0d");
var $aR9BR = parcelRequire("aR9BR");
var $fAOje = parcelRequire("fAOje");
var $6fJzd = parcelRequire("6fJzd");
/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $35b69b92bc5150dd$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $ksT2Z.eventFromException)(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $i1gqQ.Severity).Info;
        return (0, $ksT2Z.eventFromMessage)(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this._options.transportOptions), {
            dsn: this._options.dsn,
            tunnel: this._options.tunnel,
            sendClientReports: this._options.sendClientReports,
            _metadata: this._options._metadata
        });
        var api = (0, $l0qan.initAPIDetails)(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = (0, $l0qan.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel);
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $3et7T.supportsFetch)()) {
            var requestOptions = (0, $fKE23.__assign)({}, transportOptions.fetchParameters);
            this._newTransport = (0, $aR9BR.makeNewFetchTransport)({
                requestOptions: requestOptions,
                url: url
            });
            return new (0, $cUw0d.FetchTransport)(transportOptions);
        }
        this._newTransport = (0, $fAOje.makeNewXHRTransport)({
            url: url,
            headers: transportOptions.headers
        });
        return new (0, $6fJzd.XHRTransport)(transportOptions);
    };
    return BrowserBackend;
}((0, $cRBBS.BaseBackend));

});
parcelRegister("cRBBS", function(module, exports) {

$parcel$export(module.exports, "BaseBackend", () => $95d79bcf7954ef3e$export$8f43a53a38d7e95f);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("RA7oj");
var $iACIJ = parcelRequire("iACIJ");
var $XSd2U = parcelRequire("XSd2U");

var $l0qan = parcelRequire("l0qan");

var $tP6AM = parcelRequire("tP6AM");

var $5cwyQ = parcelRequire("5cwyQ");

var $kiGHW = parcelRequire("kiGHW");
/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $95d79bcf7954ef3e$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('No DSN provided, backend will not do anything.');
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $XSd2U.SentryError)('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $XSd2U.SentryError)('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $l0qan.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = (0, $5cwyQ.createEventEnvelope)(event, api);
            this._newTransport.send(env).then(null, function(reason) {
                (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error('Error while sending event:', reason);
            });
        } else this._transport.sendEvent(event).then(null, function(reason) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error('Error while sending event:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport && this._options.dsn && this._options._experiments && this._options._experiments.newTransport) {
            var api = (0, $l0qan.initAPIDetails)(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = (0, $fKE23.__read)((0, $5cwyQ.createSessionEnvelope)(session, api), 1), env = _a[0];
            this._newTransport.send(env).then(null, function(reason) {
                (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error('Error while sending session:', reason);
            });
        } else this._transport.sendSession(session).then(null, function(reason) {
            (0, $tP6AM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error('Error while sending session:', reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $kiGHW.NoopTransport)();
    };
    return BaseBackend;
}();

});
parcelRegister("l0qan", function(module, exports) {

$parcel$export(module.exports, "getStoreEndpointWithUrlEncodedAuth", () => $f4ade527dcb5d9b9$export$c1677e22ac2217a5);
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $f4ade527dcb5d9b9$export$9964600bfe84e6a3);
$parcel$export(module.exports, "initAPIDetails", () => $f4ade527dcb5d9b9$export$ad00a06efb2a29cb);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $f4ade527dcb5d9b9$export$671c7ed8e40a7a57);
parcelRequire("RA7oj");
var $6Hxbo = parcelRequire("6Hxbo");
var $8Ydiu = parcelRequire("8Ydiu");
var $f4ade527dcb5d9b9$var$SENTRY_API_VERSION = '7';
/**
 * Helper class to provide urls, headers and metadata that can be used to form
 * different types of requests to Sentry endpoints.
 * Supports both envelopes and regular event requests.
 *
 * @deprecated Please use APIDetails
 **/ var $f4ade527dcb5d9b9$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn, metadata, tunnel) {
        if (metadata === void 0) metadata = {};
        this.dsn = dsn;
        this._dsnObject = (0, $6Hxbo.makeDsn)(dsn);
        this.metadata = metadata;
        this._tunnel = tunnel;
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Does this transport force envelopes? */ API.prototype.forceEnvelope = function() {
        return !!this._tunnel;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        return $f4ade527dcb5d9b9$var$getBaseApiEndpoint(this._dsnObject);
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return $f4ade527dcb5d9b9$var$getStoreEndpoint(this._dsnObject);
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return $f4ade527dcb5d9b9$export$c1677e22ac2217a5(this._dsnObject);
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return $f4ade527dcb5d9b9$export$9964600bfe84e6a3(this._dsnObject, this._tunnel);
    };
    return API;
}();
function $f4ade527dcb5d9b9$export$ad00a06efb2a29cb(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: (0, $6Hxbo.makeDsn)(dsn),
        tunnel: tunnel
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $f4ade527dcb5d9b9$var$getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */ function $f4ade527dcb5d9b9$var$_getIngestEndpoint(dsn, target) {
    return "" + $f4ade527dcb5d9b9$var$getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $f4ade527dcb5d9b9$var$_encodedAuth(dsn) {
    return (0, $8Ydiu.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $f4ade527dcb5d9b9$var$SENTRY_API_VERSION
    });
}
/** Returns the store endpoint URL. */ function $f4ade527dcb5d9b9$var$getStoreEndpoint(dsn) {
    return $f4ade527dcb5d9b9$var$_getIngestEndpoint(dsn, 'store');
}
function $f4ade527dcb5d9b9$export$c1677e22ac2217a5(dsn) {
    return $f4ade527dcb5d9b9$var$getStoreEndpoint(dsn) + "?" + $f4ade527dcb5d9b9$var$_encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */ function $f4ade527dcb5d9b9$var$_getEnvelopeEndpoint(dsn) {
    return $f4ade527dcb5d9b9$var$_getIngestEndpoint(dsn, 'envelope');
}
function $f4ade527dcb5d9b9$export$9964600bfe84e6a3(dsn, tunnel) {
    return tunnel ? tunnel : $f4ade527dcb5d9b9$var$_getEnvelopeEndpoint(dsn) + "?" + $f4ade527dcb5d9b9$var$_encodedAuth(dsn);
}
function $f4ade527dcb5d9b9$export$1e4d4724de7b199e(dsn, clientName, clientVersion) {
    // CHANGE THIS to use metadata but keep clientName and clientVersion compatible
    var header = [
        "Sentry sentry_version=" + $f4ade527dcb5d9b9$var$SENTRY_API_VERSION
    ];
    header.push("sentry_client=" + clientName + "/" + clientVersion);
    header.push("sentry_key=" + dsn.publicKey);
    if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
    return {
        'Content-Type': 'application/json',
        'X-Sentry-Auth': header.join(', ')
    };
}
function $f4ade527dcb5d9b9$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    var dsn = (0, $6Hxbo.makeDsn)(dsnLike);
    var endpoint = $f4ade527dcb5d9b9$var$getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + (0, $6Hxbo.dsnToString)(dsn);
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'user') {
            if (!dialogOptions.user) continue;
            if (dialogOptions.user.name) encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            if (dialogOptions.user.email) encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
        } else encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
    }
    return endpoint + "?" + encodedOptions;
}

});

parcelRegister("5cwyQ", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", () => $3c9754a9a003fa6f$export$124b03c077baa2f3);
$parcel$export(module.exports, "sessionToSentryRequest", () => $3c9754a9a003fa6f$export$977ee6eda1884ec3);
$parcel$export(module.exports, "createEventEnvelope", () => $3c9754a9a003fa6f$export$c31057337a18010f);
$parcel$export(module.exports, "eventToSentryRequest", () => $3c9754a9a003fa6f$export$2006389de558b996);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("RA7oj");
var $2Uqu4 = parcelRequire("2Uqu4");
var $6Hxbo = parcelRequire("6Hxbo");
var $2PLr7 = parcelRequire("2PLr7");

var $l0qan = parcelRequire("l0qan");
/** Extract sdk info from from the API metadata */ function $3c9754a9a003fa6f$var$getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) return;
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $3c9754a9a003fa6f$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, $fKE23.__spread)(event.sdk.integrations || [], sdkInfo.integrations || []);
    event.sdk.packages = (0, $fKE23.__spread)(event.sdk.packages || [], sdkInfo.packages || []);
    return event;
}
function $3c9754a9a003fa6f$export$124b03c077baa2f3(session, api) {
    var sdkInfo = $3c9754a9a003fa6f$var$getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = (0, $fKE23.__assign)((0, $fKE23.__assign)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $6Hxbo.dsnToString)(api.dsn)
    });
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [
        {
            type: type
        },
        session
    ];
    var envelope = (0, $2Uqu4.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
    return [
        envelope,
        type
    ];
}
function $3c9754a9a003fa6f$export$977ee6eda1884ec3(session, api) {
    var _a = (0, $fKE23.__read)($3c9754a9a003fa6f$export$124b03c077baa2f3(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: (0, $2Uqu4.serializeEnvelope)(envelope),
        type: type,
        url: (0, $l0qan.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel)
    };
}
function $3c9754a9a003fa6f$export$c31057337a18010f(event, api) {
    var sdkInfo = $3c9754a9a003fa6f$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $3c9754a9a003fa6f$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = (0, $fKE23.__assign)((0, $fKE23.__assign)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }), !!api.tunnel && {
        dsn: (0, $6Hxbo.dsnToString)(api.dsn)
    });
    var eventItem = [
        {
            type: eventType,
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        },
        event
    ];
    return (0, $2Uqu4.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
function $3c9754a9a003fa6f$export$2006389de558b996(event, api) {
    var sdkInfo = $3c9754a9a003fa6f$var$getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    $3c9754a9a003fa6f$var$enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    } catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify((0, $2PLr7.normalize)(event));
        } catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: {
                    message: innerErr.message,
                    stack: innerErr.stack
                }
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope ? (0, $l0qan.getEnvelopeEndpointWithUrlEncodedAuth)(api.dsn, api.tunnel) : (0, $l0qan.getStoreEndpointWithUrlEncodedAuth)(api.dsn)
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = (0, $fKE23.__assign)((0, $fKE23.__assign)({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        }, sdkInfo && {
            sdk: sdkInfo
        }), !!api.tunnel && {
            dsn: (0, $6Hxbo.dsnToString)(api.dsn)
        });
        var eventItem = [
            {
                type: eventType,
                sample_rates: [
                    {
                        id: samplingMethod,
                        rate: sampleRate
                    }
                ]
            },
            req.body
        ];
        var envelope = (0, $2Uqu4.createEnvelope)(envelopeHeaders, [
            eventItem
        ]);
        req.body = (0, $2Uqu4.serializeEnvelope)(envelope);
    }
    return req;
}

});

parcelRegister("kiGHW", function(module, exports) {

$parcel$export(module.exports, "NoopTransport", () => $ec769df8ba8fb994$export$6f2767450ea1346c);
parcelRequire("RA7oj");
var $5PjAl = parcelRequire("5PjAl");
/** Noop transport */ var $ec769df8ba8fb994$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $5PjAl.resolvedSyncPromise)({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped'
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $5PjAl.resolvedSyncPromise)(true);
    };
    return NoopTransport;
}();

});


parcelRegister("ksT2Z", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", () => $ee611f66aed15d85$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $ee611f66aed15d85$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $ee611f66aed15d85$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $ee611f66aed15d85$export$5425b53185d13d6c);

var $fKE23 = parcelRequire("fKE23");

var $i1gqQ = parcelRequire("i1gqQ");
parcelRequire("RA7oj");
var $d6buR = parcelRequire("d6buR");
var $gXzKg = parcelRequire("gXzKg");
var $8Ydiu = parcelRequire("8Ydiu");
var $hiXkV = parcelRequire("hiXkV");
var $2PLr7 = parcelRequire("2PLr7");
var $5PjAl = parcelRequire("5PjAl");

var $3X1sG = parcelRequire("3X1sG");
function $ee611f66aed15d85$export$a6c2d27607295951(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = $ee611f66aed15d85$export$d478b2c12fbcfdda(ex);
    var exception = {
        type: ex && ex.name,
        value: $ee611f66aed15d85$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $ee611f66aed15d85$export$a6a5dd73e489caf(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $hiXkV.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + (0, $8Ydiu.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $2PLr7.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var frames_1 = $ee611f66aed15d85$export$d478b2c12fbcfdda(syntheticException);
        if (frames_1.length) event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $ee611f66aed15d85$export$73fbea5a0a5234af(ex) {
    return {
        exception: {
            values: [
                $ee611f66aed15d85$export$a6c2d27607295951(ex)
            ]
        }
    };
}
function $ee611f66aed15d85$export$d478b2c12fbcfdda(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = $ee611f66aed15d85$var$getPopSize(ex);
    try {
        return (0, $gXzKg.createStackParser)((0, $3X1sG.opera10StackParser), (0, $3X1sG.opera11StackParser), (0, $3X1sG.chromeStackParser), (0, $3X1sG.winjsStackParser), (0, $3X1sG.geckoStackParser))(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $ee611f66aed15d85$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $ee611f66aed15d85$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($ee611f66aed15d85$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $ee611f66aed15d85$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
function $ee611f66aed15d85$export$ea3ec7e569b823fc(exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $ee611f66aed15d85$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace);
    (0, $d6buR.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = (0, $i1gqQ.Severity).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $5PjAl.resolvedSyncPromise)(event);
}
function $ee611f66aed15d85$export$5425b53185d13d6c(message, level, hint, attachStacktrace) {
    if (level === void 0) level = (0, $i1gqQ.Severity).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $ee611f66aed15d85$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $5PjAl.resolvedSyncPromise)(event);
}
function $ee611f66aed15d85$export$9dd56ed1ef0c3420(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, $hiXkV.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return $ee611f66aed15d85$export$73fbea5a0a5234af(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $hiXkV.isDOMError)(exception) || (0, $hiXkV.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = $ee611f66aed15d85$export$73fbea5a0a5234af(exception);
        else {
            var name_1 = domException.name || ((0, $hiXkV.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = $ee611f66aed15d85$export$47d86ae4b3c9994(message, syntheticException, attachStacktrace);
            (0, $d6buR.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) event.tags = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event.tags), {
            'DOMException.code': "" + domException.code
        });
        return event;
    }
    if ((0, $hiXkV.isError)(exception)) // we have a real Error object, do nothing
    return $ee611f66aed15d85$export$73fbea5a0a5234af(exception);
    if ((0, $hiXkV.isPlainObject)(exception) || (0, $hiXkV.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = $ee611f66aed15d85$export$a6a5dd73e489caf(objectException, syntheticException, isUnhandledRejection);
        (0, $d6buR.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $ee611f66aed15d85$export$47d86ae4b3c9994(exception, syntheticException, attachStacktrace);
    (0, $d6buR.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $d6buR.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $ee611f66aed15d85$export$47d86ae4b3c9994(input, syntheticException, attachStacktrace) {
    var event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = $ee611f66aed15d85$export$d478b2c12fbcfdda(syntheticException);
        if (frames_2.length) event.stacktrace = {
            frames: frames_2
        };
    }
    return event;
}

});
parcelRegister("3X1sG", function(module, exports) {

$parcel$export(module.exports, "chromeStackParser", () => $2e0804074fb82000$export$c693d9295441d8f9);
$parcel$export(module.exports, "geckoStackParser", () => $2e0804074fb82000$export$c9ddf1e2b5d48bff);
$parcel$export(module.exports, "winjsStackParser", () => $2e0804074fb82000$export$b6d155d85c1dcba5);
$parcel$export(module.exports, "opera10StackParser", () => $2e0804074fb82000$export$966ec832d9699d6);
$parcel$export(module.exports, "opera11StackParser", () => $2e0804074fb82000$export$989a1824b4734ce6);

var $fKE23 = parcelRequire("fKE23");
// global reference to slice
var $2e0804074fb82000$var$UNKNOWN_FUNCTION = '?';
var $2e0804074fb82000$var$OPERA10_PRIORITY = 10;
var $2e0804074fb82000$var$OPERA11_PRIORITY = 20;
var $2e0804074fb82000$var$CHROME_PRIORITY = 30;
var $2e0804074fb82000$var$WINJS_PRIORITY = 40;
var $2e0804074fb82000$var$GECKO_PRIORITY = 50;
function $2e0804074fb82000$var$createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $2e0804074fb82000$var$chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var $2e0804074fb82000$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var $2e0804074fb82000$var$chrome = function(line) {
    var parts = $2e0804074fb82000$var$chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = $2e0804074fb82000$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0, $fKE23.__read)($2e0804074fb82000$var$extractSafariExtensionDetails(parts[1] || $2e0804074fb82000$var$UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return $2e0804074fb82000$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var $2e0804074fb82000$export$c693d9295441d8f9 = [
    $2e0804074fb82000$var$CHROME_PRIORITY,
    $2e0804074fb82000$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $2e0804074fb82000$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $2e0804074fb82000$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $2e0804074fb82000$var$gecko = function(line) {
    var _a;
    var parts = $2e0804074fb82000$var$geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = $2e0804074fb82000$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || $2e0804074fb82000$var$UNKNOWN_FUNCTION;
        _a = (0, $fKE23.__read)($2e0804074fb82000$var$extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return $2e0804074fb82000$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var $2e0804074fb82000$export$c9ddf1e2b5d48bff = [
    $2e0804074fb82000$var$GECKO_PRIORITY,
    $2e0804074fb82000$var$gecko
];
var $2e0804074fb82000$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $2e0804074fb82000$var$winjs = function(line) {
    var parts = $2e0804074fb82000$var$winjsRegex.exec(line);
    return parts ? $2e0804074fb82000$var$createFrame(parts[2], parts[1] || $2e0804074fb82000$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var $2e0804074fb82000$export$b6d155d85c1dcba5 = [
    $2e0804074fb82000$var$WINJS_PRIORITY,
    $2e0804074fb82000$var$winjs
];
var $2e0804074fb82000$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var $2e0804074fb82000$var$opera10 = function(line) {
    var parts = $2e0804074fb82000$var$opera10Regex.exec(line);
    return parts ? $2e0804074fb82000$var$createFrame(parts[2], parts[3] || $2e0804074fb82000$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var $2e0804074fb82000$export$966ec832d9699d6 = [
    $2e0804074fb82000$var$OPERA10_PRIORITY,
    $2e0804074fb82000$var$opera10
];
var $2e0804074fb82000$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var $2e0804074fb82000$var$opera11 = function(line) {
    var parts = $2e0804074fb82000$var$opera11Regex.exec(line);
    return parts ? $2e0804074fb82000$var$createFrame(parts[5], parts[3] || parts[4] || $2e0804074fb82000$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var $2e0804074fb82000$export$989a1824b4734ce6 = [
    $2e0804074fb82000$var$OPERA11_PRIORITY,
    $2e0804074fb82000$var$opera11
];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var $2e0804074fb82000$var$extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $2e0804074fb82000$var$UNKNOWN_FUNCTION,
        isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename
    ] : [
        func,
        filename
    ];
};

});


parcelRegister("cUw0d", function(module, exports) {

$parcel$export(module.exports, "FetchTransport", () => $96638a0496d42aec$export$2bdee3f9b92f4e82);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("RA7oj");
var $XSd2U = parcelRequire("XSd2U");
var $3et7T = parcelRequire("3et7T");
var $5PjAl = parcelRequire("5PjAl");

var $ijtqO = parcelRequire("ijtqO");

var $63Sy0 = parcelRequire("63Sy0");
/** `fetch` based transport */ var $96638a0496d42aec$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) fetchImpl = (0, $63Sy0.getNativeFetchImplementation)();
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $3et7T.supportsReferrerPolicy)() ? 'origin' : ''
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(function() {
            return new (0, $5PjAl.SyncPromise)(function(resolve, reject) {
                _this._fetch(sentryRequest.url, options).then(function(response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }).catch(reject);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $XSd2U.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return FetchTransport;
}((0, $ijtqO.BaseTransport));

});
parcelRegister("ijtqO", function(module, exports) {

$parcel$export(module.exports, "BaseTransport", () => $d550d4caaeeb814e$export$74b99d619e90f481);

var $fKE23 = parcelRequire("fKE23");

var $5cwyQ = parcelRequire("5cwyQ");
var $l0qan = parcelRequire("l0qan");
parcelRequire("RA7oj");
var $hSAIU = parcelRequire("hSAIU");
var $jKRLi = parcelRequire("jKRLi");
var $6Hxbo = parcelRequire("6Hxbo");
var $c2XaX = parcelRequire("c2XaX");
var $elIfN = parcelRequire("elIfN");
var $iACIJ = parcelRequire("iACIJ");
var $bf8FM = parcelRequire("bf8FM");
var $2Uqu4 = parcelRequire("2Uqu4");

var $f9zWM = parcelRequire("f9zWM");

var $63Sy0 = parcelRequire("63Sy0");
function $d550d4caaeeb814e$var$requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var $d550d4caaeeb814e$var$global = (0, $elIfN.getGlobalObject)();
/** Base Transport class implementation */ var $d550d4caaeeb814e$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = (0, $bf8FM.makePromiseBuffer)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._outcomes = {};
        this._api = (0, $l0qan.initAPIDetails)(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = (0, $l0qan.getStoreEndpointWithUrlEncodedAuth)(this._api.dsn);
        if (this.options.sendClientReports && $d550d4caaeeb814e$var$global.document) $d550d4caaeeb814e$var$global.document.addEventListener('visibilitychange', function() {
            if ($d550d4caaeeb814e$var$global.document.visibilityState === 'hidden') _this._flushOutcomes();
        });
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $5cwyQ.eventToSentryRequest)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $5cwyQ.sessionToSentryRequest)(session, this._api), session);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.recordLostEvent = function(reason, category) {
        var _a;
        if (!this.options.sendClientReports) return;
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = $d550d4caaeeb814e$var$requestTypeToCategory(category) + ":" + reason;
        (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], _a !== null && _a !== void 0 ? _a : 0) + 1;
    };
    /**
     * Send outcomes as an envelope
     */ BaseTransport.prototype._flushOutcomes = function() {
        if (!this.options.sendClientReports) return;
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).log('No outcomes to flush');
            return;
        }
        (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = (0, $l0qan.getEnvelopeEndpointWithUrlEncodedAuth)(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function(key) {
            var _a = (0, $fKE23.__read)(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = (0, $hSAIU.createClientReportEnvelope)(discardedEvents, this._api.tunnel && (0, $6Hxbo.dsnToString)(this._api.dsn));
        try {
            (0, $63Sy0.sendReport)(url, (0, $2Uqu4.serializeEnvelope)(envelope));
        } catch (e) {
            (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $c2XaX.eventStatusFromHttpCode)(response.status);
        this._rateLimits = (0, $jKRLi.updateRateLimits)(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) (0, $f9zWM.IS_DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
        (0, $iACIJ.logger).warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        if (status === 'success') {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */ BaseTransport.prototype._disabledUntil = function(requestType) {
        var category = $d550d4caaeeb814e$var$requestTypeToCategory(requestType);
        return new Date((0, $jKRLi.disabledUntil)(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */ BaseTransport.prototype._isRateLimited = function(requestType) {
        var category = $d550d4caaeeb814e$var$requestTypeToCategory(requestType);
        return (0, $jKRLi.isRateLimited)(this._rateLimits, category);
    };
    return BaseTransport;
}();

});
parcelRegister("f9zWM", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", () => $b083949c4f81f8dd$export$48a8984ec0bf2e44);
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $b083949c4f81f8dd$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

});

parcelRegister("63Sy0", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", () => $469d55df0bc73812$export$8be2119ce08e3379);
$parcel$export(module.exports, "sendReport", () => $469d55df0bc73812$export$84bb63b2c17ec44d);
parcelRequire("RA7oj");
var $kznRN = parcelRequire("kznRN");
var $elIfN = parcelRequire("elIfN");
var $3et7T = parcelRequire("3et7T");
var $iACIJ = parcelRequire("iACIJ");

var $f9zWM = parcelRequire("f9zWM");
var $469d55df0bc73812$var$global = (0, $elIfN.getGlobalObject)();
var $469d55df0bc73812$var$cachedFetchImpl;
function $469d55df0bc73812$export$8be2119ce08e3379() {
    if ($469d55df0bc73812$var$cachedFetchImpl) return $469d55df0bc73812$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $3et7T.isNativeFetch)($469d55df0bc73812$var$global.fetch)) return $469d55df0bc73812$var$cachedFetchImpl = $469d55df0bc73812$var$global.fetch.bind($469d55df0bc73812$var$global);
    var document = $469d55df0bc73812$var$global.document;
    var fetchImpl = $469d55df0bc73812$var$global.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $469d55df0bc73812$var$cachedFetchImpl = fetchImpl.bind($469d55df0bc73812$var$global);
/* eslint-enable @typescript-eslint/unbound-method */ }
function $469d55df0bc73812$export$84bb63b2c17ec44d(url, body) {
    var isRealNavigator = Object.prototype.toString.call($469d55df0bc73812$var$global && $469d55df0bc73812$var$global.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof $469d55df0bc73812$var$global.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = $469d55df0bc73812$var$global.navigator.sendBeacon.bind($469d55df0bc73812$var$global.navigator);
        return sendBeacon(url, body);
    }
    if ((0, $3et7T.supportsFetch)()) {
        var fetch_1 = $469d55df0bc73812$export$8be2119ce08e3379();
        return (0, $kznRN.forget)(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true
        }));
    }
}

});



parcelRegister("aR9BR", function(module, exports) {

$parcel$export(module.exports, "makeNewFetchTransport", () => $7e764eea64c3ed48$export$1c57e6bfd09bad13);

var $fKE23 = parcelRequire("fKE23");

var $hlxX6 = parcelRequire("hlxX6");

var $63Sy0 = parcelRequire("63Sy0");
function $7e764eea64c3ed48$export$1c57e6bfd09bad13(options, nativeFetch) {
    if (nativeFetch === void 0) nativeFetch = (0, $63Sy0.getNativeFetchImplementation)();
    function makeRequest(request) {
        var requestOptions = (0, $fKE23.__assign)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin'
        }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function(response) {
            return response.text().then(function(body) {
                return {
                    body: body,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    },
                    reason: response.statusText,
                    statusCode: response.status
                };
            });
        });
    }
    return (0, $hlxX6.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});
parcelRegister("hlxX6", function(module, exports) {

$parcel$export(module.exports, "createTransport", () => $ca0ebc0f886e145d$export$d09f50d9ab7f7b69);
parcelRequire("RA7oj");
var $jKRLi = parcelRequire("jKRLi");
var $c2XaX = parcelRequire("c2XaX");
var $2Uqu4 = parcelRequire("2Uqu4");
var $bf8FM = parcelRequire("bf8FM");
var $5PjAl = parcelRequire("5PjAl");
var $ca0ebc0f886e145d$export$d8a725a7dce95622 = 'error';
var $ca0ebc0f886e145d$export$99adc6fe67a3c63e = 'transaction';
var $ca0ebc0f886e145d$export$9d7ad34f132fe68f = 'attachment';
var $ca0ebc0f886e145d$export$42d9e7b5fc564c45 = 'session';
var $ca0ebc0f886e145d$export$e515cf6dfd2f98b8 = 30;
function $ca0ebc0f886e145d$export$d09f50d9ab7f7b69(options, makeRequest, buffer) {
    if (buffer === void 0) buffer = (0, $bf8FM.makePromiseBuffer)(options.bufferSize || $ca0ebc0f886e145d$export$e515cf6dfd2f98b8);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var envCategory = (0, $2Uqu4.getEnvelopeType)(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: (0, $2Uqu4.serializeEnvelope)(envelope)
        };
        // Don't add to buffer if transport is already rate-limited
        if ((0, $jKRLi.isRateLimited)(rateLimits, category)) return (0, $5PjAl.rejectedSyncPromise)({
            status: 'rate_limit',
            reason: $ca0ebc0f886e145d$var$getRateLimitReason(rateLimits, category)
        });
        var requestTask = function() {
            return makeRequest(request).then(function(_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = (0, $c2XaX.eventStatusFromHttpCode)(statusCode);
                if (headers) rateLimits = (0, $jKRLi.updateRateLimits)(rateLimits, headers);
                if (status === 'success') return (0, $5PjAl.resolvedSyncPromise)({
                    status: status,
                    reason: reason
                });
                return (0, $5PjAl.rejectedSyncPromise)({
                    status: status,
                    reason: reason || body || (status === 'rate_limit' ? $ca0ebc0f886e145d$var$getRateLimitReason(rateLimits, category) : 'Unknown transport error')
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush
    };
}
function $ca0ebc0f886e145d$var$getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date((0, $jKRLi.disabledUntil)(rateLimits, category)).toISOString();
}

});


parcelRegister("fAOje", function(module, exports) {

$parcel$export(module.exports, "makeNewXHRTransport", () => $b5a13e3086127a5e$export$4c0ac1dd4bbf4921);

var $hlxX6 = parcelRequire("hlxX6");
parcelRequire("RA7oj");
var $5PjAl = parcelRequire("5PjAl");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var $b5a13e3086127a5e$var$XHR_READYSTATE_DONE = 4;
function $b5a13e3086127a5e$export$4c0ac1dd4bbf4921(options) {
    function makeRequest(request) {
        return new (0, $5PjAl.SyncPromise)(function(resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function() {
                if (xhr.readyState === $b5a13e3086127a5e$var$XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After')
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $hlxX6.createTransport)({
        bufferSize: options.bufferSize
    }, makeRequest);
}

});

parcelRegister("6fJzd", function(module, exports) {

$parcel$export(module.exports, "XHRTransport", () => $48d77d7070ff4227$export$874a283af77e8e62);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("RA7oj");
var $XSd2U = parcelRequire("XSd2U");
var $5PjAl = parcelRequire("5PjAl");

var $ijtqO = parcelRequire("ijtqO");
/** `XHR` based transport */ var $48d77d7070ff4227$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429
            });
        }
        return this._buffer.add(function() {
            return new (0, $5PjAl.SyncPromise)(function(resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function() {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After')
                        };
                        _this._handleResponse({
                            requestType: sentryRequest.type,
                            response: request,
                            headers: headers,
                            resolve: resolve,
                            reject: reject
                        });
                    }
                };
                request.open('POST', sentryRequest.url);
                for(var header in _this.options.headers)if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) request.setRequestHeader(header, _this.options.headers[header]);
                request.send(sentryRequest.body);
            });
        }).then(undefined, function(reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof (0, $XSd2U.SentryError)) _this.recordLostEvent('queue_overflow', sentryRequest.type);
            else _this.recordLostEvent('network_error', sentryRequest.type);
            throw reason;
        });
    };
    return XHRTransport;
}((0, $ijtqO.BaseTransport));

});


parcelRegister("ig9bH", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreOnError", () => $d4b0d920737cf018$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $d4b0d920737cf018$export$4997ffc0176396a6);
$parcel$export(module.exports, "injectReportDialog", () => $d4b0d920737cf018$export$deb9aac8ea0b576c);

var $fKE23 = parcelRequire("fKE23");

var $cZi0S = parcelRequire("cZi0S");
var $l0qan = parcelRequire("l0qan");
parcelRequire("RA7oj");
var $d6buR = parcelRequire("d6buR");
var $8Ydiu = parcelRequire("8Ydiu");
var $elIfN = parcelRequire("elIfN");
var $iACIJ = parcelRequire("iACIJ");

var $f9zWM = parcelRequire("f9zWM");
var $d4b0d920737cf018$var$global = (0, $elIfN.getGlobalObject)();
var $d4b0d920737cf018$var$ignoreOnError = 0;
function $d4b0d920737cf018$export$b79738ab10c590b2() {
    return $d4b0d920737cf018$var$ignoreOnError > 0;
}
function $d4b0d920737cf018$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $d4b0d920737cf018$var$ignoreOnError += 1;
    setTimeout(function() {
        $d4b0d920737cf018$var$ignoreOnError -= 1;
    });
}
function $d4b0d920737cf018$export$4997ffc0176396a6(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) options = {};
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $8Ydiu.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $d4b0d920737cf018$export$4997ffc0176396a6(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $d4b0d920737cf018$export$1265a142ff5ba165();
            (0, $cZi0S.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, $d6buR.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $d6buR.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $cZi0S.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $8Ydiu.markFunctionWrapped)(sentryWrapped, fn);
    (0, $8Ydiu.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $d4b0d920737cf018$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!$d4b0d920737cf018$var$global.document) return;
    if (!options.eventId) {
        (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        (0, $f9zWM.IS_DEBUG_BUILD) && (0, $iACIJ.logger).error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = $d4b0d920737cf018$var$global.document.createElement('script');
    script.async = true;
    script.src = (0, $l0qan.getReportDialogEndpoint)(options.dsn, options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    var injectionPoint = $d4b0d920737cf018$var$global.document.head || $d4b0d920737cf018$var$global.document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
}

});
parcelRegister("cZi0S", function(module, exports) {

$parcel$export(module.exports, "captureException", () => $974927907f8d3c67$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $974927907f8d3c67$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $974927907f8d3c67$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $974927907f8d3c67$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $974927907f8d3c67$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $974927907f8d3c67$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $974927907f8d3c67$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setTags", () => $974927907f8d3c67$export$74a8fb34822092e6);
$parcel$export(module.exports, "setExtra", () => $974927907f8d3c67$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTag", () => $974927907f8d3c67$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $974927907f8d3c67$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $974927907f8d3c67$export$ec58d9285c204497);
$parcel$export(module.exports, "startTransaction", () => $974927907f8d3c67$export$e262da7ae6480481);

var $fKE23 = parcelRequire("fKE23");

var $OArqR = parcelRequire("OArqR");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $974927907f8d3c67$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $OArqR.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $fKE23.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $974927907f8d3c67$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return $974927907f8d3c67$var$callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $974927907f8d3c67$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return $974927907f8d3c67$var$callOnHub('captureMessage', message, level, (0, $fKE23.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $974927907f8d3c67$export$1462b974fdcf6ba2(event) {
    return $974927907f8d3c67$var$callOnHub('captureEvent', event);
}
function $974927907f8d3c67$export$99d44f04437e9cb8(callback) {
    $974927907f8d3c67$var$callOnHub('configureScope', callback);
}
function $974927907f8d3c67$export$efda9a273d7a036d(breadcrumb) {
    $974927907f8d3c67$var$callOnHub('addBreadcrumb', breadcrumb);
}
function $974927907f8d3c67$export$2f04de43fe27971a(name, context) {
    $974927907f8d3c67$var$callOnHub('setContext', name, context);
}
function $974927907f8d3c67$export$bb4922da0dd51b92(extras) {
    $974927907f8d3c67$var$callOnHub('setExtras', extras);
}
function $974927907f8d3c67$export$74a8fb34822092e6(tags) {
    $974927907f8d3c67$var$callOnHub('setTags', tags);
}
function $974927907f8d3c67$export$8e8e7789d42ed61d(key, extra) {
    $974927907f8d3c67$var$callOnHub('setExtra', key, extra);
}
function $974927907f8d3c67$export$a37d07ee78eb4569(key, value) {
    $974927907f8d3c67$var$callOnHub('setTag', key, value);
}
function $974927907f8d3c67$export$8b6bb3dd62a01be2(user) {
    $974927907f8d3c67$var$callOnHub('setUser', user);
}
function $974927907f8d3c67$export$ec58d9285c204497(callback) {
    $974927907f8d3c67$var$callOnHub('withScope', callback);
}
function $974927907f8d3c67$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $974927907f8d3c67$var$callOnHub.apply(void 0, (0, $fKE23.__spread)([
        '_invokeClient',
        method
    ], args));
}
function $974927907f8d3c67$export$e262da7ae6480481(context, customSamplingContext) {
    return $974927907f8d3c67$var$callOnHub('startTransaction', (0, $fKE23.__assign)({}, context), customSamplingContext);
}

});


parcelRegister("fw28U", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $b4bb81a60afd53f2$export$2dc68d50d56fbbd);

var $fKE23 = parcelRequire("fKE23");

var $OArqR = parcelRequire("OArqR");

var $i1gqQ = parcelRequire("i1gqQ");
parcelRequire("RA7oj");
var $iXghA = parcelRequire("iXghA");
var $d6buR = parcelRequire("d6buR");
var $elIfN = parcelRequire("elIfN");
var $lCbG4 = parcelRequire("lCbG4");
var $X8Ykq = parcelRequire("X8Ykq");
var $bgSaY = parcelRequire("bgSaY");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $b4bb81a60afd53f2$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $fKE23.__assign)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $OArqR.getCurrentHub)().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: (0, $d6buR.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        if (this._options.console) (0, $iXghA.addInstrumentationHandler)('console', $b4bb81a60afd53f2$var$_consoleBreadcrumb);
        if (this._options.dom) (0, $iXghA.addInstrumentationHandler)('dom', $b4bb81a60afd53f2$var$_domBreadcrumb(this._options.dom));
        if (this._options.xhr) (0, $iXghA.addInstrumentationHandler)('xhr', $b4bb81a60afd53f2$var$_xhrBreadcrumb);
        if (this._options.fetch) (0, $iXghA.addInstrumentationHandler)('fetch', $b4bb81a60afd53f2$var$_fetchBreadcrumb);
        if (this._options.history) (0, $iXghA.addInstrumentationHandler)('history', $b4bb81a60afd53f2$var$_historyBreadcrumb);
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b4bb81a60afd53f2$var$_domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $lCbG4.htmlTreeAsString)(handlerData.event.target, keyAttrs) : (0, $lCbG4.htmlTreeAsString)(handlerData.event, keyAttrs);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        (0, $OArqR.getCurrentHub)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b4bb81a60afd53f2$var$_consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console'
        },
        level: (0, $bgSaY.severityFromString)(handlerData.level),
        message: (0, $X8Ykq.safeJoin)(handlerData.args, ' ')
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + ((0, $X8Ykq.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $OArqR.getCurrentHub)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b4bb81a60afd53f2$var$_xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) return;
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        (0, $OArqR.getCurrentHub)().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code
            },
            type: 'http'
        }, {
            xhr: handlerData.xhr,
            input: body
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b4bb81a60afd53f2$var$_fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) (0, $OArqR.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: handlerData.fetchData,
        level: (0, $i1gqQ.Severity).Error,
        type: 'http'
    }, {
        data: handlerData.error,
        input: handlerData.args
    });
    else (0, $OArqR.getCurrentHub)().addBreadcrumb({
        category: 'fetch',
        data: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, handlerData.fetchData), {
            status_code: handlerData.response.status
        }),
        type: 'http'
    }, {
        input: handlerData.args,
        response: handlerData.response
    });
}
/**
 * Creates breadcrumbs from history API calls
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b4bb81a60afd53f2$var$_historyBreadcrumb(handlerData) {
    var global = (0, $elIfN.getGlobalObject)();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = (0, $d6buR.parseUrl)(global.location.href);
    var parsedFrom = (0, $d6buR.parseUrl)(from);
    var parsedTo = (0, $d6buR.parseUrl)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $OArqR.getCurrentHub)().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to
        }
    });
}

});


parcelRegister("dt0h6", function(module, exports) {

$parcel$export(module.exports, "maskEmailIds", () => $9cde325b1adc558b$export$7a75efd77ad928b4);
const $9cde325b1adc558b$var$EMAIL_REGEX = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
const $9cde325b1adc558b$export$7a75efd77ad928b4 = (text)=>text.replace($9cde325b1adc558b$var$EMAIL_REGEX, '***@***');

});



parcelRegister("ilpVd", function(module, exports) {

$parcel$export(module.exports, "AnalyticsProvider", () => $d5ae4bb6ce850d54$export$1b581a2ec13e37f1);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

const $d5ae4bb6ce850d54$export$1b581a2ec13e37f1 = ({ children: children, channel: channel })=>{
    const sendEvent = (0, $eUqFw.useCallback)((event)=>{
        var _event$clone;
        // For backwards compatibility with analytics listeners in the product
        // which attempt to determine the actionSubject and attributes
        // from the context.
        const { actionSubject: actionSubject, attributes: attributes } = event.payload;
        const context = {};
        if (actionSubject) {
            context.component = actionSubject;
            context.componentName = actionSubject;
        }
        if (attributes) context.attributes = attributes;
        event.context.push(context);
        (_event$clone = event.clone()) === null || _event$clone === void 0 || _event$clone.fire(channel);
    }, [
        channel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: (0, $e779cc169fd2a347$export$2ceccf177fae277c),
        onEvent: sendEvent
    }, children);
};

});

parcelRegister("5RM2s", function(module, exports) {

$parcel$export(module.exports, "PackageIntlProvider", () => $44572a787da406c7$export$dfce9acc1b75df7a);

var $eUqFw = parcelRequire("eUqFw");

var $jYxIw = parcelRequire("jYxIw");

var $b3GWL = parcelRequire("b3GWL");
const $44572a787da406c7$export$dfce9acc1b75df7a = ({ children: children, locale: locale })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYxIw.ProFormaIntlProvider), {
        i18nMessages: $b3GWL,
        locale: locale
    }, children);

});
parcelRegister("b3GWL", function(module, exports) {

$parcel$export(module.exports, "cs", () => (parcelRequire("Q7xtl")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("exdNF")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("66gbg")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("ah97k")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("fAoL9")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("gVSMA")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("fzlBA")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("wml6w")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("aI2Ak")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("7HihG")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("h5DIU")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("gxRCD")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("7Kax4")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("i4AqH")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("j76eY")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("jqIxn")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("2vzbq")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("lEBoP")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("hA1LO")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("5iPCG")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("jEzMw")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("6YBPtg")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("hY4F8")).default);
$parcel$export(module.exports, "zh", () => (parcelRequire("gPf0D")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("fYuCQ")).default);
/**
 * NOTE:
 *
 * This file is automatically generated.
 * DO NOT UPDATE IT BY HAND. Instead, run yarn generate-i18n-index in @atlassian/proforma-utils.
 */ 
var $Q7xtl = parcelRequire("Q7xtl");

var $exdNF = parcelRequire("exdNF");

var $66gbg = parcelRequire("66gbg");

var $ah97k = parcelRequire("ah97k");

var $fAoL9 = parcelRequire("fAoL9");

var $gVSMA = parcelRequire("gVSMA");

var $fzlBA = parcelRequire("fzlBA");

var $wml6w = parcelRequire("wml6w");

var $aI2Ak = parcelRequire("aI2Ak");

var $7HihG = parcelRequire("7HihG");

var $h5DIU = parcelRequire("h5DIU");

var $gxRCD = parcelRequire("gxRCD");

var $7Kax4 = parcelRequire("7Kax4");

var $i4AqH = parcelRequire("i4AqH");

var $j76eY = parcelRequire("j76eY");

var $jqIxn = parcelRequire("jqIxn");

var $2vzbq = parcelRequire("2vzbq");

var $lEBoP = parcelRequire("lEBoP");

var $hA1LO = parcelRequire("hA1LO");

var $5iPCG = parcelRequire("5iPCG");

var $jEzMw = parcelRequire("jEzMw");

var $6YBPtg = parcelRequire("6YBPtg");

var $hY4F8 = parcelRequire("hY4F8");

var $gPf0D = parcelRequire("gPf0D");

var $fYuCQ = parcelRequire("fYuCQ");

});
parcelRegister("Q7xtl", function(module, exports) {

$parcel$export(module.exports, "default", () => $09cab481b95459ea$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $09cab481b95459ea$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Upravit',
    'form-system.general.Form': "N\xe1zev",
    'jira-common.ListProjectForms.AffectExistingIssues': "Tato akce neovlivn\xed st\xe1vaj\xedc\xed po\u017Eadavky, kter\xe9 u\u017E pou\u017E\xedvaj\xed tento formul\xe1\u0159, ani \u017E\xe1dn\xe9 kopie tohoto formul\xe1\u0159e v\xa0jin\xfdch projektech.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "Typ po\u017Eadavku",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "Typ \u017E\xe1dosti",
    'jira-common.ListProjectForms.Cancel': "Zru\u0161it",
    'jira-common.ListProjectForms.Copy': "Kop\xedrovat do projektu",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Chyba: Formul\xe1\u0159 {formName} nelze zkop\xedrovat",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektu {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do obchodn\xedho projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Formul\xe1\u0159 {formName} lze nyn\xed pou\u017E\xedt v\xa0projektu {projectName}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfServiceProjectsMessage} a\xa0{numberOfBusinessProjectsMessage}).',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfServiceProjectsMessage} a\xa0{numberOfSoftwareProjectsMessage}).',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektu {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do projektu slu\u017Eby} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} a\xa0{numberOfBusinessProjectsMessage}).',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektech ({numberOfSoftwareProjectsMessage} a\xa0{numberOfBusinessProjectsMessage}).',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0projektu {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do softwarov\xe9ho projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0{numberOfProjects,number}\xa0projektu.} few {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt ve\xa0{numberOfProjects,number}\xa0projektech.} many {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0{numberOfProjects,number}\xa0projektech.} other {Formul\xe1\u0159 "{formName}" lze nyn\xed pou\u017E\xedt v\xa0{numberOfProjects,number}\xa0projektech.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formul\xe1\u0159 byl zkop\xedrov\xe1n do projektu} few {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} many {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F} other {Formul\xe1\u0159 byl zkop\xedrov\xe1n do {numberOfProjects,number}\xa0projekt\u016F}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "Zru\u0161it",
    'jira-common.ListProjectForms.CopyModal.Copy': "Kop\xedrovat",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Kop\xedrovat do projekt\u016F",
    'jira-common.ListProjectForms.CopyModal.Heading': "Kop\xedrovat formul\xe1\u0159 {formName} do jin\xfdch projekt\u016F",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Dal\u0161\xed informace o\xa0kop\xedrov\xe1n\xed formul\xe1\u0159\u016F",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Na\u010D\xedt\xe1n\xed projekt\u016F",
    'jira-common.ListProjectForms.CopyModal.Name': "N\xe1zev",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "Vybrat v\u0161echny projekty",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Zm\u011Bny proveden\xe9 ve formul\xe1\u0159i se neprojev\xed v\xa0\u017E\xe1dn\xe9 z\xa0jeho kopi\xed v\xa0ostatn\xedch projektech.",
    'jira-common.ListProjectForms.CopyText': "Kop\xedrovat {formName}",
    'jira-common.ListProjectForms.Delete': 'Odstranit',
    'jira-common.ListProjectForms.DeleteFormSuccess': "Formul\xe1\u0159 {formName} byl odstran\u011Bn",
    'jira-common.ListProjectForms.Duplicate': 'Duplikovat',
    'jira-common.ListProjectForms.EmptyFormName': "Formul\xe1\u0159 bez n\xe1zvu",
    'jira-common.ListProjectForms.FilterForms': "Filtrovat formul\xe1\u0159e",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "Soubor {filename} byl sta\u017Een",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Obnovte str\xe1nku a\xa0zkuste to znovu.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Soubor {filename} nebyl sta\u017Een",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% dokon\u010Deno} few {{percentCount,number}\xa0% dokon\u010Deno} many {{percentCount,number}\xa0% dokon\u010Deno} other {{percentCount,number}\xa0% dokon\u010Deno}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Stahov\xe1n\xed souboru {filename}",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportovat do souboru XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': "Dal\u0161\xed akce",
    'jira-common.ListProjectForms.FutureIssueMessage': "Budouc\xed po\u017Eadavky vytvo\u0159en\xe9 pomoc\xed t\u011Bchto typ\u016F po\u017Eadavk\u016F u\u017E nebudou obsahovat tento formul\xe1\u0159:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Budouc\xed \u017E\xe1dosti vytvo\u0159en\xe9 pomoc\xed t\u011Bchto typ\u016F \u017E\xe1dost\xed u\u017E nebudou obsahovat tento formul\xe1\u0159.",
    'jira-common.ListProjectForms.Heading': 'Odstranit formul\xe1\u0159 "{formName}"?',
    'jira-common.ListProjectForms.IssueType': "Typ po\u017Eadavku",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "Vyhledat typy po\u017Eadavk\u016F",
    'jira-common.ListProjectForms.LastUpdated': "Naposledy aktualizov\xe1no",
    'jira-common.ListProjectForms.LearnMoreLink': "Dal\u0161\xed informace o\xa0odstra\u0148ov\xe1n\xed formul\xe1\u0159\u016F",
    'jira-common.ListProjectForms.RequestType': "Typ \u017E\xe1dosti",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "Vyhledat typy \u017E\xe1dost\xed",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Odstran\u011Bn\xedm tohoto formul\xe1\u0159e jej odeberete z\xa0n\xe1sleduj\xedc\xedch typ\u016F po\u017Eadavk\u016F:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Odstran\u011Bn\xedm tohoto formul\xe1\u0159e jej odeberete z\xa0n\xe1sleduj\xedc\xedch typ\u016F \u017E\xe1dost\xed:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Zkop\xedrovat p\u0159\xedm\xfd odkaz",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Typ po\u017Eadavku",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Typ \u017E\xe1dosti",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0obchodn\xed projekt} few {{numberOfBusinessProjects,number}\xa0obchodn\xed projekty} many {{numberOfBusinessProjects,number}\xa0obchodn\xedho projektu} other {{numberOfBusinessProjects,number}\xa0obchodn\xedch projekt\u016F}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0projekt slu\u017Eby} few {{numberOfServiceProjects,number}\xa0projekty slu\u017Eby} many {{numberOfServiceProjects,number}\xa0projektu slu\u017Eby} other {{numberOfServiceProjects,number}\xa0projekt\u016F slu\u017Eby}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0softwarov\xfd projekt} few {{numberOfSoftwareProjects,number}\xa0softwarov\xe9 projekty} many {{numberOfSoftwareProjects,number}\xa0softwarov\xe9ho projektu} other {{numberOfSoftwareProjects,number}\xa0softwarov\xfdch projekt\u016F}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "Po\u010Det typ\u016F po\u017Eadavk\u016F: {count}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "Po\u010Det typ\u016F \u017E\xe1dost\xed: {count}",
    'proforma-project-forms.BusinessForms': "Pokro\u010Dil\xe9 formul\xe1\u0159e",
    'proforma-project-forms.CreateForm': "Vytvo\u0159it formul\xe1\u0159",
    'proforma-project-forms.Description': "Vytv\xe1\u0159ejte, upravujte, exportujte a\xa0odstra\u0148ujte formul\xe1\u0159e. Kop\xedrujte formul\xe1\u0159e a\xa0pou\u017E\xedvejte je v\xa0jin\xfdch projektech.",
    'proforma-project-forms.Forms': "Formul\xe1\u0159e",
    'proforma-project-forms.LearnMore': "Dal\u0161\xed informace o\xa0formul\xe1\u0159\xedch",
    'proforma-project-forms.LoadingForms': "Na\u010D\xedt\xe1n\xed\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "P\u0159id\xe1vejte pro z\xe1kazn\xedky formul\xe1\u0159e, kter\xe9 maj\xed vyplnit p\u0159i zad\xe1v\xe1n\xed \u017E\xe1dost\xed, nebo p\u0159ipojte formul\xe1\u0159e k\xa0existuj\xedc\xedm po\u017Eadavk\u016Fm, abyste z\xedskali v\xedce informac\xed.",
    'proforma-project-forms.NoFormsDescriptionJsw': "P\u0159id\xe1vejte pro z\xe1kazn\xedky formul\xe1\u0159e, kter\xe9 maj\xed vyplnit p\u0159i vytv\xe1\u0159en\xed po\u017Eadavk\u016F, nebo p\u0159ipojte formul\xe1\u0159e k\xa0existuj\xedc\xedm po\u017Eadavk\u016Fm, abyste z\xedskali v\xedce informac\xed.",
    'proforma-project-forms.NoFormsDescriptionJwm': "P\u0159id\xe1vejte pro z\xe1kazn\xedky formul\xe1\u0159e, kter\xe9 maj\xed vyplnit p\u0159i vytv\xe1\u0159en\xed polo\u017Eek, nebo p\u0159ipojte formul\xe1\u0159e k\xa0existuj\xedc\xedm po\u017Eadavk\u016Fm, abyste z\xedskali v\xedce informac\xed.",
    'proforma-project-forms.NoFormsHeading': "V\u0161echny va\u0161e formul\xe1\u0159e se zobraz\xed zde",
    'proforma-project-forms.create-form-button.create-blank': "Vytvo\u0159it pr\xe1zdn\xfd formul\xe1\u0159",
    'proforma-project-forms.create-form-button.create-with-template': "Vytvo\u0159it ze \u0161ablony",
    'proforma-project-forms.create-form-button.trigger': "Vytvo\u0159it formul\xe1\u0159"
};

});

parcelRegister("exdNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a94eda258c16f48f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $a94eda258c16f48f$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Rediger',
    'form-system.general.Form': 'Navn',
    'jira-common.ListProjectForms.AffectExistingIssues': "Dette p\xe5virker ikke eksisterende sager, der allerede anvender denne formular, eller kopier af denne formular p\xe5 andre projekter.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Sagstype',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Anmodningstype',
    'jira-common.ListProjectForms.Cancel': 'Annuller',
    'jira-common.ListProjectForms.Copy': "Kopi\xe9r til projekt",
    'jira-common.ListProjectForms.CopyFormErrorTitle': 'Fejl: "{formName}" kunne ikke kopieres',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Formular blev kopieret til et forretningsprojekt} other {Formularen blev kopieret til {numberOfBusinessProjects,number} forretningsprojekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Formularen blev kopieret til {numberOfProjects,number} projekt} other {Formularen blev kopieret til {numberOfProjects,number} projekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" kan nu anvendes p\xe5 "{projectName}"',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage} og {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage} og {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Formularen blev kopieret til et serviceprojekt} other {Formularen blev kopieret til {numberOfServiceProjects,number} serviceprojekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu bruges i {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" kan nu bruges i {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Formularen blev kopieret til et softwareprojekt} other {Formularen blev kopieret til {numberOfSoftwareProjects,number} softwareprojekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" kan nu bruges i {numberOfProjects,number} projekt.} other {"{formName}" kan nu bruges i {numberOfProjects,number} projekter.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Formularen blev kopieret til et projekt} other {Formularen blev kopieret til {numberOfProjects,number} projekter}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Annuller',
    'jira-common.ListProjectForms.CopyModal.Copy': "Kopi\xe9r",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Kopi\xe9r til projekt(er)",
    'jira-common.ListProjectForms.CopyModal.Heading': 'Kopi\xe9r "{formName}" til andre projekter',
    'jira-common.ListProjectForms.CopyModal.LearnMore': "F\xe5 mere at vide om, hvordan du kopierer formularer",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Indl\xe6ser projekter",
    'jira-common.ListProjectForms.CopyModal.Name': 'Navn',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "V\xe6lg alle projekter",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Hvis der foretages \xe6ndringer i en formular, bliver disse \xe6ndringer ikke afspejlet i kopier af formularen, der ligger i andre projekter.",
    'jira-common.ListProjectForms.CopyText': 'Kopi af {formName}',
    'jira-common.ListProjectForms.Delete': 'Slet',
    'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" blev slettet',
    'jira-common.ListProjectForms.Duplicate': 'Dupliker',
    'jira-common.ListProjectForms.EmptyFormName': 'Formular uden titel',
    'jira-common.ListProjectForms.FilterForms': 'Filtrer formularer',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" blev downloadet',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Opdater siden, og pr\xf8v igen.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" blev ikke downloadet',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% fuldf\xf8rt} other {{percentCount,number}\xa0% fuldf\xf8rt}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Downloader "{filename}"',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Eksport\xe9r som xlsx-fil",
    'jira-common.ListProjectForms.FormActions.MoreActions': 'Flere handlinger',
    'jira-common.ListProjectForms.FutureIssueMessage': "Sager, der fremover oprettes med disse sagstyper, vil ikke l\xe6ngere indeholde denne formular:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Fremtidige anmodninger, der oprettes med disse anmodningstyper, vil ikke l\xe6ngere indeholde denne formular.",
    'jira-common.ListProjectForms.Heading': 'Vil du slette "{formName}"?',
    'jira-common.ListProjectForms.IssueType': 'Sagstype',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "S\xf8g efter sagstyper",
    'jira-common.ListProjectForms.LastUpdated': 'Senest opdateret',
    'jira-common.ListProjectForms.LearnMoreLink': "L\xe6s mere om, hvordan du sletter formularer.",
    'jira-common.ListProjectForms.RequestType': 'Anmodningstype',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "S\xf8g efter anmodningstyper",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Hvis du sletter denne formular, fjernes den fra f\xf8lgende sagstyper:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Hvis du sletter denne formular, fjernes den fra f\xf8lgende anmodningstyper:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Kopi\xe9r direkte link",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Sagstype',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Anmodningstype',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} forretningsprojekt} other {{numberOfBusinessProjects,number} forretningsprojekter}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceprojekt} other {{numberOfServiceProjects,number} serviceprojekter}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} softwareprojekt} other {{numberOfSoftwareProjects,number} softwareprojekter}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} sagstyper',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} anmodningstyper',
    'proforma-project-forms.BusinessForms': 'Avancerede formularer',
    'proforma-project-forms.CreateForm': 'Opret formular',
    'proforma-project-forms.Description': "Opret, rediger, eksport\xe9r og slet formularer. Kopi\xe9r formularer, og brug dem i andre projekter.",
    'proforma-project-forms.Forms': 'Formularer',
    'proforma-project-forms.LearnMore': "F\xe5 mere at vide om formularer.",
    'proforma-project-forms.LoadingForms': "Indl\xe6ser \u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "Tilf\xf8j formularer, som kunderne skal udfylde, n\xe5r de opretter en anmodning, eller vedh\xe6ft formularer til eksisterende sager for at indsamle flere oplysninger.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Tilf\xf8j formularer, som kunderne skal udfylde, n\xe5r de opretter en sag, eller vedh\xe6ft formularer til eksisterende sager for at indsamle flere oplysninger.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Tilf\xf8j formularer, som kunderne skal udfylde, n\xe5r de opretter et element, eller vedh\xe6ft formularer til eksisterende sager for at indsamle flere oplysninger.",
    'proforma-project-forms.NoFormsHeading': 'Alle dine formularer bliver vist her',
    'proforma-project-forms.create-form-button.create-blank': 'Opret blank',
    'proforma-project-forms.create-form-button.create-with-template': 'Opret fra skabelon',
    'proforma-project-forms.create-form-button.trigger': 'Opret formular'
};

});

parcelRegister("66gbg", function(module, exports) {

$parcel$export(module.exports, "default", () => $470fdabf97baa29f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $470fdabf97baa29f$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Bearbeiten',
    'form-system.general.Form': 'Name',
    'jira-common.ListProjectForms.AffectExistingIssues': "Dies wirkt sich weder auf bestehende Vorg\xe4nge aus, in denen dieses Formular bereits verwendet wird, noch auf Kopien dieses Formulars in anderen Projekten.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Vorgangstyp',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Anfragetyp',
    'jira-common.ListProjectForms.Cancel': 'Abbrechen',
    'jira-common.ListProjectForms.Copy': 'In Projekt kopieren',
    'jira-common.ListProjectForms.CopyFormErrorTitle': 'Fehler: {formName} konnte nicht kopiert werden.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfBusinessProjectsMessage} verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formular in Gesch\xe4ftsprojekt kopiert} other {Formular in {numberOfBusinessProjects,number}\xa0Gesch\xe4ftsprojekte kopiert}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formular in {numberOfProjects,number}\xa0Projekt kopiert} other {Formular in {numberOfProjects,number}\xa0Projekte kopiert}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" kann jetzt in "{projectName}" verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage} und {numberOfBusinessProjectsMessage} verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage} und {numberOfSoftwareProjectsMessage} verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage} verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formular in Serviceprojekt kopiert} other {Formular in {numberOfServiceProjects,number}\xa0Serviceprojekte kopiert}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} und {numberOfBusinessProjectsMessage} verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" kann jetzt in {numberOfSoftwareProjectsMessage} und {numberOfBusinessProjectsMessage} verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" kann jetzt in {numberOfSoftwareProjectsMessage} verwendet werden.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formular in Softwareprojekt kopiert} other {Formular in {numberOfSoftwareProjects,number}\xa0Softwareprojekte kopiert}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" kann jetzt in {numberOfProjects,number}\xa0Projekt verwendet werden.} other {"{formName}" kann jetzt in {numberOfProjects,number}\xa0Projekten verwendet werden.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formular in Projekt kopiert} other {Formular in {numberOfProjects,number}\xa0Projekte kopiert}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Abbrechen',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Kopieren',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'In Projekt(e) kopieren',
    'jira-common.ListProjectForms.CopyModal.Heading': '"{formName}" in andere Projekte kopieren',
    'jira-common.ListProjectForms.CopyModal.LearnMore': 'Weitere Informationen zum Kopieren von Formularen',
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Projekte werden geladen',
    'jira-common.ListProjectForms.CopyModal.Name': 'Name',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "Alle Projekte ausw\xe4hlen",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "An einem Formular vorgenommene \xc4nderungen werden f\xfcr keine seiner Kopien in anderen Projekten \xfcbernommen.",
    'jira-common.ListProjectForms.CopyText': 'Kopie von {formName}',
    'jira-common.ListProjectForms.Delete': "L\xf6schen",
    'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" gel\xf6scht',
    'jira-common.ListProjectForms.Duplicate': 'Duplizieren',
    'jira-common.ListProjectForms.EmptyFormName': 'Formular ohne Namen',
    'jira-common.ListProjectForms.FilterForms': 'Formulare filtern',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" wurde heruntergeladen',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Aktualisieren Sie die Seite und versuchen Sie es dann erneut.',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" wurde nicht heruntergeladen',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% abgeschlossen} other {{percentCount,number}\xa0% abgeschlossen}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '"{filename}" wird heruntergeladen',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'In XLSX exportieren',
    'jira-common.ListProjectForms.FormActions.MoreActions': 'Weitere Aktionen',
    'jira-common.ListProjectForms.FutureIssueMessage': "Zuk\xfcnftige Vorg\xe4nge, die mit diesen Vorgangstypen erstellt werden, enthalten dieses Formular nicht mehr:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Zuk\xfcnftige Anfragen, die mit diesen Anfragetypen erstellt werden, enthalten dieses Formular nicht mehr.",
    'jira-common.ListProjectForms.Heading': '"{formName}" l\xf6schen?',
    'jira-common.ListProjectForms.IssueType': 'Vorgangstyp',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Vorgangstypen suchen',
    'jira-common.ListProjectForms.LastUpdated': 'Letzte Aktualisierung',
    'jira-common.ListProjectForms.LearnMoreLink': "Weitere Informationen zum L\xf6schen von Formularen.",
    'jira-common.ListProjectForms.RequestType': 'Anfragetyp',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Anfragetypen suchen',
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Wenn Sie dieses Formular l\xf6schen, wird es aus den folgenden Vorgangstypen entfernt:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Wenn Sie dieses Formular l\xf6schen, wird es aus den folgenden Anfragetypen entfernt:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Direktlink kopieren',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Vorgangstyp',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Anfragetyp',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0Gesch\xe4ftsprojekt} other {{numberOfBusinessProjects,number}\xa0Gesch\xe4ftsprojekte}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0Serviceprojekt} other {{numberOfServiceProjects,number}\xa0Serviceprojekte}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0Softwareprojekt} other {{numberOfSoftwareProjects,number}\xa0Softwareprojekte}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count}\xa0Vorgangstypen",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count}\xa0Anfragetypen",
    'proforma-project-forms.BusinessForms': 'Erweiterte Formulare',
    'proforma-project-forms.CreateForm': 'Formular erstellen',
    'proforma-project-forms.Description': "Erstellen, bearbeiten, exportieren und l\xf6schen Sie Formulare. Kopieren Sie Formulare und nutzen Sie sie in anderen Projekten.",
    'proforma-project-forms.Forms': 'Formulare',
    'proforma-project-forms.LearnMore': 'Weitere Informationen zu Formularen',
    'proforma-project-forms.LoadingForms': "Wird geladen\xa0\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "F\xfcgen Sie Formulare hinzu, die Kunden ausf\xfcllen sollen, wenn sie eine Anfrage stellen, oder h\xe4ngen Sie Formulare an bestehende Vorg\xe4nge an, um weitere Informationen zu erfassen.",
    'proforma-project-forms.NoFormsDescriptionJsw': "F\xfcgen Sie Formulare hinzu, die Kunden ausf\xfcllen sollen, wenn sie einen Vorgang erstellen, oder h\xe4ngen Sie Formulare an bestehende Vorg\xe4nge an, um weitere Informationen zu erfassen.",
    'proforma-project-forms.NoFormsDescriptionJwm': "F\xfcgen Sie Formulare hinzu, die Kunden ausf\xfcllen sollen, wenn sie ein Element erstellen, oder h\xe4ngen Sie Formulare an bestehende Vorg\xe4nge an, um weitere Informationen zu erfassen.",
    'proforma-project-forms.NoFormsHeading': 'Alle Ihre Formulare werden hier angezeigt.',
    'proforma-project-forms.create-form-button.create-blank': 'Leeres Formular erstellen',
    'proforma-project-forms.create-form-button.create-with-template': 'Aus Vorlage erstellen',
    'proforma-project-forms.create-form-button.trigger': 'Formular erstellen'
};

});

parcelRegister("ah97k", function(module, exports) {

$parcel$export(module.exports, "default", () => $77b2906c0a287c91$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $77b2906c0a287c91$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Edit',
    'form-system.general.Form': 'Name',
    'jira-common.ListProjectForms.AffectExistingIssues': "This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Issue type',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Request type',
    'jira-common.ListProjectForms.Cancel': 'Cancel',
    'jira-common.ListProjectForms.Copy': 'Copy to project',
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Error: Could not copy \u201C{formName}\u201D over",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': 'Form copied to {numberOfBusinessProjects, plural, one {business project} other {# business projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': 'Form copied to {numberOfProjects, plural, one {# project} other {# projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': 'Form copied to {numberOfServiceProjects, plural, one {service project} other {# service projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': 'Form copied to {numberOfSoftwareProjects, plural, one {software project} other {# software projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfProjects, plural, one {# project} other {# projects}}.",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': 'Form copied to {numberOfProjects, plural, one {project} other {# projects}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancel',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Copy',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copy to project(s)',
    'jira-common.ListProjectForms.CopyModal.Heading': "Copy \u201C{formName}\u201D to other projects",
    'jira-common.ListProjectForms.CopyModal.LearnMore': 'Learn more about copying forms',
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Loading projects',
    'jira-common.ListProjectForms.CopyModal.Name': 'Name',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Select all projects',
    'jira-common.ListProjectForms.CopyModal.SubHeading': 'Changes made to a form are not reflected across any of its copies in other projects.',
    'jira-common.ListProjectForms.CopyText': '{formName} copy',
    'jira-common.ListProjectForms.Delete': 'Delete',
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D deleted",
    'jira-common.ListProjectForms.Duplicate': 'Duplicate',
    'jira-common.ListProjectForms.EmptyFormName': 'Untitled Form',
    'jira-common.ListProjectForms.FilterForms': 'Filter forms',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201C{filename}\u201D downloaded",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Refresh the page and try again.',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201C{filename}\u201D not downloaded",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {# % complete} other {# % complete}}',
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Downloading \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Export in XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': 'More actions',
    'jira-common.ListProjectForms.FutureIssueMessage': 'Future issues created using these issue types will no longer include this form:',
    'jira-common.ListProjectForms.FutureRequestMessage': 'Future requests created using these request types will no longer include this form.',
    'jira-common.ListProjectForms.Heading': "Delete \u201C{formName}\u201D?",
    'jira-common.ListProjectForms.IssueType': 'Issue type',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Search issue types',
    'jira-common.ListProjectForms.LastUpdated': 'Last updated',
    'jira-common.ListProjectForms.LearnMoreLink': 'Learn more about deleting forms.',
    'jira-common.ListProjectForms.RequestType': 'Request type',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Search request types',
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': 'Deleting this form will remove it from the following issue types:',
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': 'Deleting this form will remove it from the following request types:',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copy direct link',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Issue type',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Request type',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {# business project} other {# business projects}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {# service project} other {# service projects}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {# software project} other {# software projects}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} issue types',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} request types',
    'proforma-project-forms.BusinessForms': 'Advanced Forms',
    'proforma-project-forms.CreateForm': 'Create form',
    'proforma-project-forms.Description': 'Create, edit, export, and delete forms. Copy forms and use them in other projects.',
    'proforma-project-forms.Forms': 'Forms',
    'proforma-project-forms.LearnMore': 'Learn more about forms.',
    'proforma-project-forms.LoadingForms': 'Loading...',
    'proforma-project-forms.NoFormsDescriptionJsm': 'Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.',
    'proforma-project-forms.NoFormsDescriptionJsw': 'Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.',
    'proforma-project-forms.NoFormsDescriptionJwm': 'Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.',
    'proforma-project-forms.NoFormsHeading': 'All of your forms will show up here',
    'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
    'proforma-project-forms.create-form-button.convert-form': 'Create from import',
    'proforma-project-forms.create-form-button.create-blank': 'Create blank',
    'proforma-project-forms.create-form-button.create-from-blank': 'Create from blank',
    'proforma-project-forms.create-form-button.create-with-template': 'Create from template',
    'proforma-project-forms.create-form-button.trigger': 'Create form'
};

});

parcelRegister("fAoL9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58d6c85590808b7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $b58d6c85590808b7$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Edit',
    'form-system.general.Form': 'Name',
    'jira-common.ListProjectForms.AffectExistingIssues': "This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Issue type',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Request type',
    'jira-common.ListProjectForms.Cancel': 'Cancel',
    'jira-common.ListProjectForms.Copy': 'Copy to project',
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Error: Could not copy \u201C{formName}\u201D over",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': 'Form copied to {numberOfBusinessProjects, plural, one {business project} other {# business projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': 'Form copied to {numberOfProjects, plural, one {# project} other {# projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': 'Form copied to {numberOfServiceProjects, plural, one {service project} other {# service projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': 'Form copied to {numberOfSoftwareProjects, plural, one {software project} other {# software projects}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "\u201C{formName}\u201D can now be used in {numberOfProjects, plural, one {# project} other {# projects}}.",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': 'Form copied to {numberOfProjects, plural, one {project} other {# projects}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancel',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Copy',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copy to project(s)',
    'jira-common.ListProjectForms.CopyModal.Heading': "Copy \u201C{formName}\u201D to other projects",
    'jira-common.ListProjectForms.CopyModal.LearnMore': 'Learn more about copying forms',
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Loading projects',
    'jira-common.ListProjectForms.CopyModal.Name': 'Name',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Select all projects',
    'jira-common.ListProjectForms.CopyModal.SubHeading': 'Changes made to a form are not reflected across any of its copies in other projects.',
    'jira-common.ListProjectForms.CopyText': '{formName} copy',
    'jira-common.ListProjectForms.Delete': 'Delete',
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D deleted",
    'jira-common.ListProjectForms.Duplicate': 'Duplicate',
    'jira-common.ListProjectForms.EmptyFormName': 'Untitled Form',
    'jira-common.ListProjectForms.FilterForms': 'Filter forms',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201C{filename}\u201D downloaded",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Refresh the page and try again.',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201C{filename}\u201D not downloaded",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {# % complete} other {# % complete}}',
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Downloading \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Export in XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': 'More actions',
    'jira-common.ListProjectForms.FutureIssueMessage': 'Future issues created using these issue types will no longer include this form:',
    'jira-common.ListProjectForms.FutureRequestMessage': 'Future requests created using these request types will no longer include this form.',
    'jira-common.ListProjectForms.Heading': "Delete \u201C{formName}\u201D?",
    'jira-common.ListProjectForms.IssueType': 'Issue type',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Search issue types',
    'jira-common.ListProjectForms.LastUpdated': 'Last updated',
    'jira-common.ListProjectForms.LearnMoreLink': 'Learn more about deleting forms.',
    'jira-common.ListProjectForms.RequestType': 'Request type',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Search request types',
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': 'Deleting this form will remove it from the following issue types:',
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': 'Deleting this form will remove it from the following request types:',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copy direct link',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Issue type',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Request type',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {# business project} other {# business projects}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {# service project} other {# service projects}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {# software project} other {# software projects}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} issue types',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} request types',
    'proforma-project-forms.BusinessForms': 'Advanced Forms',
    'proforma-project-forms.CreateForm': 'Create form',
    'proforma-project-forms.Description': 'Create, edit, export, and delete forms. Copy forms and use them in other projects.',
    'proforma-project-forms.Forms': 'Forms',
    'proforma-project-forms.LearnMore': 'Learn more about forms.',
    'proforma-project-forms.LoadingForms': 'Loading...',
    'proforma-project-forms.NoFormsDescriptionJsm': 'Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.',
    'proforma-project-forms.NoFormsDescriptionJsw': 'Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.',
    'proforma-project-forms.NoFormsDescriptionJwm': 'Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.',
    'proforma-project-forms.NoFormsHeading': 'All of your forms will show up here',
    'proforma-project-forms.create-form-button.atlassian-intelligence-label': 'Atlassian Intelligence',
    'proforma-project-forms.create-form-button.convert-form': 'Create from import',
    'proforma-project-forms.create-form-button.create-blank': 'Create blank',
    'proforma-project-forms.create-form-button.create-from-blank': 'Create from blank',
    'proforma-project-forms.create-form-button.create-with-template': 'Create from template',
    'proforma-project-forms.create-form-button.trigger': 'Create form'
};

});

parcelRegister("gVSMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c53c76e1f7a796ac$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $c53c76e1f7a796ac$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\u2063\u2062Edit\x90\u2061\u2061\u206D\x8f\x81\u206A\x90\u206A\x9d\x8f\u2060\u206F\u206A\u200C\u200D\u206C\u2061\u206D\x90\x81\x81\x9d\x81\u200C\u206E\x90\u200C\u200C\u206B\u206E\x90\u2063\u2064",
    'form-system.general.Form': "\u2063\u2062Name\x8d\x8f\u200C\x8f\x8d\u206B\u061C\x90\u200D\u2061\u2060\u061C\x8d\u2060\u200C\u206D\u200C\u206C\u206E\u200C\u200C\u206B\x90\u2061\x81\u206E\u206F\u206C\u206F\u200C\u206F\u206F\u2063\u2064",
    'jira-common.ListProjectForms.AffectExistingIssues': "\u2063\u2062This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects.\u206F\u2060\x90\u200C\u200D\u206B\u061C\x90\u206D\u200D\x9d\u206C\u061C\u206D\u2061\x8d\u206A\u200C\u2061\u206F\u206A\x8f\u206F\x8d\u200D\x8f\x9d\x90\x8f\u200D\x8d\u061C\u2063\u2064",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\u2063\u2062Issue type\u200D\u206A\x8d\u2060\x8d\u206E\u200C\u206E\u206E\x8f\u2060\u206D\x90\u200C\u206E\u206E\u206C\u2061\u206D\x9d\x81\u206D\u2061\u206C\x90\u200C\x9d\u206F\x9d\x90\u2060\u206E\u2063\u2064",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\u2063\u2062Request type\u206C\u206B\u206D\u206D\u2060\x8f\u206D\x90\u2061\x8f\u206A\u206F\u061C\u200D\u200D\x9d\u206D\x81\x9d\u2061\u206D\x8f\u061C\u2060\x81\u061C\u2060\x8d\u200C\u200C\u200C\u206B\u2063\u2064",
    'jira-common.ListProjectForms.Cancel': "\u2063\u2062Cancel\u206E\x8f\x9d\u200C\u206C\u200D\u206A\u200C\u200D\u2061\x90\u200C\u200C\u061C\x9d\u206F\u206A\x9d\u2060\x8f\x81\x90\u200C\u2061\u200D\u206C\u200C\u206B\u206E\u206B\x9d\u200C\u2063\u2064",
    'jira-common.ListProjectForms.Copy': "\u2063\u2062Copy to project\x8f\x9d\u206D\u200C\u061C\u206C\u206D\x81\u206E\x8d\x8f\u200C\x90\u206B\u206C\u206A\u200D\u206D\u200D\u061C\u206E\u2061\x90\u206F\u200C\x81\u206E\u200D\u200C\u206D\u200D\x9d\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "\u2063\u2062Error: Could not copy \u201C{formName}\u201D over\x90\u206A\u206C\u200C\u206C\x8d\u206E\x90\x81\u2060\u206D\u206A\x8f\u206C\u206C\u206B\u206B\x90\x90\x9d\x9d\x9d\u061C\u206D\x8d\u206A\x90\u061C\u2060\u206C\x8f\u2061\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.\u061C\u061C\u061C\u2061\u206F\u061C\u2060\u206A\u061C\u206E\u206A\x81\u206C\u206B\u2061\u200C\u206C\u200D\u206A\u206B\u206A\x9d\u061C\u061C\u206B\u206D\x8f\u206C\u2060\x90\x90\u206F\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {\u2063\u2062Form copied to business project\u2060\u206C\u206A\x90\x9d\x90\u206D\u200C\u2061\u206B\u206D\u200D\x8d\x90\u206E\u2060\u206B\u206B\u206D\u206C\u2061\u206B\u2061\u061C\u206A\x9d\u206B\u206B\u2060\u206C\u206E\u206E\u2063\u2064} other {\u2063\u2062Form copied to {numberOfBusinessProjects,number} business projects\u2060\u206C\u206A\x90\x9d\x90\u206D\u200C\u2061\u206B\u206D\u200D\x8d\x90\u206E\u2060\u206B\u206B\u206D\u206C\u2061\u206B\u2061\u061C\u206A\x9d\u206B\u206B\u2060\u206C\u206E\u206E\u2063\u2064}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {\u2063\u2062Form copied to {numberOfProjects,number} project\u2061\u206E\u061C\x9d\u200D\u2060\u206D\u206F\u2061\x8d\u2061\x81\u061C\u200D\x90\x8f\x81\u2060\u200D\u200D\u206F\u206B\x90\x8d\u200D\u200C\u200C\u206D\u206A\u200D\u2061\u206F\u2063\u2064} other {\u2063\u2062Form copied to {numberOfProjects,number} projects\u2061\u206E\u061C\x9d\u200D\u2060\u206D\u206F\u2061\x8d\u2061\x81\u061C\u200D\x90\x8f\x81\u2060\u200D\u200D\u206F\u206B\x90\x8d\u200D\u200C\u200C\u206D\u206A\u200D\u2061\u206F\u2063\u2064}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.\x81\u061C\x8f\x90\u2060\x8d\u2061\u206A\u206D\u206D\u2061\x8f\u2060\u206F\x90\u206D\u2060\u2060\u206E\x8f\u2060\u206C\u061C\u206D\u2061\u206C\x81\x81\x8d\x8f\u206E\x90\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.\u206B\u2060\u2060\u206D\x9d\u206B\x8f\u206E\u206A\u206A\u206A\u206E\u200D\u200C\u206F\u061C\x8d\u2061\u2060\u206C\x81\u2061\x9d\u206B\u2061\u2061\u206D\u061C\x90\x90\x8f\u2061\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.\u200D\u206E\u2061\u061C\x9d\x90\u206C\x9d\u206D\u200C\u206E\u061C\x81\u206A\u206C\u206A\u2060\u206E\u206B\u206F\u206F\u206F\x8d\u206E\u200C\u206C\u2061\u2061\u206E\u206A\u2061\u2060\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.\x8f\x9d\u2060\x90\u206F\u206F\u206A\u206D\x8d\u206B\u200C\u206B\u206B\u061C\x8d\u200D\u206F\x90\u206D\u206F\u206D\u2061\u206F\x8f\u206A\u2060\u206C\u200C\u061C\u206A\u206A\u200D\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {\u2063\u2062Form copied to service project\u2060\x8f\u2061\u061C\x81\u206B\u206D\u200C\u206E\u206A\u061C\u2061\x8f\u200D\u061C\u206D\u206C\u206E\u2060\u206F\x9d\x8f\u200C\x8f\u206A\u2060\x8f\x8f\x8d\u061C\u206B\x90\u2063\u2064} other {\u2063\u2062Form copied to {numberOfServiceProjects,number} service projects\u2060\x8f\u2061\u061C\x81\u206B\u206D\u200C\u206E\u206A\u061C\u2061\x8f\u200D\u061C\u206D\u206C\u206E\u2060\u206F\x9d\x8f\u200C\x8f\u206A\u2060\x8f\x8f\x8d\u061C\u206B\x90\u2063\u2064}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.\x90\u206E\x8f\x8d\x8d\u2060\u200C\x9d\x9d\u206A\x9d\x8d\u2060\u206E\u206A\u206C\u2060\u200C\x8d\x9d\x9d\u206D\u200C\x90\u200C\x8d\u206C\u206E\u2060\x9d\u206B\x81\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.\x81\u206D\x90\u2060\u200C\u2061\u061C\x8d\u200C\u206C\x8f\x8f\x8d\x81\u206D\x8d\u206C\x81\x8d\u206E\x90\u200D\x8d\u200C\u061C\u200C\u206B\u206E\u2060\u2061\u2061\u200D\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.\u2061\x81\x9d\u206B\x8f\u206D\u061C\u200D\x8f\x81\x8f\x8d\u206E\u206A\u2060\u061C\x81\x81\x9d\x9d\u206F\u2060\u2061\u206A\u061C\x8f\x8f\x90\u206B\u206D\u061C\x9d\u2063\u2064",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {\u2063\u2062Form copied to software project\x8f\u200D\u206D\x8f\x81\u206C\x9d\x90\u2060\u2061\x81\x8f\x90\x8d\u2061\u2060\u061C\x9d\u200D\u2061\u206C\u206C\u206A\u061C\x8d\u200C\u200C\u206A\u206E\x9d\u206B\x81\u2063\u2064} other {\u2063\u2062Form copied to {numberOfSoftwareProjects,number} software projects\x8f\u200D\u206D\x8f\x81\u206C\x9d\x90\u2060\u2061\x81\x8f\x90\x8d\u2061\u2060\u061C\x9d\u200D\u2061\u206C\u206C\u206A\u061C\x8d\u200C\u200C\u206A\u206E\x9d\u206B\x81\u2063\u2064}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfProjects,number} project.\u206D\u206F\x90\u206A\x8f\u206C\u206E\u206A\x90\u200D\u206D\u206C\u061C\u206B\u206F\u206F\u206D\u206D\x90\x8d\x90\u2060\x9d\x8d\u2061\u200D\x81\x81\x81\u206A\x90\u206D\u2063\u2064} other {\u2063\u2062\u201C{formName}\u201D can now be used in {numberOfProjects,number} projects.\u206D\u206F\x90\u206A\x8f\u206C\u206E\u206A\x90\u200D\u206D\u206C\u061C\u206B\u206F\u206F\u206D\u206D\x90\x8d\x90\u2060\x9d\x8d\u2061\u200D\x81\x81\x81\u206A\x90\u206D\u2063\u2064}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {\u2063\u2062Form copied to project\u206E\u206F\u200C\u206F\u200C\x81\x9d\x8d\u200C\u206F\u206A\x8f\x8f\u2060\x8f\u206C\u206F\x8d\x9d\u206F\u2060\u206B\u200D\x9d\u2061\x9d\u206C\u200C\u206A\u206B\x81\u2061\u2063\u2064} other {\u2063\u2062Form copied to {numberOfProjects,number} projects\u206E\u206F\u200C\u206F\u200C\x81\x9d\x8d\u200C\u206F\u206A\x8f\x8f\u2060\x8f\u206C\u206F\x8d\x9d\u206F\u2060\u206B\u200D\x9d\u2061\x9d\u206C\u200C\u206A\u206B\x81\u2061\u2063\u2064}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u2063\u2062Cancel\u061C\u206D\u206D\u206C\u206F\u200C\u206C\u206F\x90\x8f\u206F\x8f\u206C\u2061\x90\u200C\u200C\x9d\x8f\u200D\u206C\u206A\u206C\u206C\u061C\u2061\u2060\u206D\x9d\u061C\x9d\u206F\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.Copy': "\u2063\u2062Copy\x8d\u206D\u206E\u206A\x8f\u206C\u206E\u061C\x8d\u206C\x81\u200D\u206B\u2061\u200C\x81\x81\u206E\x90\u206F\u206E\x8f\u206A\x9d\u200D\u206B\u206C\u061C\u206E\x90\u2060\u206B\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u2063\u2062Copy to project(s)\u206D\x8d\u206B\u061C\u206A\u061C\u206D\x81\x81\x90\u200C\x9d\u206E\u206C\u206F\u2061\u206C\x81\u206B\u206C\u2061\u200C\u200C\u2061\u200D\u206D\u2061\x90\u206B\u2060\x8d\x8f\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.Heading': "\u2063\u2062Copy \u201C{formName}\u201D to other projects\u206C\u206F\x9d\x8f\u206F\x8f\u200C\x8f\u2060\x81\x90\x8d\u206F\u061C\u061C\u206B\x90\x9d\x8d\u206A\u2060\u206E\u200C\u200D\u200D\u206E\u206E\u2061\u200C\x9d\x8f\u2060\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\u2063\u2062Learn more about copying forms\u206F\u206C\u206D\x90\x81\u206E\u206D\u206F\x8f\x81\u206D\x8d\x81\u206D\u206E\u206E\x90\u206E\u200C\x9d\u206E\u061C\u200D\u2060\u206C\u200C\u2060\x8f\u206A\x8d\x90\x8d\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u2063\u2062Loading projects\u206E\x8f\u206E\u206A\u200D\x9d\u206C\u206F\x81\u061C\x8f\u206A\u206B\u2060\x9d\u206F\x8f\x8f\x81\u206E\x9d\u200D\u206E\u2061\x90\u2061\x8d\u206A\x90\u206C\x8d\x8d\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.Name': "\u2063\u2062Name\u206C\u206B\x8d\x81\u206A\u206D\u206B\u206B\u206A\u206C\u206C\u206D\u206C\u206A\x81\u2061\x9d\u206D\x90\x90\u200D\u2060\x8d\x9d\u200C\u206C\u200C\u200D\u2061\x8f\u206F\u2061\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u2063\u2062Select all projects\x8f\u206D\u200D\u061C\x8d\x9d\u061C\x8f\x90\x90\u200D\u200C\x90\u206A\x8d\u2060\u206D\u206E\x90\u206E\u200C\u206D\x90\x81\u206C\x8d\x8f\x9d\u206A\x81\x81\x90\u2063\u2064",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\u2063\u2062Changes made to a form are not reflected across any of its copies in other projects.\u206E\u2061\u206D\x90\u2061\u206D\x9d\u061C\u2060\x9d\x9d\x9d\u2061\u206C\u206F\x81\u206B\u061C\x9d\u206E\x9d\u206B\u2061\x8f\x8d\u206B\u2061\u206E\u2060\x8f\u2060\u200D\u2063\u2064",
    'jira-common.ListProjectForms.CopyText': "\u2063\u2062{formName} copy\u206D\x8f\x81\x9d\u200C\u206D\u200D\x9d\u206C\u2060\x81\x81\u200D\x9d\x90\u206D\x9d\x81\u206E\u206B\u206C\x8d\u200C\u206B\u206D\x90\x8f\u200C\u206E\u200D\u061C\u061C\u2063\u2064",
    'jira-common.ListProjectForms.Delete': "\u2063\u2062Delete\x81\u206D\u2060\x8f\x9d\u200D\u206E\u206A\x8d\u206F\u206E\x90\u200C\u206C\x81\x8f\u206B\u206D\u200C\u206C\u200D\u206F\x90\u061C\u206A\x8d\u206A\x9d\x9d\x8f\u200C\u2061\u2063\u2064",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u2063\u2062\u201C{formName}\u201D deleted\x8d\u206C\u061C\u206C\u061C\u200C\u206D\u200D\x8f\x8f\u200C\x81\u200D\u200D\u2061\u206A\u200D\u200D\u206A\u206E\u206F\u200C\x90\u206C\u206A\u206B\u206D\u206F\u061C\u200D\u206F\u206C\u2063\u2064",
    'jira-common.ListProjectForms.Duplicate': "\u2063\u2062Duplicate\u061C\u206B\u206C\x81\u206B\u2060\u2061\u206A\u206C\u206D\u2060\x8d\u206C\u206A\u206D\u206E\x81\u200C\x90\x9d\u206A\u206C\u206C\u206B\u206E\u2060\u206D\u206B\u200C\u206B\u206F\x81\u2063\u2064",
    'jira-common.ListProjectForms.EmptyFormName': "\u2063\u2062Untitled Form\u2061\u206D\u206F\x90\x9d\u2061\x90\x8f\u200C\u200C\u200D\x81\x9d\u200D\u2061\u2061\u206D\x9d\u206B\u200D\u206F\u206C\u061C\u200D\x81\x90\x8d\x9d\x9d\u206A\x90\x8d\u2063\u2064",
    'jira-common.ListProjectForms.FilterForms': "\u2063\u2062Filter forms\u206E\u206D\u206B\u2061\u2061\u206E\x81\x81\u206B\u061C\u2060\u206D\u061C\u206D\u2061\u2060\x8f\x81\x90\u206A\u206A\u206F\u061C\u200C\u206B\x90\u206B\u2061\x9d\u2060\u206E\x8d\u2063\u2064",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u2063\u2062\u201C{filename}\u201D downloaded\u200C\x9d\u206F\x8f\u2060\u206B\u200D\u206C\u206F\x9d\u200D\x8f\u061C\x90\u200C\u206F\x81\u206C\u206C\x9d\u061C\x81\u206E\u206B\x81\u061C\u206B\u206D\x8d\u206C\u061C\u206E\u2063\u2064",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u2063\u2062Refresh the page and try again.\u206C\x8d\u200C\u206A\u206C\u206C\u206B\x9d\u2060\u206D\x8f\u2061\u206A\x8d\x8f\x81\u2061\u2060\u206B\x8f\u206E\x81\x8d\x9d\u200C\x8d\u206C\u206D\u206C\u206E\u061C\u206D\u2063\u2064",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u2063\u2062\u201C{filename}\u201D not downloaded\x9d\u061C\u200D\x90\u2061\u206F\x9d\x8f\x90\x8f\u200C\u2060\u2060\x90\u206C\u206D\x8d\u206A\x81\u206E\x8d\u206A\u2061\x90\u206C\u206A\u2060\u200C\u061C\u061C\u206F\u206F\u2063\u2064",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {\u2063\u2062{percentCount,number} % complete\u061C\u206B\x8f\x8f\x9d\x8d\u200C\x8f\x81\u206B\u206A\u2060\u2061\u206D\u206E\x9d\u206B\x90\u200D\u200C\u2061\x90\u206B\u206B\u061C\u061C\u206F\u206D\u2060\u2060\u200C\u2061\u2063\u2064} other {\u2063\u2062{percentCount,number} % complete\u061C\u206B\x8f\x8f\x9d\x8d\u200C\x8f\x81\u206B\u206A\u2060\u2061\u206D\u206E\x9d\u206B\x90\u200D\u200C\u2061\x90\u206B\u206B\u061C\u061C\u206F\u206D\u2060\u2060\u200C\u2061\u2063\u2064}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u2063\u2062Downloading \u201C{filename}\u201D\x8d\u061C\x8d\x81\x81\u206C\x8f\u206A\x90\x90\x81\u206B\u200C\u206A\u206B\x8d\u206B\x8f\x8d\u206D\x8d\u2060\u2061\u2060\u206F\u061C\u2061\x90\x81\x8d\u200D\x8d\u2063\u2064",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u2063\u2062Export in XLSX\x8d\u206D\x90\u206C\u061C\u206D\x9d\x90\u200C\x8f\x8f\x9d\u2061\x90\x90\u206B\x81\u206B\x8d\u206A\u206C\x8d\u061C\u2060\u206B\u206F\x8f\u206C\u206D\u2060\x9d\u206E\u2063\u2064",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\u2063\u2062More actions\u200C\x8d\u200C\u2061\x90\u206B\x8f\x8d\u206B\u206D\u206B\u206C\u2060\x8f\u206C\u206A\u200D\u206B\x9d\u061C\x8f\x8f\u206C\u2060\x9d\u206D\u206F\x90\u061C\u2060\x8d\u206B\u2063\u2064",
    'jira-common.ListProjectForms.FutureIssueMessage': "\u2063\u2062Future issues created using these issue types will no longer include this form:\u200C\x81\x81\x8f\x8f\u206C\u206A\u206A\u206F\u206D\u2060\u2060\x81\x8d\u206A\u206D\u200C\u206B\u206E\x8d\x9d\u200D\x81\u206C\u206B\u2060\u061C\u2061\u206B\u206F\u200D\x8d\u2063\u2064",
    'jira-common.ListProjectForms.FutureRequestMessage': "\u2063\u2062Future requests created using these request types will no longer include this form.\u206D\u206F\u2060\x90\u200C\u2060\u061C\u200C\u206B\u206A\u206C\u206B\u206B\u206C\u206D\u206A\u206B\u206A\u200C\u061C\x8f\u2060\u206F\u206D\x81\u206E\u2060\u206D\u206B\u206C\u206E\x90\u2063\u2064",
    'jira-common.ListProjectForms.Heading': "\u2063\u2062Delete \u201C{formName}\u201D?\u061C\u206D\u2061\u206C\u206E\u206A\x8d\u206B\u200C\u2060\u206A\u2061\u2060\u206A\u206B\u206A\x9d\x90\x9d\u061C\u206C\u206E\u206F\x81\x8d\x8d\u061C\x8d\u206B\x8f\u2060\u2061\u2063\u2064",
    'jira-common.ListProjectForms.IssueType': "\u2063\u2062Issue type\u206F\x9d\x8f\x90\x81\x81\u200D\x9d\u200D\u200C\u206E\u2060\x9d\u206E\u061C\u206B\x8f\u206E\u200D\u206F\u2060\u061C\x81\x8d\u200C\u206B\u200C\u206A\x8f\u206F\u206C\x8f\u2063\u2064",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u2063\u2062Search issue types\u200C\x8f\u206B\x81\u206B\x8f\u206F\u061C\x81\u200C\x8d\u206F\u206D\u200D\x81\x8f\u206E\u206A\x9d\x8d\u206E\u206A\u2060\u2060\u206C\x8d\u2060\u206B\u2060\u206D\u206A\u206D\u2063\u2064",
    'jira-common.ListProjectForms.LastUpdated': "\u2063\u2062Last updated\u2061\u200C\u200D\u200C\x81\u206B\u200D\x9d\u2061\x81\x90\u200D\x8d\u200D\u206B\u200D\x8d\u206A\u2060\x90\x90\x90\u061C\u206A\u206E\u061C\u061C\x90\u206B\u206C\u2060\u200D\u2063\u2064",
    'jira-common.ListProjectForms.LearnMoreLink': "\u2063\u2062Learn more about deleting forms.\u206F\x8d\u2060\u061C\x90\x90\u206E\u206A\u200D\x81\u206D\x81\x9d\x8f\u206E\u206C\u206E\u206D\x81\u206C\u206C\u2060\u061C\u2060\u206C\u200D\x8d\x81\u061C\u200D\u206A\u206B\u2063\u2064",
    'jira-common.ListProjectForms.RequestType': "\u2063\u2062Request type\u206A\u200C\x8d\x8f\u206E\u200C\u206E\u206C\x9d\x81\u200D\u2060\u206F\u2060\x90\u061C\u206D\x9d\u200D\u206A\u061C\u206C\x81\u206D\u200C\u2061\u206D\u061C\u200C\u206C\u200D\u061C\u2063\u2064",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u2063\u2062Search request types\u2061\u2060\u2060\u061C\x9d\u061C\u061C\x81\x90\u061C\u061C\x90\u206D\x8f\u206F\u200C\u206A\x90\u200C\u206D\x8d\u200C\x8f\u206B\u2060\u206C\x81\u206F\x90\x8f\u206F\u206B\u2063\u2064",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u2063\u2062Deleting this form will remove it from the following issue types:\u206C\x81\u2060\u206C\u200C\x81\u2061\x8f\u206F\u206F\x8d\u200C\x8f\u061C\x8d\u206A\u061C\u206F\u206C\u206F\x8d\u2060\u061C\u2060\x9d\u2060\u206B\u206F\x8f\u200D\x90\x8d\u2063\u2064",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u2063\u2062Deleting this form will remove it from the following request types:\u206A\u200C\u206A\x90\u206F\x8f\u206E\u2060\u206B\u206C\u206C\u2061\u206F\u206C\x81\u206E\u206E\u2061\x9d\u2060\u200C\u206C\u206C\u061C\u2060\u206A\u206F\x9d\u200C\x9d\u206D\u200D\u2063\u2064",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u2063\u2062Copy direct link\x8f\x9d\x8f\u206C\u2060\u200D\x81\u206E\u206C\u200C\x90\u206A\u206F\x8d\u206A\u206A\x90\u2061\u061C\u200D\u200C\u2060\x81\u200C\x81\u206C\u061C\x8f\x90\u206D\u206D\u206D\u2063\u2064",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u2063\u2062Issue type\x81\x8f\u2060\u2061\u200C\x8d\u2061\x8d\x8d\u206F\u206A\u206A\u206F\x9d\u206F\u206F\u206F\x9d\u206B\u206C\u206D\u2061\u206A\u206C\u200D\x9d\x9d\u206D\u206F\u200D\u061C\u2061\u2063\u2064",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u2063\u2062Request type\u206A\u200D\u200D\x8f\u206A\x8d\u206C\u206B\x8f\x81\u206D\u206F\u2060\x8d\u206B\x8f\x8f\u206B\u206F\u2060\u061C\u206A\x8d\u206C\u061C\u061C\u206C\u206F\u206C\u200D\u206E\x81\u2063\u2064",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {\u2063\u2062{numberOfBusinessProjects,number} business project\u206D\u206B\u2060\x8f\x90\x81\u206A\u2061\u200D\u206C\u206D\u206B\u206F\u061C\u061C\u200D\u206F\u206F\u206E\u206D\x8f\u200D\u206E\u206B\u2061\u206A\u206E\u206E\x81\x8d\x90\u2060\u2063\u2064} other {\u2063\u2062{numberOfBusinessProjects,number} business projects\u206D\u206B\u2060\x8f\x90\x81\u206A\u2061\u200D\u206C\u206D\u206B\u206F\u061C\u061C\u200D\u206F\u206F\u206E\u206D\x8f\u200D\u206E\u206B\u2061\u206A\u206E\u206E\x81\x8d\x90\u2060\u2063\u2064}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {\u2063\u2062{numberOfServiceProjects,number} service project\u2060\u206B\x8d\u206B\u2061\x8f\u200C\x8f\u206D\u2061\x8f\u061C\u200C\x90\x8d\u206C\u206C\x8f\u2061\u206A\u206D\u206A\u206E\x8d\u206A\u200C\u206E\u206F\u206F\x81\u206E\u206A\u2063\u2064} other {\u2063\u2062{numberOfServiceProjects,number} service projects\u2060\u206B\x8d\u206B\u2061\x8f\u200C\x8f\u206D\u2061\x8f\u061C\u200C\x90\x8d\u206C\u206C\x8f\u2061\u206A\u206D\u206A\u206E\x8d\u206A\u200C\u206E\u206F\u206F\x81\u206E\u206A\u2063\u2064}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {\u2063\u2062{numberOfSoftwareProjects,number} software project\x9d\u2060\x90\u206D\u2060\u2060\x8f\x9d\u206A\x8f\u2060\x8f\u206B\u200C\u061C\x8d\x81\u061C\x8f\u061C\u206A\u2060\u061C\x90\x81\u2061\u061C\u206F\x8d\u200C\u206B\u206B\u2063\u2064} other {\u2063\u2062{numberOfSoftwareProjects,number} software projects\x9d\u2060\x90\u206D\u2060\u2060\x8f\x9d\u206A\x8f\u2060\x8f\u206B\u200C\u061C\x8d\x81\u061C\x8f\u061C\u206A\u2060\u061C\x90\x81\u2061\u061C\u206F\x8d\u200C\u206B\u206B\u2063\u2064}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\u2063\u2062{count} issue types\u206F\x8d\x8f\x8f\u2061\u061C\u206F\u206E\u206A\u206C\x9d\x9d\u206C\u206B\u200D\u206B\u206C\u206E\u061C\u2060\u200C\u206E\u206B\u206D\u2060\u200C\x8d\u206D\x81\x9d\u206C\x81\u2063\u2064",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\u2063\u2062{count} request types\x8d\x90\u200C\u206C\x9d\u206F\u206F\u206B\u200D\u206B\u206F\u206B\u206E\u2061\u206A\u206F\u206D\u200C\u206F\x9d\u206B\u061C\u200D\x81\x9d\u206B\u206D\x81\u2060\x9d\u061C\u206C\u2063\u2064",
    'proforma-project-forms.BusinessForms': "\u2063\u2062Advanced Forms\u206A\x90\u206D\u206A\x8f\u206C\u2061\u206D\x8f\u206E\x8d\x8f\u2061\u2061\x90\u206A\u206B\u206B\u206F\x81\u206B\u200D\x81\u2061\u2060\x9d\u200C\x8f\u2061\x81\x90\u206D\u2063\u2064",
    'proforma-project-forms.CreateForm': "\u2063\u2062Create form\u2060\x8d\u206A\u2061\u206B\u200D\u200C\x81\x9d\u206B\u206A\u200D\x81\u061C\u206B\x8f\u206B\x8f\u206D\u206F\x9d\x8d\x81\u206B\u061C\x9d\x8d\u206A\u061C\u206D\u206B\x9d\u2063\u2064",
    'proforma-project-forms.Description': "\u2063\u2062Create, edit, export, and delete forms. Copy forms and use them in other projects.\x9d\u2061\x8f\u206D\x9d\u200C\u200C\x90\u206B\u206B\u200C\u2060\u206F\u206F\x8f\u206A\u2060\u206D\x81\x81\u206D\x81\u200C\u200C\x81\u206E\u206C\x8f\u200D\u206B\u206C\u206E\u2063\u2064",
    'proforma-project-forms.Forms': "\u2063\u2062Forms\x8f\u206F\x8f\x8f\u061C\x8f\x9d\u206D\u206B\u206D\x81\u206E\x81\u061C\u2061\x90\u206F\u2060\u206B\u206C\u206F\x81\x8d\x8f\u200C\u2060\u206D\u206C\x90\u206F\u2060\u200D\u2063\u2064",
    'proforma-project-forms.LearnMore': "\u2063\u2062Learn more about forms.\u200C\x8d\u206D\u206D\u206D\x9d\u061C\u206F\u200C\u2060\u061C\u206E\x9d\u206F\u206C\u206A\x90\u206D\x90\x90\u2060\x81\u206F\u061C\u206D\x8d\x8f\u206B\x90\u206E\u206C\x9d\u2063\u2064",
    'proforma-project-forms.LoadingForms': "\u2063\u2062Loading...\u206A\u206D\u206A\x81\u2060\u061C\x8d\u206A\x81\x81\u206C\x8d\u200D\u2060\u2061\x9d\u200C\u2060\u2060\u206F\u206E\u206D\u206E\u200D\x9d\x90\x8f\x8d\x9d\u2060\u2061\u206A\u2063\u2064",
    'proforma-project-forms.NoFormsDescriptionJsm': "\u2063\u2062Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.\x8d\x81\x81\u206E\u206D\x90\u206F\u206C\u206E\u206C\u206F\u2061\u206E\u061C\u206B\u206D\u061C\u206D\u206F\u206B\u206F\u2060\u206D\x90\u2061\x9d\x90\x90\x81\x8f\x8f\u061C\u2063\u2064",
    'proforma-project-forms.NoFormsDescriptionJsw': "\u2063\u2062Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.\x9d\x81\u206D\x8d\u206C\x81\x8d\x81\u061C\x9d\u206C\x8d\u206E\x90\u206F\u206A\u206F\x8f\x8f\u061C\u200C\u206A\x8f\x8f\u206B\u061C\u206C\x90\u2060\x8d\u206F\u206C\u2063\u2064",
    'proforma-project-forms.NoFormsDescriptionJwm': "\u2063\u2062Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.\u2060\u200C\x8d\u206A\x8d\u206E\u206E\u206B\u061C\u2060\u206B\u061C\u2060\u206E\x81\u206D\x8d\x9d\x8d\x8f\u200D\u200C\u200C\x81\u200D\x8f\x8f\u206E\u061C\u2060\u206A\u206D\u2063\u2064",
    'proforma-project-forms.NoFormsHeading': "\u2063\u2062All of your forms will show up here\u206E\u2060\x9d\u2060\u206A\u061C\u200C\u2060\u200C\u2061\x9d\x81\u206C\x81\u200D\u206C\u061C\x9d\u206C\u206F\u2060\u206A\x9d\x8d\u200D\x8f\u206A\u2060\u206C\u206E\u2060\u200D\u2063\u2064",
    'proforma-project-forms.create-form-button.atlassian-intelligence-label': "\u2063\u2062Atlassian Intelligence\u200C\u206E\u206A\u200C\x9d\u200D\x90\x81\u200C\x8d\u206C\u206C\u200D\u206E\u2060\x81\u206A\u2060\u2060\x8f\u206B\u2061\u2060\x8f\x8d\u200C\x9d\x8d\x8f\u2060\x81\u206A\u2063\u2064",
    'proforma-project-forms.create-form-button.convert-form': "\u2063\u2062Create from import\u200C\x90\x90\u206D\u061C\x8f\x9d\u206B\u2061\u206D\u206F\u200C\u206C\u206D\u206B\u061C\u2061\u206A\u200C\u2060\x81\x81\x9d\u206F\u206C\u200D\x9d\u2061\u206C\u061C\u206B\u206A\u2063\u2064",
    'proforma-project-forms.create-form-button.create-blank': "\u2063\u2062Create blank\u206C\u200C\u2060\u200D\u2060\u061C\u206C\u2060\x8d\u206E\u200D\u200D\x9d\u206A\u206C\u206E\u206E\u061C\u200C\u2060\u206E\u206E\u200D\u200C\x90\u206A\u206C\u206F\x90\u2060\u206A\x90\u2063\u2064",
    'proforma-project-forms.create-form-button.create-from-blank': "\u2063\u2062Create from blank\x8d\u206D\u206C\x9d\u200D\u206D\x90\u200C\x81\x9d\u206B\u206C\x9d\x8f\u206F\u206D\x90\u061C\u206A\x90\u061C\x90\x8d\u2061\u200D\u206A\u206F\u206E\u200C\u206F\u2061\u206F\u2063\u2064",
    'proforma-project-forms.create-form-button.create-with-template': "\u2063\u2062Create from template\u200C\u206A\x9d\u2061\u206C\u206A\u206C\x8d\x81\u2061\u206C\x8f\x8f\x81\u206B\x9d\x8d\u2060\x81\x9d\u206E\u206A\x9d\u200D\u061C\u206A\x90\u2060\u2061\u206F\x90\x9d\u2063\u2064",
    'proforma-project-forms.create-form-button.trigger': "\u2063\u2062Create form\x8d\u206F\x8f\u206C\u200C\u200D\u200C\x8d\u200D\u200D\u206E\x8d\x81\u206B\u206A\u061C\u200D\u2060\x8d\x8d\u200D\x81\u206F\x90\u206A\x81\x90\u061C\u206F\u206F\x90\u206E\u2063\u2064"
};

});

parcelRegister("fzlBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b55ae24306065955$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $b55ae24306065955$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Editar',
    'form-system.general.Form': 'Nombre',
    'jira-common.ListProjectForms.AffectExistingIssues': "Esto no afectar\xe1 a las incidencias existentes que ya usen este formulario ni a ninguna copia de este formulario en otros proyectos.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Tipo de incidencia',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Tipo de solicitud',
    'jira-common.ListProjectForms.Cancel': 'Cancelar',
    'jira-common.ListProjectForms.Copy': 'Copiar en el proyecto',
    'jira-common.ListProjectForms.CopyFormErrorTitle': 'Error: No se ha podido copiar "{formName}"',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Formulario copiado en el proyecto empresarial} other {Formulario copiado en {numberOfBusinessProjects,number} proyectos empresariales}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Formulario copiado en {numberOfProjects,number} proyecto} other {Formulario copiado en {numberOfProjects,number} proyectos}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" ahora se puede utilizar en "{projectName}".',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage} y {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage} y {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Formulario copiado en el proyecto de asistencia} other {Formulario copiado en {numberOfServiceProjects,number} proyectos de asistencia}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} y {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfSoftwareProjectsMessage} y {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" ahora se puede utilizar en {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Formulario copiado en el proyecto de software} other {Formulario copiado en {numberOfSoftwareProjects,number} proyectos de software}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" ahora se puede utilizar en {numberOfProjects,number} proyecto.} other {"{formName}" ahora se puede utilizar en {numberOfProjects,number} proyectos.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Formulario copiado en el proyecto} other {Formulario copiado en {numberOfProjects,number} proyectos}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancelar',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Copiar',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copiar en proyectos',
    'jira-common.ListProjectForms.CopyModal.Heading': 'Copiar "{formName}" en otros proyectos',
    'jira-common.ListProjectForms.CopyModal.LearnMore': "M\xe1s informaci\xf3n sobre c\xf3mo copiar formularios",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Cargando proyectos',
    'jira-common.ListProjectForms.CopyModal.Name': 'Nombre',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Seleccionar todos los proyectos',
    'jira-common.ListProjectForms.CopyModal.SubHeading': 'Los cambios realizados en un formulario no se reflejan en ninguna de sus copias en otros proyectos.',
    'jira-common.ListProjectForms.CopyText': 'Copia de {formName}',
    'jira-common.ListProjectForms.Delete': 'Eliminar',
    'jira-common.ListProjectForms.DeleteFormSuccess': 'Se ha eliminado "{formName}"',
    'jira-common.ListProjectForms.Duplicate': 'Duplicar',
    'jira-common.ListProjectForms.EmptyFormName': "Formulario sin t\xedtulo",
    'jira-common.ListProjectForms.FilterForms': 'Filtrar formularios',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" se ha descargado',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Actualiza la p\xe1gina e int\xe9ntalo de nuevo.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" no se ha descargado',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {{percentCount,number} % completado} other {{percentCount,number} % completado}}',
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Descargando "{filename}"',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportar en XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': "M\xe1s acciones",
    'jira-common.ListProjectForms.FutureIssueMessage': "Las incidencias futuras creadas con estos tipos de incidencia ya no incluir\xe1n este formulario:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Las futuras solicitudes creadas con estos tipos de solicitudes ya no incluir\xe1n este formulario.",
    'jira-common.ListProjectForms.Heading': '\xbfQuieres eliminar "{formName}"?',
    'jira-common.ListProjectForms.IssueType': 'Tipo de incidencia',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Buscar tipos de incidencias',
    'jira-common.ListProjectForms.LastUpdated': "\xdaltima actualizaci\xf3n",
    'jira-common.ListProjectForms.LearnMoreLink': "M\xe1s informaci\xf3n sobre c\xf3mo eliminar formularios.",
    'jira-common.ListProjectForms.RequestType': 'Tipo de solicitud',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Buscar tipos de solicitud',
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Al eliminar este formulario, se eliminar\xe1 de los siguientes tipos de incidencias:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Al eliminar este formulario, se eliminar\xe1 de los siguientes tipos de solicitud:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copiar enlace directo',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Tipo de incidencia',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Tipo de solicitud',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} proyecto empresarial} other {{numberOfBusinessProjects,number} proyectos empresariales}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} proyecto de asistencia} other {{numberOfServiceProjects,number} proyectos de asistencia}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} proyecto de software} other {{numberOfSoftwareProjects,number} proyectos de software}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} tipos de incidencia',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} tipos de solicitud',
    'proforma-project-forms.BusinessForms': 'Formularios avanzados',
    'proforma-project-forms.CreateForm': 'Crear formulario',
    'proforma-project-forms.Description': "Crea, edita, exporta y elimina formularios. Copia formularios y util\xedzalos en otros proyectos.",
    'proforma-project-forms.Forms': 'Formularios',
    'proforma-project-forms.LearnMore': "M\xe1s informaci\xf3n sobre los formularios.",
    'proforma-project-forms.LoadingForms': 'Cargando...',
    'proforma-project-forms.NoFormsDescriptionJsm': "A\xf1ade formularios para que los clientes los cumplimenten cuando presenten una solicitud o adjunta formularios a las incidencias existentes para recopilar m\xe1s informaci\xf3n.",
    'proforma-project-forms.NoFormsDescriptionJsw': "A\xf1ade formularios para que los clientes los cumplimenten cuando creen una incidencia o adjunta formularios a las incidencias existentes para recopilar m\xe1s informaci\xf3n.",
    'proforma-project-forms.NoFormsDescriptionJwm': "A\xf1ade formularios para que los clientes los cumplimenten cuando creen un elemento o adjunta formularios a las incidencias existentes para recopilar m\xe1s informaci\xf3n.",
    'proforma-project-forms.NoFormsHeading': "Todos tus formularios aparecer\xe1n aqu\xed",
    'proforma-project-forms.create-form-button.create-blank': 'Crear formulario en blanco',
    'proforma-project-forms.create-form-button.create-with-template': 'Crear desde plantilla',
    'proforma-project-forms.create-form-button.trigger': 'Crear formulario'
};

});

parcelRegister("wml6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $06145169587f4fcd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $06145169587f4fcd$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Muokkaa',
    'form-system.general.Form': 'Nimi',
    'jira-common.ListProjectForms.AffectExistingIssues': "T\xe4m\xe4 ei vaikuta olemassa oleviin asioihin, jotka k\xe4ytt\xe4v\xe4t jo t\xe4t\xe4 lomaketta, tai t\xe4m\xe4n lomakkeen kopioihin muissa projekteissa.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Asiatyyppi',
    'jira-common.ListProjectForms.AssociatedRequestTypes': "Pyynt\xf6tyyppi",
    'jira-common.ListProjectForms.Cancel': 'Peruuta',
    'jira-common.ListProjectForms.Copy': 'Kopioi projektiin',
    'jira-common.ListProjectForms.CopyFormErrorTitle': 'Virhe: lomaketta {formName} ei voitu kopioida',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 projektissa {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Lomake kopioitu liiketoimintaprojektiin} other {Lomake kopioitu {numberOfBusinessProjects,number} liiketoimintaprojektiin}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Lomake kopioitu {numberOfProjects,number} projektiin} other {Lomake kopioitu {numberOfProjects,number} projektiin}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Lomaketta {formName} voi nyt k\xe4ytt\xe4\xe4 projektissa {projectName}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage} ja {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage} ja {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Lomake kopioitu palveluprojektiin} other {Lomake kopioitu {numberOfServiceProjects,number} palveluprojektiin}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} ja {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfSoftwareProjectsMessage} ja {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 seuraavissa: {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Lomake kopioitu ohjelmistoprojektiin} other {Lomake kopioitu {numberOfSoftwareProjects,number} ohjelmistoprojektiin}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 {numberOfProjects,number} projektissa.} other {Lomaketta "{formName}" voi nyt k\xe4ytt\xe4\xe4 {numberOfProjects,number} projektissa.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Lomake kopioitu projektiin} other {Lomake kopioitu {numberOfProjects,number} projektiin}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Peruuta',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Kopioi',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Kopioi projekteihin',
    'jira-common.ListProjectForms.CopyModal.Heading': 'Kopioi {formName} muihin projekteihin',
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Lue lis\xe4\xe4 lomakkeiden kopioimisesta",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Ladataan projekteja',
    'jira-common.ListProjectForms.CopyModal.Name': 'Nimi',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Valitse kaikki projektit',
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Lomakkeeseen tehdyt muutokset eiv\xe4t vaikuta sen kopioihin muissa projekteissa.",
    'jira-common.ListProjectForms.CopyText': 'Lomakkeen {formName} kopio',
    'jira-common.ListProjectForms.Delete': 'Poista',
    'jira-common.ListProjectForms.DeleteFormSuccess': '{formName} poistettu',
    'jira-common.ListProjectForms.Duplicate': 'Kopioi',
    'jira-common.ListProjectForms.EmptyFormName': "Nimet\xf6n lomake",
    'jira-common.ListProjectForms.FilterForms': 'Suodata lomakkeita',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '{filename} ladattiin',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "P\xe4ivit\xe4 sivu ja yrit\xe4 uudelleen.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': 'Tiedostoa {filename} ei ladattu',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% valmiina} other {{percentCount,number}\xa0% valmiina}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Tiedostoa {filename} ladataan',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Vie XLSX-muodossa',
    'jira-common.ListProjectForms.FormActions.MoreActions': "Lis\xe4\xe4 toimintoja",
    'jira-common.ListProjectForms.FutureIssueMessage': "Tulevat asiat, jotka luodaan k\xe4ytt\xe4en n\xe4it\xe4 asiatyyppej\xe4, eiv\xe4t en\xe4\xe4 sis\xe4ll\xe4 t\xe4t\xe4 lomaketta:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Tulevat pyynn\xf6t, jotka luodaan k\xe4ytt\xe4en n\xe4it\xe4 pyynt\xf6tyyppej\xe4, eiv\xe4t en\xe4\xe4 sis\xe4ll\xe4 t\xe4t\xe4 lomaketta.",
    'jira-common.ListProjectForms.Heading': 'Poistetaanko "{formName}"?',
    'jira-common.ListProjectForms.IssueType': 'Asiatyyppi',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "Hae asiatyyppej\xe4",
    'jira-common.ListProjectForms.LastUpdated': "Viimeksi p\xe4ivitetty",
    'jira-common.ListProjectForms.LearnMoreLink': "Lue lis\xe4\xe4 lomakkeiden poistamisesta.",
    'jira-common.ListProjectForms.RequestType': "Pyynt\xf6tyyppi",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "Hae pyynt\xf6tyyppej\xe4",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "T\xe4m\xe4n lomakkeen poistaminen poistaa sen seuraavista asiatyypeist\xe4:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "T\xe4m\xe4n lomakkeen poistaminen poistaa sen seuraavista pyynt\xf6tyypeist\xe4:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Kopioi suora linkki',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Asiatyyppi',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Pyynt\xf6tyyppi",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} liiketoimintaprojekti} other {{numberOfBusinessProjects,number} liiketoimintaprojektia}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} palveluprojekti} other {{numberOfServiceProjects,number} palveluprojektia}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} ohjelmistoprojekti} other {{numberOfSoftwareProjects,number} ohjelmistoprojektia}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} asiatyyppi\xe4",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} pyynt\xf6tyyppi\xe4",
    'proforma-project-forms.BusinessForms': 'Edistyneet lomakkeet',
    'proforma-project-forms.CreateForm': 'Luo lomake',
    'proforma-project-forms.Description': "Luo, muokkaa, vie ja poista lomakkeita. Kopioi lomakkeita ja k\xe4yt\xe4 niit\xe4 muissa projekteissa.",
    'proforma-project-forms.Forms': 'Lomakkeet',
    'proforma-project-forms.LearnMore': "Lue lis\xe4\xe4 lomakkeista.",
    'proforma-project-forms.LoadingForms': 'Ladataan...',
    'proforma-project-forms.NoFormsDescriptionJsm': "Lis\xe4\xe4 lomakkeita, joita asiakkaat voivat t\xe4ytt\xe4\xe4 tehdess\xe4\xe4n pyynn\xf6n, tai liit\xe4 lomakkeita olemassa oleviin asioihin lis\xe4tietojen ker\xe4\xe4mist\xe4 varten.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Lis\xe4\xe4 lomakkeita, joita asiakkaat voivat t\xe4ytt\xe4\xe4 luodessaan asian, tai liit\xe4 lomakkeita olemassa oleviin asioihin lis\xe4tietojen ker\xe4\xe4mist\xe4 varten.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Lis\xe4\xe4 lomakkeita, joita asiakkaat voivat t\xe4ytt\xe4\xe4 luodessaan teht\xe4v\xe4n, tai liit\xe4 lomakkeita olemassa oleviin asioihin lis\xe4tietojen ker\xe4\xe4mist\xe4 varten.",
    'proforma-project-forms.NoFormsHeading': "Kaikki lomakkeesi n\xe4kyv\xe4t t\xe4\xe4ll\xe4",
    'proforma-project-forms.create-form-button.create-blank': "Luo tyhj\xe4",
    'proforma-project-forms.create-form-button.create-with-template': 'Luo sivupohjasta',
    'proforma-project-forms.create-form-button.trigger': 'Luo lomake'
};

});

parcelRegister("aI2Ak", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cc004bcd8402a5e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $7cc004bcd8402a5e$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Modifier',
    'form-system.general.Form': 'Nom',
    'jira-common.ListProjectForms.AffectExistingIssues': "Cela n'affectera pas les tickets existants qui utilisent d\xe9j\xe0 ce formulaire, ni aucune copie de ce formulaire dans d'autres projets.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Type de ticket',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Type de demande',
    'jira-common.ListProjectForms.Cancel': 'Annuler',
    'jira-common.ListProjectForms.Copy': 'Copier vers un projet',
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Erreur\xa0: impossible de copier le formulaire \xab\xa0{formName}\xa0\xbb vers le projet",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formulaire copi\xe9 vers le projet m\xe9tier} other {Formulaire copi\xe9 vers {numberOfBusinessProjects,number}\xa0projets m\xe9tier}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formulaire copi\xe9 vers {numberOfProjects,number}\xa0projet} other {Formulaire copi\xe9 vers {numberOfProjects,number}\xa0projets}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans \xab\xa0{projectName}\xa0\xbb.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage} et {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage} et {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formulaire copi\xe9 vers le projet de services} other {Formulaire copi\xe9 vers {numberOfServiceProjects,number}\xa0projets de services}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} et {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfSoftwareProjectsMessage} et {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formulaire copi\xe9 vers le projet logiciel} other {Formulaire copi\xe9 vers {numberOfSoftwareProjects,number}\xa0projets logiciels}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfProjects,number}\xa0projet.} other {\xab\xa0{formName}\xa0\xbb peut d\xe9sormais \xeatre utilis\xe9 dans {numberOfProjects,number}\xa0projets.}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formulaire copi\xe9 vers le projet} other {Formulaire copi\xe9 vers {numberOfProjects,number}\xa0projets}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Annuler',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Copier',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copier vers un ou plusieurs projets',
    'jira-common.ListProjectForms.CopyModal.Heading': "Copier \xab\xa0{formName}\xa0\xbb vers d'autres projets",
    'jira-common.ListProjectForms.CopyModal.LearnMore': 'En savoir plus sur la copie de formulaires',
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Chargement de projets en cours',
    'jira-common.ListProjectForms.CopyModal.Name': 'Nom',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "S\xe9lectionner tous les projets",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Les changements apport\xe9s \xe0 un formulaire ne sont pas appliqu\xe9s \xe0 ses copies dans d'autres projets.",
    'jira-common.ListProjectForms.CopyText': "Copie de\xa0{formName}",
    'jira-common.ListProjectForms.Delete': 'Supprimer',
    'jira-common.ListProjectForms.DeleteFormSuccess': "\xab\xa0{formName}\xa0\xbb a \xe9t\xe9 supprim\xe9",
    'jira-common.ListProjectForms.Duplicate': 'Dupliquer',
    'jira-common.ListProjectForms.EmptyFormName': 'Formulaire sans titre',
    'jira-common.ListProjectForms.FilterForms': 'Filtrez les formulaires',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\xab\xa0{filename}\xa0\xbb t\xe9l\xe9charg\xe9",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Actualisez la page, puis r\xe9essayez.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\xab\xa0{filename}\xa0\xbb non t\xe9l\xe9charg\xe9",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% termin\xe9} other {{percentCount,number}\xa0% termin\xe9s}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "T\xe9l\xe9chargement de \xab\xa0{filename}\xa0\xbb",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Exporter au format\xa0XLSX",
    'jira-common.ListProjectForms.FormActions.MoreActions': "Plus d'actions",
    'jira-common.ListProjectForms.FutureIssueMessage': "Les tickets ult\xe9rieurs cr\xe9\xe9s \xe0 l'aide de ces types de ticket ne seront plus inclus dans ce formulaire\xa0:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Les demandes ult\xe9rieures cr\xe9\xe9es \xe0 l'aide de ces types de demande ne seront plus incluses dans ce formulaire.",
    'jira-common.ListProjectForms.Heading': "Supprimer \xab\xa0{formName}\xa0\xbb\xa0?",
    'jira-common.ListProjectForms.IssueType': 'Type de ticket',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Rechercher des types de ticket',
    'jira-common.ListProjectForms.LastUpdated': "Derni\xe8re mise \xe0 jour",
    'jira-common.ListProjectForms.LearnMoreLink': 'En savoir plus sur la suppression de formulaires.',
    'jira-common.ListProjectForms.RequestType': 'Type de demande',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Rechercher des types de demande',
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Si vous supprimez ce formulaire, il sera supprim\xe9 des types de ticket suivants\xa0:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Si vous supprimez ce formulaire, il sera supprim\xe9 des types de demande suivants\xa0:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copier le lien direct',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Type de ticket',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Type de demande',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0projet m\xe9tier} other {{numberOfBusinessProjects,number}\xa0projets m\xe9tier}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0projet de services} other {{numberOfServiceProjects,number}\xa0projets de services}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0projet logiciel} other {{numberOfSoftwareProjects,number}\xa0projets logiciels}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count}\xa0types de tickets",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count}\xa0types de demandes",
    'proforma-project-forms.BusinessForms': "Formulaires avanc\xe9s",
    'proforma-project-forms.CreateForm': "Cr\xe9er un formulaire",
    'proforma-project-forms.Description': "Cr\xe9ez, modifiez, exportez et supprimez des formulaires. Copiez des formulaires et utilisez-les dans d'autres projets.",
    'proforma-project-forms.Forms': 'Formulaires',
    'proforma-project-forms.LearnMore': 'En savoir plus sur les formulaires.',
    'proforma-project-forms.LoadingForms': "Chargement\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "Ajoutez des formulaires que les clients doivent remplir lorsqu'ils cr\xe9ent une demande, ou joignez des formulaires aux tickets existants pour recueillir plus d'informations.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Ajoutez des formulaires que les clients doivent remplir lorsqu'ils cr\xe9ent un ticket, ou joignez des formulaires aux tickets existants pour recueillir plus d'informations.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Ajoutez des formulaires que les clients doivent remplir lorsqu'ils cr\xe9ent un \xe9l\xe9ment, ou joignez des formulaires aux tickets existants pour recueillir plus d'informations.",
    'proforma-project-forms.NoFormsHeading': "Tous vos formulaires s'afficheront ici",
    'proforma-project-forms.create-form-button.create-blank': "Cr\xe9er un formulaire vierge",
    'proforma-project-forms.create-form-button.create-with-template': "Cr\xe9er \xe0 partir d'un mod\xe8le",
    'proforma-project-forms.create-form-button.trigger': "Cr\xe9er un formulaire"
};

});

parcelRegister("7HihG", function(module, exports) {

$parcel$export(module.exports, "default", () => $59aabb6ec6a744c0$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $59aabb6ec6a744c0$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "Szerkeszt\xe9s",
    'form-system.general.Form': "N\xe9v",
    'jira-common.ListProjectForms.AffectExistingIssues': "Ez nem \xe9rinti azokat a l\xe9tez\u0151 \xfcgyeket, amelyek m\xe1r haszn\xe1lj\xe1k ezt az \u0171rlapot, sem az \u0171rlap m\xe1s projektekben haszn\xe1lt m\xe1solatait.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\xdcgyt\xedpus",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "K\xe9relemt\xedpus",
    'jira-common.ListProjectForms.Cancel': "M\xe9gse",
    'jira-common.ListProjectForms.Copy': "M\xe1sol\xe1s projektbe",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Hiba: Nem siker\xfclt m\xe1solni a k\xf6vetkez\u0151t: \u201E{formName}\u201C",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Az \u0171rlap bem\xe1solva az \xfczleti projektbe} other {Az \u0171rlap bem\xe1solva {numberOfBusinessProjects,number} projektbe}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Az \u0171rlap bem\xe1solva {numberOfProjects,number} projektbe} other {Az \u0171rlap bem\xe1solva {numberOfProjects,number} projektbe}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "A(z) \u201E{formName}\u201C \u0171rlap most m\xe1r haszn\xe1lhat\xf3 ebben a projektben: \u201E{projectName}\u201C.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage} \xe9s {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage} \xe9s {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Az \u0171rlap bem\xe1solva az \xfcgyf\xe9lszolg\xe1lati projektbe} other {Az \u0171rlap bem\xe1solva {numberOfServiceProjects,number} \xfcgyf\xe9lszolg\xe1lati projektbe}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \xe9s {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfSoftwareProjectsMessage} \xe9s {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 itt: {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Az \u0171rlap bem\xe1solva a szoftverprojektbe} other {Az \u0171rlap bem\xe1solva {numberOfSoftwareProjects,number} szoftverprojektbe}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 {numberOfProjects,number} projektben.} other {A(z) "{formName}" \u0171rlap most m\xe1r haszn\xe1lhat\xf3 {numberOfProjects,number} projektben.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Az \u0171rlap bem\xe1solva a projektbe} other {Az \u0171rlap bem\xe1solva {numberOfProjects,number} projektbe}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "M\xe9gse",
    'jira-common.ListProjectForms.CopyModal.Copy': "M\xe1sol\xe1s",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "M\xe1sol\xe1s projekt(ek)be",
    'jira-common.ListProjectForms.CopyModal.Heading': "A(z) \u201E{formName}\u201C \u0171rlap m\xe1sol\xe1sa m\xe1s projektekbe",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Tov\xe1bbi inform\xe1ci\xf3 az \u0171rlapok m\xe1sol\xe1s\xe1r\xf3l",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Projektek bet\xf6lt\xe9se",
    'jira-common.ListProjectForms.CopyModal.Name': "N\xe9v",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\xd6sszes projekt kijel\xf6l\xe9se",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Az \u0171rlapokon v\xe9grehajtott m\xf3dos\xedt\xe1sok nem jelennek meg a m\xe1s projektekben tal\xe1lhat\xf3 m\xe1solatokban.",
    'jira-common.ListProjectForms.CopyText': "{formName} m\xe1solata",
    'jira-common.ListProjectForms.Delete': "T\xf6rl\xe9s",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u201E{formName}\u201D t\xf6r\xf6lve",
    'jira-common.ListProjectForms.Duplicate': "Duplik\xe1l\xe1s",
    'jira-common.ListProjectForms.EmptyFormName': "C\xedm n\xe9lk\xfcli \u0171rlap",
    'jira-common.ListProjectForms.FilterForms': "\u0170rlapok sz\u0171r\xe9se",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201E{filename}\u201C let\xf6ltve",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Friss\xedtsd az oldalt, majd pr\xf3b\xe1lkozz \xfajra.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201E{filename}\u201C nincs let\xf6ltve",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number} % k\xe9sz} other {{percentCount,number} % k\xe9sz}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u201E{filename}\u201C let\xf6lt\xe9se folyamatban",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Export\xe1l\xe1s XLSX form\xe1tumban",
    'jira-common.ListProjectForms.FormActions.MoreActions': "Tov\xe1bbi m\u0171veletek",
    'jira-common.ListProjectForms.FutureIssueMessage': "Az ezen \xfcgyt\xedpusok felhaszn\xe1l\xe1s\xe1val l\xe9trehozott, j\xf6v\u0151beni \xfcgyekben m\xe1r nem fog szerepelni ez az \u0171rlap:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Az e k\xe9relemt\xedpusok felhaszn\xe1l\xe1s\xe1val l\xe9trehozott, j\xf6v\u0151beni k\xe9relmekben m\xe1r nem fog szerepelni ez az \u0171rlap.",
    'jira-common.ListProjectForms.Heading': "T\xf6rl\xf6d ezt az \u0171rlapot: \u201E{formName}\u201D?",
    'jira-common.ListProjectForms.IssueType': "\xdcgyt\xedpus",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\xdcgyt\xedpusok keres\xe9se",
    'jira-common.ListProjectForms.LastUpdated': "Utols\xf3 friss\xedt\xe9s",
    'jira-common.ListProjectForms.LearnMoreLink': "Tov\xe1bbi inform\xe1ci\xf3 az \u0171rlapok t\xf6rl\xe9s\xe9r\u0151l.",
    'jira-common.ListProjectForms.RequestType': "K\xe9relemt\xedpus",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "K\xe9relemt\xedpusok keres\xe9se",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Ha t\xf6rl\xf6d ezt az \u0171rlapot, akkor elt\xe1vol\xedtod a k\xf6vetkez\u0151 \xfcgyt\xedpusokb\xf3l:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Ha t\xf6rl\xf6d ezt az \u0171rlapot, akkor elt\xe1vol\xedtod a k\xf6vetkez\u0151 k\xe9relemt\xedpusokb\xf3l:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "K\xf6zvetlen link m\xe1sol\xe1sa",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\xdcgyt\xedpus",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "K\xe9relemt\xedpus",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} \xfczleti projektben} other {{numberOfBusinessProjects,number} \xfczleti projektben}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} \xfcgyf\xe9lszolg\xe1lati projektben} other {{numberOfServiceProjects,number} \xfcgyf\xe9lszolg\xe1lati projektben}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} szoftverprojektben} other {{numberOfSoftwareProjects,number} szoftverprojektben}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \xfcgyt\xedpus",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} k\xe9relemt\xedpus",
    'proforma-project-forms.BusinessForms': "Halad\xf3 \u0171rlapok",
    'proforma-project-forms.CreateForm': "\u0170rlap l\xe9trehoz\xe1sa",
    'proforma-project-forms.Description': "\u0170rlapok l\xe9trehoz\xe1sa, szerkeszt\xe9se, export\xe1l\xe1sa \xe9s t\xf6rl\xe9se. \u0170rlapok m\xe1sol\xe1sa \xe9s felhaszn\xe1l\xe1sa m\xe1s projektekben.",
    'proforma-project-forms.Forms': "\u0170rlapok",
    'proforma-project-forms.LearnMore': "Tov\xe1bbi inform\xe1ci\xf3 az \u0171rlapokr\xf3l.",
    'proforma-project-forms.LoadingForms': "Bet\xf6lt\xe9s\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "Hozz\xe1adhatsz \u0171rlapokat, amelyeket az \xfcgyfelek kit\xf6lthetnek, amikor k\xe9relmet k\xfcldenek be, vagy \u0171rlapokat csatolhatsz a megl\xe9v\u0151 \xfcgyekhez, amelyekr\u0151l szeretn\xe9l tov\xe1bbi inform\xe1ci\xf3t gy\u0171jteni.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Hozz\xe1adhatsz \u0171rlapokat, amelyeket az \xfcgyfelek kit\xf6lthetnek, amikor \xfcgyet hoznak l\xe9tre, vagy \u0171rlapokat csatolhatsz a megl\xe9v\u0151 \xfcgyekhez, amelyekr\u0151l szeretn\xe9l tov\xe1bbi inform\xe1ci\xf3t gy\u0171jteni.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Hozz\xe1adhatsz \u0171rlapokat, amelyeket az \xfcgyfelek kit\xf6lthetnek, amikor l\xe9trehoznak egy t\xe9telt, vagy \u0171rlapokat csatolhatsz a megl\xe9v\u0151 \xfcgyekhez, amelyekr\u0151l szeretn\xe9l tov\xe1bbi inform\xe1ci\xf3t gy\u0171jteni.",
    'proforma-project-forms.NoFormsHeading': "Az \xf6sszes \u0171rlapod itt lesz l\xe1that\xf3",
    'proforma-project-forms.create-form-button.create-blank': "\xdcres l\xe9trehoz\xe1sa",
    'proforma-project-forms.create-form-button.create-with-template': "L\xe9trehoz\xe1s sablonb\xf3l",
    'proforma-project-forms.create-form-button.trigger': "\u0170rlap l\xe9trehoz\xe1sa"
};

});

parcelRegister("h5DIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c711b7800b7cd6ff$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $c711b7800b7cd6ff$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Modifica',
    'form-system.general.Form': 'Nome',
    'jira-common.ListProjectForms.AffectExistingIssues': "Questa condizione non influisce sui ticket esistenti che gi\xe0 utilizzano questo modulo o su eventuali copie di questo modulo presenti in altri progetti.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Tipo di ticket',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Tipo di richiesta',
    'jira-common.ListProjectForms.Cancel': 'Annulla',
    'jira-common.ListProjectForms.Copy': 'Copia nel progetto',
    'jira-common.ListProjectForms.CopyFormErrorTitle': 'Errore: impossibile copiare "{formName}" in uno o pi\xf9 progetti',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Modulo copiato nel progetto aziendale} other {Modulo copiato in {numberOfBusinessProjects,number} progetti aziendali}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Modulo copiato in {numberOfProjects,number} progetto} other {Modulo copiato in {numberOfProjects,number} progetti}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" \xe8 ora utilizzabile in "{projectName}".',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage} e {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage} e {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Modulo copiato nel progetto del servizio} other {Modulo copiato in {numberOfServiceProjects,number} progetti di service management}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" \xe8 ora utilizzabile in {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Modulo copiato nel progetto software} other {Modulo copiato in {numberOfSoftwareProjects,number} progetti software}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" \xe8 ora utilizzabile in {numberOfProjects,number} progetto.} other {"{formName}" \xe8 ora utilizzabile in {numberOfProjects,number} progetti.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Modulo copiato nel progetto} other {Modulo copiato in {numberOfProjects,number} progetti}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Annulla',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Copia',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copia in progetti',
    'jira-common.ListProjectForms.CopyModal.Heading': 'Copia "{formName}" in altri progetti',
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Scopri di pi\xf9 sulla copia dei moduli",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Caricamento di progetti',
    'jira-common.ListProjectForms.CopyModal.Name': 'Nome',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Seleziona tutti i progetti',
    'jira-common.ListProjectForms.CopyModal.SubHeading': 'Le modifiche apportate a un modulo non vengono riportate nelle copie presenti in altri progetti.',
    'jira-common.ListProjectForms.CopyText': 'Copia di {formName}',
    'jira-common.ListProjectForms.Delete': 'Elimina',
    'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" eliminato',
    'jira-common.ListProjectForms.Duplicate': 'Duplica',
    'jira-common.ListProjectForms.EmptyFormName': 'Modulo senza titolo',
    'jira-common.ListProjectForms.FilterForms': 'Filtra moduli',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" scaricato',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Aggiorna la pagina e riprova.',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" non scaricato',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {{percentCount,number}% completato} other {{percentCount,number}% completati}}',
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': 'Download di "{filename}" in corso',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Esporta in XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': 'Altre azioni',
    'jira-common.ListProjectForms.FutureIssueMessage': "I ticket futuri creati utilizzando questi tipi di ticket non includeranno pi\xf9 questo modulo:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Le richieste future create utilizzando questi tipi di richiesta non includeranno pi\xf9 questo modulo.",
    'jira-common.ListProjectForms.Heading': 'Vuoi eliminare "{formName}"?',
    'jira-common.ListProjectForms.IssueType': 'Tipo di ticket',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Cerca i tipi di ticket',
    'jira-common.ListProjectForms.LastUpdated': 'Ultimo aggiornamento',
    'jira-common.ListProjectForms.LearnMoreLink': "Scopri di pi\xf9 sull'eliminazione dei moduli.",
    'jira-common.ListProjectForms.RequestType': 'Tipo di richiesta',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Cerca i tipi di richieste',
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "L'eliminazione di questo modulo ne comporter\xe0 la rimozione anche dai seguenti tipi di ticket:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "L'eliminazione di questo modulo ne comporter\xe0 la rimozione anche dai seguenti tipi di richiesta:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copia link diretto',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Tipo di ticket',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Tipo di richiesta',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} progetto aziendale} other {{numberOfBusinessProjects,number} progetti aziendali}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} progetto di servizio} other {{numberOfServiceProjects,number} progetti di servizio}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} progetto software} other {{numberOfSoftwareProjects,number} progetti software}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} tipi di ticket',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} tipi di richiesta',
    'proforma-project-forms.BusinessForms': 'Moduli avanzati',
    'proforma-project-forms.CreateForm': 'Crea modulo',
    'proforma-project-forms.Description': 'Crea, modifica, esporta ed elimina i moduli. Copia i moduli e utilizzali in altri progetti.',
    'proforma-project-forms.Forms': 'Moduli',
    'proforma-project-forms.LearnMore': "Scopri di pi\xf9 sui moduli.",
    'proforma-project-forms.LoadingForms': 'Caricamento in corso...',
    'proforma-project-forms.NoFormsDescriptionJsm': 'Aggiungi moduli che i clienti possono compilare quando inviano una richiesta o allega moduli a ticket esistenti per raccogliere maggiori informazioni.',
    'proforma-project-forms.NoFormsDescriptionJsw': 'Aggiungi moduli che i clienti possono compilare quando creano un ticket o allega moduli a ticket esistenti per raccogliere maggiori informazioni.',
    'proforma-project-forms.NoFormsDescriptionJwm': 'Aggiungi moduli che i clienti possono compilare quando creano un elemento o allega moduli a ticket esistenti per raccogliere maggiori informazioni.',
    'proforma-project-forms.NoFormsHeading': 'Tutti i moduli verranno visualizzati qui',
    'proforma-project-forms.create-form-button.create-blank': 'Crea vuoto',
    'proforma-project-forms.create-form-button.create-with-template': 'Crea da modello',
    'proforma-project-forms.create-form-button.trigger': 'Crea modulo'
};

});

parcelRegister("gxRCD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0b952a8f858c041$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $c0b952a8f858c041$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\u7DE8\u96C6",
    'form-system.general.Form': "\u540D\u524D",
    'jira-common.ListProjectForms.AffectExistingIssues': "\u3053\u308C\u306F\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u3059\u3067\u306B\u4F7F\u7528\u3057\u3066\u3044\u308B\u65E2\u5B58\u306E\u8AB2\u984C\u3001\u307E\u305F\u306F\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u304A\u3051\u308B\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306E\u30B3\u30D4\u30FC\u306B\u306F\u5F71\u97FF\u3057\u307E\u305B\u3093\u3002",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\u8AB2\u984C\u30BF\u30A4\u30D7",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
    'jira-common.ListProjectForms.Cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'jira-common.ListProjectForms.Copy': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "\u30A8\u30E9\u30FC:\u300C{formName}\u300D\u3092\u30B3\u30D4\u30FC\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfBusinessProjects,number} \u4EF6\u306E\u30D3\u30B8\u30CD\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfProjects,number} \u4EF6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u300C{projectName}\u300D\u3067\u300C{formName}\u300D\u3092\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage} \u3068 {numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage} \u3068 {numberOfSoftwareProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfServiceProjects,number} \u4EF6\u306E\u30B5\u30FC\u30D3\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfServiceProjectsMessage}\u3001{numberOfSoftwareProjectsMessage}\u3001{numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfSoftwareProjectsMessage} \u3068 {numberOfBusinessProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u300C{formName}\u300D\u3092 {numberOfSoftwareProjectsMessage} \u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfSoftwareProjects,number} \u4EF6\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, other {\u300C{formName}\u300D\u3092 {numberOfProjects,number} \u4EF6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u4F7F\u7528\u3067\u304D\u308B\u3088\u3046\u306B\u306A\u308A\u307E\u3057\u305F\u3002}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u30D5\u30A9\u30FC\u30E0\u304C {numberOfProjects,number} \u4EF6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC\u3055\u308C\u307E\u3057\u305F\u3002}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u30AD\u30E3\u30F3\u30BB\u30EB",
    'jira-common.ListProjectForms.CopyModal.Copy': "\u30B3\u30D4\u30FC",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC",
    'jira-common.ListProjectForms.CopyModal.Heading': "\u300C{formName}\u300D\u3092\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u30B3\u30D4\u30FC",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\u30D5\u30A9\u30FC\u30E0\u306E\u30B3\u30D4\u30FC\u306B\u95A2\u3059\u308B\u8A73\u7D30",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306E\u8AAD\u307F\u8FBC\u307F\u4E2D",
    'jira-common.ListProjectForms.CopyModal.Name': "\u540D\u524D",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u3059\u3079\u3066\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3092\u9078\u629E",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\u30D5\u30A9\u30FC\u30E0\u306B\u52A0\u3048\u305F\u5909\u66F4\u306F\u3001\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u306B\u3042\u308B\u3059\u3079\u3066\u306E\u3044\u30B3\u30D4\u30FC\u5168\u4F53\u306B\u306F\u53CD\u6620\u3055\u308C\u307E\u305B\u3093\u3002",
    'jira-common.ListProjectForms.CopyText': "{formName} \u306E\u30B3\u30D4\u30FC",
    'jira-common.ListProjectForms.Delete': "\u524A\u9664",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u300C{formName}\u300D\u304C\u524A\u9664\u3055\u308C\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.Duplicate': "\u8907\u88FD",
    'jira-common.ListProjectForms.EmptyFormName': "\u7121\u984C\u306E\u30D5\u30A9\u30FC\u30E0",
    'jira-common.ListProjectForms.FilterForms': "\u30D5\u30A9\u30FC\u30E0\u3092\u30D5\u30A3\u30EB\u30BF\u30EA\u30F3\u30B0",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u300C{filename}\u300D\u304C\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u307E\u3057\u305F\u3002",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u30DA\u30FC\u30B8\u3092\u66F4\u65B0\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u300C{filename}\u300D\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {{percentCount,number} % \u5B8C\u4E86}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u300C{filename}\u300D\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u4E2D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "XLSX \u3067\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\u305D\u306E\u4ED6\u306E\u64CD\u4F5C",
    'jira-common.ListProjectForms.FutureIssueMessage': "\u4ECA\u5F8C\u3001\u3053\u308C\u3089\u306E\u8AB2\u984C\u30BF\u30A4\u30D7\u3092\u4F7F\u7528\u3057\u3066\u4F5C\u6210\u3057\u305F\u8AB2\u984C\u306B\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002",
    'jira-common.ListProjectForms.FutureRequestMessage': "\u4ECA\u5F8C\u3001\u3053\u308C\u3089\u306E\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7\u3092\u4F7F\u7528\u3057\u3066\u4F5C\u6210\u3055\u308C\u305F\u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u306F\u542B\u307E\u308C\u307E\u305B\u3093\u3002",
    'jira-common.ListProjectForms.Heading': "\u300C{formName}\u300D\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B? ",
    'jira-common.ListProjectForms.IssueType': "\u8AB2\u984C\u30BF\u30A4\u30D7",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u8AB2\u984C\u30BF\u30A4\u30D7\u3092\u691C\u7D22",
    'jira-common.ListProjectForms.LastUpdated': "\u6700\u7D42\u66F4\u65B0\u65E5",
    'jira-common.ListProjectForms.LearnMoreLink': "\u30D5\u30A9\u30FC\u30E0\u306E\u524A\u9664\u306B\u95A2\u3059\u308B\u8A73\u7D30\u306B\u3064\u3044\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    'jira-common.ListProjectForms.RequestType': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7\u3092\u691C\u7D22",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u6B21\u306E\u8AB2\u984C\u30BF\u30A4\u30D7\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u524A\u9664\u3059\u308B\u3068\u3001\u6B21\u306E\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7\u304B\u3089\u524A\u9664\u3055\u308C\u307E\u3059\u3002",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u30C0\u30A4\u30EC\u30AF\u30C8 \u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u8AB2\u984C\u30BF\u30A4\u30D7",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} \u4EF6\u306E\u30D3\u30B8\u30CD\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\\}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} \u4EF6\u306E\u30B5\u30FC\u30D3\u30B9 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} \u4EF6\u306E\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2 \u30D7\u30ED\u30B8\u30A7\u30AF\u30C8}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u500B\u306E\u8AB2\u984C\u30BF\u30A4\u30D7",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u500B\u306E\u30EA\u30AF\u30A8\u30B9\u30C8 \u30BF\u30A4\u30D7",
    'proforma-project-forms.BusinessForms': "\u8A73\u7D30\u306A\u30D5\u30A9\u30FC\u30E0",
    'proforma-project-forms.CreateForm': "\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210",
    'proforma-project-forms.Description': "\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210\u3001\u7DE8\u96C6\u3001\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u3001\u524A\u9664\u3057\u307E\u3059\u3002\u30D5\u30A9\u30FC\u30E0\u3092\u30B3\u30D4\u30FC\u3057\u3066\u3001\u4ED6\u306E\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u3067\u4F7F\u7528\u3057\u307E\u3059\u3002",
    'proforma-project-forms.Forms': "\u30D5\u30A9\u30FC\u30E0",
    'proforma-project-forms.LearnMore': "\u30D5\u30A9\u30FC\u30E0\u306E\u8A73\u7D30\u306B\u3064\u3044\u3066\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002",
    'proforma-project-forms.LoadingForms': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u767B\u9332\u6642\u306B\u9867\u5BA2\u304C\u8A18\u5165\u3059\u308B\u30D5\u30A9\u30FC\u30E0\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u8AB2\u984C\u306B\u30D5\u30A9\u30FC\u30E0\u3092\u6DFB\u4ED8\u3057\u3066\u8A73\u7D30\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002",
    'proforma-project-forms.NoFormsDescriptionJsw': "\u8AB2\u984C\u306E\u4F5C\u6210\u6642\u306B\u9867\u5BA2\u304C\u8A18\u5165\u3059\u308B\u30D5\u30A9\u30FC\u30E0\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u8AB2\u984C\u306B\u30D5\u30A9\u30FC\u30E0\u3092\u6DFB\u4ED8\u3057\u3066\u8A73\u7D30\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002",
    'proforma-project-forms.NoFormsDescriptionJwm': "\u30A2\u30A4\u30C6\u30E0\u306E\u4F5C\u6210\u6642\u306B\u9867\u5BA2\u304C\u8A18\u5165\u3059\u308B\u30D5\u30A9\u30FC\u30E0\u3092\u8FFD\u52A0\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u8AB2\u984C\u306B\u30D5\u30A9\u30FC\u30E0\u3092\u6DFB\u4ED8\u3057\u3066\u8A73\u7D30\u60C5\u5831\u3092\u53CE\u96C6\u3057\u307E\u3059\u3002",
    'proforma-project-forms.NoFormsHeading': "\u30D5\u30A9\u30FC\u30E0\u306F\u3059\u3079\u3066\u3001\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
    'proforma-project-forms.create-form-button.create-blank': "\u7A7A\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210",
    'proforma-project-forms.create-form-button.create-with-template': "\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u304B\u3089\u4F5C\u6210",
    'proforma-project-forms.create-form-button.trigger': "\u30D5\u30A9\u30FC\u30E0\u3092\u4F5C\u6210"
};

});

parcelRegister("7Kax4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a34ffcd4b21bbfb$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $5a34ffcd4b21bbfb$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\uD3B8\uC9D1",
    'form-system.general.Form': "\uC774\uB984",
    'jira-common.ListProjectForms.AffectExistingIssues': "\uC774 \uC591\uC2DD\uC744 \uC774\uBBF8 \uC0AC\uC6A9\uD558\uB294 \uAE30\uC874 \uC774\uC288 \uB610\uB294 \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uC774 \uC591\uC2DD\uC758 \uBCF5\uC0AC\uBCF8\uC5D0\uB294 \uC601\uD5A5\uC744 \uC8FC\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\uC774\uC288 \uC720\uD615",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\uC694\uCCAD \uC720\uD615",
    'jira-common.ListProjectForms.Cancel': "\uCDE8\uC18C",
    'jira-common.ListProjectForms.Copy': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC",
    'jira-common.ListProjectForms.CopyFormErrorTitle': '\uC624\uB958: "{formName}"\uC744(\uB97C) \uBCF5\uC0AC\uD560 \uC218 \uC5C6\uC74C',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '\uC774\uC81C {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\uC591\uC2DD\uC774 {numberOfBusinessProjects,number}\uAC1C\uC758 \uBE44\uC988\uB2C8\uC2A4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\uC591\uC2DD\uC774 {numberOfProjects,number}\uAC1C\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '\uC774\uC81C "{projectName}"\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage} \uBC0F {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage} \uBC0F {numberOfSoftwareProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\uC591\uC2DD\uC774 {numberOfServiceProjects,number}\uAC1C\uC758 \uC11C\uBE44\uC2A4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '\uC774\uC81C {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \uBC0F {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '\uC774\uC81C {numberOfSoftwareProjectsMessage} \uBC0F {numberOfBusinessProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '\uC774\uC81C {numberOfSoftwareProjectsMessage}\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\uC591\uC2DD\uC774 {numberOfSoftwareProjects,number}\uAC1C\uC758 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {\uC774\uC81C {numberOfProjects,number}\uAC1C\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C "{formName}"\uC744(\uB97C) \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\uC591\uC2DD\uC774 {numberOfProjects,number}\uAC1C\uC758 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC\uB428}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\uCDE8\uC18C",
    'jira-common.ListProjectForms.CopyModal.Copy': "\uBCF5\uC0AC",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC",
    'jira-common.ListProjectForms.CopyModal.Heading': '"{formName}"\uC744(\uB97C) \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC5D0 \uBCF5\uC0AC',
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\uC591\uC2DD \uBCF5\uC0AC\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uAE30",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\uD504\uB85C\uC81D\uD2B8 \uB85C\uB4DC \uC911",
    'jira-common.ListProjectForms.CopyModal.Name': "\uC774\uB984",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\uBAA8\uB4E0 \uD504\uB85C\uC81D\uD2B8 \uC120\uD0DD",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\uC591\uC2DD\uC5D0 \uB300\uD55C \uBCC0\uACBD \uC0AC\uD56D\uC740 \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC758 \uBCF5\uC0AC\uBCF8\uC5D0 \uBC18\uC601\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    'jira-common.ListProjectForms.CopyText': "{formName} \uBCF5\uC0AC\uBCF8",
    'jira-common.ListProjectForms.Delete': "\uC0AD\uC81C",
    'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" \uC0AD\uC81C\uB428',
    'jira-common.ListProjectForms.Duplicate': "\uBCF5\uC81C",
    'jira-common.ListProjectForms.EmptyFormName': "\uC81C\uBAA9 \uC5C6\uB294 \uC591\uC2DD",
    'jira-common.ListProjectForms.FilterForms': "\uC591\uC2DD \uD544\uD130\uB9C1",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}"\uC774(\uAC00) \uB2E4\uC6B4\uB85C\uB4DC\uB428',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\uD398\uC774\uC9C0\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD558\uC138\uC694.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}"\uC744(\uB97C) \uB2E4\uC6B4\uB85C\uB4DC\uD558\uC9C0 \uBABB\uD568',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {{percentCount,number}% \uC644\uB8CC}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '"{filename}" \uB2E4\uC6B4\uB85C\uB4DC \uC911',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "XLSX\uB85C \uB0B4\uBCF4\uB0B4\uAE30",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\uCD94\uAC00 \uC791\uC5C5",
    'jira-common.ListProjectForms.FutureIssueMessage': "\uC774\uB7EC\uD55C \uC774\uC288 \uC720\uD615\uC744 \uC0AC\uC6A9\uD558\uC5EC \uB9CC\uB4E0 \uD5A5\uD6C4 \uC774\uC288\uC5D0\uB294 \uB354 \uC774\uC0C1 \uC774 \uC591\uC2DD\uC774 \uD3EC\uD568\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    'jira-common.ListProjectForms.FutureRequestMessage': "\uC774\uB7EC\uD55C \uC694\uCCAD \uC720\uD615\uC744 \uC0AC\uC6A9\uD558\uC5EC \uB9CC\uB4E0 \uD5A5\uD6C4 \uC694\uCCAD\uC5D0\uB294 \uB354 \uC774\uC0C1 \uC774 \uC591\uC2DD\uC774 \uD3EC\uD568\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.",
    'jira-common.ListProjectForms.Heading': '"{formName}"\uC744(\uB97C) \uC0AD\uC81C\uD558\uACA0\uC2B5\uB2C8\uAE4C?',
    'jira-common.ListProjectForms.IssueType': "\uC774\uC288 \uC720\uD615",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\uC774\uC288 \uC720\uD615 \uAC80\uC0C9",
    'jira-common.ListProjectForms.LastUpdated': "\uCD5C\uADFC \uC5C5\uB370\uC774\uD2B8",
    'jira-common.ListProjectForms.LearnMoreLink': "\uC591\uC2DD \uC0AD\uC81C\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.",
    'jira-common.ListProjectForms.RequestType': "\uC694\uCCAD \uC720\uD615",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\uC694\uCCAD \uC720\uD615 \uAC80\uC0C9",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\uC774 \uC591\uC2DD\uC744 \uC0AD\uC81C\uD558\uBA74 \uB2E4\uC74C\uACFC \uAC19\uC740 \uC774\uC288 \uC720\uD615\uC5D0\uC11C\uB3C4 \uC81C\uAC70\uB429\uB2C8\uB2E4.",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\uC774 \uC591\uC2DD\uC744 \uC0AD\uC81C\uD558\uBA74 \uB2E4\uC74C\uACFC \uAC19\uC740 \uC694\uCCAD \uC720\uD615\uC5D0\uC11C\uB3C4 \uC81C\uAC70\uB429\uB2C8\uB2E4.",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\uC9C1\uC811 \uB9C1\uD06C \uBCF5\uC0AC",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\uC774\uC288 \uC720\uD615",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\uC694\uCCAD \uC720\uD615",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number}\uAC1C\uC758 \uBE44\uC988\uB2C8\uC2A4 \uD504\uB85C\uC81D\uD2B8}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number}\uAC1C\uC758 \uC11C\uBE44\uC2A4 \uD504\uB85C\uC81D\uD2B8}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number}\uAC1C\uC758 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uD504\uB85C\uC81D\uD2B8}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\uC774\uC288 \uC720\uD615 {count}\uAC1C",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\uC694\uCCAD \uC720\uD615 {count}\uAC1C",
    'proforma-project-forms.BusinessForms': "\uACE0\uAE09 \uC591\uC2DD",
    'proforma-project-forms.CreateForm': "\uC591\uC2DD \uB9CC\uB4E4\uAE30",
    'proforma-project-forms.Description': "\uC591\uC2DD\uC744 \uB9CC\uB4E4\uACE0, \uD3B8\uC9D1\uD558\uACE0, \uB0B4\uBCF4\uB0B4\uACE0, \uC0AD\uC81C\uD569\uB2C8\uB2E4. \uC591\uC2DD\uC744 \uBCF5\uC0AC\uD558\uC5EC \uB2E4\uB978 \uD504\uB85C\uC81D\uD2B8\uC5D0\uC11C \uC0AC\uC6A9\uD569\uB2C8\uB2E4.",
    'proforma-project-forms.Forms': "\uC591\uC2DD",
    'proforma-project-forms.LearnMore': "\uC591\uC2DD\uC5D0 \uB300\uD574 \uC790\uC138\uD788 \uC54C\uC544\uBCF4\uC138\uC694.",
    'proforma-project-forms.LoadingForms': "\uB85C\uB4DC \uC911\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "\uC694\uCCAD\uC744 \uC81C\uAE30\uD560 \uB54C \uACE0\uAC1D\uC774 \uC791\uC131\uD560 \uC591\uC2DD\uC744 \uCD94\uAC00\uD558\uAC70\uB098, \uB354 \uB9CE\uC740 \uC815\uBCF4\uB97C \uC218\uC9D1\uD558\uAE30 \uC704\uD574 \uAE30\uC874 \uC774\uC288\uC5D0 \uC591\uC2DD\uC744 \uCCA8\uBD80\uD558\uC138\uC694.",
    'proforma-project-forms.NoFormsDescriptionJsw': "\uC774\uC288\uB97C \uB9CC\uB4E4 \uB54C \uACE0\uAC1D\uC774 \uC791\uC131\uD560 \uC591\uC2DD\uC744 \uCD94\uAC00\uD558\uAC70\uB098, \uB354 \uB9CE\uC740 \uC815\uBCF4\uB97C \uC218\uC9D1\uD558\uAE30 \uC704\uD574 \uAE30\uC874 \uC774\uC288\uC5D0 \uC591\uC2DD\uC744 \uCCA8\uBD80\uD558\uC138\uC694.",
    'proforma-project-forms.NoFormsDescriptionJwm': "\uD56D\uBAA9\uC744 \uB9CC\uB4E4 \uB54C \uACE0\uAC1D\uC774 \uC791\uC131\uD560 \uC591\uC2DD\uC744 \uCD94\uAC00\uD558\uAC70\uB098, \uB354 \uB9CE\uC740 \uC815\uBCF4\uB97C \uC218\uC9D1\uD558\uAE30 \uC704\uD574 \uAE30\uC874 \uC774\uC288\uC5D0 \uC591\uC2DD\uC744 \uCCA8\uBD80\uD558\uC138\uC694.",
    'proforma-project-forms.NoFormsHeading': "\uBAA8\uB4E0 \uC591\uC2DD\uC740 \uC5EC\uAE30\uC5D0 \uD45C\uC2DC\uB429\uB2C8\uB2E4",
    'proforma-project-forms.create-form-button.create-blank': "\uBE48 \uC591\uC2DD \uB9CC\uB4E4\uAE30",
    'proforma-project-forms.create-form-button.create-with-template': "\uD15C\uD50C\uB9BF\uC5D0\uC11C \uB9CC\uB4E4\uAE30",
    'proforma-project-forms.create-form-button.trigger': "\uC591\uC2DD \uB9CC\uB4E4\uAE30"
};

});

parcelRegister("i4AqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d284dbdb74ffa2c5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $d284dbdb74ffa2c5$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Rediger',
    'form-system.general.Form': 'Navn',
    'jira-common.ListProjectForms.AffectExistingIssues': "Dette vil ikke p\xe5virke eksisterende saker som allerede bruker dette skjemaet, eller kopier av dette skjemaet i andre prosjekter.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Sakstype',
    'jira-common.ListProjectForms.AssociatedRequestTypes': "Foresp\xf8rselstype",
    'jira-common.ListProjectForms.Cancel': 'Avbryt',
    'jira-common.ListProjectForms.Copy': 'Kopier til prosjekt',
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Feil: Kan ikke kopiere over \xab{formName}\xbb",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Skjema kopiert til forretningsprosjekt} other {Skjema kopiert til {numberOfBusinessProjects,number} forretningsprosjekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Skjema kopiert til {numberOfProjects,number} prosjekt} other {Skjema kopiert til {numberOfProjects,number} prosjekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\xab{formName}\xbb kan n\xe5 brukes i \xab{projectName}\xbb.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage} og {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage} og {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Skjema kopiert til serviceprosjekt} other {Skjema kopiert til {numberOfServiceProjects,number} serviceprosjekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfSoftwareProjectsMessage} og {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\xab{formName}\xbb kan n\xe5 brukes i {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Skjema kopiert til programvareprosjekt} other {Skjema kopiert til {numberOfSoftwareProjects,number} programvareprosjekter}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\xab{formName}\xbb kan n\xe5 brukes i {numberOfProjects,number} prosjekt.} other {\xab{formName}\xbb kan n\xe5 brukes i {numberOfProjects,number} prosjekter.}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Skjema kopiert til prosjekt} other {Skjema kopiert til {numberOfProjects,number} prosjekter}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Avbryt',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Kopier',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Kopier til prosjekt(er)',
    'jira-common.ListProjectForms.CopyModal.Heading': "Kopier \xab{formName}\xbb til andre prosjekter",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Finn ut mer om \xe5 kopiere skjemaer",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Laster inn prosjekter',
    'jira-common.ListProjectForms.CopyModal.Name': 'Navn',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Velg alle prosjekter',
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Endringer som gj\xf8res i ett skjema, blir ikke reprodusert i skjemaets kopier i andre prosjekter.",
    'jira-common.ListProjectForms.CopyText': 'Kopi av {formName}',
    'jira-common.ListProjectForms.Delete': 'Slett',
    'jira-common.ListProjectForms.DeleteFormSuccess': "\xab{formName}\xbb er slettet",
    'jira-common.ListProjectForms.Duplicate': 'Dupliser',
    'jira-common.ListProjectForms.EmptyFormName': 'Skjema uten tittel',
    'jira-common.ListProjectForms.FilterForms': 'Filtrer skjemaer',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\xab{filename}\xbb er lastet ned",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Oppdater siden og pr\xf8v p\xe5 nytt.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\xab{filename}\xbb ble ikke lastet ned",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% fullf\xf8rt} other {{percentCount,number}\xa0% fullf\xf8rt}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Laster ned \xab{filename}\xbb",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Eksporter til XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': 'Flere handlinger',
    'jira-common.ListProjectForms.FutureIssueMessage': 'Fremtidige saker som blir opprettet med disse sakstypene, vil ikke lenger inkludere dette skjemaet:',
    'jira-common.ListProjectForms.FutureRequestMessage': "Fremtidige foresp\xf8rsler opprettet med disse foresp\xf8rselstypene vil ikke lenger inkludere dette skjemaet.",
    'jira-common.ListProjectForms.Heading': "Vil du slette \xab{formName}\xbb?",
    'jira-common.ListProjectForms.IssueType': 'Sakstype',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "S\xf8k etter sakstyper",
    'jira-common.ListProjectForms.LastUpdated': 'Sist oppdatert',
    'jira-common.ListProjectForms.LearnMoreLink': "Finn ut mer om \xe5 slette skjema.",
    'jira-common.ListProjectForms.RequestType': "Type foresp\xf8rsel",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "S\xf8k etter foresp\xf8rselstyper",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Hvis du sletter dette skjemaet, fjernes det fra f\xf8lgende sakstyper:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Hvis du sletter dette skjemaet, fjernes det fra f\xf8lgende foresp\xf8rselstyper:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Kopier direktekobling',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Sakstype',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Type foresp\xf8rsel",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} forretningsprosjekt} other {{numberOfBusinessProjects,number} forretningsprosjekter}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceprosjekt} other {{numberOfServiceProjects,number} serviceprosjekter}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} programvareprosjekt} other {{numberOfSoftwareProjects,number} programvareprosjekter}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} sakstyper',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} foresp\xf8rselstyper",
    'proforma-project-forms.BusinessForms': 'Avanserte skjemaer',
    'proforma-project-forms.CreateForm': 'Opprett skjema',
    'proforma-project-forms.Description': 'Opprett, rediger, eksporter og slett skjemaer. Kopier skjemaer og bruk dem i andre prosjekter.',
    'proforma-project-forms.Forms': 'Skjemaer',
    'proforma-project-forms.LearnMore': 'Finn ut mer om skjemaer.',
    'proforma-project-forms.LoadingForms': "Laster inn\xa0\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "Legg til skjemaer kunder kan fylle ut n\xe5r de sender inn en foresp\xf8rsel, eller legg til skjemaer i eksisterende saker for \xe5 innhente mer informasjon.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Legg til skjemaer kunder kan fylle ut n\xe5r de oppretter et sak, eller legg til skjemaer i eksisterende saker for \xe5 innhente mer informasjon.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Legg til skjemaer kunder kan fylle ut n\xe5r de oppretter et element, eller legg til skjemaer i eksisterende saker for \xe5 innhente mer informasjon.",
    'proforma-project-forms.NoFormsHeading': 'Alle skjemaene dine vises her',
    'proforma-project-forms.create-form-button.create-blank': 'Opprett tomt',
    'proforma-project-forms.create-form-button.create-with-template': 'Opprett fra mal',
    'proforma-project-forms.create-form-button.trigger': 'Opprett skjema'
};

});

parcelRegister("j76eY", function(module, exports) {

$parcel$export(module.exports, "default", () => $dea382fd6e8bb389$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $dea382fd6e8bb389$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Bewerken',
    'form-system.general.Form': 'Naam',
    'jira-common.ListProjectForms.AffectExistingIssues': "Dit heeft geen effect op bestaande issues die al gebruikmaken van dit formulier, of op kopie\xebn van dit formulier in andere projecten.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Issuetype',
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Aanvraagtype',
    'jira-common.ListProjectForms.Cancel': 'Annuleren',
    'jira-common.ListProjectForms.Copy': "Kopi\xebren naar project",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Fout: {formName} kopi\xebren is mislukt",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': '{numberOfBusinessProjects, plural, one {Formulier gekopieerd naar zakelijk project} other {Formulier gekopieerd naar {numberOfBusinessProjects,number} zakelijke projecten}}',
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': '{numberOfProjects, plural, one {Formulier gekopieerd naar {numberOfProjects,number} project} other {Formulier gekopieerd naar {numberOfProjects,number} projecten}}',
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '{formName} kan nu gebruikt worden in {projectName}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage} en {numberOfBusinessProjectsMessage}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage} en {numberOfSoftwareProjectsMessage}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': '{numberOfServiceProjects, plural, one {Formulier gekopieerd naar serviceproject} other {Formulier gekopieerd naar {numberOfServiceProjects,number} serviceprojecten}}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} en {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfSoftwareProjectsMessage} en {numberOfBusinessProjectsMessage}",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "''{formName}' kan nu gebruikt worden in {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': '{numberOfSoftwareProjects, plural, one {Formulier gekopieerd naar softwareproject} other {Formulier gekopieerd naar {numberOfSoftwareProjects,number} softwareprojecten}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {''{formName}' kan nu gebruikt worden in {numberOfProjects,number} project.} other {''{formName}' kan nu gebruikt worden in {numberOfProjects,number} projecten.}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': '{numberOfProjects, plural, one {Formulier gekopieerd naar project} other {Formulier gekopieerd naar {numberOfProjects,number} projecten}}',
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Annuleren',
    'jira-common.ListProjectForms.CopyModal.Copy': "Kopi\xebren",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Naar project(en) kopi\xebren",
    'jira-common.ListProjectForms.CopyModal.Heading': "{formName} naar andere projecten kopi\xebren",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Meer informatie over het kopi\xebren van formulieren",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Bezig met laden van projecten',
    'jira-common.ListProjectForms.CopyModal.Name': 'Naam',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Alle projecten selecteren',
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Wijzigingen aan een formulier worden niet weergegeven in de kopie\xebn ervan in andere projecten.",
    'jira-common.ListProjectForms.CopyText': '{formName} (kopie)',
    'jira-common.ListProjectForms.Delete': 'Verwijderen',
    'jira-common.ListProjectForms.DeleteFormSuccess': '{formName} is verwijderd',
    'jira-common.ListProjectForms.Duplicate': 'Dupliceren',
    'jira-common.ListProjectForms.EmptyFormName': 'Formulier zonder titel',
    'jira-common.ListProjectForms.FilterForms': 'Formulieren filteren',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '{filename} gedownload',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': 'Vernieuw de pagina en probeer het opnieuw.',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '{filename} niet gedownload',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': '{percentCount, plural, one {{percentCount,number}% voltooid} other {{percentCount,number}% voltooid}}',
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '{filename} downloaden',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'In XLSX exporteren',
    'jira-common.ListProjectForms.FormActions.MoreActions': 'Meer acties',
    'jira-common.ListProjectForms.FutureIssueMessage': 'Toekomstige issues die aangemaakt worden met dit issuetype zullen niet langer dit formulier bevatten:',
    'jira-common.ListProjectForms.FutureRequestMessage': 'Toekomstige aanvragen die aangemaakt worden met dit aanvraagtype zullen niet langer dit formulier bevatten.',
    'jira-common.ListProjectForms.Heading': '"{formName}" verwijderen?',
    'jira-common.ListProjectForms.IssueType': 'Issuetype',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Issuetypen zoeken',
    'jira-common.ListProjectForms.LastUpdated': 'Laatst bijgewerkt',
    'jira-common.ListProjectForms.LearnMoreLink': 'Meer informatie over het verwijderen van formulieren.',
    'jira-common.ListProjectForms.RequestType': 'Aanvraagtype',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': 'Aanvraagtypen zoeken',
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': 'Als je dit formulier verwijdert, wordt het verwijderd uit de volgende issuetypen:',
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': 'Als je dit formulier verwijdert, wordt het verwijderd uit de volgende aanvraagtypen:',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Rechtstreekse link kopi\xebren",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Issuetype',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Aanvraagtype',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} zakelijk project} other {{numberOfBusinessProjects,number} zakelijke projecten}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceproject} other {{numberOfServiceProjects,number} serviceprojecten}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} softwareproject} other {{numberOfSoftwareProjects,number} softwareprojecten}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': '{count} issuetypen',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': '{count} aanvraagtypen',
    'proforma-project-forms.BusinessForms': 'Geavanceerde formulieren',
    'proforma-project-forms.CreateForm': 'Formulier aanmaken',
    'proforma-project-forms.Description': 'Formulieren aanmaken, bewerken, exporteren en verwijderen. Kopieer formulieren en gebruik ze bij andere projecten.',
    'proforma-project-forms.Forms': 'Formulieren',
    'proforma-project-forms.LearnMore': 'Meer informatie over formulieren.',
    'proforma-project-forms.LoadingForms': 'Bezig met laden ...',
    'proforma-project-forms.NoFormsDescriptionJsm': 'Voeg formulieren voor klanten toe bij het aanmaken van een aanvraag, of voeg formulieren toe aan bestaande issues om meer informatie te verkrijgen.',
    'proforma-project-forms.NoFormsDescriptionJsw': 'Voeg formulieren voor klanten toe bij het aanmaken van een issue, of voeg formulieren toe aan bestaande issues om meer informatie te verkrijgen.',
    'proforma-project-forms.NoFormsDescriptionJwm': 'Voeg formulieren voor klanten toe bij het aanmaken van een item, of voeg formulieren toe aan bestaande issues om meer informatie te verkrijgen.',
    'proforma-project-forms.NoFormsHeading': 'Al je formulieren verschijnen hier',
    'proforma-project-forms.create-form-button.create-blank': 'Een leeg formulier aanmaken',
    'proforma-project-forms.create-form-button.create-with-template': 'Aanmaken op basis van sjabloon',
    'proforma-project-forms.create-form-button.trigger': 'Formulier aanmaken'
};

});

parcelRegister("jqIxn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e252fe324f988318$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $e252fe324f988318$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Edytuj',
    'form-system.general.Form': 'Nazwa',
    'jira-common.ListProjectForms.AffectExistingIssues': "Nie b\u0119dzie to mia\u0142o wp\u0142ywu na istniej\u0105ce zg\u0142oszenia, w kt\xf3rych ju\u017C u\u017Cyto tego formularza, ani na \u017Cadne kopie tego formularza w innych projektach.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "Typ zg\u0142oszenia",
    'jira-common.ListProjectForms.AssociatedRequestTypes': 'Typ wniosku',
    'jira-common.ListProjectForms.Cancel': 'Anuluj',
    'jira-common.ListProjectForms.Copy': 'Kopiuj do projektu',
    'jira-common.ListProjectForms.CopyFormErrorTitle': "B\u0142\u0105d: Nie mo\u017Cna przekopiowa\u0107 formularza \u201E{formName}\u201D",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Skopiowano formularz do projektu biznesowego} few {Skopiowano formularz do {numberOfBusinessProjects,number} projekt\xf3w biznesowych} many {Skopiowano formularz do {numberOfBusinessProjects,number} projekt\xf3w biznesowych} other {Skopiowano formularz do {numberOfBusinessProjects,number} projektu biznesowego}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Skopiowano formularz do {numberOfProjects,number} projektu} few {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} many {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} other {Skopiowano formularz do {numberOfProjects,number} projektu}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Formularza \u201E{formName}\u201D mo\u017Cna teraz u\u017Cywa\u0107 w\xa0projekcie \u201E{projectName}\u201D.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage} i {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage} i {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Skopiowano formularz do projektu us\u0142ugowego} few {Skopiowano formularz do {numberOfServiceProjects,number} projekt\xf3w us\u0142ugowych} many {Skopiowano formularz do {numberOfServiceProjects,number} projekt\xf3w us\u0142ugowych} other {Skopiowano formularz do {numberOfServiceProjects,number} projektu us\u0142ugowego}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} i {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfSoftwareProjectsMessage} i {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Skopiowano formularz do projektu oprogramowania} few {Skopiowano formularz do {numberOfSoftwareProjects,number} projekt\xf3w oprogramowania} many {Skopiowano formularz do {numberOfSoftwareProjects,number} projekt\xf3w oprogramowania} other {Skopiowano formularz do {numberOfSoftwareProjects,number} projektu oprogramowania}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projekcie.} few {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projektach.} many {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projektach.} other {Formularza "{formName}" mo\u017Cna teraz u\u017Cywa\u0107 w {numberOfProjects,number} projektu.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Skopiowano formularz do projektu} few {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} many {Skopiowano formularz do {numberOfProjects,number} projekt\xf3w} other {Skopiowano formularz do {numberOfProjects,number} projektu}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Anuluj',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Kopiuj',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Kopiuj do projekt\xf3w",
    'jira-common.ListProjectForms.CopyModal.Heading': "Kopiuj formularz \u201E{formName}\u201D do innych projekt\xf3w",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Dowiedz si\u0119 wi\u0119cej o kopiowaniu formularzy",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0141adowanie projekt\xf3w",
    'jira-common.ListProjectForms.CopyModal.Name': 'Nazwa',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Wybierz wszystkie projekty',
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Zmiany wprowadzone w formularzu nie s\u0105 odzwierciedlane w \u017Cadnej z jego kopii w innych projektach.",
    'jira-common.ListProjectForms.CopyText': "{formName} \u2014 kopia",
    'jira-common.ListProjectForms.Delete': "Usu\u0144",
    'jira-common.ListProjectForms.DeleteFormSuccess': "Usuni\u0119to formularz \u201E{formName}\u201D",
    'jira-common.ListProjectForms.Duplicate': 'Duplikuj',
    'jira-common.ListProjectForms.EmptyFormName': 'Formularz bez nazwy',
    'jira-common.ListProjectForms.FilterForms': 'Filtruj formularze',
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "Pobrano plik \u201E{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Od\u015Bwie\u017C stron\u0119 i spr\xf3buj ponownie.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Nie pobrano pliku \u201E{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {Uko\u0144czono {percentCount,number}%} few {Uko\u0144czono {percentCount,number}%} many {Uko\u0144czono {percentCount,number}%} other {Uko\u0144czono {percentCount,number}%}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Pobieranie pliku \u201E{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Eksportuj do pliku XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': "Wi\u0119cej czynno\u015Bci",
    'jira-common.ListProjectForms.FutureIssueMessage': "Przysz\u0142e zg\u0142oszenia utworzone przy u\u017Cyciu tych typ\xf3w zg\u0142osze\u0144 nie b\u0119d\u0105 ju\u017C zawiera\u0142y tego formularza:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Przysz\u0142e wnioski utworzone przy u\u017Cyciu tych typ\xf3w wniosk\xf3w nie b\u0119d\u0105 ju\u017C uwzgl\u0119dnia\u0107 tego formularza.",
    'jira-common.ListProjectForms.Heading': "Czy usun\u0105\u0107 formularz \u201E{formName}\u201D?",
    'jira-common.ListProjectForms.IssueType': "Typ zg\u0142oszenia",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "Wyszukaj typy zg\u0142osze\u0144",
    'jira-common.ListProjectForms.LastUpdated': 'Ostatnia aktualizacja',
    'jira-common.ListProjectForms.LearnMoreLink': "Dowiedz si\u0119 wi\u0119cej o usuwaniu formularzy.",
    'jira-common.ListProjectForms.RequestType': 'Typ wniosku',
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "Wyszukaj typy wniosk\xf3w",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Usuni\u0119cie tego formularza spowoduje usuni\u0119cie go z nast\u0119puj\u0105cych typ\xf3w zg\u0142osze\u0144:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Usuni\u0119cie tego formularza spowoduje usuni\u0119cie go z nast\u0119puj\u0105cych typ\xf3w wniosk\xf3w:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Kopiuj \u0142\u0105cze bezpo\u015Brednie",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Typ zg\u0142oszenia",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': 'Typ wniosku',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': '{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} projekcie biznesowym} few {{numberOfBusinessProjects,number} projektach biznesowych} many {{numberOfBusinessProjects,number} projektach biznesowych} other {{numberOfBusinessProjects,number} projektu biznesowego}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} projekcie us\u0142ugowym} few {{numberOfServiceProjects,number} projektach us\u0142ugowych} many {{numberOfServiceProjects,number} projektach us\u0142ugowych} other {{numberOfServiceProjects,number} projektu us\u0142ugowego}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} projekcie oprogramowania} few {{numberOfSoftwareProjects,number} projektach oprogramowania} many {{numberOfSoftwareProjects,number} projektach oprogramowania} other {{numberOfSoftwareProjects,number} projektu oprogramowania}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "Typy zg\u0142osze\u0144: {count}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "Typy zapyta\u0144: {count}",
    'proforma-project-forms.BusinessForms': 'Formularze zaawansowane',
    'proforma-project-forms.CreateForm': "Utw\xf3rz formularz",
    'proforma-project-forms.Description': "Tw\xf3rz, edytuj, eksportuj i usuwaj formularze. Kopiuj formularze i u\u017Cywaj ich w innych projektach.",
    'proforma-project-forms.Forms': 'Formularze',
    'proforma-project-forms.LearnMore': "Dowiedz si\u0119 wi\u0119cej na temat formularzy.",
    'proforma-project-forms.LoadingForms': "\u0141adowanie\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "Dodawaj formularze, kt\xf3re klienci mog\u0105 wype\u0142ni\u0107 podczas zg\u0142aszania wniosku, lub do\u0142\u0105czaj formularze do istniej\u0105cych zg\u0142osze\u0144, aby zebra\u0107 wi\u0119cej informacji.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Dodawaj formularze, kt\xf3re klienci mog\u0105 wype\u0142ni\u0107 podczas tworzenia zg\u0142oszenia, lub do\u0142\u0105czaj formularze do istniej\u0105cych zg\u0142osze\u0144, aby zebra\u0107 wi\u0119cej informacji.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Dodawaj formularze, kt\xf3re klienci mog\u0105 wype\u0142ni\u0107 podczas tworzenia elementu, lub do\u0142\u0105czaj formularze do istniej\u0105cych zg\u0142osze\u0144, aby zebra\u0107 wi\u0119cej informacji.",
    'proforma-project-forms.NoFormsHeading': "Wszystkie Twoje formularze b\u0119d\u0105 pojawia\u0107 si\u0119 tutaj",
    'proforma-project-forms.create-form-button.create-blank': "Utw\xf3rz pusty",
    'proforma-project-forms.create-form-button.create-with-template': "Utw\xf3rz z szablonu",
    'proforma-project-forms.create-form-button.trigger': "Utw\xf3rz formularz"
};

});

parcelRegister("2vzbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d39c4ab00d9d6aa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $1d39c4ab00d9d6aa$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Editar',
    'form-system.general.Form': 'Nome',
    'jira-common.ListProjectForms.AffectExistingIssues': "Itens existentes que j\xe1 usam este formul\xe1rio ou c\xf3pias deste formul\xe1rio em outros projetos n\xe3o v\xe3o ser afetados.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': 'Tipo do item',
    'jira-common.ListProjectForms.AssociatedRequestTypes': "Tipo de solicita\xe7\xe3o",
    'jira-common.ListProjectForms.Cancel': 'Cancelar',
    'jira-common.ListProjectForms.Copy': 'Copiar para projeto',
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Erro: n\xe3o foi poss\xedvel copiar o \u201C{formName}\u201D",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formul\xe1rio copiado para o projeto de neg\xf3cios} other {Formul\xe1rio copiado para {numberOfBusinessProjects,number} projetos de neg\xf3cios}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formul\xe1rio copiado para {numberOfProjects,number} projeto} other {Formul\xe1rio copiado para {numberOfProjects,number} projetos}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "O \u201C{formName}\u201D agora pode ser usado no \u201C{projectName}\u201D.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage} e {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage} e {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formul\xe1rio copiado para o projeto de servi\xe7o} other {Formul\xe1rio copiado para {numberOfServiceProjects,number} projetos de servi\xe7o}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "''{formName}' agora pode ser usado em {numberOfSoftwareProjectsMessage} e {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "''{formName}' agora pode ser usado em {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formul\xe1rio copiado para projeto de software} other {Formul\xe1rio copiado para {numberOfSoftwareProjects,number} projetos de software}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {O ''{formName}' agora pode ser usado em {numberOfProjects,number} projeto.} other {O ''{formName}' agora pode ser usado em {numberOfProjects,number} projetos.}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formul\xe1rio copiado para o projeto} other {Formul\xe1rio copiado para {numberOfProjects,number} projetos}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Cancelar',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Copiar',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Copiar para projeto(s)',
    'jira-common.ListProjectForms.CopyModal.Heading': "Copiar \u201C{formName}\u201D para outros projetos",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Saiba mais sobre a c\xf3pia de formul\xe1rios",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': 'Carregando projetos',
    'jira-common.ListProjectForms.CopyModal.Name': 'Nome',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': 'Selecionar todos os projetos',
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Altera\xe7\xf5es feitas no formul\xe1rio n\xe3o s\xe3o refletidas em nenhuma das c\xf3pias em outros projetos.",
    'jira-common.ListProjectForms.CopyText': "C\xf3pia de {formName}",
    'jira-common.ListProjectForms.Delete': 'Excluir',
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D exclu\xeddo",
    'jira-common.ListProjectForms.Duplicate': 'Duplicar',
    'jira-common.ListProjectForms.EmptyFormName': "Formul\xe1rio sem t\xedtulo",
    'jira-common.ListProjectForms.FilterForms': "Filtrar formul\xe1rios",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "Download de \u201C{filename}\u201D conclu\xeddo",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Atualize a p\xe1gina e tente de novo.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Falha no download de \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}% conclu\xeddo} other {{percentCount,number}% conclu\xeddos}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Fazendo download de \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportar em XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': "Mais a\xe7\xf5es",
    'jira-common.ListProjectForms.FutureIssueMessage': "Itens futuros criados com esses tipos de item n\xe3o v\xe3o mais incluir este formul\xe1rio:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Solicita\xe7\xf5es futuras criadas com esses tipos de solicita\xe7\xe3o n\xe3o v\xe3o mais incluir este formul\xe1rio.",
    'jira-common.ListProjectForms.Heading': "Excluir \u201C{formName}\u201D?",
    'jira-common.ListProjectForms.IssueType': 'Tipo do item',
    'jira-common.ListProjectForms.IssueTypeAriaLabel': 'Pesquisar tipos de item',
    'jira-common.ListProjectForms.LastUpdated': "\xdaltima atualiza\xe7\xe3o",
    'jira-common.ListProjectForms.LearnMoreLink': "Saiba mais sobre a exclus\xe3o de formul\xe1rios.",
    'jira-common.ListProjectForms.RequestType': "Tipo de solicita\xe7\xe3o",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "Pesquisar tipos de solicita\xe7\xe3o",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "A exclus\xe3o vai remover o formul\xe1rio dos seguintes tipos de item:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "A exclus\xe3o vai remover o formul\xe1rio dos seguintes tipos de solicita\xe7\xe3o:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': 'Copiar link direto',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': 'Tipo do item',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Tipo de solicita\xe7\xe3o",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} projeto de neg\xf3cios} other {{numberOfBusinessProjects,number} projetos de neg\xf3cios}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} projeto de servi\xe7o} other {{numberOfServiceProjects,number} projetos de servi\xe7o}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} projeto de software} other {{numberOfSoftwareProjects,number} projetos de software}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': 'Tipos de item {count}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "Tipos de solicita\xe7\xe3o {count}",
    'proforma-project-forms.BusinessForms': "Formul\xe1rios avan\xe7ados",
    'proforma-project-forms.CreateForm': "Criar formul\xe1rio",
    'proforma-project-forms.Description': "Crie, edite, exporte e exclua formul\xe1rios. Copie e use formul\xe1rios em outros projetos.",
    'proforma-project-forms.Forms': "Formul\xe1rios",
    'proforma-project-forms.LearnMore': "Saiba mais sobre formul\xe1rios.",
    'proforma-project-forms.LoadingForms': 'Carregando...',
    'proforma-project-forms.NoFormsDescriptionJsm': "Adicione formul\xe1rios para que os clientes preencham quando criarem solicita\xe7\xf5es ou anexe formul\xe1rios aos itens atuais para ter mais informa\xe7\xf5es.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Adicione formul\xe1rios para que os clientes preencham quando criarem itens ou anexe formul\xe1rios aos itens atuais para ter mais informa\xe7\xf5es.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Adicione formul\xe1rios para que os clientes preencham quando criarem itens ou anexe formul\xe1rios aos itens atuais para ter mais informa\xe7\xf5es.",
    'proforma-project-forms.NoFormsHeading': "Todos os seus formul\xe1rios v\xe3o ser exibidos aqui",
    'proforma-project-forms.create-form-button.create-blank': "Criar formul\xe1rio em branco",
    'proforma-project-forms.create-form-button.create-with-template': 'Criar a partir de um template',
    'proforma-project-forms.create-form-button.trigger': "Criar formul\xe1rio"
};

});

parcelRegister("lEBoP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc3a582827b3ff6f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $fc3a582827b3ff6f$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C",
    'form-system.general.Form': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
    'jira-common.ListProjectForms.AffectExistingIssues': "\u042D\u0442\u043E \u043D\u0435 \u0437\u0430\u0442\u0440\u043E\u043D\u0435\u0442 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0443\u0436\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443, \u043B\u0438\u0431\u043E \u043A\u043E\u043F\u0438\u0438 \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\u0422\u0438\u043F \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
    'jira-common.ListProjectForms.Cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
    'jira-common.ListProjectForms.Copy': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 \u043F\u0440\u043E\u0435\u043A\u0442",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "\u041E\u0448\u0438\u0431\u043A\u0430: \u043D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u0435 \xab{projectName}\xbb.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage} \u0438 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage} \u0438 {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \u0438 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfSoftwareProjectsMessage} \u0438 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0435.} few {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.} many {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.} other {\u0422\u0435\u043F\u0435\u0440\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430.}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442} few {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {\u0424\u043E\u0440\u043C\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u041E\u0442\u043C\u0435\u043D\u0430",
    'jira-common.ListProjectForms.CopyModal.Copy': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432 \u043F\u0440\u043E\u0435\u043A\u0442\u044B",
    'jira-common.ListProjectForms.CopyModal.Heading': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u043E\u0440\u043C\u044B \xab{formName}\xbb \u0432 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u0444\u043E\u0440\u043C",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432",
    'jira-common.ListProjectForms.CopyModal.Name': "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\u0412\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0435 \u0432 \u0444\u043E\u0440\u043C\u0443 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u043D\u0435 \u043E\u0442\u0440\u0430\u0436\u0430\u044E\u0442\u0441\u044F \u0432 \u0435\u0435 \u043A\u043E\u043F\u0438\u044F\u0445 \u0438\u0437 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432.",
    'jira-common.ListProjectForms.CopyText': "\u041A\u043E\u043F\u0438\u044F \u0444\u043E\u0440\u043C\u044B \xab{formName}\xbb",
    'jira-common.ListProjectForms.Delete': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u0424\u043E\u0440\u043C\u0430 \xab{formName}\xbb \u0443\u0434\u0430\u043B\u0435\u043D\u0430",
    'jira-common.ListProjectForms.Duplicate': "\u0414\u0443\u0431\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
    'jira-common.ListProjectForms.EmptyFormName': "\u0424\u043E\u0440\u043C\u0430 \u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F",
    'jira-common.ListProjectForms.FilterForms': "\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u044B",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0424\u0430\u0439\u043B \xab{filename}\xbb \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u0424\u0430\u0439\u043B \xab{filename}\xbb \u043D\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%} few {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%} many {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%} other {\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E: {percentCount,number}\xa0%}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0444\u0430\u0439\u043B\u0430 \xab{filename}\xbb",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u042D\u043A\u0441\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432 XLSX",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\u0414\u0440\u0443\u0433\u0438\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F",
    'jira-common.ListProjectForms.FutureIssueMessage': "\u0411\u0443\u0434\u0443\u0449\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u044D\u0442\u0438\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447, \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u0434\u0430\u043D\u043D\u0443\u044E \u0444\u043E\u0440\u043C\u0443:",
    'jira-common.ListProjectForms.FutureRequestMessage': "\u0411\u0443\u0434\u0443\u0449\u0438\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u044B, \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432, \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.",
    'jira-common.ListProjectForms.Heading': "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb?",
    'jira-common.ListProjectForms.IssueType': "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u041F\u043E\u0438\u0441\u043A \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447",
    'jira-common.ListProjectForms.LastUpdated': "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435",
    'jira-common.ListProjectForms.LearnMoreLink': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E\u0431 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0438 \u0444\u043E\u0440\u043C.",
    'jira-common.ListProjectForms.RequestType': "\u0422\u0438\u043F \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u041F\u043E\u0438\u0441\u043A \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u043E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u043E\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0442\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u044F\u043C\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447\u0438",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u043F\u0440\u043E\u0441\u0430",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442} few {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430} many {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432} other {{numberOfBusinessProjects,number}\xa0\u0431\u0438\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0435\u043A\u0442\u0430}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} few {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} many {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438} other {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043B\u0443\u0436\u0431\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} few {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} many {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E} other {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u043F\u043E \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0435 \u041F\u041E}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\u0422\u0438\u043F\u043E\u0432 \u0437\u0430\u0434\u0430\u0447: {count}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\u0422\u0438\u043F\u043E\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432: {count}",
    'proforma-project-forms.BusinessForms': "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B",
    'proforma-project-forms.CreateForm': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443",
    'proforma-project-forms.Description': "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435, \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0444\u043E\u0440\u043C. \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0444\u043E\u0440\u043C \u0434\u043B\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430\u0445.",
    'proforma-project-forms.Forms': "\u0424\u043E\u0440\u043C\u044B",
    'proforma-project-forms.LearnMore': "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u0444\u043E\u0440\u043C\u0430\u0445.",
    'proforma-project-forms.LoadingForms': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u044B, \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u0430, \u0438\u043B\u0438 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u044B \u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u043C \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
    'proforma-project-forms.NoFormsDescriptionJsw': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u044B, \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u0437\u0430\u0434\u0430\u0447\u0438, \u0438\u043B\u0438 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u044B \u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u043C \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
    'proforma-project-forms.NoFormsDescriptionJwm': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0444\u043E\u0440\u043C\u044B, \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u0435\u043C\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u043F\u0440\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430, \u0438\u043B\u0438 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u044B \u043A \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u0434\u0430\u0447\u0430\u043C \u0434\u043B\u044F \u0441\u0431\u043E\u0440\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438.",
    'proforma-project-forms.NoFormsHeading': "\u0417\u0434\u0435\u0441\u044C \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0432\u0441\u0435 \u0432\u0430\u0448\u0438 \u0444\u043E\u0440\u043C\u044B",
    'proforma-project-forms.create-form-button.create-blank': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u0443\u0441\u0442\u0443\u044E",
    'proforma-project-forms.create-form-button.create-with-template': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0430",
    'proforma-project-forms.create-form-button.trigger': "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0444\u043E\u0440\u043C\u0443"
};

});

parcelRegister("hA1LO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc72bf6e62c93a1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $ccc72bf6e62c93a1$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': 'Redigera',
    'form-system.general.Form': 'Namn',
    'jira-common.ListProjectForms.AffectExistingIssues': "Detta p\xe5verkar inte befintliga \xe4renden som redan anv\xe4nder det h\xe4r formul\xe4ret, eller kopior av detta formul\xe4r i andra projekt.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\xc4rendetyp",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "F\xf6rfr\xe5gningstyp",
    'jira-common.ListProjectForms.Cancel': 'Avbryt',
    'jira-common.ListProjectForms.Copy': 'Kopiera till projekt',
    'jira-common.ListProjectForms.CopyFormErrorTitle': "Fel: Kunde inte kopiera \xf6ver \u201D{formName}\u201D",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Formul\xe4ret har kopierats till aff\xe4rsprojektet} other {Formul\xe4ret har kopierats till {numberOfBusinessProjects,number} aff\xe4rsprojekt}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Formul\xe4ret har kopierats till {numberOfProjects,number} projekt} other {Formul\xe4ret har kopierats till {numberOfProjects,number} projekt}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201D{formName}\u201D kan nu anv\xe4ndas i \u201D{projectName}\u201D.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage} och {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage} och {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Formul\xe4ret har kopierats till serviceprojektet} other {Formul\xe4ret har kopierats till {numberOfServiceProjects,number} serviceprojekt}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} och {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfSoftwareProjectsMessage} och {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" kan nu anv\xe4ndas i {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Formul\xe4ret har kopierats till programvaruprojektet} other {Formul\xe4ret har kopierats till {numberOfSoftwareProjects,number} programvaruprojekt}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" kan nu anv\xe4ndas i {numberOfProjects,number} projekt.} other {"{formName}" kan nu anv\xe4ndas i {numberOfProjects,number} projekt.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Formul\xe4ret har kopierats till projektet} other {Formul\xe4ret har kopierats till {numberOfProjects,number} projekt}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': 'Avbryt',
    'jira-common.ListProjectForms.CopyModal.Copy': 'Kopiera',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Kopiera till projekt',
    'jira-common.ListProjectForms.CopyModal.Heading': "Kopiera \u201D{formName}\u201D till andra projekt",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "L\xe4s mer om att kopiera formul\xe4r",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "L\xe4ser in projekt",
    'jira-common.ListProjectForms.CopyModal.Name': 'Namn',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "V\xe4lj alla projekt",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\xc4ndringar som g\xf6rs i ett formul\xe4r \xe5terspeglas inte i n\xe5gon av dess kopior i andra projekt.",
    'jira-common.ListProjectForms.CopyText': 'Kopia av {formName}',
    'jira-common.ListProjectForms.Delete': 'Radera',
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u201D{formName}\u201D har raderats",
    'jira-common.ListProjectForms.Duplicate': 'Duplicera',
    'jira-common.ListProjectForms.EmptyFormName': "Namnl\xf6st formul\xe4r",
    'jira-common.ListProjectForms.FilterForms': "Filtrera formul\xe4r",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201D{filename}\u201D har laddats ner",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Uppdatera sidan och f\xf6rs\xf6k igen.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201D{filename}\u201D har inte laddats ner",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {{percentCount,number}\xa0% slutf\xf6rt} other {{percentCount,number}\xa0% slutf\xf6rt}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "Laddar ner \u201D{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': 'Exportera i XLSX',
    'jira-common.ListProjectForms.FormActions.MoreActions': "Fler \xe5tg\xe4rder",
    'jira-common.ListProjectForms.FutureIssueMessage': "Framtida \xe4renden som skapas med dessa \xe4rendetyper kommer inte l\xe4ngre att inkludera det h\xe4r formul\xe4ret.",
    'jira-common.ListProjectForms.FutureRequestMessage': "Framtida f\xf6rfr\xe5gningar som skapas med dessa f\xf6rfr\xe5gningstyper kommer inte l\xe4ngre att inkludera det h\xe4r formul\xe4ret.",
    'jira-common.ListProjectForms.Heading': "Vill du radera \u201D{formName}\u201D?",
    'jira-common.ListProjectForms.IssueType': "\xc4rendetyp",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "S\xf6k efter \xe4rendetyper",
    'jira-common.ListProjectForms.LastUpdated': 'Uppdaterades senast',
    'jira-common.ListProjectForms.LearnMoreLink': "L\xe4s mer om att radera formul\xe4r.",
    'jira-common.ListProjectForms.RequestType': "Typ av f\xf6rfr\xe5gan",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "S\xf6k efter f\xf6rfr\xe5gningstyper",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Om formul\xe4ret raderas tas det bort fr\xe5n f\xf6ljande \xe4rendetyper:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Om formul\xe4ret raderas tas det bort fr\xe5n f\xf6ljande f\xf6rfr\xe5gningstyper:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Kopiera direktl\xe4nken",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\xc4rendetyp",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Typ av f\xf6rfr\xe5gan",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} aff\xe4rsprojekt} other {{numberOfBusinessProjects,number} aff\xe4rsprojekt}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} serviceprojekt} other {{numberOfServiceProjects,number} serviceprojekt}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': '{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} programvaruprojekt} other {{numberOfSoftwareProjects,number} programvaruprojekt}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \xe4rendetyper",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} f\xf6rfr\xe5gningstyper",
    'proforma-project-forms.BusinessForms': "Avancerade formul\xe4r",
    'proforma-project-forms.CreateForm': "Skapa formul\xe4r",
    'proforma-project-forms.Description': "Skapa, redigera, exportera och radera formul\xe4r. Kopiera formul\xe4r och anv\xe4nd dem i andra projekt.",
    'proforma-project-forms.Forms': "Formul\xe4r",
    'proforma-project-forms.LearnMore': "L\xe4s mer om formul\xe4r.",
    'proforma-project-forms.LoadingForms': "L\xe4ser in\xa0\u2026",
    'proforma-project-forms.NoFormsDescriptionJsm': "L\xe4gg till formul\xe4r som kunder kan fylla i n\xe4r de skapar en f\xf6rfr\xe5gan, eller bifoga formul\xe4r till befintliga \xe4renden f\xf6r att samla in mer information.",
    'proforma-project-forms.NoFormsDescriptionJsw': "L\xe4gg till formul\xe4r som kunder kan fylla i n\xe4r de skapar ett \xe4rende, eller bifoga formul\xe4r till befintliga \xe4renden f\xf6r att samla in mer information.",
    'proforma-project-forms.NoFormsDescriptionJwm': "L\xe4gg till formul\xe4r som kunder kan fylla i n\xe4r de skapar en uppgift, eller bifoga formul\xe4r till befintliga \xe4renden f\xf6r att samla in mer information.",
    'proforma-project-forms.NoFormsHeading': "Alla dina formul\xe4r kommer att visas h\xe4r",
    'proforma-project-forms.create-form-button.create-blank': 'Skapa tom',
    'proforma-project-forms.create-form-button.create-with-template': "Skapa fr\xe5n mall",
    'proforma-project-forms.create-form-button.trigger': "Skapa formul\xe4r"
};

});

parcelRegister("5iPCG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc6ad6a88e8a870$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $3dc6ad6a88e8a870$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\u0E41\u0E01\u0E49\u0E44\u0E02",
    'form-system.general.Form': "\u0E0A\u0E37\u0E48\u0E2D",
    'jira-common.ListProjectForms.AffectExistingIssues': "\u0E0B\u0E36\u0E48\u0E07\u0E08\u0E30\u0E44\u0E21\u0E48\u0E2A\u0E48\u0E07\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E15\u0E48\u0E2D\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E41\u0E25\u0E49\u0E27 \u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E43\u0E14 \u0E46 \u0E02\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
    'jira-common.ListProjectForms.Cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'jira-common.ListProjectForms.Copy': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14: \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 {formName} \u0E44\u0E14\u0E49",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfBusinessProjectsMessage}',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E41\u0E25\u0E49\u0E27 {numberOfBusinessProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27 {numberOfProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 \u201C{projectName}\u201D",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage} \u0E41\u0E25\u0E30 {numberOfBusinessProjectsMessage}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage} \u0E41\u0E25\u0E30 {numberOfSoftwareProjectsMessage}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage}',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E41\u0E25\u0E49\u0E27 {numberOfServiceProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} \u0E41\u0E25\u0E30 {numberOfBusinessProjectsMessage}',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfSoftwareProjectsMessage} \u0E41\u0E25\u0E30 {numberOfBusinessProjectsMessage}',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19 {numberOfSoftwareProjectsMessage}',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E41\u0E25\u0E49\u0E27 {numberOfSoftwareProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {"{formName}" \u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C {numberOfProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E41\u0E25\u0E49\u0E27 {numberOfProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01",
    'jira-common.ListProjectForms.CopyModal.Copy': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'jira-common.ListProjectForms.CopyModal.Heading': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 \u201C{formName}\u201D \u0E44\u0E1B\u0E22\u0E31\u0E07\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C",
    'jira-common.ListProjectForms.CopyModal.Name': "\u0E0A\u0E37\u0E48\u0E2D",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E43\u0E14\u0E46 \u0E17\u0E35\u0E48\u0E17\u0E33\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E08\u0E30\u0E44\u0E21\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E47\u0E19\u0E43\u0E19\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E02\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46",
    'jira-common.ListProjectForms.CopyText': "\u0E2A\u0E33\u0E40\u0E19\u0E32 {formName}",
    'jira-common.ListProjectForms.Delete': "\u0E25\u0E1A",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u0E25\u0E1A \u201C{formName}\u201D \u0E41\u0E25\u0E49\u0E27",
    'jira-common.ListProjectForms.Duplicate': "\u0E17\u0E33\u0E2A\u0E33\u0E40\u0E19\u0E32",
    'jira-common.ListProjectForms.EmptyFormName': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D",
    'jira-common.ListProjectForms.FilterForms': "\u0E01\u0E23\u0E2D\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u201C{filename}\u201D \u0E41\u0E25\u0E49\u0E27",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E2B\u0E19\u0E49\u0E32\u0E19\u0E35\u0E49 \u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27 {percentCount,number}%}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1F\u0E25\u0E4C XLSX",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'jira-common.ListProjectForms.FutureIssueMessage': "\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E02\u0E36\u0E49\u0E19\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B:",
    'jira-common.ListProjectForms.FutureRequestMessage': "\u0E04\u0E33\u0E02\u0E2D\u0E43\u0E19\u0E2D\u0E19\u0E32\u0E04\u0E15\u0E17\u0E35\u0E48\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E14\u0E49\u0E27\u0E22\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D\u0E40\u0E2B\u0E25\u0E48\u0E32\u0E19\u0E35\u0E49\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E27\u0E21\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E2D\u0E35\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B",
    'jira-common.ListProjectForms.Heading': "\u0E25\u0E1A \u201C{formName}\u201D \u0E43\u0E0A\u0E48\u0E44\u0E2B\u0E21",
    'jira-common.ListProjectForms.IssueType': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'jira-common.ListProjectForms.LastUpdated': "\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
    'jira-common.ListProjectForms.LearnMoreLink': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
    'jira-common.ListProjectForms.RequestType': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E40\u0E0A\u0E48\u0E19\u0E01\u0E31\u0E19",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49\u0E08\u0E30\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49\u0E14\u0E49\u0E27\u0E22\u0E40\u0E0A\u0E48\u0E19\u0E01\u0E31\u0E19",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08 {numberOfBusinessProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23 {numberOfServiceProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C {numberOfSoftwareProjects,number} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E1B\u0E31\u0E0D\u0E2B\u0E32",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E04\u0E33\u0E02\u0E2D",
    'proforma-project-forms.BusinessForms': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E02\u0E31\u0E49\u0E19\u0E2A\u0E39\u0E07",
    'proforma-project-forms.CreateForm': "\u0E08\u0E31\u0E14\u0E17\u0E33\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
    'proforma-project-forms.Description': "\u0E08\u0E31\u0E14\u0E17\u0E33 \u0E41\u0E01\u0E49\u0E44\u0E02 \u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01 \u0E41\u0E25\u0E30\u0E25\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21 \u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E41\u0E25\u0E30\u0E43\u0E0A\u0E49\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E40\u0E08\u0E01\u0E15\u0E4C\u0E2D\u0E37\u0E48\u0E19 \u0E46",
    'proforma-project-forms.Forms': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
    'proforma-project-forms.LearnMore': "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E01\u0E31\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21",
    'proforma-project-forms.LoadingForms': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    'proforma-project-forms.NoFormsDescriptionJsm': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E04\u0E33\u0E02\u0E2D \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E19\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'proforma-project-forms.NoFormsDescriptionJsw': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32 \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E19\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'proforma-project-forms.NoFormsDescriptionJwm': "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E2B\u0E23\u0E37\u0E2D\u0E41\u0E19\u0E1A\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'proforma-project-forms.NoFormsHeading': "\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E36\u0E49\u0E19\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48",
    'proforma-project-forms.create-form-button.create-blank': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E27\u0E48\u0E32\u0E07",
    'proforma-project-forms.create-form-button.create-with-template': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E08\u0E32\u0E01\u0E41\u0E21\u0E48\u0E41\u0E1A\u0E1A",
    'proforma-project-forms.create-form-button.trigger': "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21"
};

});

parcelRegister("jEzMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ed8235a75eb67d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $e4ed8235a75eb67d$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "D\xfczenle",
    'form-system.general.Form': 'Ad',
    'jira-common.ListProjectForms.AffectExistingIssues': "Bu durum, bu formu zaten kullanan mevcut konular\u0131 veya bu formun di\u011Fer projelerdeki kopyalar\u0131n\u0131 etkilemez.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "Konu t\xfcr\xfc",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "Talep t\xfcr\xfc",
    'jira-common.ListProjectForms.Cancel': "\u0130ptal",
    'jira-common.ListProjectForms.Copy': 'Projeye kopyala',
    'jira-common.ListProjectForms.CopyFormErrorTitle': 'Hata: "{formName}" kopyalanam\u0131yor',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {Form i\u015F projesine kopyaland\u0131} other {Form {numberOfBusinessProjects,number} i\u015F projesine kopyaland\u0131}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {Form {numberOfProjects,number} projeye kopyaland\u0131} other {Form {numberOfProjects,number} projeye kopyaland\u0131}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': '"{formName}" art\u0131k "{projectName}" projesinde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage} ve {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage} ve {numberOfSoftwareProjectsMessage} i\xe7inde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage} i\xe7inde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {Form destek projesine kopyaland\u0131} other {Form {numberOfServiceProjects,number} destek projesine kopyaland\u0131}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} ve {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" art\u0131k {numberOfSoftwareProjectsMessage} ve {numberOfBusinessProjectsMessage} i\xe7inde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" art\u0131k {numberOfSoftwareProjectsMessage} i\xe7inde kullan\u0131labilir.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {Form yaz\u0131l\u0131m projesine kopyaland\u0131} other {Form {numberOfSoftwareProjects,number} yaz\u0131l\u0131m projesine kopyaland\u0131}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, one {"{formName}" art\u0131k {numberOfProjects,number} projede kullan\u0131labilir.} other {"{formName}" art\u0131k {numberOfProjects,number} projede kullan\u0131labilir.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {Form projeye kopyaland\u0131} other {Form {numberOfProjects,number} projeye kopyaland\u0131}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u0130ptal",
    'jira-common.ListProjectForms.CopyModal.Copy': 'Kopyala',
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': 'Projelere kopyala',
    'jira-common.ListProjectForms.CopyModal.Heading': '"{formName}" formunu di\u011Fer projelere kopyalay\u0131n',
    'jira-common.ListProjectForms.CopyModal.LearnMore': "Formlar\u0131 kopyalamak hakk\u0131nda daha fazla bilgi edinin",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "Projeler y\xfckleniyor",
    'jira-common.ListProjectForms.CopyModal.Name': 'Ad',
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "T\xfcm projeleri se\xe7",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "Bir formda yap\u0131lan de\u011Fi\u015Fiklikler, di\u011Fer projelerdeki kopyalar\u0131na yans\u0131t\u0131lmaz.",
    'jira-common.ListProjectForms.CopyText': "{formName} formunun kopyas\u0131",
    'jira-common.ListProjectForms.Delete': 'Sil',
    'jira-common.ListProjectForms.DeleteFormSuccess': '"{formName}" silindi',
    'jira-common.ListProjectForms.Duplicate': "\xc7o\u011Falt",
    'jira-common.ListProjectForms.EmptyFormName': "Ba\u015Fl\u0131ks\u0131z Form",
    'jira-common.ListProjectForms.FilterForms': "Formlar\u0131 filtreleyin",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': '"{filename}" indirildi',
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "Sayfay\u0131 yenileyin ve tekrar deneyin.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': '"{filename}" indirilemedi',
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {%{percentCount,number} tamamland\u0131} other {%{percentCount,number} tamamland\u0131}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': '"{filename}" indiriliyor',
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "XLSX olarak d\u0131\u015Fa aktar",
    'jira-common.ListProjectForms.FormActions.MoreActions': "Daha fazla i\u015Flem",
    'jira-common.ListProjectForms.FutureIssueMessage': "Bu konu t\xfcrleri kullan\u0131larak olu\u015Fturulacak konular art\u0131k bu formu i\xe7ermeyecek:",
    'jira-common.ListProjectForms.FutureRequestMessage': "Bu talep t\xfcrleri kullan\u0131larak olu\u015Fturulacak talepler art\u0131k bu formu i\xe7ermeyecek.",
    'jira-common.ListProjectForms.Heading': '"{formName}" silinsin mi?',
    'jira-common.ListProjectForms.IssueType': "Konu t\xfcr\xfc",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "Konu t\xfcrlerini aray\u0131n",
    'jira-common.ListProjectForms.LastUpdated': "Son g\xfcncelleme",
    'jira-common.ListProjectForms.LearnMoreLink': "Formlar\u0131 silmek hakk\u0131nda daha fazla bilgi edinin.",
    'jira-common.ListProjectForms.RequestType': "Talep t\xfcr\xfc",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "Talep t\xfcrlerini aray\u0131n",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "Bu formu sildi\u011Finizde form a\u015Fa\u011F\u0131daki konu t\xfcrlerinden kald\u0131r\u0131l\u0131r:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "Bu formu sildi\u011Finizde form a\u015Fa\u011F\u0131daki talep t\xfcrlerinden kald\u0131r\u0131l\u0131r:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Do\u011Frudan ba\u011Flant\u0131y\u0131 kopyala",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Konu t\xfcr\xfc",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Talep t\xfcr\xfc",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number} i\u015F projesi} other {{numberOfBusinessProjects,number} i\u015F projesi}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': '{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number} destek projesi} other {{numberOfServiceProjects,number} destek projesi}}',
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number} yaz\u0131l\u0131m projesi} other {{numberOfSoftwareProjects,number} yaz\u0131l\u0131m projesi}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} konu t\xfcr\xfc",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} talep t\xfcr\xfc",
    'proforma-project-forms.BusinessForms': "Geli\u015Fmi\u015F Formlar",
    'proforma-project-forms.CreateForm': "Form olu\u015Ftur",
    'proforma-project-forms.Description': "Form olu\u015Fturun, d\xfczenleyin, d\u0131\u015Fa aktar\u0131n veya silin. Formlar\u0131 kopyalay\u0131p di\u011Fer projelerde kullan\u0131n.",
    'proforma-project-forms.Forms': 'Formlar',
    'proforma-project-forms.LearnMore': "Formlar hakk\u0131nda daha fazla bilgi edinin.",
    'proforma-project-forms.LoadingForms': "Y\xfckleniyor...",
    'proforma-project-forms.NoFormsDescriptionJsm': "Talep olu\u015Ftururken m\xfc\u015Fterilerin dolduraca\u011F\u0131 formlar ekleyin veya daha fazla bilgi toplamak i\xe7in formlar\u0131 mevcut konulara ekleyin.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Konu olu\u015Ftururken m\xfc\u015Fterilerin dolduraca\u011F\u0131 formlar ekleyin veya daha fazla bilgi toplamak i\xe7in formlar\u0131 mevcut konulara ekleyin.",
    'proforma-project-forms.NoFormsDescriptionJwm': "\xd6\u011Fe olu\u015Ftururken m\xfc\u015Fterilerin dolduraca\u011F\u0131 formlar ekleyin veya daha fazla bilgi toplamak i\xe7in formlar\u0131 mevcut konulara ekleyin.",
    'proforma-project-forms.NoFormsHeading': "T\xfcm formlar\u0131n\u0131z burada g\xf6r\xfcnecek",
    'proforma-project-forms.create-form-button.create-blank': "Bo\u015F form olu\u015Ftur",
    'proforma-project-forms.create-form-button.create-with-template': "\u015Eablondan olu\u015Ftur",
    'proforma-project-forms.create-form-button.trigger': "Form olu\u015Ftur"
};

});

parcelRegister("6YBPtg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5145b0c1b2334d60$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $5145b0c1b2334d60$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
    'form-system.general.Form': "\u041D\u0430\u0437\u0432\u0430",
    'jira-common.ListProjectForms.AffectExistingIssues': "\u0426\u0435 \u043D\u0435 \u0432\u043F\u043B\u0438\u043D\u0435 \u043D\u0430 \u043D\u0430\u044F\u0432\u043D\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F, \u0443 \u044F\u043A\u0438\u0445 \u0443\u0436\u0435 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u044C\u0441\u044F \u0446\u044F \u0444\u043E\u0440\u043C\u0430, \u0430\u0431\u043E \u043D\u0430 \u0431\u0443\u0434\u044C-\u044F\u043A\u0456 \u043A\u043E\u043F\u0456\u0457 \u0444\u043E\u0440\u043C\u0438 \u0432 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\u0422\u0438\u043F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\u0422\u0438\u043F \u0437\u0430\u043F\u0438\u0442\u0443",
    'jira-common.ListProjectForms.Cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'jira-common.ListProjectForms.Copy': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "\u041F\u043E\u043C\u0438\u043B\u043A\u0430: \u043D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0443} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 \u043F\u0440\u043E\u0454\u043A\u0442\u0456 \xab{projectName}\xbb.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage} \u0456 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage} \u0456 {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0441\u043B\u0443\u0436\u0431\u0438} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u043B\u0443\u0436\u0431\u0438} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u043B\u0443\u0436\u0431\u0438} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0441\u043B\u0443\u0436\u0431\u0438}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfServiceProjectsMessage}), {numberOfSoftwareProjectsMessage} \u0456 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfSoftwareProjectsMessage} \u0456 {numberOfBusinessProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfSoftwareProjectsMessage}.",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, one {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456.} few {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.} many {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.} other {\u0422\u0435\u043F\u0435\u0440 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u043C\u043E\u0436\u043D\u0430 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0432\u0430\u0442\u0438 \u0432 {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, one {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443} few {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} many {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432} other {\u0424\u043E\u0440\u043C\u0443 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0434\u043E {numberOfProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
    'jira-common.ListProjectForms.CopyModal.Copy': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u0434\u043E \u043F\u0440\u043E\u0454\u043A\u0442\u0443(-\u0456\u0432)",
    'jira-common.ListProjectForms.CopyModal.Heading': "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u0434\u043E \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u043A\u043E\u043F\u0456\u044E\u0432\u0430\u043D\u043D\u044F \u0444\u043E\u0440\u043C",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043F\u0440\u043E\u0454\u043A\u0442\u0456\u0432",
    'jira-common.ListProjectForms.CopyModal.Name': "\u041D\u0430\u0437\u0432\u0430",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456 \u043F\u0440\u043E\u0454\u043A\u0442\u0438",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\u0417\u043C\u0456\u043D\u0438 \u0444\u043E\u0440\u043C\u0438 \u043D\u0435 \u0431\u0443\u0434\u0435 \u043F\u043E\u0448\u0438\u0440\u0435\u043D\u043E \u043D\u0430 \u0457\u0457 \u043A\u043E\u043F\u0456\u0457 \u0432 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.",
    'jira-common.ListProjectForms.CopyText': "\u041A\u043E\u043F\u0456\u044F \u0444\u043E\u0440\u043C\u0438 {formName}",
    'jira-common.ListProjectForms.Delete': "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u0424\u043E\u0440\u043C\u0443 \xab{formName}\xbb \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
    'jira-common.ListProjectForms.Duplicate': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043A\u043E\u043F\u0456\u044E",
    'jira-common.ListProjectForms.EmptyFormName': "\u0424\u043E\u0440\u043C\u0430 \u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0438",
    'jira-common.ListProjectForms.FilterForms': "\u0424\u0456\u043B\u044C\u0442\u0440 \u0444\u043E\u0440\u043C",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043E \u0444\u0430\u0439\u043B \xab{filename}\xbb",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u041E\u043D\u043E\u0432\u0456\u0442\u044C \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u0456\u0442\u044C \u0441\u043F\u0440\u043E\u0431\u0443.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u0430\u0439\u043B \xab{filename}\xbb",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, one {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%} few {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%} many {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%} other {\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E: {percentCount,number}\xa0%}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0444\u0430\u0439\u043B\u0443 \xab{filename}\xbb",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u0415\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 XLSX",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\u0406\u043D\u0448\u0456 \u0434\u0456\u0457",
    'jira-common.ListProjectForms.FutureIssueMessage': "\u0426\u044F \u0444\u043E\u0440\u043C\u0430 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442\u0438\u043C\u0435 \u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0445 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0446\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C.",
    'jira-common.ListProjectForms.FutureRequestMessage': "\u0426\u044F \u0444\u043E\u0440\u043C\u0430 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u0432\u0445\u043E\u0434\u0438\u0442\u0438\u043C\u0435 \u0434\u043E \u043F\u043E\u0434\u0430\u043B\u044C\u0448\u0438\u0445 \u0437\u0430\u043F\u0438\u0442\u0456\u0432, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0445 \u0437\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u043E\u044E \u0446\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432.",
    'jira-common.ListProjectForms.Heading': "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443 \xab{formName}\xbb?",
    'jira-common.ListProjectForms.IssueType': "\u0422\u0438\u043F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u041F\u043E\u0448\u0443\u043A \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
    'jira-common.ListProjectForms.LastUpdated': "\u0412\u043E\u0441\u0442\u0430\u043D\u043D\u0454 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E",
    'jira-common.ListProjectForms.LearnMoreLink': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0444\u043E\u0440\u043C.",
    'jira-common.ListProjectForms.RequestType': "\u0422\u0438\u043F \u0437\u0430\u043F\u0438\u0442\u0443",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u041F\u043E\u0448\u0443\u043A \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u0423 \u0440\u0430\u0437\u0456 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0444\u043E\u0440\u043C\u0438 \u0457\u0457 \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0442\u0430\u043A\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u0423 \u0440\u0430\u0437\u0456 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0444\u043E\u0440\u043C\u0438 \u0457\u0457 \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u0437 \u0442\u0430\u043A\u0438\u0445 \u0442\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u0440\u044F\u043C\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u0422\u0438\u043F \u0437\u0430\u043F\u0438\u0442\u0443",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, one {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0456} few {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445} many {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445} other {{numberOfBusinessProjects,number}\xa0\u0431\u0456\u0437\u043D\u0435\u0441-\u043F\u0440\u043E\u0454\u043A\u0442\u0443}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, one {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456 \u0441\u043B\u0443\u0436\u0431} few {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0441\u043B\u0443\u0436\u0431} many {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0441\u043B\u0443\u0436\u0431} other {{numberOfServiceProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0441\u043B\u0443\u0436\u0431}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, one {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0456 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} few {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} many {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F} other {{numberOfSoftwareProjects,number}\xa0\u043F\u0440\u043E\u0454\u043A\u0442\u0443 \u0456\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043D\u043E\u0433\u043E \u0437\u0430\u0431\u0435\u0437\u043F\u0435\u0447\u0435\u043D\u043D\u044F}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "\u0422\u0438\u043F\u0456\u0432 \u0437\u0430\u0432\u0434\u0430\u043D\u044C: {count}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "\u0422\u0438\u043F\u0456\u0432 \u0437\u0430\u043F\u0438\u0442\u0456\u0432: {count}",
    'proforma-project-forms.BusinessForms': "\u0420\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0456 \u0444\u043E\u0440\u043C\u0438",
    'proforma-project-forms.CreateForm': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443",
    'proforma-project-forms.Description': "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435, \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435, \u0435\u043A\u0441\u043F\u043E\u0440\u0442\u0443\u0439\u0442\u0435 \u0442\u0430 \u0432\u0438\u0434\u0430\u043B\u044F\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438. \u041A\u043E\u043F\u0456\u044E\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438 \u0439 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0457\u0445 \u0432 \u0456\u043D\u0448\u0438\u0445 \u043F\u0440\u043E\u0454\u043A\u0442\u0430\u0445.",
    'proforma-project-forms.Forms': "\u0424\u043E\u0440\u043C\u0438",
    'proforma-project-forms.LearnMore': "\u0414\u043E\u043A\u043B\u0430\u0434\u043D\u0456\u0448\u0435 \u043F\u0440\u043E \u0444\u043E\u0440\u043C\u0438",
    'proforma-project-forms.LoadingForms': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    'proforma-project-forms.NoFormsDescriptionJsm': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438, \u044F\u043A\u0456 \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0438 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0442\u0456\u0432, \u0430\u0431\u043E \u0432\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0444\u043E\u0440\u043C\u0438 \u0434\u043E \u043D\u0430\u044F\u0432\u043D\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0449\u043E\u0431 \u0437\u0456\u0431\u0440\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457.",
    'proforma-project-forms.NoFormsDescriptionJsw': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438, \u044F\u043A\u0456 \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0438 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0430\u0431\u043E \u0432\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0444\u043E\u0440\u043C\u0438 \u0434\u043E \u043D\u0430\u044F\u0432\u043D\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0449\u043E\u0431 \u0437\u0456\u0431\u0440\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457.",
    'proforma-project-forms.NoFormsDescriptionJwm': "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0438, \u044F\u043A\u0456 \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u0432\u0430\u0442\u0438\u043C\u0443\u0442\u044C \u043A\u043B\u0456\u0454\u043D\u0442\u0438 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u0443\u043D\u043A\u0442\u0456\u0432, \u0430\u0431\u043E \u0432\u043A\u043B\u0430\u0434\u0456\u0442\u044C \u0444\u043E\u0440\u043C\u0438 \u0434\u043E \u043D\u0430\u044F\u0432\u043D\u0438\u0445 \u0437\u0430\u0432\u0434\u0430\u043D\u044C, \u0449\u043E\u0431 \u0437\u0456\u0431\u0440\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u0457.",
    'proforma-project-forms.NoFormsHeading': "\u0423\u0441\u0456 \u0432\u0430\u0448\u0456 \u0444\u043E\u0440\u043C\u0438 \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u0438\u043C\u0443\u0442\u044C\u0441\u044F \u0442\u0443\u0442",
    'proforma-project-forms.create-form-button.create-blank': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u043F\u043E\u0440\u043E\u0436\u043D\u044E \u0444\u043E\u0440\u043C\u0443",
    'proforma-project-forms.create-form-button.create-with-template': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
    'proforma-project-forms.create-form-button.trigger': "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0444\u043E\u0440\u043C\u0443"
};

});

parcelRegister("hY4F8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d14ba824a5c43bd9$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $d14ba824a5c43bd9$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "S\u1EEDa",
    'form-system.general.Form': "T\xean",
    'jira-common.ListProjectForms.AffectExistingIssues': "Vi\u1EC7c n\xe0y s\u1EBD kh\xf4ng \u1EA3nh h\u01B0\u1EDFng \u0111\u1EBFn c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\xe3 s\u1EED d\u1EE5ng bi\u1EC3u m\u1EABu n\xe0y ho\u1EB7c b\u1EA5t k\u1EF3 b\u1EA3n sao n\xe0o c\u1EE7a bi\u1EC3u m\u1EABu n\xe0y trong c\xe1c d\u1EF1 \xe1n kh\xe1c.",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "Lo\u1EA1i v\u1EA5n \u0111\u1EC1",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "Lo\u1EA1i y\xeau c\u1EA7u",
    'jira-common.ListProjectForms.Cancel': "H\u1EE7y",
    'jira-common.ListProjectForms.Copy': "Sao ch\xe9p v\xe0o d\u1EF1 \xe1n",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "L\u1ED7i: Kh\xf4ng th\u1EC3 sao ch\xe9p \u201C{formName}\u201D",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfBusinessProjects,number} d\u1EF1 \xe1n kinh doanh}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfProjects,number} d\u1EF1 \xe1n}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng \u201C{formName}\u201D trong \u201C{projectName}\u201D.",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage} v\xe0 {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage} v\xe0 {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfServiceProjects,number} d\u1EF1 \xe1n d\u1ECBch v\u1EE5}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} v\xe0 {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfSoftwareProjectsMessage} v\xe0 {numberOfBusinessProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': 'Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfSoftwareProjectsMessage}.',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfSoftwareProjects,number} d\u1EF1 \xe1n ph\u1EA7n m\u1EC1m}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {Hi\u1EC7n c\xf3 th\u1EC3 s\u1EED d\u1EE5ng "{formName}" trong {numberOfProjects,number} d\u1EF1 \xe1n.}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u0110\xe3 sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0o {numberOfProjects,number} d\u1EF1 \xe1n}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "H\u1EE7y",
    'jira-common.ListProjectForms.CopyModal.Copy': "Sao ch\xe9p",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "Sao ch\xe9p v\xe0o (c\xe1c) d\u1EF1 \xe1n",
    'jira-common.ListProjectForms.CopyModal.Heading': "Sao ch\xe9p \u201C{formName}\u201D v\xe0o c\xe1c d\u1EF1 \xe1n kh\xe1c",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "T\xecm hi\u1EC3u th\xeam v\u1EC1 vi\u1EC7c sao ch\xe9p bi\u1EC3u m\u1EABu",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u0110ang t\u1EA3i d\u1EF1 \xe1n",
    'jira-common.ListProjectForms.CopyModal.Name': "T\xean",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "Ch\u1ECDn t\u1EA5t c\u1EA3 c\xe1c d\u1EF1 \xe1n",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "N\u1ED9i dung thay \u0111\u1ED5i c\u1EE7a bi\u1EC3u m\u1EABu kh\xf4ng \u0111\u01B0\u1EE3c ph\u1EA3n \xe1nh tr\xean b\u1EA5t k\u1EF3 b\u1EA3n sao n\xe0o c\u1EE7a bi\u1EC3u m\u1EABu trong c\xe1c d\u1EF1 \xe1n kh\xe1c.",
    'jira-common.ListProjectForms.CopyText': "{formName} b\u1EA3n sao",
    'jira-common.ListProjectForms.Delete': "X\xf3a",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u0110\xe3 x\xf3a \u201C{formName}\u201D",
    'jira-common.ListProjectForms.Duplicate': "B\u1EA3n sao",
    'jira-common.ListProjectForms.EmptyFormName': "Bi\u1EC3u m\u1EABu ch\u01B0a c\xf3 t\xean",
    'jira-common.ListProjectForms.FilterForms': "L\u1ECDc bi\u1EC3u m\u1EABu",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u0110\xe3 t\u1EA3i xu\u1ED1ng \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "L\xe0m m\u1EDBi trang n\xe0y v\xe0 th\u1EED l\u1EA1i.",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "Ch\u01B0a t\u1EA3i xu\u1ED1ng \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {\u0110\xe3 ho\xe0n t\u1EA5t {percentCount,number} %}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u0110ang t\u1EA3i xu\u1ED1ng \u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "Xu\u1EA5t th\xe0nh XLSX",
    'jira-common.ListProjectForms.FormActions.MoreActions': "H\xe0nh \u0111\u1ED9ng kh\xe1c",
    'jira-common.ListProjectForms.FutureIssueMessage': "C\xe1c v\u1EA5n \u0111\u1EC1 t\u01B0\u01A1ng lai \u0111\u01B0\u1EE3c t\u1EA1o b\u1EB1ng nh\u1EEFng lo\u1EA1i v\u1EA5n \u0111\u1EC1 n\xe0y s\u1EBD kh\xf4ng c\xf2n bao g\u1ED3m bi\u1EC3u m\u1EABu n\xe0y.",
    'jira-common.ListProjectForms.FutureRequestMessage': "C\xe1c y\xeau c\u1EA7u t\u01B0\u01A1ng lai \u0111\u01B0\u1EE3c t\u1EA1o b\u1EB1ng nh\u1EEFng lo\u1EA1i y\xeau c\u1EA7u n\xe0y s\u1EBD kh\xf4ng c\xf2n bao g\u1ED3m bi\u1EC3u m\u1EABu n\xe0y.",
    'jira-common.ListProjectForms.Heading': "Xo\xe1 \u201C{formName}\u201D?",
    'jira-common.ListProjectForms.IssueType': "Lo\u1EA1i v\u1EA5n \u0111\u1EC1",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "T\xecm ki\u1EBFm lo\u1EA1i v\u1EA5n \u0111\u1EC1",
    'jira-common.ListProjectForms.LastUpdated': "C\u1EADp nh\u1EADt g\u1EA7n \u0111\xe2y nh\u1EA5t",
    'jira-common.ListProjectForms.LearnMoreLink': "T\xecm hi\u1EC3u th\xeam v\u1EC1 vi\u1EC7c x\xf3a bi\u1EC3u m\u1EABu.",
    'jira-common.ListProjectForms.RequestType': "Lo\u1EA1i y\xeau c\u1EA7u",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "T\xecm ki\u1EBFm lo\u1EA1i y\xeau c\u1EA7u",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "X\xf3a bi\u1EC3u m\u1EABu n\xe0y s\u1EBD lo\u1EA1i b\u1ECF bi\u1EC3u m\u1EABu kh\u1ECFi c\xe1c lo\u1EA1i v\u1EA5n \u0111\u1EC1 sau \u0111\xe2y:",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "X\xf3a bi\u1EC3u m\u1EABu n\xe0y s\u1EBD lo\u1EA1i b\u1ECF bi\u1EC3u m\u1EABu kh\u1ECFi c\xe1c lo\u1EA1i y\xeau c\u1EA7u sau \u0111\xe2y:",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "Sao ch\xe9p li\xean k\u1EBFt tr\u1EF1c ti\u1EBFp",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "Lo\u1EA1i v\u1EA5n \u0111\u1EC1",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "Lo\u1EA1i y\xeau c\u1EA7u",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} d\u1EF1 \xe1n kinh doanh}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} d\u1EF1 \xe1n d\u1ECBch v\u1EE5}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} d\u1EF1 \xe1n ph\u1EA7n m\u1EC1m}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} lo\u1EA1i v\u1EA5n \u0111\u1EC1",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} lo\u1EA1i y\xeau c\u1EA7u",
    'proforma-project-forms.BusinessForms': "Bi\u1EC3u m\u1EABu n\xe2ng cao",
    'proforma-project-forms.CreateForm': "T\u1EA1o bi\u1EC3u m\u1EABu",
    'proforma-project-forms.Description': "T\u1EA1o, s\u1EEDa, xu\u1EA5t v\xe0 x\xf3a bi\u1EC3u m\u1EABu. Sao ch\xe9p bi\u1EC3u m\u1EABu v\xe0 s\u1EED d\u1EE5ng bi\u1EC3u m\u1EABu trong c\xe1c d\u1EF1 \xe1n kh\xe1c.",
    'proforma-project-forms.Forms': "Bi\u1EC3u m\u1EABu",
    'proforma-project-forms.LearnMore': "T\xecm hi\u1EC3u th\xeam v\u1EC1 bi\u1EC3u m\u1EABu.",
    'proforma-project-forms.LoadingForms': "\u0110ang t\u1EA3i...",
    'proforma-project-forms.NoFormsDescriptionJsm': "Th\xeam bi\u1EC3u m\u1EABu \u0111\u1EC3 kh\xe1ch h\xe0ng \u0111i\u1EC1n v\xe0o khi \u0111\u01B0a ra y\xeau c\u1EA7u ho\u1EB7c \u0111\xednh k\xe8m bi\u1EC3u m\u1EABu v\xe0o c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\u1EC3 thu th\u1EADp th\xeam th\xf4ng tin.",
    'proforma-project-forms.NoFormsDescriptionJsw': "Th\xeam bi\u1EC3u m\u1EABu \u0111\u1EC3 kh\xe1ch h\xe0ng \u0111i\u1EC1n v\xe0o khi t\u1EA1o v\u1EA5n \u0111\u1EC1 ho\u1EB7c \u0111\xednh k\xe8m bi\u1EC3u m\u1EABu v\xe0o c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\u1EC3 thu th\u1EADp th\xeam th\xf4ng tin.",
    'proforma-project-forms.NoFormsDescriptionJwm': "Th\xeam bi\u1EC3u m\u1EABu \u0111\u1EC3 kh\xe1ch h\xe0ng \u0111i\u1EC1n v\xe0o khi t\u1EA1o m\u1EE5c ho\u1EB7c \u0111\xednh k\xe8m bi\u1EC3u m\u1EABu v\xe0o c\xe1c v\u1EA5n \u0111\u1EC1 hi\u1EC7n c\xf3 \u0111\u1EC3 thu th\u1EADp th\xeam th\xf4ng tin.",
    'proforma-project-forms.NoFormsHeading': "T\u1EA5t c\u1EA3 bi\u1EC3u m\u1EABu c\u1EE7a b\u1EA1n s\u1EBD hi\u1EC3n th\u1ECB \u1EDF \u0111\xe2y",
    'proforma-project-forms.create-form-button.create-blank': "T\u1EA1o bi\u1EC3u m\u1EABu tr\u1ED1ng",
    'proforma-project-forms.create-form-button.create-with-template': "T\u1EA1o t\u1EEB m\u1EABu",
    'proforma-project-forms.create-form-button.trigger': "T\u1EA1o bi\u1EC3u m\u1EABu"
};

});

parcelRegister("gPf0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3fd0d4c3514bc67$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $c3fd0d4c3514bc67$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\u7F16\u8F91",
    'form-system.general.Form': "\u540D\u79F0",
    'jira-common.ListProjectForms.AffectExistingIssues': "\u8FD9\u4E0D\u4F1A\u5F71\u54CD\u5DF2\u7ECF\u4F7F\u7528\u6B64\u8868\u5355\u7684\u73B0\u6709\u4E8B\u52A1\uFF0C\u4E5F\u4E0D\u4F1A\u5F71\u54CD\u5176\u4ED6\u9879\u76EE\u4E2D\u6B64\u8868\u5355\u7684\u6240\u6709\u526F\u672C\u3002",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\u4E8B\u52A1\u7C7B\u578B",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\u8BF7\u6C42\u7C7B\u578B",
    'jira-common.ListProjectForms.Cancel': "\u53D6\u6D88",
    'jira-common.ListProjectForms.Copy': "\u590D\u5236\u5230\u9879\u76EE",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "\u9519\u8BEF\uFF1A\u65E0\u6CD5\u590D\u5236\u201C{formName}\u201D",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfBusinessProjects,number} \u4E2A\u4E1A\u52A1\u9879\u76EE}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfProjects,number} \u4E2A\u9879\u76EE}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u201C{formName}\u201D\u73B0\u5728\u53EF\u4EE5\u5728\u201C{projectName}\u201D\u4E2D\u4F7F\u7528\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u548C {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u548C {numberOfSoftwareProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfServiceProjects,number} \u4E2A\u670D\u52A1\u9879\u76EE}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfServiceProjectsMessage}\u3001{numberOfSoftwareProjectsMessage}\u548C {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfSoftwareProjectsMessage}\u548C {numberOfBusinessProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': '"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfSoftwareProjectsMessage}\u4E2D\u4F7F\u7528\u3002',
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfSoftwareProjects,number} \u4E2A\u8F6F\u4EF6\u9879\u76EE}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': '{numberOfProjects, plural, other {"{formName}" \u73B0\u5728\u53EF\u4EE5\u5728 {numberOfProjects,number} \u4E2A\u9879\u76EE\u4E2D\u4F7F\u7528\u3002}}',
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u8868\u5355\u5DF2\u590D\u5236\u5230 {numberOfProjects,number} \u4E2A\u9879\u76EE}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u53D6\u6D88",
    'jira-common.ListProjectForms.CopyModal.Copy': "\u590D\u5236",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u590D\u5236\u5230\u9879\u76EE",
    'jira-common.ListProjectForms.CopyModal.Heading': "\u5C06\u201C{formName}\u201D\u590D\u5236\u5230\u5176\u4ED6\u9879\u76EE",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\u4E86\u89E3\u6709\u5173\u590D\u5236\u8868\u5355\u7684\u66F4\u591A\u4FE1\u606F",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u6B63\u5728\u52A0\u8F7D\u9879\u76EE",
    'jira-common.ListProjectForms.CopyModal.Name': "\u540D\u79F0",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u9009\u62E9\u6240\u6709\u9879\u76EE",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\u5BF9\u8868\u5355\u6240\u505A\u7684\u53D8\u66F4\u4E0D\u4F1A\u53CD\u6620\u5728\u8BE5\u8868\u5355\u5728\u5176\u4ED6\u9879\u76EE\u4E2D\u7684\u526F\u672C\u5185\u3002",
    'jira-common.ListProjectForms.CopyText': "{formName} \u526F\u672C",
    'jira-common.ListProjectForms.Delete': "\u5220\u9664",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u201C{formName}\u201D\u5DF2\u5220\u9664",
    'jira-common.ListProjectForms.Duplicate': "\u590D\u5236",
    'jira-common.ListProjectForms.EmptyFormName': "\u672A\u547D\u540D\u8868\u5355",
    'jira-common.ListProjectForms.FilterForms': "\u7B5B\u9009\u8868\u5355",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u201C{filename}\u201D\u5DF2\u4E0B\u8F7D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u8BF7\u5237\u65B0\u9875\u9762\uFF0C\u7136\u540E\u91CD\u8BD5\u3002",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u201C{filename}\u201D\u672A\u4E0B\u8F7D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {{percentCount,number}% \u5DF2\u5B8C\u6210}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u6B63\u5728\u4E0B\u8F7D\u201C{filename}\u201D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u4EE5 XLSX \u683C\u5F0F\u5BFC\u51FA",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\u66F4\u591A\u64CD\u4F5C",
    'jira-common.ListProjectForms.FutureIssueMessage': "\u4F7F\u7528\u8FD9\u4E9B\u4E8B\u52A1\u7C7B\u578B\u521B\u5EFA\u7684\u672A\u6765\u8BF7\u6C42\u5C06\u4E0D\u518D\u5305\u542B\u6B64\u8868\u5355\uFF1A",
    'jira-common.ListProjectForms.FutureRequestMessage': "\u4F7F\u7528\u8FD9\u4E9B\u8BF7\u6C42\u7C7B\u578B\u521B\u5EFA\u7684\u672A\u6765\u8BF7\u6C42\u5C06\u4E0D\u518D\u5305\u542B\u6B64\u8868\u5355\u3002",
    'jira-common.ListProjectForms.Heading': "\u5220\u9664\u201C{formName}\u201D\uFF1F",
    'jira-common.ListProjectForms.IssueType': "\u4E8B\u52A1\u7C7B\u578B",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u641C\u7D22\u4E8B\u52A1\u7C7B\u578B",
    'jira-common.ListProjectForms.LastUpdated': "\u4E0A\u6B21\u66F4\u65B0",
    'jira-common.ListProjectForms.LearnMoreLink': "\u4E86\u89E3\u6709\u5173\u5220\u9664\u8868\u5355\u7684\u66F4\u591A\u4FE1\u606F\u3002",
    'jira-common.ListProjectForms.RequestType': "\u8BF7\u6C42\u7C7B\u578B",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u641C\u7D22\u8BF7\u6C42\u7C7B\u578B",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u5220\u9664\u6B64\u8868\u5355\u4F1A\u5C06\u5176\u4ECE\u4EE5\u4E0B\u4E8B\u52A1\u7C7B\u578B\u4E2D\u79FB\u9664\uFF1A",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u5220\u9664\u6B64\u8868\u5355\u4F1A\u5C06\u5176\u4ECE\u4EE5\u4E0B\u8BF7\u6C42\u7C7B\u578B\u4E2D\u79FB\u9664\uFF1A",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u590D\u5236\u76F4\u63A5\u94FE\u63A5",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u4E8B\u52A1\u7C7B\u578B",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u8BF7\u6C42\u7C7B\u578B",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} \u4E2A\u4E1A\u52A1\u9879\u76EE}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} \u4E2A\u670D\u52A1\u9879\u76EE}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} \u4E2A\u8F6F\u4EF6\u9879\u76EE}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u79CD\u4E8B\u52A1\u7C7B\u578B",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u79CD\u8BF7\u6C42\u7C7B\u578B",
    'proforma-project-forms.BusinessForms': "\u9AD8\u7EA7\u8868\u5355",
    'proforma-project-forms.CreateForm': "\u521B\u5EFA\u8868\u5355",
    'proforma-project-forms.Description': "\u521B\u5EFA\u3001\u7F16\u8F91\u3001\u5BFC\u51FA\u548C\u5220\u9664\u8868\u5355\u3002\u590D\u5236\u8868\u5355\u5E76\u5C06\u5176\u7528\u4E8E\u5176\u4ED6\u9879\u76EE\u3002",
    'proforma-project-forms.Forms': "\u8868\u5355",
    'proforma-project-forms.LearnMore': "\u4E86\u89E3\u6709\u5173\u8868\u5355\u7684\u66F4\u591A\u4FE1\u606F\u3002",
    'proforma-project-forms.LoadingForms': "\u6B63\u5728\u52A0\u8F7D...",
    'proforma-project-forms.NoFormsDescriptionJsm': "\u6DFB\u52A0\u8868\u5355\uFF0C\u4F9B\u5BA2\u6237\u63D0\u51FA\u8BF7\u6C42\u65F6\u8FDB\u884C\u586B\u5199\uFF0C\u6216\u5C06\u8868\u5355\u9644\u52A0\u5230\u73B0\u6709\u4E8B\u52A1\u4EE5\u6536\u96C6\u66F4\u591A\u4FE1\u606F\u3002",
    'proforma-project-forms.NoFormsDescriptionJsw': "\u6DFB\u52A0\u8868\u5355\uFF0C\u4F9B\u5BA2\u6237\u521B\u5EFA\u4E8B\u52A1\u65F6\u8FDB\u884C\u586B\u5199\uFF0C\u6216\u5C06\u8868\u5355\u9644\u52A0\u5230\u73B0\u6709\u4E8B\u52A1\u4EE5\u6536\u96C6\u66F4\u591A\u4FE1\u606F\u3002",
    'proforma-project-forms.NoFormsDescriptionJwm': "\u6DFB\u52A0\u8868\u5355\uFF0C\u4F9B\u5BA2\u6237\u521B\u5EFA\u9879\u76EE\u65F6\u8FDB\u884C\u586B\u5199\uFF0C\u6216\u5C06\u8868\u5355\u9644\u52A0\u5230\u73B0\u6709\u4E8B\u52A1\u4EE5\u6536\u96C6\u66F4\u591A\u4FE1\u606F\u3002",
    'proforma-project-forms.NoFormsHeading': "\u60A8\u7684\u6240\u6709\u8868\u5355\u5747\u4F1A\u663E\u793A\u5728\u6B64\u5904",
    'proforma-project-forms.create-form-button.create-blank': "\u521B\u5EFA\u7A7A\u767D\u8868\u5355",
    'proforma-project-forms.create-form-button.create-with-template': "\u4ECE\u6A21\u677F\u521B\u5EFA",
    'proforma-project-forms.create-form-button.trigger': "\u521B\u5EFA\u8868\u5355"
};

});

parcelRegister("fYuCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba143738718f7b8d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $ba143738718f7b8d$export$2e2bcd8739ae039 = {
    'form-system.general.Edit': "\u7DE8\u8F2F",
    'form-system.general.Form': "\u540D\u7A31",
    'jira-common.ListProjectForms.AffectExistingIssues': "\u9019\u4E0D\u6703\u5F71\u97FF\u5DF2\u7D93\u4F7F\u7528\u6B64\u8868\u55AE (\u6216\u8005\u6B64\u8868\u55AE\u5728\u5176\u4ED6\u5C08\u6848\u4E2D\u7684\u4EFB\u4F55\u8907\u672C) \u7684\u73FE\u6709\u8B70\u984C\u3002",
    'jira-common.ListProjectForms.AssociatedIssueTypes': "\u8B70\u984C\u985E\u578B",
    'jira-common.ListProjectForms.AssociatedRequestTypes': "\u8981\u6C42\u985E\u578B",
    'jira-common.ListProjectForms.Cancel': "\u53D6\u6D88",
    'jira-common.ListProjectForms.Copy': "\u8907\u88FD\u5230\u5C08\u6848",
    'jira-common.ListProjectForms.CopyFormErrorTitle': "\u932F\u8AA4\uFF1A\u7121\u6CD5\u5C07\u300C{formName}\u300D\u8907\u88FD\u904E\u53BB",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle': "{numberOfBusinessProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfBusinessProjects,number} \u500B\u696D\u52D9\u5C08\u6848}}",
    'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle': "{numberOfProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfProjects,number} \u500B\u5C08\u6848}}",
    'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{projectName}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u8207\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u8207\u300C{numberOfSoftwareProjectsMessage}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle': "{numberOfServiceProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfServiceProjects,number} \u500B\u670D\u52D9\u5C08\u6848}}",
    'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfServiceProjectsMessage}\u300D\u3001\u300C{numberOfSoftwareProjectsMessage}\u300D\u8207\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfSoftwareProjectsMessage}\u300D\u8207\u300C{numberOfBusinessProjectsMessage}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription': "\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC\u300C{numberOfSoftwareProjectsMessage}\u300D\u3002",
    'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle': "{numberOfSoftwareProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfSoftwareProjects,number} \u500B\u8EDF\u9AD4\u5C08\u6848}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription': "{numberOfProjects, plural, other {\u300C{formName}\u300D\u73FE\u5728\u53EF\u4EE5\u7528\u65BC {numberOfProjects,number} \u500B\u5C08\u6848\u3002}}",
    'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle': "{numberOfProjects, plural, other {\u8868\u55AE\u5DF2\u8907\u88FD\u5230 {numberOfProjects,number} \u500B\u5C08\u6848}}",
    'jira-common.ListProjectForms.CopyModal.Cancel': "\u53D6\u6D88",
    'jira-common.ListProjectForms.CopyModal.Copy': "\u8907\u88FD",
    'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle': "\u8907\u88FD\u5230\u5C08\u6848",
    'jira-common.ListProjectForms.CopyModal.Heading': "\u5C07\u300C{formName}\u300D\u8907\u88FD\u5230\u5176\u4ED6\u5C08\u6848",
    'jira-common.ListProjectForms.CopyModal.LearnMore': "\u6DF1\u5165\u4E86\u89E3\u5982\u4F55\u8907\u88FD\u8868\u55AE",
    'jira-common.ListProjectForms.CopyModal.LoadingProjects': "\u6B63\u5728\u8F09\u5165\u5C08\u6848",
    'jira-common.ListProjectForms.CopyModal.Name': "\u540D\u7A31",
    'jira-common.ListProjectForms.CopyModal.SelectAllProjects': "\u9078\u53D6\u6240\u6709\u5C08\u6848",
    'jira-common.ListProjectForms.CopyModal.SubHeading': "\u5C0D\u8868\u55AE\u6240\u505A\u7684\u8B8A\u66F4\u4E0D\u6703\u53CD\u6620\u5728\u5176\u4ED6\u5C08\u6848\u7684\u4EFB\u4F55\u526F\u672C\u3002",
    'jira-common.ListProjectForms.CopyText': "\u300C{formName}\u300D\u526F\u672C",
    'jira-common.ListProjectForms.Delete': "\u522A\u9664",
    'jira-common.ListProjectForms.DeleteFormSuccess': "\u300C{formName}\u300D\u5DF2\u522A\u9664",
    'jira-common.ListProjectForms.Duplicate': "\u8907\u88FD",
    'jira-common.ListProjectForms.EmptyFormName': "\u7121\u6A19\u984C\u8868\u55AE",
    'jira-common.ListProjectForms.FilterForms': "\u7BE9\u9078\u8868\u55AE",
    'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle': "\u300C{filename}\u300D\u5DF2\u4E0B\u8F09",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription': "\u8ACB\u91CD\u65B0\u6574\u7406\u9801\u9762\uFF0C\u7136\u5F8C\u518D\u8A66\u4E00\u6B21\u3002",
    'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle': "\u672A\u4E0B\u8F09\u300C{filename}\u300D",
    'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete': "{percentCount, plural, other {\u5B8C\u6210 {percentCount,number}%}}",
    'jira-common.ListProjectForms.FormActions.DownloadFlagTitle': "\u6B63\u5728\u4E0B\u8F09\u300C{filename}\u300D",
    'jira-common.ListProjectForms.FormActions.ExportInXlsx': "\u5728 XLSX \u4E2D\u532F\u51FA",
    'jira-common.ListProjectForms.FormActions.MoreActions': "\u66F4\u591A\u52D5\u4F5C",
    'jira-common.ListProjectForms.FutureIssueMessage': "\u4F7F\u7528\u9019\u4E9B\u8B70\u984C\u985E\u578B\u5EFA\u7ACB\u7684\u672A\u4F86\u8B70\u984C\u5C07\u4E0D\u518D\u5305\u542B\u4EE5\u4E0B\u8868\u55AE\uFF1A",
    'jira-common.ListProjectForms.FutureRequestMessage': "\u65E5\u5F8C\u4F7F\u7528\u9019\u4E9B\u8981\u6C42\u985E\u578B\u6240\u5EFA\u7ACB\u7684\u8981\u6C42\u5C07\u4E0D\u6703\u518D\u5305\u542B\u6B64\u8868\u55AE\u3002",
    'jira-common.ListProjectForms.Heading': "\u8981\u522A\u9664\u300C{formName}\u300D\u55CE\uFF1F",
    'jira-common.ListProjectForms.IssueType': "\u8B70\u984C\u985E\u578B",
    'jira-common.ListProjectForms.IssueTypeAriaLabel': "\u641C\u5C0B\u8B70\u984C\u985E\u578B",
    'jira-common.ListProjectForms.LastUpdated': "\u4E0A\u6B21\u66F4\u65B0",
    'jira-common.ListProjectForms.LearnMoreLink': "\u9032\u4E00\u6B65\u4E86\u89E3\u5982\u4F55\u522A\u9664\u8868\u55AE\u3002",
    'jira-common.ListProjectForms.RequestType': "\u8981\u6C42\u985E\u578B",
    'jira-common.ListProjectForms.RequestTypeAriaLabel': "\u641C\u5C0B\u8981\u6C42\u985E\u578B",
    'jira-common.ListProjectForms.WillRemoveIssueTypesMsg': "\u5982\u679C\u522A\u9664\u6B64\u8868\u55AE\uFF0C\u7CFB\u7D71\u6703\u5C07\u5176\u5F9E\u4EE5\u4E0B\u8B70\u984C\u985E\u578B\u4E2D\u79FB\u9664\uFF1A",
    'jira-common.ListProjectForms.WillRemoveRequestTypesMsg': "\u5982\u679C\u522A\u9664\u6B64\u8868\u55AE\uFF0C\u7CFB\u7D71\u6703\u5C07\u5176\u5F9E\u4EE5\u4E0B\u8981\u6C42\u985E\u578B\u4E2D\u79FB\u9664\uFF1A",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel': "\u8907\u88FD\u76F4\u63A5\u9023\u7D50",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader': "\u8B70\u984C\u985E\u578B",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader': "\u8981\u6C42\u985E\u578B",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects': "{numberOfBusinessProjects, plural, other {{numberOfBusinessProjects,number} \u500B\u696D\u52D9\u5C08\u6848}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects': "{numberOfServiceProjects, plural, other {{numberOfServiceProjects,number} \u500B\u670D\u52D9\u5C08\u6848}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects': "{numberOfSoftwareProjects, plural, other {{numberOfSoftwareProjects,number} \u500B\u8EDF\u9AD4\u5C08\u6848}}",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel': "{count} \u500B\u8B70\u984C\u985E\u578B",
    'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel': "{count} \u500B\u8981\u6C42\u985E\u578B",
    'proforma-project-forms.BusinessForms': "\u9032\u968E\u8868\u55AE",
    'proforma-project-forms.CreateForm': "\u5EFA\u7ACB\u8868\u55AE",
    'proforma-project-forms.Description': "\u5EFA\u7ACB\u3001\u7DE8\u8F2F\u3001\u532F\u51FA\u548C\u522A\u9664\u8868\u55AE\u3002\u8907\u88FD\u8868\u55AE\u4E26\u4E14\u5728\u5176\u4ED6\u5C08\u6848\u4E2D\u4F7F\u7528\u3002",
    'proforma-project-forms.Forms': "\u8868\u55AE",
    'proforma-project-forms.LearnMore': "\u6DF1\u5165\u4E86\u89E3\u8868\u55AE\u3002",
    'proforma-project-forms.LoadingForms': "\u8F09\u5165\u4E2D...",
    'proforma-project-forms.NoFormsDescriptionJsm': "\u65B0\u589E\u8868\u55AE\u4EE5\u4F9B\u5BA2\u6236\u5728\u63D0\u51FA\u8981\u6C42\u6642\u586B\u5BEB\uFF0C\u6216\u5C07\u8868\u55AE\u9644\u52A0\u5230\u73FE\u6709\u8B70\u984C\u4EE5\u6536\u96C6\u66F4\u591A\u8CC7\u8A0A\u3002",
    'proforma-project-forms.NoFormsDescriptionJsw': "\u65B0\u589E\u8868\u55AE\u4EE5\u4F9B\u5BA2\u6236\u5728\u5EFA\u7ACB\u8B70\u984C\u6642\u586B\u5BEB\uFF0C\u6216\u5C07\u8868\u55AE\u9644\u52A0\u5230\u73FE\u6709\u8B70\u984C\u4EE5\u6536\u96C6\u66F4\u591A\u8CC7\u8A0A\u3002",
    'proforma-project-forms.NoFormsDescriptionJwm': "\u65B0\u589E\u8868\u55AE\u4EE5\u4F9B\u5BA2\u6236\u5728\u5EFA\u7ACB\u9805\u76EE\u6642\u586B\u5BEB\uFF0C\u6216\u5C07\u8868\u55AE\u9644\u52A0\u5230\u73FE\u6709\u8B70\u984C\u4EE5\u6536\u96C6\u66F4\u591A\u8CC7\u8A0A\u3002",
    'proforma-project-forms.NoFormsHeading': "\u60A8\u7684\u6240\u6709\u8868\u55AE\u90FD\u6703\u986F\u793A\u5728\u9019\u88E1",
    'proforma-project-forms.create-form-button.create-blank': "\u5EFA\u7ACB\u7A7A\u767D\u8868\u55AE",
    'proforma-project-forms.create-form-button.create-with-template': "\u5F9E\u7BC4\u672C\u5EFA\u7ACB",
    'proforma-project-forms.create-form-button.trigger': "\u5EFA\u7ACB\u8868\u55AE"
};

});



parcelRegister("bu1Yj", function(module, exports) {

$parcel$export(module.exports, "ProjectFormsContainer", () => $85c4069828856c64$export$bcb823343695b9a8);
$parcel$export(module.exports, "useProjectFormsController", () => $85c4069828856c64$export$afd20f582dd6fb24);
$parcel$export(module.exports, "useProjectFormsControllerActions", () => $85c4069828856c64$export$cb8caaed5fbed4c4);

var $WBLbN = parcelRequire("WBLbN");
const $85c4069828856c64$var$initialState = {
    forms: [],
    loading: false,
    sortKey: 'Name',
    sortOrder: 'ASC'
};
const $85c4069828856c64$var$actions = {
    load: ()=>({ setState: setState, getState: getState }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
            if (getState().loading) return Promise.resolve();
            setState({
                loading: true
            });
            return projectFormApi.getForms().then((newForms)=>{
                setState({
                    forms: newForms,
                    loading: false
                });
            }).catch((error)=>{
                errorUtils.reportError(error, {
                    id: 'getForms'
                });
                return Promise.reject(error);
            });
        },
    onSort: (sortDetails)=>({ setState: setState })=>{
            setState({
                sortKey: sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.key,
                sortOrder: sortDetails === null || sortDetails === void 0 ? void 0 : sortDetails.sortOrder
            });
        }
};
const $85c4069828856c64$var$Store = (0, $WBLbN.createStore)({
    initialState: $85c4069828856c64$var$initialState,
    actions: $85c4069828856c64$var$actions,
    name: 'ProjectFormsStore'
});
const $85c4069828856c64$export$bcb823343695b9a8 = (0, $WBLbN.createContainer)($85c4069828856c64$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($85c4069828856c64$var$actions.load())
});
const $85c4069828856c64$export$afd20f582dd6fb24 = (0, $WBLbN.createHook)($85c4069828856c64$var$Store);
const $85c4069828856c64$export$cb8caaed5fbed4c4 = (0, $WBLbN.createHook)($85c4069828856c64$var$Store, {
    selector: null
});

});

parcelRegister("tJCsl", function(module, exports) {

$parcel$export(module.exports, "IssueFormsApiProvider", () => $05961895599bc80c$export$cc17409dbbedbd3d);
$parcel$export(module.exports, "useIssueFormsApi", () => $05961895599bc80c$export$b3af41f49cf1d3c8);

var $eUqFw = parcelRequire("eUqFw");

var $fMYmR = parcelRequire("fMYmR");
const $05961895599bc80c$var$IssueFormsApiContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $05961895599bc80c$export$cc17409dbbedbd3d = ({ issueFormsApi: issueFormsApi, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($05961895599bc80c$var$IssueFormsApiContext.Provider, {
        value: issueFormsApi
    }, children);
const $05961895599bc80c$export$b3af41f49cf1d3c8 = ()=>{
    const issueFormsApi = (0, $eUqFw.useContext)($05961895599bc80c$var$IssueFormsApiContext);
    if (issueFormsApi === null) throw new Error(`useIssueFormsApi() must be used within a IssueFormsApiProvider. ${(0, $fMYmR.errorMessageDuplicateCommonCore)}`);
    return issueFormsApi;
};

});
parcelRegister("fMYmR", function(module, exports) {

$parcel$export(module.exports, "errorMessageDuplicateCommonCore", () => $b7ea2a7b5f8f525b$export$202e68bc03a230f);
const $b7ea2a7b5f8f525b$export$202e68bc03a230f = "Please check that the yarn.lock file contains only 1 version of proforma-common-core. You should bump all Proforma packages to their latest version";

});


parcelRegister("9SGXg", function(module, exports) {

$parcel$export(module.exports, "LiveIssueFormsApi", () => $731a7a24b4e10eea$export$261c0d1781964c99);
class $731a7a24b4e10eea$export$261c0d1781964c99 {
    constructor(projectId, util){
        this.projectId = projectId;
        this.util = util;
    }
    async getIssueFormsInfo() {
        return this.util.get(`/api/cloud/createissue/project/${this.projectId}/forms`);
    }
}

});

parcelRegister("8x5lY", function(module, exports) {

$parcel$export(module.exports, "LiveProjectApi", () => $63658edb5ad5cdb1$export$c5bc9c89db1bda99);

var $5zQU9 = parcelRequire("5zQU9");
class $63658edb5ad5cdb1$export$c5bc9c89db1bda99 {
    constructor(util){
        // TODO: proforma-cloud repo is returning a project's ID as a string, it should
        // be changed to a Long, and this quick fix reverted, in FORM-1517
        (0, $5zQU9.default)(this, "convertJiraProjectToProject", (jiraProject)=>({
                ...jiraProject,
                id: parseInt(jiraProject.id, 10)
            }));
        this.util = util;
    }
    getAllProjects() {
        return this.util.get('/api/3/projects').then((projects)=>projects.map((project)=>this.convertJiraProjectToProject(project)));
    }
}

});

parcelRegister("i7vgA", function(module, exports) {

$parcel$export(module.exports, "ProjectApiProvider", () => $d31122567483a0ae$export$d59c1879d9521dec);
$parcel$export(module.exports, "useProjectApi", () => $d31122567483a0ae$export$46e1d0c6200f37f);

var $eUqFw = parcelRequire("eUqFw");

var $fMYmR = parcelRequire("fMYmR");
const $d31122567483a0ae$var$ProjectApiContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $d31122567483a0ae$export$d59c1879d9521dec = ({ projectApi: projectApi, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d31122567483a0ae$var$ProjectApiContext.Provider, {
        value: projectApi
    }, children);
const $d31122567483a0ae$export$46e1d0c6200f37f = ()=>{
    const projectApi = (0, $eUqFw.useContext)($d31122567483a0ae$var$ProjectApiContext);
    if (projectApi === undefined) throw new Error(`useProjectApi() must be used within a ProjectApiProvider. ${(0, $fMYmR.errorMessageDuplicateCommonCore)}`);
    return projectApi;
};

});

parcelRegister("5zR2s", function(module, exports) {

$parcel$export(module.exports, "LiveProjectFormApi", () => $40f95cfd0e2c0ac6$export$633a9f556df6b0b0);

var $eknFc = parcelRequire("eknFc");
class $40f95cfd0e2c0ac6$export$633a9f556df6b0b0 {
    constructor(projectId, util){
        this.projectId = projectId;
        this.util = util;
    }
    getForms() {
        return this.util.get(`/api/1/projects/${this.projectId}/forms`);
    }
    // public getFormsPaginated(
    //   pageSize: number,
    //   cursor?: string,
    // ): Promise<PagedResults<TemplateFormIndex>> {
    //   return this.util.get(
    //     `/api/2/projects/${this.projectId}/forms?pageSize=${pageSize}` +
    //       urlParam('cursor', cursor),
    //   );
    // }
    startXlsxDownload(templateFormId) {
        return this.util.post(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}`, undefined);
    }
    checkXlsxDownload(templateFormId, taskId) {
        return this.util.get(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}/${taskId}`);
    }
    downloadFinishedXlsx(templateFormId, taskId) {
        return this.util.get(`/api/2/reports/all-form-responses/${this.projectId}/${templateFormId}/${taskId}/ProForma-${this.projectId}-form-${templateFormId}.xlsx`, 'exportDownload', (0, $eknFc.AcceptedResponseType).Blob);
    }
    deleteProjectForm(templateFormId) {
        return this.util.delete(`/api/1/projects/${this.projectId}/forms/${templateFormId}`);
    }
}

});

parcelRegister("aXZh9", function(module, exports) {

$parcel$export(module.exports, "ProjectFormApiProvider", () => $7fbef222cb36f40d$export$1b3e028f1b481fa1);
$parcel$export(module.exports, "useProjectFormApi", () => $7fbef222cb36f40d$export$c06094384c75f8b4);

var $eUqFw = parcelRequire("eUqFw");

var $fMYmR = parcelRequire("fMYmR");
const $7fbef222cb36f40d$var$ProjectFormApiContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $7fbef222cb36f40d$export$1b3e028f1b481fa1 = ({ projectFormApi: projectFormApi, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fbef222cb36f40d$var$ProjectFormApiContext.Provider, {
        value: projectFormApi
    }, children);
const $7fbef222cb36f40d$export$c06094384c75f8b4 = ()=>{
    const projectFormApi = (0, $eUqFw.useContext)($7fbef222cb36f40d$var$ProjectFormApiContext);
    if (projectFormApi === undefined) throw new Error(`useProjectFormApi() must be used within a ProjectFormApiProvider. ${(0, $fMYmR.errorMessageDuplicateCommonCore)}`);
    return projectFormApi;
};

});

parcelRegister("9Td3m", function(module, exports) {

$parcel$export(module.exports, "LiveRequestTypeApi", () => $73336034bb02274d$export$1705810df2e31f50);
class $73336034bb02274d$export$1705810df2e31f50 {
    constructor(projectId, util){
        this.projectId = projectId;
        this.util = util;
    }
    async getRequestTypeCategories() {
        return this.util.jiraGet(`/rest/servicedesk/1/servicedesk/${this.projectId}/request-types`);
    }
}

});

parcelRegister("f1O3r", function(module, exports) {

$parcel$export(module.exports, "RequestTypeApiProvider", () => $af0dc6ca1caf50c0$export$3f33beafacd46d1a);
$parcel$export(module.exports, "useRequestTypeApi", () => $af0dc6ca1caf50c0$export$812317080a6b942d);

var $eUqFw = parcelRequire("eUqFw");

var $fMYmR = parcelRequire("fMYmR");
const $af0dc6ca1caf50c0$var$RequestTypeApiContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $af0dc6ca1caf50c0$export$3f33beafacd46d1a = ({ requestTypeApi: requestTypeApi, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($af0dc6ca1caf50c0$var$RequestTypeApiContext.Provider, {
        value: requestTypeApi
    }, children);
const $af0dc6ca1caf50c0$export$812317080a6b942d = ()=>{
    const requestTypeApi = (0, $eUqFw.useContext)($af0dc6ca1caf50c0$var$RequestTypeApiContext);
    if (requestTypeApi === null) throw new Error(`useRequestTypeApi() must be used within a RequestTypeApiProvider. ${(0, $fMYmR.errorMessageDuplicateCommonCore)}`);
    return requestTypeApi;
};

});

parcelRegister("bJ6Ty", function(module, exports) {

$parcel$export(module.exports, "LiveTemplateFormApi", () => $88993ee05146324d$export$a54d6a590c20cde6);
class $88993ee05146324d$export$a54d6a590c20cde6 {
    constructor(util){
        this.util = util;
    }
    copyTemplateForm(formId, projectId, copyProjectId, formName) {
        return this.util.post(`/api/2/projects/${projectId}/forms`, {
            name: formName,
            copyProjectId: copyProjectId,
            copyFormId: formId.toString()
        });
    }
    createTemplateFormForProject(projectId, formName) {
        return this.util.post(`/api/2/projects/${projectId}/forms`, {
            name: formName
        });
    }
}

});

parcelRegister("kCDeN", function(module, exports) {

$parcel$export(module.exports, "TemplateFormApiProvider", () => $f035cb0ed25d7b24$export$54424fb733a27080);
$parcel$export(module.exports, "useTemplateFormApi", () => $f035cb0ed25d7b24$export$b549592ba5c7b5b);

var $eUqFw = parcelRequire("eUqFw");

var $fMYmR = parcelRequire("fMYmR");
const $f035cb0ed25d7b24$var$TemplateFormApiContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $f035cb0ed25d7b24$export$54424fb733a27080 = ({ templateFormApi: templateFormApi, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f035cb0ed25d7b24$var$TemplateFormApiContext.Provider, {
        value: templateFormApi
    }, children);
const $f035cb0ed25d7b24$export$b549592ba5c7b5b = ()=>{
    const templateFormApi = (0, $eUqFw.useContext)($f035cb0ed25d7b24$var$TemplateFormApiContext);
    if (templateFormApi === undefined) throw new Error(`useTemplateFormApi must be used within a TemplateFormApiProvider. ${(0, $fMYmR.errorMessageDuplicateCommonCore)}`);
    return templateFormApi;
};

});

parcelRegister("1M84e", function(module, exports) {

$parcel$export(module.exports, "ProjectForms", () => $14b0881e5924537c$export$fba3a70fd399a62d);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $lB25E = parcelRequire("lB25E");

var $bFzGY = parcelRequire("bFzGY");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $hFGUl = parcelRequire("hFGUl");

var $gWxA1 = parcelRequire("gWxA1");

var $eQ9kk = parcelRequire("eQ9kk");

var $lSi60 = parcelRequire("lSi60");

var $jvRd3 = parcelRequire("jvRd3");

var $7xF7k = parcelRequire("7xF7k");

var $bu1Yj = parcelRequire("bu1Yj");

var $kCDeN = parcelRequire("kCDeN");

var $jzjRl = parcelRequire("jzjRl");

var $gbf0s = parcelRequire("gbf0s");

var $84JkN = parcelRequire("84JkN");

var $gyqTW = parcelRequire("gyqTW");

var $cdCbx = parcelRequire("cdCbx");
const $14b0881e5924537c$export$fba3a70fd399a62d = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, simplifiedProject: simplifiedProject, userIsProjectAdmin: userIsProjectAdmin })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { onOpenInProductHelpArticle: onOpenInProductHelpArticle } = (0, $lSi60.useInProductHelp)();
    const [{ forms: forms, loading: loading }] = (0, $bu1Yj.useProjectFormsController)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const templateFormApi = (0, $kCDeN.useTemplateFormApi)();
    const { setIsTemplateLibraryOpen: setIsTemplateLibraryOpen } = (0, $jvRd3.useTemplateLibraryActions)();
    const [isCreatingForm, setIsCreatingForm] = (0, $eUqFw.useState)(false);
    const pageHeadingMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), projectType === 'business' ? (0, $gyqTW.messages).pageHeadingJwm : (0, $gyqTW.messages).pageHeadingNonJwm);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.ProjectFormsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.HeadingContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), null, pageHeadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQ9kk.LoadingSpinner), {
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyqTW.messages).loading)));
    const createForm = (_, analyticsEvent)=>{
        (0, $gWxA1.fireUIAnalytics)(analyticsEvent, 'createTemplateForm');
        // Call API to create form
        setIsCreatingForm(true);
        templateFormApi.createTemplateFormForProject(projectId, '').then((response)=>{
            (0, $gWxA1.fireTrackAnalytics)(createAnalyticsEvent({}), `${(0, $7xF7k.ActionSubject).TEMPLATE_FORM} ${(0, $7xF7k.Action).CREATED}`, {
                templateFormId: response.id
            });
            push(response.nextUrl);
        }).finally(()=>{
            setIsCreatingForm(false);
        });
    };
    const openTemplateLibrary = ()=>setIsTemplateLibraryOpen(true);
    const learnMoreButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: ()=>onOpenInProductHelpArticle('5TZElbp1tEXG70CGT0HmT4')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyqTW.messages).learnMoreLinkLabel));
    const headingActions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gbf0s.CreateFormDropdown), {
        isLoading: isCreatingForm,
        onCreateBlankForm: createForm,
        onCreateFormFromTemplate: openTemplateLibrary
    }));
    if (forms.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.ProjectFormsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.HeadingContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        actions: headingActions
    }, pageHeadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.NoFormsColumn), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jzjRl.CreateFormSvg), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.NoFormsHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyqTW.messages).noFormsHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.NoFormsDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), projectType === 'service_desk' ? (0, $gyqTW.messages).noFormsDescriptionJsm : projectType === 'software' ? (0, $gyqTW.messages).noFormsDescriptionJsw : (0, $gyqTW.messages).noFormsDescriptionJwm)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.NoFormsLearnMoreLink), null, learnMoreButton)));
    const bottomBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.Description), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gyqTW.messages).description), "\xA0", learnMoreButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.ProjectFormsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdCbx.HeadingContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hFGUl.default), {
        actions: headingActions,
        bottomBar: bottomBar
    }, pageHeadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84JkN.ListProjectForms), {
        projectType: projectType,
        projectKey: projectKey,
        simplifiedProject: simplifiedProject,
        userIsProjectAdmin: userIsProjectAdmin
    }));
};

});
parcelRegister("hFGUl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ce2fac4b2f156d$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $eUqFw = parcelRequire("eUqFw");

var $5ubTM = parcelRequire("5ubTM");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $f0ce2fac4b2f156d$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.OuterWrapper), null, breadcrumbs, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleWrapper), {
        truncateTitle: truncateTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.TitleContainer), {
        truncateTitle: truncateTitle
    }, disableTitleStyles ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.StyledTitleWrapper), {
        ref: innerRef,
        truncateTitle: truncateTitle,
        id: id
    }, children)), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.ActionsWrapper), null, actions)), bottomBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5ubTM.BottomBarWrapper), null, " ", bottomBar, " "));
};
var $f0ce2fac4b2f156d$export$2e2bcd8739ae039 = $f0ce2fac4b2f156d$var$PageHeader;

});
parcelRegister("5ubTM", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $fce98fdc5842132f$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $fce98fdc5842132f$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $fce98fdc5842132f$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $fce98fdc5842132f$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $fce98fdc5842132f$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $fce98fdc5842132f$export$6330225854c30dc);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ /**
                                                                          * @jsxRuntime classic
                                                                          * @jsx jsx
                                                                          */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
function $fce98fdc5842132f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fce98fdc5842132f$var$truncateStyles = {
    name: "13oenf9",
    styles: "overflow-x:hidden;overflow-y:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $fce98fdc5842132f$var$outerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-200, 16px)"} 0`
});
const $fce98fdc5842132f$var$titleStyles = {
    name: "1o56te0",
    styles: "color:var(--ds-text, #172B4D);font:var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);letter-spacing:normal;margin-block-start:0;outline:none"
};
const $fce98fdc5842132f$var$titleWrapperStyles = {
    name: "1wb76vg",
    styles: "display:flex;align-items:flex-start;flex-wrap:wrap"
};
const $fce98fdc5842132f$var$titleWrapperTruncateStyles = {
    name: "14gl6v0",
    styles: "flex-wrap:nowrap"
};
const $fce98fdc5842132f$var$titleContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexShrink: undefined,
    marginBlockEnd: "var(--ds-space-100, 8px)"
});
const $fce98fdc5842132f$var$actionStyles = {
    name: "1ianfu6",
    styles: "max-width:100%;flex:0 0 auto;margin-block-end:var(--ds-space-100, 8px);margin-inline-start:auto;padding-inline-start:var(--ds-space-400, 32px);white-space:nowrap;>{text-align:right;}"
};
const $fce98fdc5842132f$var$titleContainerTruncateStyles = {
    name: "s2a4s9",
    styles: "flex-shrink:1"
};
const $fce98fdc5842132f$var$bottomBarStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.200'
});
const $fce98fdc5842132f$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$outerStyles
    }, children);
};
const $fce98fdc5842132f$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: [
            $fce98fdc5842132f$var$titleStyles,
            truncateTitle && $fce98fdc5842132f$var$truncateStyles
        ],
        ref: ref,
        tabIndex: -1,
        id: id
    }, children);
});
const $fce98fdc5842132f$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleWrapperStyles,
            truncateTitle && $fce98fdc5842132f$var$titleWrapperTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $fce98fdc5842132f$var$titleContainerStyles,
            truncateTitle && $fce98fdc5842132f$var$titleContainerTruncateStyles
        ]
    }, children);
};
const $fce98fdc5842132f$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fce98fdc5842132f$var$actionStyles
    }, children);
};
const $fce98fdc5842132f$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $fce98fdc5842132f$var$bottomBarStyles
    }, children);
};

});


parcelRegister("eQ9kk", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $acdd282208b9e0f1$export$b08b517936747730);

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $4Bees = parcelRequire("4Bees");
const $acdd282208b9e0f1$export$b08b517936747730 = ({ size: size = 'medium', children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($acdd282208b9e0f1$var$LoadingSpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($acdd282208b9e0f1$var$LoadingSpinnerMessage, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acdd282208b9e0f1$var$LoadingSpinnerContainer = (0, $exJuA.default).div({
    textAlign: 'center'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression -- Ignored via go/DSP-18766
const $acdd282208b9e0f1$var$LoadingSpinnerMessage = (0, $exJuA.default).p({});

});

parcelRegister("jvRd3", function(module, exports) {

$parcel$export(module.exports, "TemplateLibraryContainer", () => $e34a2fe53c6f5516$export$b414c1ae30748492);
$parcel$export(module.exports, "useTemplateLibraryState", () => $e34a2fe53c6f5516$export$47840b12545bcb14);
$parcel$export(module.exports, "useTemplateLibraryActions", () => $e34a2fe53c6f5516$export$8bf462d2c8456f46);
$parcel$export(module.exports, "useTemplateForm", () => $e34a2fe53c6f5516$export$7646fd624e15efcf);

var $WBLbN = parcelRequire("WBLbN");
const $e34a2fe53c6f5516$export$6114e3fefcbff062 = (isOpen)=>({ setState: setState })=>{
        setState({
            isTemplateLibraryOpen: isOpen
        });
    };
const $e34a2fe53c6f5516$export$b9839c0fc9ebf20a = (selectedTemplate)=>({ setState: setState })=>{
        setState({
            selectedTemplate: selectedTemplate
        });
    };
const $e34a2fe53c6f5516$export$7679083b8956d369 = (id, template)=>({ setState: setState, getState: getState })=>{
        const currentTemplates = getState().templates;
        if (!currentTemplates[id]) {
            currentTemplates[id] = {
                ...template
            };
            setState({
                templates: {
                    ...currentTemplates
                }
            });
        }
    };
const $e34a2fe53c6f5516$var$actions = {
    setIsTemplateLibraryOpen: $e34a2fe53c6f5516$export$6114e3fefcbff062,
    setSelectedTemplate: $e34a2fe53c6f5516$export$b9839c0fc9ebf20a,
    setTemplates: $e34a2fe53c6f5516$export$7679083b8956d369
};
const $e34a2fe53c6f5516$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isTemplateLibraryOpen: false,
        selectedTemplate: undefined,
        templates: {}
    },
    name: 'proforma-template-library-store',
    actions: $e34a2fe53c6f5516$var$actions
});
const $e34a2fe53c6f5516$export$b414c1ae30748492 = (0, $WBLbN.createContainer)($e34a2fe53c6f5516$var$Store);
const $e34a2fe53c6f5516$export$47840b12545bcb14 = (0, $WBLbN.createStateHook)($e34a2fe53c6f5516$var$Store);
const $e34a2fe53c6f5516$export$8bf462d2c8456f46 = (0, $WBLbN.createActionsHook)($e34a2fe53c6f5516$var$Store);
const $e34a2fe53c6f5516$export$1a4139ca79fdfefc = (state, id)=>state.templates[id];
const $e34a2fe53c6f5516$export$7646fd624e15efcf = (0, $WBLbN.createStateHook)($e34a2fe53c6f5516$var$Store, {
    selector: $e34a2fe53c6f5516$export$1a4139ca79fdfefc
});

});

parcelRegister("jzjRl", function(module, exports) {

$parcel$export(module.exports, "CreateFormSvg", () => $e3f0b0e24ae9bfef$export$b31d126f74eb63db);

var $eUqFw = parcelRequire("eUqFw");
const $e3f0b0e24ae9bfef$export$b31d126f74eb63db = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "216",
        height: "167",
        viewBox: "0 0 365.22 282.95"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("style", null, `
        .cls-1{isolation:isolate;}
        .cls-2{fill:url(#linear-gradient);}
        .cls-3{opacity:0.07;fill:url(#linear-gradient-2);}
        .cls-4{fill:#4c9aff;}
        .cls-5{fill:url(#linear-gradient-3);}
        .cls-6,.cls-9{fill:#dfe1e5;}
        .cls-15,.cls-16,.cls-6{mix - blend - mode:multiply;}
        .cls-7{fill:#0052cc;}
        .cls-8{fill:#b2d4ff;}
        .cls-10{fill:url(#linear-gradient-4);}
        .cls-11{fill:url(#linear-gradient-5);}
        .cls-12{fill:url(#linear-gradient-6);}
        .cls-13{fill:url(#linear-gradient-7);}
        .cls-14{fill:none;stroke:#2684ff;stroke-miterlimit:10;stroke-width:8px;}
        .cls-15,.cls-16{opacity:0.39;}
        .cls-15{fill:url(#linear-gradient-8);}
        .cls-16{fill:url(#linear-gradient-9);}
        `), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient",
        x1: "43.88",
        y1: "263.33",
        x2: "351.09",
        y2: "-43.88",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: "#dfe1e5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#fafbfc"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-2",
        x1: "135.86",
        y1: "138.06",
        x2: "135.86",
        y2: "235.8",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: "#091e42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#091e42",
        stopOpacity: "0.1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-3",
        x1: "10.35",
        y1: "146.56",
        x2: "311.65",
        y2: "146.56",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: "#b2d4ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.02",
        stopColor: "#b5d6ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.13",
        stopColor: "#c8dfff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.26",
        stopColor: "#d4e6ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.43",
        stopColor: "#dceaff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.79",
        stopColor: "#deebff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-4",
        x1: "49.65",
        y1: "180.3",
        x2: "269.79",
        y2: "180.3",
        xlinkHref: "#linear-gradient-3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-5",
        x1: "37.04",
        y1: "209.41",
        x2: "338.35",
        y2: "209.41",
        xlinkHref: "#linear-gradient-3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-6",
        x1: "3.07",
        y1: "266.43",
        x2: "303.37",
        y2: "266.43",
        xlinkHref: "#linear-gradient-3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-7",
        x1: "49.65",
        y1: "236.32",
        x2: "269.79",
        y2: "236.32",
        xlinkHref: "#linear-gradient-3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-8",
        x1: "187.7",
        y1: "713.48",
        x2: "187.7",
        y2: "741.99",
        gradientTransform: "matrix(1, 0, 0, -1, 0, 907.97)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: "#b2d4ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.87",
        stopColor: "#b2d4ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#b2d4ff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "linear-gradient-9",
        x1: "189.7",
        y1: "659.36",
        x2: "189.7",
        y2: "684.03",
        xlinkHref: "#linear-gradient-8"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        className: "cls-1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Layer_1-2",
        "data-name": "Layer 1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        className: "cls-2",
        width: "365.22",
        height: "249.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        className: "cls-3",
        d: "M244.35,248.89c-90.8.08-228.87,0-228.87,0L36.94,123.29h219.3Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        className: "cls-4",
        d: "M40.05,90.07H325.34a3,3,0,0,1,3,3v37.05a0,0,0,0,1,0,0H37a0,0,0,0,1,0,0V93.08A3,3,0,0,1,40.05,90.07Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        className: "cls-5",
        points: "338.35 163.52 47.04 163.52 37.04 129.61 328.35 129.61 338.35 163.52"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        className: "cls-6",
        x: "37.35",
        y: "32.72",
        width: "174.7",
        height: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        className: "cls-6",
        x: "37.35",
        y: "49.52",
        width: "127.57",
        height: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        className: "cls-7",
        x: "52.13",
        y: "107.11",
        width: "186.18",
        height: "7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        className: "cls-8",
        x: "229.2",
        y: "18.12",
        width: "52.93",
        height: "52.93",
        rx: "4.24"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        className: "cls-9",
        x: "297.53",
        y: "30.42",
        width: "28.32",
        height: "28.32",
        rx: "3.56"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        className: "cls-10",
        points: "338.35 163.47 47.04 163.47 37.04 197.12 328.35 197.12 338.35 163.47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        className: "cls-11",
        points: "338.35 221.8 47.04 221.8 37.04 197.02 328.35 197.02 338.35 221.8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        className: "cls-12",
        points: "341.35 282.95 50.04 282.95 41.04 249.91 332.35 249.91 341.35 282.95"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        className: "cls-13",
        points: "338.35 221.77 47.04 221.77 41.04 250.88 332.35 250.88 338.35 221.77"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polyline", {
        className: "cls-14",
        points: "238.44 45.85 250.93 58.54 273.92 29.16"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        className: "cls-15",
        points: "338.35 163.47 47.04 163.47 37.04 197.12 328.35 197.12 338.35 163.47"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        className: "cls-16",
        points: "338.35 221.77 47.04 221.77 41.04 250.88 332.35 250.88 338.35 221.77"
    })))));

});

parcelRegister("gbf0s", function(module, exports) {

$parcel$export(module.exports, "CreateFormDropdown", () => $bc7950664473270d$export$d9c4444e1f762d71);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $7opLA = parcelRequire("7opLA");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $dosj3 = parcelRequire("dosj3");

var $86Ndv = parcelRequire("86Ndv");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");

var $bbj3r = parcelRequire("bbj3r");
const $bc7950664473270d$export$d9c4444e1f762d71 = ({ isLoading: isLoading, onConvertForm: onConvertForm, onCreateBlankForm: onCreateBlankForm, onCreateFormFromTemplate: onCreateFormFromTemplate })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleOnCreateBlank = (e)=>{
        onCreateBlankForm(e, createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), (0, $kU09D.default)({}, props, {
                appearance: "primary",
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                    label: ""
                }),
                ref: triggerRef,
                isLoading: isLoading
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bbj3r.messages).createFormTrigger))
    }, (0, $XHGTv.fg)('shipit59_ai_forms_convertor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleOnCreateBlank
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bbj3r.messages).createFormFromBlank)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onCreateFormFromTemplate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bbj3r.messages).createFormTemplate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onConvertForm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bbj3r.messages).createFromImport), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dosj3))), {
        color: "var(--ds-icon-brand, #0C66E4)",
        label: formatMessage((0, $bbj3r.messages).atlassianIntelligenceLabel)
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: onCreateFormFromTemplate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bbj3r.messages).createFormTemplate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: handleOnCreateBlank
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $bbj3r.messages).createFormBlank))));
};

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $epS3S = parcelRequire("epS3S");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $eUqFw.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event, currentLevel)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) requestAnimationFrame(()=>{
            triggerRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $epS3S.DropdownMenuProvider), {
        value: {
            returnFocusRef: triggerRef
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    })));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);


var $XHGTv = parcelRequire("XHGTv");

var $8gwL5 = parcelRequire("8gwL5");
const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if ((0, $XHGTv.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $8gwL5.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});



parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("epS3S", function(module, exports) {

$parcel$export(module.exports, "DropdownMenuProvider", () => $ee1dc8dd27dd916a$export$9357e33608f1035a);

var $eUqFw = parcelRequire("eUqFw");
const $ee1dc8dd27dd916a$var$DropdownMenuContext = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $ee1dc8dd27dd916a$export$9357e33608f1035a = $ee1dc8dd27dd916a$var$DropdownMenuContext.Provider;

});

parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});


parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ki32l = parcelRequire("ki32l");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $ki32l.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");


var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("dosj3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c9e42f0bd2701e924d060f406b40f887>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c037948a4504eb1$var$_react = $9c037948a4504eb1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $9c037948a4504eb1$var$_UNSAFE_baseNew = $9c037948a4504eb1$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $9c037948a4504eb1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "AtlassianIntelligence".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Atlassian Intelligence products or experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c037948a4504eb1$var$AtlassianIntelligenceIcon = (props)=>/*#__PURE__*/ $9c037948a4504eb1$var$_react.default.createElement($9c037948a4504eb1$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m2 2 4 4m8 8-4-4m4-8-4 4m-8 8 4-4m2-9v3m0 8v3m7-7h-3M4 8H1"/>`
    }, props));
$9c037948a4504eb1$var$AtlassianIntelligenceIcon.displayName = 'AtlassianIntelligenceIcon';
var $9c037948a4504eb1$var$_default = module.exports.default = $9c037948a4504eb1$var$AtlassianIntelligenceIcon;

});

parcelRegister("bbj3r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $823f809e497a698f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $823f809e497a698f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    atlassianIntelligenceLabel: {
        id: 'proforma-project-forms.create-form-button.atlassian-intelligence-label',
        defaultMessage: 'Atlassian Intelligence',
        description: 'Label for Atlassian Intelligence icon'
    },
    createFromImport: {
        id: 'proforma-project-forms.create-form-button.convert-form',
        defaultMessage: 'Create from import',
        description: 'Option to create a form from import'
    },
    createFormTrigger: {
        id: 'proforma-project-forms.create-form-button.trigger',
        defaultMessage: 'Create form',
        description: 'Trigger for dropdown to create a new form'
    },
    createFormTemplate: {
        id: 'proforma-project-forms.create-form-button.create-with-template',
        defaultMessage: 'Create from template',
        description: 'Option to create a new form from a template'
    },
    createFormBlank: {
        id: 'proforma-project-forms.create-form-button.create-blank',
        defaultMessage: 'Create blank',
        description: 'Option to create a new blank form'
    },
    createFormFromBlank: {
        id: 'proforma-project-forms.create-form-button.create-from-blank',
        defaultMessage: 'Create from blank',
        description: 'Option to create a new blank form'
    }
});

});


parcelRegister("84JkN", function(module, exports) {

$parcel$export(module.exports, "ListProjectForms", () => $5e11dcea37bbae1b$export$48af72d90bb7288e);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cf2Y4 = parcelRequire("cf2Y4");

var $2UZ8t = parcelRequire("2UZ8t");

var $7xF7k = parcelRequire("7xF7k");

var $5RM2s = parcelRequire("5RM2s");

var $bu1Yj = parcelRequire("bu1Yj");

var $25Aee = parcelRequire("25Aee");

var $87uMK = parcelRequire("87uMK");

var $3lEkI = parcelRequire("3lEkI");

var $29dcw = parcelRequire("29dcw");
const $5e11dcea37bbae1b$export$48af72d90bb7288e = ({ projectKey: projectKey, projectType: projectType, simplifiedProject: simplifiedProject, userIsProjectAdmin: userIsProjectAdmin })=>{
    const intl = (0, $5JgJ2.default)();
    const [{ forms: forms, loading: loading }] = (0, $bu1Yj.useProjectFormsController)();
    const isServiceProject = projectType === 'service_desk';
    const [searchTextFilter, setSearchTextFilter] = (0, $eUqFw.useState)('');
    const [filteredTypeIds, setFilteredTypeIds] = (0, $eUqFw.useState)([]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RM2s.PackageIntlProvider), {
        locale: intl.locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87uMK.ListProjectFormsWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87uMK.TopBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87uMK.TextfieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87uMK.SmallSearchIcon), {
            label: ""
        }),
        onChange: (e)=>setSearchTextFilter(e.target.value),
        placeholder: intl.formatMessage((0, $25Aee.messages).formsFilterPlaceholder),
        isCompact: true,
        "aria-label": intl.formatMessage((0, $25Aee.messages).formsFilterPlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87uMK.RequestTypeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29dcw.TicketTypeDropdown), {
        isServiceProject: isServiceProject,
        onChange: setFilteredTypeIds
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87uMK.TableWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lEkI.Table), {
        projectKey: projectKey,
        projectType: projectType,
        simplifiedProject: simplifiedProject,
        userIsProjectAdmin: userIsProjectAdmin,
        searchTextFilter: searchTextFilter,
        filteredTypeIds: filteredTypeIds
    }), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2UZ8t.FireUIAnalytics), {
        actionSubject: (0, $7xF7k.ActionSubject).LIST,
        action: (0, $7xF7k.Action).VIEWED,
        actionSubjectId: "templateFormsList",
        attributes: {
            templateFormsCount: forms.length
        }
    }))));
};

});
parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $73a5c9d720aa66e1$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("25Aee", function(module, exports) {

$parcel$export(module.exports, "messages", () => $185826a1b833825e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $185826a1b833825e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    formsFilterPlaceholder: {
        id: 'jira-common.ListProjectForms.FilterForms',
        defaultMessage: 'Filter forms',
        description: 'Placeholder for a text field where a user can type to search for a form by name.'
    }
});

});

parcelRegister("87uMK", function(module, exports) {

$parcel$export(module.exports, "ListProjectFormsWrapper", () => $5e96db788a19c9a2$export$ab6d0d94aaf980af);
$parcel$export(module.exports, "RequestTypeWrapper", () => $5e96db788a19c9a2$export$c060feb82836da90);
$parcel$export(module.exports, "SmallSearchIcon", () => $5e96db788a19c9a2$export$4f3c3d5b26cd28e4);
$parcel$export(module.exports, "TableWrapper", () => $5e96db788a19c9a2$export$4267411171632d35);
$parcel$export(module.exports, "TextfieldWrapper", () => $5e96db788a19c9a2$export$9700332e73c23bb3);
$parcel$export(module.exports, "TopBar", () => $5e96db788a19c9a2$export$c4e96258f3b6511);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");

var $bPZtE = parcelRequire("bPZtE");
const $5e96db788a19c9a2$export$ab6d0d94aaf980af = (0, $exJuA.default).div({
    maxWidth: '1000px'
});
const $5e96db788a19c9a2$export$c060feb82836da90 = (0, $exJuA.default).div({
    marginRight: "var(--ds-space-100, 8px)"
});
const $5e96db788a19c9a2$export$4f3c3d5b26cd28e4 = (0, $exJuA.default)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))))({
    width: '20px',
    height: '20px'
});
const $5e96db788a19c9a2$export$4267411171632d35 = (0, $exJuA.default).div({
    /* Shift first row header to align with rest of the row */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'th:first-child': {
        paddingLeft: "var(--ds-space-150, 12px)"
    },
    /* Fix alignment of 2nd and 3rd columns */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'th:nth-child(2)': {
        paddingLeft: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td:nth-child(2)': {
        paddingLeft: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'th:nth-child(3)': {
        paddingLeft: "var(--ds-space-200, 16px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'td:nth-child(3)': {
        paddingLeft: "var(--ds-space-200, 16px)"
    }
});
const $5e96db788a19c9a2$export$9700332e73c23bb3 = (0, $exJuA.default).div({
    marginRight: "var(--ds-space-100, 8px)"
});
const $5e96db788a19c9a2$export$c4e96258f3b6511 = (0, $exJuA.default).div({
    paddingBottom: "var(--ds-space-300, 24)",
    display: 'flex'
});

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $89e4253a013a6022$var$_search = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("9IsWp")));
function $89e4253a013a6022$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
    }, props, {
        newIcon: $89e4253a013a6022$var$_search.default
    }));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = module.exports.default = $89e4253a013a6022$var$EditorSearchIcon;

});


parcelRegister("3lEkI", function(module, exports) {

$parcel$export(module.exports, "Table", () => $27029e991573f495$export$54ec01a60f47d33d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $lB25E = parcelRequire("lB25E");

var $7u4fN = parcelRequire("7u4fN");

var $clqWl = parcelRequire("clqWl");


var $2UZ8t = parcelRequire("2UZ8t");

var $fmOEh = parcelRequire("fmOEh");

var $7ODmA = parcelRequire("7ODmA");

var $7xF7k = parcelRequire("7xF7k");

var $8KsJV = parcelRequire("8KsJV");

var $bu1Yj = parcelRequire("bu1Yj");

var $55415 = parcelRequire("55415");

var $ebI2v = parcelRequire("ebI2v");

var $tJCsl = parcelRequire("tJCsl");

var $aXZh9 = parcelRequire("aXZh9");

var $gpOkP = parcelRequire("gpOkP");

var $sQtW8 = parcelRequire("sQtW8");

var $6AbVQ = parcelRequire("6AbVQ");

var $75QHx = parcelRequire("75QHx");
var $27029e991573f495$var$ProjectFormColumns = /*#__PURE__*/ function(ProjectFormColumns) {
    ProjectFormColumns["Actions"] = "Actions";
    ProjectFormColumns["AssociatedTypes"] = "AssociatedTypes";
    ProjectFormColumns["Name"] = "Name";
    ProjectFormColumns["Updated"] = "Updated";
    return ProjectFormColumns;
}($27029e991573f495$var$ProjectFormColumns || {});
const $27029e991573f495$export$54ec01a60f47d33d = ({ projectKey: projectKey, projectType: projectType, userIsProjectAdmin: userIsProjectAdmin, searchTextFilter: searchTextFilter, simplifiedProject: simplifiedProject, filteredTypeIds: filteredTypeIds })=>{
    const isServiceProject = projectType === 'service_desk';
    const errorUtils = (0, $fmOEh.usePfErrorUtils)();
    const projectFormApi = (0, $aXZh9.useProjectFormApi)();
    const issueFormsApi = (0, $tJCsl.useIssueFormsApi)();
    const [{ forms: forms, loading: loading, sortKey: sortKey, sortOrder: sortOrder }, { onSort: onSort }] = (0, $bu1Yj.useProjectFormsController)();
    const requestTypeCategories = (0, $55415.useRequestTypeCategories)({
        isServiceCMP: isServiceProject && !simplifiedProject
    });
    const { push: push } = (0, $lB25E.useRouterActions)();
    const [issueFormsInfo, setIssueFormsInfo] = (0, $eUqFw.useState)(undefined);
    (0, $eUqFw.useEffect)(()=>{
        issueFormsApi.getIssueFormsInfo().then((res)=>{
            setIssueFormsInfo(res);
        });
    }, [
        issueFormsApi
    ]);
    const headers = [
        {
            key: $27029e991573f495$var$ProjectFormColumns.Name,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $sQtW8.messages).nameColumnHeader),
            isSortable: false,
            width: 8
        },
        {
            key: $27029e991573f495$var$ProjectFormColumns.AssociatedTypes,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), isServiceProject ? (0, $sQtW8.messages).requestTypesColumnHeader : (0, $sQtW8.messages).issueTypesColumnHeader),
            isSortable: false,
            width: 5
        },
        {
            key: $27029e991573f495$var$ProjectFormColumns.Updated,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $sQtW8.messages).lastUpdatedColumnHeader),
            isSortable: true,
            width: 3
        },
        {
            key: $27029e991573f495$var$ProjectFormColumns.Actions,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
            isSortable: false,
            width: 1
        }
    ].filter(Boolean);
    const [rows, setRows] = (0, $eUqFw.useState)([]);
    (0, $eUqFw.useEffect)(()=>{
        const typeFilter = isServiceProject ? (t)=>t.type === (0, $7ODmA.TicketType).RequestType : (t)=>t.type === (0, $7ODmA.TicketType).IssueType;
        const formFilter = (form)=>form.name.toLowerCase().includes(searchTextFilter.toLowerCase()) && (filteredTypeIds.length === 0 || form.requesttypes.filter(typeFilter).some((requestType)=>filteredTypeIds.length === 0 || filteredTypeIds.includes((0, $8KsJV.extractTicketTypeId)(requestType.id))));
        setRows(forms.filter(formFilter).map((form)=>{
            const requestTypes = form.requesttypes.filter(typeFilter);
            return {
                key: `row-${form.projectId}-${form.id}`,
                cells: [
                    {
                        key: `${form.name}-${form.id}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                            appearance: "subtle-link",
                            onClick: ()=>push(form.editUrl),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                display: 'flex',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                alignItems: 'center',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: 'fit-content'
                            }
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $75QHx.FormNameWrapper), {
                            id: `${form.name.replace(/\s+/g, '')}-${form.id}`
                        }, form.name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $sQtW8.messages).emptyFormName)))
                    },
                    {
                        key: $27029e991573f495$var$ProjectFormColumns.AssociatedTypes,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6AbVQ.RequestTypes), {
                            projectKey: projectKey,
                            simplifiedProject: simplifiedProject,
                            isServiceProject: isServiceProject,
                            requestTypes: requestTypes,
                            requestTypeCategories: requestTypeCategories
                        })
                    },
                    {
                        key: `${$27029e991573f495$var$ProjectFormColumns.Updated}-${form.updated.iso8601}-${form.id}`,
                        content: form.updated.friendly
                    },
                    {
                        key: `${$27029e991573f495$var$ProjectFormColumns.Actions}-${form.id}`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gpOkP.FormActions), {
                            projectType: projectType,
                            simplifiedProject: simplifiedProject,
                            userIsProjectAdmin: userIsProjectAdmin,
                            form: form,
                            projectKey: projectKey,
                            issueFormsInfo: issueFormsInfo
                        })
                    }
                ].filter(Boolean)
            };
        }));
    }, [
        filteredTypeIds,
        forms,
        isServiceProject,
        projectType,
        push,
        searchTextFilter,
        userIsProjectAdmin,
        projectKey,
        simplifiedProject,
        requestTypeCategories,
        issueFormsInfo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1reo1wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1bsb1c3h _g7111wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ebI2v.ExportContainer), {
        errorUtils: errorUtils,
        projectFormApi: projectFormApi
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $clqWl.default), {
        head: {
            cells: headers
        },
        rows: rows,
        loadingSpinnerSize: "large",
        isLoading: loading,
        isFixedSize: true,
        sortKey: sortKey,
        sortOrder: sortOrder,
        onSort: onSort
    })), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2UZ8t.FireUIAnalytics), {
        actionSubject: (0, $7xF7k.ActionSubject).TABLE,
        action: (0, $7xF7k.Action).VIEWED,
        actionSubjectId: "proformaDynamicTable",
        attributes: {
            tableRowsCount: rows.length,
            tableSortKey: sortKey,
            tableSortOrder: sortOrder
        }
    })));
};
const $27029e991573f495$var$WrapperContainer = null;
const $27029e991573f495$var$OverflowContainer = null;

});
parcelRegister("clqWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cd2847e492d5dd4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");


var $fVXMO = parcelRequire("fVXMO");

var $3tjuM = parcelRequire("3tjuM");

var $iK2U9 = parcelRequire("iK2U9");

var $9t1Ml = parcelRequire("9t1Ml");

var $aLrpD = parcelRequire("aLrpD");

var $a96y2 = parcelRequire("a96y2");

var $DPlg5 = parcelRequire("DPlg5");

var $i9y06 = parcelRequire("i9y06");

var $cTO8p = parcelRequire("cTO8p");
function $7cd2847e492d5dd4$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65:
            return 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b;
        case 0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b:
            return 0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $7cd2847e492d5dd4$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $5Q9wj.default), onSort: providedOnSort = (0, $5Q9wj.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $5Q9wj.default), onRankEnd: providedOnRankEnd = (0, $5Q9wj.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eUqFw.useState)(false);
    const tableBodyRef = (0, $eUqFw.useRef)(null);
    const onSort = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eUqFw.useEffect)(()=>{
        (0, $fVXMO.validateSortKey)(sortKey, head);
        (0, $fVXMO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) : $7cd2847e492d5dd4$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $fVXMO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3) : (0, $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK2U9.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $DPlg5.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cTO8p.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tjuM.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9y06.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a96y2.default), {
        isLoading: isLoading,
        spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $7cd2847e492d5dd4$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("7BSAY")));
const $7cd2847e492d5dd4$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9t1Ml.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aLrpD.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd2847e492d5dd4$var$RankableTableBody, {
        ref: ref,
        ...bodyProps,
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    }))) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7cd2847e492d5dd4$export$2e2bcd8739ae039 = $7cd2847e492d5dd4$var$DynamicTable;

});
const $9ad1be2eb14b8d3d$export$1dee026a19752d6b = 'ASC';
const $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65 = 'DESC';
const $9ad1be2eb14b8d3d$export$71dd4c8ecd45e95f = 'small';
const $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3 = 'large';
const $9ad1be2eb14b8d3d$export$3843c586a90b9cbf = 0.22;

parcelRegister("fVXMO", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $9778ffcbc0ef1196$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $9778ffcbc0ef1196$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $9778ffcbc0ef1196$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $9778ffcbc0ef1196$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $9778ffcbc0ef1196$export$c476bbe5da59992d);
const $9778ffcbc0ef1196$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $9778ffcbc0ef1196$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $9778ffcbc0ef1196$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $9778ffcbc0ef1196$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $9778ffcbc0ef1196$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $9778ffcbc0ef1196$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $9778ffcbc0ef1196$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("3tjuM", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $1430aaf59e7cbeab$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $1430aaf59e7cbeab$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $1430aaf59e7cbeab$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $1430aaf59e7cbeab$export$3e5e12dc01f20a43);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g2Ovh = parcelRequire("g2Ovh");
function $1430aaf59e7cbeab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1430aaf59e7cbeab$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $1430aaf59e7cbeab$var$fixedSizeTableStyles = {
    name: "wgb42e",
    styles: "table-layout:fixed"
};
const $1430aaf59e7cbeab$var$tableStyles = {
    name: "mul4pg",
    styles: "width:100%;border-collapse:separate;border-spacing:0px"
};
const $1430aaf59e7cbeab$var$bodyBorder = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`
});
const $1430aaf59e7cbeab$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("table", {
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $g2Ovh.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $g2Ovh.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$1430aaf59e7cbeab$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $g2Ovh.row).focusOutline
        },
        css: [
            $1430aaf59e7cbeab$var$tableStyles,
            isFixedSize && $1430aaf59e7cbeab$var$fixedSizeTableStyles,
            hasDataRow && $1430aaf59e7cbeab$var$bodyBorder
        ],
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`
    }, children);
});
const $1430aaf59e7cbeab$var$captionStyles = {
    name: "h9a27i",
    styles: "font:var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-100, 8px);margin-block-start:var(--ds-space-300, 24px);will-change:transform"
};
const $1430aaf59e7cbeab$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("caption", {
        css: $1430aaf59e7cbeab$var$captionStyles
    }, children);
const $1430aaf59e7cbeab$var$paginationWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $1430aaf59e7cbeab$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1430aaf59e7cbeab$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("g2Ovh", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $47d84a50d7c96182$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $47d84a50d7c96182$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $47d84a50d7c96182$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $47d84a50d7c96182$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $47d84a50d7c96182$export$38d703b73e2cf64d);

const $47d84a50d7c96182$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $47d84a50d7c96182$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$73a5c9d720aa66e1$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$73a5c9d720aa66e1$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$73a5c9d720aa66e1$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$73a5c9d720aa66e1$export$8c13c2ee36917869})`
};
const $47d84a50d7c96182$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$73a5c9d720aa66e1$export$e2ef2124cf4024b1})`
};
const $47d84a50d7c96182$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$73a5c9d720aa66e1$export$1ce2d1575d444ceb})`
};

});


parcelRegister("iK2U9", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1c04c67c6d2e01dc$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1c04c67c6d2e01dc$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $1c04c67c6d2e01dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c04c67c6d2e01dc$var$fixedHeightStyles = {
    name: "50gc26",
    styles: "height:9rem"
};
const $1c04c67c6d2e01dc$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1c04c67c6d2e01dc$var$emptyViewContainerStyles = {
    name: "1yld51o",
    styles: "width:50%;margin:auto;padding:10px;text-align:center"
};
const $1c04c67c6d2e01dc$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1c04c67c6d2e01dc$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("9t1Ml", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdc1fe407cca2cd9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2c84N = parcelRequire("2c84N");

var $a8MUu = parcelRequire("a8MUu");
class $bdc1fe407cca2cd9$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8MUu.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $bdc1fe407cca2cd9$var$Body = (0, $2c84N.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc1fe407cca2cd9$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bdc1fe407cca2cd9$export$2e2bcd8739ae039 = $bdc1fe407cca2cd9$var$Body;

});
parcelRegister("2c84N", function(module, exports) {

$parcel$export(module.exports, "default", () => $1514dd575e5332c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $fVXMO = parcelRequire("fVXMO");
const $1514dd575e5332c4$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $1514dd575e5332c4$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $1514dd575e5332c4$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $1514dd575e5332c4$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $1514dd575e5332c4$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $fVXMO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $1514dd575e5332c4$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $fVXMO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("a8MUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $2038a3700f41e476$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4RemJ = parcelRequire("4RemJ");

var $iqL3E = parcelRequire("iqL3E");
const $2038a3700f41e476$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iqL3E.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }, cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4RemJ.TableBodyCell), {
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
            ...restCellProps,
            isFixedSize: isFixedSize,
            key: cellIndex,
            shouldTruncate: shouldTruncate,
            width: width
        }, content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2038a3700f41e476$export$2e2bcd8739ae039 = $2038a3700f41e476$var$Row;

});
parcelRegister("4RemJ", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $5915d36ce36ccacb$export$948e91fcef170792);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $39mp0 = parcelRequire("39mp0");
const $5915d36ce36ccacb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles)
        ],
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        ...props
    });

});
parcelRegister("39mp0", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $ad2974e69f235483$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $ad2974e69f235483$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $ad2974e69f235483$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $ad2974e69f235483$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $ad2974e69f235483$export$f7913df521f684e2);

var $byn9U = parcelRequire("byn9U");
function $ad2974e69f235483$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2974e69f235483$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $ad2974e69f235483$export$708a733455f59a29 = /*#__PURE__*/ (0, $byn9U.css)({
    width: `var(${$ad2974e69f235483$var$CSS_VAR_WIDTH})`
});
const $ad2974e69f235483$export$616c93ee022c8812 = {
    name: "1s7jr4j",
    styles: "text-overflow:ellipsis;white-space:nowrap"
};
const $ad2974e69f235483$export$7f2cd17defa265d8 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $ad2974e69f235483$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$ad2974e69f235483$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $ad2974e69f235483$export$f7913df521f684e2 = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iqL3E", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $6b389a48d047c2ef$export$45f39d9c38b886d5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3tjuM = parcelRequire("3tjuM");
const $6b389a48d047c2ef$var$rowStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $6b389a48d047c2ef$var$rowBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $3tjuM.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $6b389a48d047c2ef$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $6b389a48d047c2ef$var$rowStyles,
            isHighlighted ? $6b389a48d047c2ef$var$rowHighlightedBackgroundStyles : $6b389a48d047c2ef$var$rowBackgroundStyles
        ],
        ...rest,
        ref: ref,
        "data-testid": testId
    }, children);
});

});



parcelRegister("aLrpD", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $73b0e671a4d4f805$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $73b0e671a4d4f805$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("a96y2", function(module, exports) {

$parcel$export(module.exports, "default", () => $feff75185b46f730$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $a53tD = parcelRequire("a53tD");
class $feff75185b46f730$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a53tD.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}

});
parcelRegister("a53tD", function(module, exports) {

$parcel$export(module.exports, "Container", () => $aa6b103a00044c0b$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $aa6b103a00044c0b$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $aa6b103a00044c0b$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $byn9U = parcelRequire("byn9U");
function $aa6b103a00044c0b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa6b103a00044c0b$export$c335a80381ec61f5 = '--contents-opacity';
const $aa6b103a00044c0b$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $aa6b103a00044c0b$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $aa6b103a00044c0b$var$contentsContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    opacity: `var(${$aa6b103a00044c0b$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $aa6b103a00044c0b$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$aa6b103a00044c0b$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $aa6b103a00044c0b$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $aa6b103a00044c0b$var$spinnerContainerStyles = {
    name: "su4u96",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center"
};
const $aa6b103a00044c0b$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $aa6b103a00044c0b$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("DPlg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c0b56c99dd019f1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $4Bees = parcelRequire("4Bees");


var $sM67g = parcelRequire("sM67g");
class $6c0b56c99dd019f1$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $9ad1be2eb14b8d3d$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $9ad1be2eb14b8d3d$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $sM67g.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("sM67g", function(module, exports) {

$parcel$export(module.exports, "Container", () => $e14096c71a70d04d$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $e14096c71a70d04d$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $e14096c71a70d04d$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $e14096c71a70d04d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e14096c71a70d04d$var$containerStyles = {
    name: "17fhw1k",
    styles: "position:relative;margin-block-end:var(--ds-space-300, 24px)"
};
const $e14096c71a70d04d$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$containerStyles,
        ...rest,
        "data-testid": testId,
        ref: ref
    }, children));
});
const $e14096c71a70d04d$var$spinnerBackdropStyles = {
    name: "1yy6mjk",
    styles: "display:flex;position:absolute;inset:0;align-items:center;justify-content:center;pointer-events:none"
};
const $e14096c71a70d04d$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $e14096c71a70d04d$var$spinnerContainerStyles = {
    name: "vi3nlf",
    styles: "position:relative;inset-block-start:0"
};
const $e14096c71a70d04d$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e14096c71a70d04d$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("i9y06", function(module, exports) {

$parcel$export(module.exports, "default", () => $59228fe552548a0a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3KPTt = parcelRequire("3KPTt");
class $59228fe552548a0a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KPTt.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});
parcelRegister("3KPTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d6d0a6ee26c024$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $5Mzgj = parcelRequire("5Mzgj");

var $2C9cn = parcelRequire("2C9cn");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $4DxcJ = parcelRequire("4DxcJ");

var $7X9O4 = parcelRequire("7X9O4");

var $eDUla = parcelRequire("eDUla");

var $1ssgv = parcelRequire("1ssgv");

var $bZ2kD = parcelRequire("bZ2kD");
const $52d6d0a6ee26c024$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $52d6d0a6ee26c024$var$paginationMenuStyles = (0, $1ZAYh.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $52d6d0a6ee26c024$var$paginationMenuItemStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.0'
});
const $52d6d0a6ee26c024$var$navigatorIconWrapperStyles = (0, $1ZAYh.xcss)({
    paddingInline: 'space.075'
});
function $52d6d0a6ee26c024$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($5Mzgj))) : (0, (/*@__PURE__*/$parcel$interopDefault($2C9cn)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $52d6d0a6ee26c024$var$navigatorIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $52d6d0a6ee26c024$var$InnerPagination({ components: components = (0, $1ssgv.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1ssgv.emptyObject), max: max = 7, onChange: onChange = (0, $5Q9wj.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $eDUla.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2WwAS.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$52d6d0a6ee26c024$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            as: "li",
            xcss: $52d6d0a6ee26c024$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7X9O4.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $52d6d0a6ee26c024$var$paginationMenuStyles
    }, (0, $bZ2kD.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4DxcJ.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52d6d0a6ee26c024$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $52d6d0a6ee26c024$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($52d6d0a6ee26c024$var$InnerPagination));
var $52d6d0a6ee26c024$export$2e2bcd8739ae039 = $52d6d0a6ee26c024$var$Pagination;

});
parcelRegister("5Mzgj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $435cc9c581f97870$var$_react = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $435cc9c581f97870$var$_chevronLeft = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("a4cVy")));

var $435cc9c581f97870$var$_chevronLeftLarge = $435cc9c581f97870$var$_interopRequireDefault((parcelRequire("dXKde")));
function $435cc9c581f97870$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $435cc9c581f97870$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $435cc9c581f97870$var$_react.default.createElement($435cc9c581f97870$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $435cc9c581f97870$var$_chevronLeftLarge.default
    }, props));
$435cc9c581f97870$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $435cc9c581f97870$var$_default = module.exports.default = $435cc9c581f97870$var$ChevronLeftIcon;

});
parcelRegister("a4cVy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75444e382f2d4220$var$_react = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75444e382f2d4220$var$_UNSAFE_baseNew = $75444e382f2d4220$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75444e382f2d4220$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75444e382f2d4220$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $75444e382f2d4220$var$_react.default.createElement($75444e382f2d4220$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$75444e382f2d4220$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $75444e382f2d4220$var$_default = module.exports.default = $75444e382f2d4220$var$ChevronLeftIcon;

});

parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $a2a4a1e4b9148f86$var$_chevronLeft = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("a4cVy")));
function $a2a4a1e4b9148f86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a2a4a1e4b9148f86$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = module.exports.default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;

});


parcelRegister("2C9cn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e764405146a3983$var$_react = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $1e764405146a3983$var$_chevronRight = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("fCmfi")));

var $1e764405146a3983$var$_chevronRightLarge = $1e764405146a3983$var$_interopRequireDefault((parcelRequire("dwj4T")));
function $1e764405146a3983$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1e764405146a3983$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $1e764405146a3983$var$_react.default.createElement($1e764405146a3983$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $1e764405146a3983$var$_chevronRightLarge.default
    }, props));
$1e764405146a3983$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $1e764405146a3983$var$_default = module.exports.default = $1e764405146a3983$var$ChevronRightIcon;

});
parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9d7d0ffff46f5f00$var$_chevronRight = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("fCmfi")));
function $9d7d0ffff46f5f00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9d7d0ffff46f5f00$var$_chevronRight.default,
        iconType: "utility"
    }));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = module.exports.default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;

});


parcelRegister("4DxcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d3c7b4b153b94a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $a4d3c7b4b153b94a$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("7X9O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5f9797829cf4ad3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
function $e5f9797829cf4ad3$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("eDUla", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceba78dad21693c3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lkPEe = parcelRequire("lkPEe");
const $ceba78dad21693c3$var$containerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'relative'
});
function $ceba78dad21693c3$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $ceba78dad21693c3$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkPEe.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("1ssgv", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $3850a464bb1795dd$export$3f860eba1218f8d3);
const $3850a464bb1795dd$export$3f860eba1218f8d3 = {};

});

parcelRegister("bZ2kD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a954a8bde9a3bed3$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $a954a8bde9a3bed3$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $a954a8bde9a3bed3$export$2e2bcd8739ae039 = $a954a8bde9a3bed3$var$collapseRange;

});



parcelRegister("cTO8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e1cf364925ee2f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVXMO = parcelRequire("fVXMO");

var $iLooJ = parcelRequire("iLooJ");

var $6Ztqc = parcelRequire("6Ztqc");

var $jRqbA = parcelRequire("jRqbA");
class $7e1cf364925ee2f7$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $fVXMO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $fVXMO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $6Ztqc.default) : (0, $jRqbA.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, {
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width,
                ...restCellProps
            });
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7e1cf364925ee2f7$export$2e2bcd8739ae039 = $7e1cf364925ee2f7$var$TableHead;

});
parcelRegister("iLooJ", function(module, exports) {

$parcel$export(module.exports, "Head", () => $e23e257a0c447ed4$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $e23e257a0c447ed4$export$4e8024263ace498b);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
                                                         * @jsxRuntime classic
                                                         * @jsx jsx
                                                         */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");



var $g2Ovh = parcelRequire("g2Ovh");

var $39mp0 = parcelRequire("39mp0");
function $e23e257a0c447ed4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $e23e257a0c447ed4$var$rankingStyles = {
    name: "4zleql",
    styles: "display:block"
};
const $e23e257a0c447ed4$var$headStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $e23e257a0c447ed4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("thead", {
        css: [
            $e23e257a0c447ed4$var$headStyles,
            isRanking && $e23e257a0c447ed4$var$rankingStyles
        ],
        "data-testid": testId,
        ...props
    });
};
const $e23e257a0c447ed4$var$headCellBaseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$headCellBaseStylesModernized = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $g2Ovh.tableBorder).borderColor}`,
    color: `var(--ds-text-subtle, ${`var(${$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a)})`}`
    }
});
const $e23e257a0c447ed4$var$onClickStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $e23e257a0c447ed4$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $g2Ovh.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).Text}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$ascendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$var$descendingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $g2Ovh.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $g2Ovh.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $e23e257a0c447ed4$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $39mp0.getTruncationStyleVars)({
            width: width
        }),
        [$e23e257a0c447ed4$var$CSS_VAR_TEXT_COLOR]: (0, $g2Ovh.head).textColor
    };
    const isASC = sortOrder === (0, $9ad1be2eb14b8d3d$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $9ad1be2eb14b8d3d$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $byn9U.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.cellStyles),
            (0, $XHGTv.fg)('design_system_team_dynamic_table_typography') ? $e23e257a0c447ed4$var$headCellBaseStylesModernized : $e23e257a0c447ed4$var$headCellBaseStyles,
            onClick && $e23e257a0c447ed4$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $39mp0.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $39mp0.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $39mp0.overflowTruncateStyles),
            isSortable && $e23e257a0c447ed4$var$baseStyles,
            isASC && $e23e257a0c447ed4$var$ascendingStyles,
            isDESC && $e23e257a0c447ed4$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId,
        ...rest
    }, children);
});

});

parcelRegister("6Ztqc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0043750917848b87$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hwoBY = parcelRequire("hwoBY");

var $fVXMO = parcelRequire("fVXMO");

var $jRqbA = parcelRequire("jRqbA");
class $0043750917848b87$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $fVXMO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRqbA.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $0043750917848b87$var$RankableTableHeadCell = (0, $hwoBY.default)($0043750917848b87$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0043750917848b87$export$2e2bcd8739ae039 = $0043750917848b87$var$RankableTableHeadCell;

});
parcelRegister("hwoBY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f810d119edc97937$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $f810d119edc97937$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("jRqbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $635bc03d85c6882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iLooJ = parcelRequire("iLooJ");
const $635bc03d85c6882e$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLooJ.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        onClick: onClick,
        isSortable: isSortable
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635bc03d85c6882e$export$2e2bcd8739ae039 = $635bc03d85c6882e$var$TableHeadCell;

});



parcelRegister("7BSAY", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("aVYwg")
]).then(()=>parcelRequire('jlg4D'));

});


parcelRegister("7ODmA", function(module, exports) {

$parcel$export(module.exports, "TicketType", () => $5b0bbcaa69380b53$export$b7a6204b7553fd04);
let $5b0bbcaa69380b53$export$b7a6204b7553fd04 = /*#__PURE__*/ function(TicketType) {
    TicketType["IssueType"] = "issue";
    TicketType["RequestType"] = "request";
    return TicketType;
}({}); // Confusingly, this can represent either an IssueType or RequestType

});

parcelRegister("8KsJV", function(module, exports) {

$parcel$export(module.exports, "extractTicketTypeId", () => $65e8e9b9f0ca55ad$export$ab6a536ba5209e34);
$parcel$export(module.exports, "groupRequestTypes", () => $65e8e9b9f0ca55ad$export$3759ef5bb78a955a);
const $65e8e9b9f0ca55ad$export$ab6a536ba5209e34 = (id)=>id.slice(1);
const $65e8e9b9f0ca55ad$export$3759ef5bb78a955a = (requestTypes)=>requestTypes.reduce((acc, rt)=>{
        const rtId = $65e8e9b9f0ca55ad$export$ab6a536ba5209e34(rt.id);
        if (rtId in acc) acc[rtId] = [
            ...acc[rtId],
            rt
        ];
        else acc[rtId] = [
            rt
        ];
        return acc;
    }, {});

});

parcelRegister("55415", function(module, exports) {

$parcel$export(module.exports, "useRequestTypeCategories", () => $3b3088f47a662478$export$62864a475521b9aa);

var $eUqFw = parcelRequire("eUqFw");

var $f1O3r = parcelRequire("f1O3r");
const $3b3088f47a662478$export$62864a475521b9aa = ({ isServiceCMP: isServiceCMP })=>{
    const requestTypeApi = (0, $f1O3r.useRequestTypeApi)();
    const [requestTypeCategoryMappings, setRequestTypeCategoryMappings] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isServiceCMP) requestTypeApi.getRequestTypeCategories().then((response)=>{
            setRequestTypeCategoryMappings(response.ticketTypes.reduce((prev, curr)=>{
                var _response$practices$f;
                return {
                    ...prev,
                    [curr.id]: (_response$practices$f = response.practices.find((category)=>category.ticketTypes.includes(curr.id))) === null || _response$practices$f === void 0 ? void 0 : _response$practices$f.key
                };
            }, {}));
        });
    }, [
        isServiceCMP,
        requestTypeApi
    ]);
    return requestTypeCategoryMappings;
};

});

parcelRegister("ebI2v", function(module, exports) {

$parcel$export(module.exports, "ExportContainer", () => $a54441179a613576$export$fb2223a1cd71ec4d);
$parcel$export(module.exports, "useExportController", () => $a54441179a613576$export$76bdaf6da83e5e48);

var $WBLbN = parcelRequire("WBLbN");
// TODO: This export service should be made generic and then moved to 'proforma[-jira]-export'
//       so that it can be used in this package, Jira issue view, and Jira issue search (possibly others).
const $a54441179a613576$var$spreadsheetPollMaximumDelay = 5000; // 5000ms = five seconds
const $a54441179a613576$var$spreadsheetPollMultiplier = 1.2; // 1.2x = increase wait time by 20% for each poll
const $a54441179a613576$var$initialState = {
    formId: undefined,
    filename: undefined,
    serverProgress: undefined,
    taskId: undefined,
    // For internal use only.
    pollDelay: 500,
    // For internal use only. // 500ms = half a second
    timeoutHandle: undefined,
    // For internal use only.
    downloading: false,
    successful: false,
    error: false
};
const $a54441179a613576$var$actions = {
    start: (form)=>({ setState: setState, getState: getState, dispatch: dispatch }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
            if (getState().filename) return false;
            setState({
                formId: form.id,
                filename: `${form.name}.xlsx`
            });
            projectFormApi.startXlsxDownload(form.id).then((xlsxDownloadTask)=>{
                if (xlsxDownloadTask) setState({
                    serverProgress: 0,
                    taskId: xlsxDownloadTask.id
                });
                dispatch($a54441179a613576$var$processXlsxDownloadResponse(xlsxDownloadTask));
            }).catch(()=>{
                errorUtils.reportError(new Error('The XLSX download task failed while starting.'));
                setState({
                    error: true
                });
            });
            // NOTE: Analytics should probably be re-added here.
            return true;
        },
    clear: ()=>({ setState: setState, getState: getState })=>{
            window.clearTimeout(getState().timeoutHandle);
            setState($a54441179a613576$var$initialState);
        }
};
const $a54441179a613576$var$Store = (0, $WBLbN.createStore)({
    initialState: $a54441179a613576$var$initialState,
    actions: $a54441179a613576$var$actions,
    name: 'ExportStore'
});
const $a54441179a613576$export$fb2223a1cd71ec4d = (0, $WBLbN.createContainer)($a54441179a613576$var$Store);
const $a54441179a613576$export$76bdaf6da83e5e48 = (0, $WBLbN.createHook)($a54441179a613576$var$Store);
const $a54441179a613576$var$processXlsxDownloadResponse = (xlsxDownloadTask)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        if (xlsxDownloadTask.status.failed) setState({
            error: true
        });
        else if (xlsxDownloadTask.status.complete) {
            setState({
                serverProgress: 100
            });
            dispatch($a54441179a613576$var$downloadXlsx());
        } else {
            const state = getState();
            setState({
                serverProgress: xlsxDownloadTask.status.progress,
                pollDelay: Math.min(state.pollDelay * $a54441179a613576$var$spreadsheetPollMultiplier, $a54441179a613576$var$spreadsheetPollMaximumDelay),
                timeoutHandle: window.setTimeout(()=>dispatch($a54441179a613576$var$checkXlsxDownload()), state.pollDelay)
            });
        }
    };
const $a54441179a613576$var$checkXlsxDownload = ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
        const { formId: formId, taskId: taskId } = getState();
        if (formId === undefined || taskId === undefined) {
            errorUtils.reportError(new Error('Cannot check XLSX download, the download form or task ID is undefined.'));
            setState({
                error: true
            });
            return;
        }
        projectFormApi.checkXlsxDownload(formId, taskId).then((xlsxDownloadTask)=>dispatch($a54441179a613576$var$processXlsxDownloadResponse(xlsxDownloadTask))).catch(()=>{
            errorUtils.reportError(new Error('The XLSX download task failed while checking progress.'));
            setState({
                error: true
            });
        });
    };
const $a54441179a613576$var$downloadXlsx = ()=>({ setState: setState, getState: getState }, { errorUtils: errorUtils, projectFormApi: projectFormApi })=>{
        const { formId: formId, filename: filename, taskId: taskId } = getState();
        if (formId === undefined || filename === undefined || taskId === undefined) {
            errorUtils.reportError(new Error('Cannot finish XLSX download, a required property is undefined.'));
            setState({
                error: true
            });
            return;
        }
        setState({
            downloading: true
        });
        projectFormApi.downloadFinishedXlsx(formId, taskId).then((xlsxBlob)=>{
            const downloadLink = window.document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(xlsxBlob);
            downloadLink.setAttribute('download', filename);
            window.document.body.appendChild(downloadLink);
            downloadLink.click();
            window.document.body.removeChild(downloadLink);
            setState({
                downloading: false,
                successful: true
            });
        }).catch(()=>{
            errorUtils.reportError(new Error('The XLSX download task failed while downloading.'));
            setState({
                error: true
            });
        });
    };

});

parcelRegister("gpOkP", function(module, exports) {

$parcel$export(module.exports, "FormActions", () => $bf3606a1233f3cb4$export$9494d5a5e5299081);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $7u4fN = parcelRequire("7u4fN");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $f86rB = parcelRequire("f86rB");

var $6Wxq8 = parcelRequire("6Wxq8");

var $5k4ch = parcelRequire("5k4ch");

var $jG1wZ = parcelRequire("jG1wZ");

var $3MV1G = parcelRequire("3MV1G");

var $iRFLU = parcelRequire("iRFLU");


var $ebI2v = parcelRequire("ebI2v");

var $3XpT1 = parcelRequire("3XpT1");

var $glcjW = parcelRequire("glcjW");

var $25KqE = parcelRequire("25KqE");

var $64fao = parcelRequire("64fao");

var $74Bzd = parcelRequire("74Bzd");

var $ie2PP = parcelRequire("ie2PP");
const $bf3606a1233f3cb4$export$9494d5a5e5299081 = ({ projectType: projectType, simplifiedProject: simplifiedProject, userIsProjectAdmin: userIsProjectAdmin, form: form, projectKey: projectKey, issueFormsInfo: issueFormsInfo })=>{
    const [{ error: error, filename: filename, formId: formId, serverProgress: serverProgress, successful: successful }, { clear: clear, start: start }] = (0, $ebI2v.useExportController)();
    const { showFlag: showFlag } = (0, $f86rB.useFlags)();
    const { push: push } = (0, $lB25E.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [showCopyFormModal, setShowCopyFormModal] = (0, $eUqFw.useState)(false);
    const [showDeleteFormModal, setShowDeleteFormModal] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const issueFormInfo = issueFormsInfo === null || issueFormsInfo === void 0 ? void 0 : issueFormsInfo.filter((f)=>f.projectFormId === form.id);
    (0, $eUqFw.useEffect)(()=>{
        let icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Wxq8))), {
            label: ""
        });
        let title;
        let description;
        if (error) {
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
                label: "",
                primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`
            });
            title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $74Bzd.messages).downloadFlagErrorTitle, {
                values: {
                    filename: filename
                }
            }));
            description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $74Bzd.messages).downloadFlagErrorDescription);
            clear();
        } else if (successful) {
            title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $74Bzd.messages).downloadFlagCompleteTitle, {
                values: {
                    filename: filename
                }
            }));
            clear();
        } else if (serverProgress !== undefined) {
            title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $74Bzd.messages).downloadFlagTitle, {
                values: {
                    filename: filename
                }
            }));
            description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iRFLU.default), {
                value: serverProgress / 100
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ie2PP.FlagParagraph), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $74Bzd.messages).downloadFlagPercentComplete, {
                values: {
                    percentCount: serverProgress
                }
            }))));
        }
        if (title !== undefined) showFlag({
            id: `export-${formId}`,
            icon: icon,
            title: title,
            description: description
        });
    }, [
        clear,
        error,
        filename,
        formId,
        serverProgress,
        showFlag,
        successful
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: ({ ...providedProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), (0, $kU09D.default)({}, providedProps, {
                appearance: "subtle",
                id: `more_actions${form.id}`,
                "aria-labelledby": `more_actions${form.id} ${form.name.replace(/\s+/g, '')}-${form.id}`,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: formatMessage((0, $74Bzd.messages).moreActions)
                }),
                onClick: ()=>setIsOpen(!isOpen)
            })),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                onClick: ()=>push(form.editUrl)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $74Bzd.messages).edit)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $64fao.DuplicateFormAction), {
                form: form
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3XpT1.CopyDirectLink), {
                projectType: projectType,
                projectKey: projectKey,
                simplifiedProject: simplifiedProject,
                issueFormInfo: issueFormInfo,
                onCloseParent: ()=>setIsOpen(false)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                onClick: ()=>setShowCopyFormModal(true)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $74Bzd.messages).copyLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                onClick: ()=>setShowDeleteFormModal(true)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $74Bzd.messages).deleteLabel)), userIsProjectAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                isDisabled: formId !== undefined,
                onClick: ()=>start(form)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $74Bzd.messages).exportInXlsx)))
    }), showCopyFormModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $glcjW.CopyProjectFormModal), {
        onClose: ()=>setShowCopyFormModal(false),
        formToCopy: form
    }), showDeleteFormModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $25KqE.DeleteProjectFormModal), {
        isServiceProject: projectType === 'service_desk',
        form: form,
        onClose: ()=>setShowDeleteFormModal(false)
    }));
};

});
parcelRegister("6Wxq8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $50e215742d0d2558$var$_react = $50e215742d0d2558$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50e215742d0d2558$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50e215742d0d2558$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $50e215742d0d2558$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22A06B" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5H6.93z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$50e215742d0d2558$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $50e215742d0d2558$var$_default = $50e215742d0d2558$var$ExcelSpreadsheet24Icon;
module.exports.default = $50e215742d0d2558$var$_default;

});

parcelRegister("5k4ch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e02137160dfc264$var$_react = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $3e02137160dfc264$var$_crossCircle = $3e02137160dfc264$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $3e02137160dfc264$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e02137160dfc264$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $3e02137160dfc264$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $3e02137160dfc264$var$_crossCircle.default
    }));
$3e02137160dfc264$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $3e02137160dfc264$var$_default = module.exports.default = $3e02137160dfc264$var$CrossCircleIcon;

});
parcelRegister("hsyGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb5ff45e92d98b0f$var$_react = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cb5ff45e92d98b0f$var$_UNSAFE_baseNew = $cb5ff45e92d98b0f$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $cb5ff45e92d98b0f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb5ff45e92d98b0f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $cb5ff45e92d98b0f$var$_react.default.createElement($cb5ff45e92d98b0f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$cb5ff45e92d98b0f$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $cb5ff45e92d98b0f$var$_default = module.exports.default = $cb5ff45e92d98b0f$var$CrossCircleIcon;

});


parcelRegister("iRFLU", function(module, exports) {

$parcel$export(module.exports, "default", () => $741f3f691e937b15$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

function $741f3f691e937b15$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $741f3f691e937b15$var$MIN_VALUE = 0;
const $741f3f691e937b15$var$MAX_VALUE = 1;
const $741f3f691e937b15$var$increasingBarAnimation = (0, $byn9U.keyframes)({
    from: {
        left: '-5%',
        width: '5%'
    },
    to: {
        left: '130%',
        width: ' 100%'
    }
});
const $741f3f691e937b15$var$decreasingBarAnimation = (0, $byn9U.keyframes)({
    from: {
        left: '-80%',
        width: '80%'
    },
    to: {
        left: '110%',
        width: '10%'
    }
});
const $741f3f691e937b15$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: `100%`,
    height: 6,
    position: 'relative',
    background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    overflow: 'hidden'
});
const $741f3f691e937b15$var$containerAppearance = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }),
    success: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral, ${(0, $73a5c9d720aa66e1$export$46987b49aab6d1a8)})`
    }),
    inverse: {
        name: "17q4nu8",
        styles: "background:var(--ds-background-inverse-subtle, rgba(255, 255, 255, 0.5))"
    }
};
const $741f3f691e937b15$var$barAppearance = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-neutral-bold, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`
    }),
    success: /*#__PURE__*/ (0, $byn9U.css)({
        background: `var(--ds-background-success-bold, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
    }),
    inverse: {
        name: "1n6cgt8",
        styles: "background:var(--ds-surface, white)"
    }
};
const $741f3f691e937b15$var$barStyles = {
    name: "np1q02",
    styles: "display:block;height:6px;position:absolute;border-radius:var(--ds-border-radius, 3px)"
};
const $741f3f691e937b15$var$determinateBarStyles = {
    name: "1nxgqyg",
    styles: "transition:width 0.2s"
};
const $741f3f691e937b15$var$increasingBarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$741f3f691e937b15$var$increasingBarAnimation} 2s infinite`
});
const $741f3f691e937b15$var$decreasingBarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    animation: `${$741f3f691e937b15$var$decreasingBarAnimation} 2s 0.5s infinite`
});
/**
 * __Progress bar__
 *
 * A progress bar displays the status of a given process.
 *
 * - [Examples](https://atlassian.design/components/progress-bar/examples)
 * - [Code](https://atlassian.design/components/progress-bar/code)
 * - [Usage](https://atlassian.design/components/progress-bar/usage)
 */ const $741f3f691e937b15$var$ProgressBar = ({ appearance: appearance = 'default', ariaLabel: ariaLabel, isIndeterminate: isIndeterminate = false, testId: testId = 'progress-bar', value: value = 0 })=>{
    const valueParsed = isIndeterminate ? $741f3f691e937b15$var$MIN_VALUE : Math.max($741f3f691e937b15$var$MIN_VALUE, Math.min(value, $741f3f691e937b15$var$MAX_VALUE));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $741f3f691e937b15$var$containerStyles,
            $741f3f691e937b15$var$containerAppearance[appearance]
        ],
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $741f3f691e937b15$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $741f3f691e937b15$var$MAX_VALUE,
        tabIndex: 0,
        "data-testid": testId
    }, isIndeterminate ? /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$increasingBarStyles
        ]
    }), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$decreasingBarStyles
        ]
    })) : /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: {
            width: `${Number(value) * 100}%`
        },
        css: [
            $741f3f691e937b15$var$barStyles,
            $741f3f691e937b15$var$barAppearance[appearance],
            $741f3f691e937b15$var$determinateBarStyles
        ]
    }));
};
var $741f3f691e937b15$export$2e2bcd8739ae039 = $741f3f691e937b15$var$ProgressBar;

});

parcelRegister("3XpT1", function(module, exports) {

$parcel$export(module.exports, "CopyDirectLink", () => $2e1af65100ebdd77$export$849f21ba228a66a);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $dtaN9 = parcelRequire("dtaN9");

var $bULPy = parcelRequire("bULPy");

var $cOZFa = parcelRequire("cOZFa");

var $dWaLU = parcelRequire("dWaLU");
const $2e1af65100ebdd77$export$849f21ba228a66a = ({ projectType: projectType, projectKey: projectKey, simplifiedProject: simplifiedProject, issueFormInfo: issueFormInfo, onCloseParent: onCloseParent })=>{
    const intl = (0, $5JgJ2.default)();
    if (!issueFormInfo || (issueFormInfo === null || issueFormInfo === void 0 ? void 0 : issueFormInfo.length) === 0) return null;
    const handleClick = (info)=>()=>{
            const url = `${window.location.origin}/jira/${(0, $dWaLU.getProjectTypeURLString)(projectType, simplifiedProject)}/projects/${projectKey}/forms/form/direct/${info.projectFormId}/${info.issueType.id}${info.requestType ? `?requestTypeId=${info.requestType.id}` : ''}`;
            (0, $dWaLU.copyToClipboard)(url);
            onCloseParent();
        };
    if (issueFormInfo.length === 1) {
        const rt = issueFormInfo[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            onClick: handleClick(rt)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cOZFa.messages).copyDirectLinkLabel));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "right-start",
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), (0, $kU09D.default)({}, triggerProps, {
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
                    label: ""
                })
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $cOZFa.messages).copyDirectLinkLabel))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        title: intl.formatMessage(projectType === 'service_desk' ? (0, $cOZFa.messages).requestTypesHeader : (0, $cOZFa.messages).issueTypesHeader)
    }, issueFormInfo.map((info)=>{
        var _info$requestType;
        const rt = (_info$requestType = info.requestType) !== null && _info$requestType !== void 0 ? _info$requestType : info.issueType;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            key: rt.id,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
                src: rt.icon,
                alt: ""
            }),
            onClick: handleClick(info)
        }, rt.name);
    })));
};

});
parcelRegister("cOZFa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9559fc8327f06c9a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9559fc8327f06c9a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    copyDirectLinkLabel: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.copyDirectLinkLabel',
        defaultMessage: 'Copy direct link',
        description: 'Label for a menu item that copies a link to issue forms direct for the selected form to the clipboard.'
    },
    requestTypesHeader: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.requestTypesHeader',
        defaultMessage: 'Request type',
        description: 'Header for the submenu containing a list of request types to select, in JSM projects.'
    },
    issueTypesHeader: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-direct-link.issueTypesHeader',
        defaultMessage: 'Issue type',
        description: 'Header for the submenu containing a list of request types to select, in non-JSM projects.'
    }
});

});

parcelRegister("dWaLU", function(module, exports) {

$parcel$export(module.exports, "copyToClipboard", () => $a2590c2bfba773b3$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "getProjectTypeURLString", () => $a2590c2bfba773b3$export$1671a9efc8e29ec4);
const $a2590c2bfba773b3$export$2cdf1b96a9f86d16 = (text)=>{
    if (window.navigator.clipboard) return window.navigator.clipboard.writeText(text);
    // Fallback logic for older browsers
    return new Promise((resolve)=>{
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        resolve();
    });
};
const $a2590c2bfba773b3$export$1671a9efc8e29ec4 = (projectType, simplifiedProject)=>{
    switch(projectType){
        case 'business':
            return 'core';
        case 'service_desk':
            return 'servicedesk';
        case 'software':
            return simplifiedProject ? 'software' : 'software/c';
        default:
            // should never happen, typescript use your typechecking brain pls
            return '';
    }
};

});


parcelRegister("glcjW", function(module, exports) {

$parcel$export(module.exports, "CopyProjectFormModal", () => $be582a1bba70d282$export$c47b7672f932f38a);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $8uD7Y = parcelRequire("8uD7Y");

var $iJlfe = parcelRequire("iJlfe");

var $7u4fN = parcelRequire("7u4fN");

var $bT7k5 = parcelRequire("bT7k5");

var $f86rB = parcelRequire("f86rB");

var $cSu9v = parcelRequire("cSu9v");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $eQ9kk = parcelRequire("eQ9kk");

var $lSi60 = parcelRequire("lSi60");

var $bu1Yj = parcelRequire("bu1Yj");

var $i7vgA = parcelRequire("i7vgA");

var $kCDeN = parcelRequire("kCDeN");

var $lPek2 = parcelRequire("lPek2");

var $3KzVr = parcelRequire("3KzVr");

var $74PUT = parcelRequire("74PUT");
const $be582a1bba70d282$export$c47b7672f932f38a = ({ onClose: onClose, formToCopy: formToCopy })=>{
    const { showFlag: showFlag } = (0, $f86rB.useFlags)();
    const { simplifiedProject: simplifiedProject, onOpenInProductHelpArticle: onOpenInProductHelpArticle } = (0, $lSi60.useInProductHelp)();
    const projectApi = (0, $i7vgA.useProjectApi)();
    const [, { load: load }] = (0, $bu1Yj.useProjectFormsControllerActions)();
    const templateFormApi = (0, $kCDeN.useTemplateFormApi)();
    const [projects, setProjects] = (0, $eUqFw.useState)([]);
    const [isLoadingProjects, setIsLoadingProjects] = (0, $eUqFw.useState)(true);
    const handleCopy = ()=>(0, $74PUT.onCopyClick)(formToCopy, projects, templateFormApi, showFlag, load, onClose);
    (0, $eUqFw.useEffect)(()=>{
        projectApi.getAllProjects().then((newProjects)=>{
            const projectsWithSelectedState = newProjects.sort((projectA, projectB)=>// The current project should be listed first:
                projectA.id === formToCopy.projectId ? -1 : projectB.id === formToCopy.projectId ? 1 : projectA.name.localeCompare(projectB.name)).map((project)=>({
                    ...project,
                    selected: false
                }));
            setProjects(projectsWithSelectedState);
            setIsLoadingProjects(false);
        });
    }, [
        formToCopy.projectId,
        projectApi
    ]);
    const handleSelectProject = (projectId)=>{
        const newProjects = [
            ...projects
        ];
        const projectIndex = newProjects.findIndex((project)=>project.id === projectId);
        if (projectIndex !== -1) newProjects[projectIndex].selected = !newProjects[projectIndex].selected;
        setProjects(newProjects);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.ModalTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).heading, {
        values: {
            formName: formToCopy.name
        }
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lPek2.messages).subHeading), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: ()=>onOpenInProductHelpArticle(simplifiedProject ? '2UpZYTmtNjy287pvVmqg8Z' : '4lpdE2uEWCBRuduqNGgLLs')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lPek2.messages).learnMore))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.Divider), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.PanelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.LeftPanel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be582a1bba70d282$var$PanelTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lPek2.messages).name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.FormNameContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formToCopy.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: "Right arrow icon"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.RightPanel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be582a1bba70d282$var$PanelTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lPek2.messages).copyToProjectsTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.ProjectsContainer), null, isLoadingProjects ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eQ9kk.LoadingSpinner), {
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lPek2.messages).loadingProjects)) : projects.map((project)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
            value: project.id,
            size: "large",
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.ProjectLabelContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
                appearance: "square",
                size: "small",
                src: project.smallAvatarUrl,
                name: project.name
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.ProjectNameContainer), null, project.name)),
            isChecked: project.selected,
            onChange: ()=>handleSelectProject(project.id),
            name: project.name
        }))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3KzVr.Divider), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lPek2.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: handleCopy
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lPek2.messages).copy))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $be582a1bba70d282$var$PanelTitle = (0, $exJuA.default).h2({
    fontSize: "var(--ds-font-body, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    paddingTop: "var(--ds-space-200, 16px)"
});

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");


var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $73a5c9d720aa66e1$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $73a5c9d720aa66e1$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $73a5c9d720aa66e1$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $73a5c9d720aa66e1$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $73a5c9d720aa66e1$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $73a5c9d720aa66e1$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $73a5c9d720aa66e1$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $9601eacac1d33448$var$_arrowRight = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("gTPnA")));
function $9601eacac1d33448$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $9601eacac1d33448$var$_arrowRight.default
    }));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = module.exports.default = $9601eacac1d33448$var$ArrowRightIcon;

});
parcelRegister("gTPnA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a0af1361c1c47b464cd1f3e8c2b50c2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4d9a34bffd519bc$var$_react = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c4d9a34bffd519bc$var$_UNSAFE_baseNew = $c4d9a34bffd519bc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c4d9a34bffd519bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c4d9a34bffd519bc$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c4d9a34bffd519bc$var$_react.default.createElement($c4d9a34bffd519bc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
    }, props));
$c4d9a34bffd519bc$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c4d9a34bffd519bc$var$_default = module.exports.default = $c4d9a34bffd519bc$var$ArrowRightIcon;

});


parcelRegister("lPek2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fe3978762518f86b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $fe3978762518f86b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    cancel: {
        id: 'jira-common.ListProjectForms.CopyModal.Cancel',
        defaultMessage: 'Cancel',
        description: 'Title of a Modal button for cancellation an action to copy a form between projects'
    },
    copy: {
        id: 'jira-common.ListProjectForms.CopyModal.Copy',
        defaultMessage: 'Copy',
        description: 'Title of a Modal button for starting the copy of a form between projects'
    },
    copyErrorTitle: {
        id: 'jira-common.ListProjectForms.CopyFormErrorTitle',
        defaultMessage: "Error: Could not copy \u201C{formName}\u201D over",
        description: 'Title displayed when an error occurred when trying to copy a form over to one or more projects.'
    },
    copySuccessBusinessProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfBusinessProjectsMessage}.",
        description: 'Flag description displayed when a form has been successfully copied to business projects.'
    },
    copySuccessBusinessProjectsTitle: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessBusinessProjectsTitle',
        defaultMessage: 'Form copied to {numberOfBusinessProjects, plural, one {business project} other {# business projects}}',
        description: 'Flag title displayed when a form has been successfully copied to business projects.'
    },
    copySuccessMultipleProjectTypesTitle: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessMultipleProjectTypesTitle',
        defaultMessage: 'Form copied to {numberOfProjects, plural, one {# project} other {# projects}}',
        description: 'Flag title displayed when a form has been successfully copied to multiple project types.'
    },
    copySuccessOneProjectDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessOneProjectDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in \u201C{projectName}\u201D.",
        description: 'Flag description displayed when a form has been successfully copied to one project.'
    },
    copySuccessServiceAndBusinessProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessServiceAndBusinessProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        description: 'Flag description displayed when a form has been successfully copied to service and business projects.'
    },
    copySuccessServiceAndSoftwareProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessServiceAndSoftwareProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage} and {numberOfSoftwareProjectsMessage}.",
        description: 'Flag description displayed when a form has been successfully copied to service and software projects.'
    },
    copySuccessServiceProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}.",
        description: 'Flag description displayed when a form has been successfully copied to service projects.'
    },
    copySuccessServiceProjectsTitle: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessServiceProjectsTitle',
        defaultMessage: 'Form copied to {numberOfServiceProjects, plural, one {service project} other {# service projects}}',
        description: 'Flag title displayed when a form has been successfully copied to service projects.'
    },
    copySuccessServiceSoftwareAndBusinessProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessServiceSoftwareAndBusinessProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfServiceProjectsMessage}, {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        description: 'Flag description displayed when a form has been successfully copied to service, software and business projects.'
    },
    copySuccessSoftwareAndBusinessProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareAndBusinessProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage} and {numberOfBusinessProjectsMessage}.",
        description: 'Flag description displayed when a form has been successfully copied to software and business projects.'
    },
    copySuccessSoftwareProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfSoftwareProjectsMessage}.",
        description: 'Flag description displayed when a form has been successfully copied to software projects.'
    },
    copySuccessSoftwareProjectsTitle: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessSoftwareProjectsTitle',
        defaultMessage: 'Form copied to {numberOfSoftwareProjects, plural, one {software project} other {# software projects}}',
        description: 'Flag title displayed when a form has been successfully copied to software projects.'
    },
    copySuccessUnrecognisedProjectsDescription: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsDescription',
        defaultMessage: "\u201C{formName}\u201D can now be used in {numberOfProjects, plural, one {# project} other {# projects}}.",
        description: 'Flag description displayed when a form has been successfully copied to projects, and at least one project type was not recognised.'
    },
    copySuccessUnrecognisedProjectsTitle: {
        id: 'jira-common.ListProjectForms.CopyFormSuccessUnrecognisedProjectsTitle',
        defaultMessage: 'Form copied to {numberOfProjects, plural, one {project} other {# projects}}',
        description: 'Flag title displayed when a form has been successfully copied to projects, and at least one project type was not recognised.'
    },
    copyToProjectsTitle: {
        id: 'jira-common.ListProjectForms.CopyModal.CopyToProjectsTitle',
        defaultMessage: 'Copy to project(s)',
        description: 'Title of a heading above the name of the projects where the form can be copied to'
    },
    heading: {
        id: 'jira-common.ListProjectForms.CopyModal.Heading',
        defaultMessage: "Copy \u201C{formName}\u201D to other projects",
        description: 'Heading for a modal to copy a form between projects'
    },
    learnMore: {
        id: 'jira-common.ListProjectForms.CopyModal.LearnMore',
        defaultMessage: 'Learn more about copying forms',
        description: 'Title of a link button to trigger in app help about copying forms'
    },
    loadingProjects: {
        id: 'jira-common.ListProjectForms.CopyModal.LoadingProjects',
        defaultMessage: 'Loading projects',
        description: 'Message to display while the list of projects are being loaded'
    },
    name: {
        id: 'jira-common.ListProjectForms.CopyModal.Name',
        defaultMessage: 'Name',
        description: 'Title of a heading above the name of the form chosen to be copied between projects'
    },
    numberOfBusinessProjects: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-business-projects',
        defaultMessage: '{numberOfBusinessProjects, plural, one {# business project} other {# business projects}}',
        description: 'The number of business projects copied to. Only concatenated within forms copied to projects messages.'
    },
    numberOfServiceProjects: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-service-projects',
        defaultMessage: '{numberOfServiceProjects, plural, one {# service project} other {# service projects}}',
        description: 'The number of service projects copied to. Only concatenated within forms copied to projects messages.'
    },
    numberOfSoftwareProjects: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.form-actions.copy-project-form-modal.number-of-software-projects',
        defaultMessage: '{numberOfSoftwareProjects, plural, one {# software project} other {# software projects}}',
        description: 'The number of software projects copied to. Only concatenated within forms copied to projects messages.'
    },
    selectAllProjects: {
        id: 'jira-common.ListProjectForms.CopyModal.SelectAllProjects',
        defaultMessage: 'Select all projects',
        description: 'Description for a checkbox to allow all projects in a list to be selected'
    },
    subHeading: {
        id: 'jira-common.ListProjectForms.CopyModal.SubHeading',
        defaultMessage: 'Changes made to a form are not reflected across any of its copies in other projects.',
        description: 'Subheading for a modal for copying a form between projects'
    }
});

});

parcelRegister("3KzVr", function(module, exports) {

$parcel$export(module.exports, "Divider", () => $2bb18904bf5a3163$export$2e0a83ec2e27ecbb);
$parcel$export(module.exports, "FormNameContainer", () => $2bb18904bf5a3163$export$8da3ed372522c458);
$parcel$export(module.exports, "LeftPanel", () => $2bb18904bf5a3163$export$110709f040143804);
$parcel$export(module.exports, "ModalTitleContainer", () => $2bb18904bf5a3163$export$8bbe98d958a85a9d);
$parcel$export(module.exports, "PanelContainer", () => $2bb18904bf5a3163$export$7c4d2b536147788a);
$parcel$export(module.exports, "RightPanel", () => $2bb18904bf5a3163$export$364a989a35814102);
$parcel$export(module.exports, "ProjectLabelContainer", () => $2bb18904bf5a3163$export$ab41bd356b0897d4);
$parcel$export(module.exports, "ProjectNameContainer", () => $2bb18904bf5a3163$export$3244ac263792ccd);
$parcel$export(module.exports, "ProjectsContainer", () => $2bb18904bf5a3163$export$99e3a663fb5d4ea4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");

const $2bb18904bf5a3163$export$2e0a83ec2e27ecbb = (0, $exJuA.default).hr({
    borderStyle: 'none',
    backgroundColor: `var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`,
    margin: 0
});
const $2bb18904bf5a3163$export$8da3ed372522c458 = (0, $exJuA.default).div({
    marginTop: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-200, 16px)",
    display: 'flex',
    justifyContent: 'space-between'
});
const $2bb18904bf5a3163$export$110709f040143804 = (0, $exJuA.default).div({
    flexBasis: '100%'
});
const $2bb18904bf5a3163$export$8bbe98d958a85a9d = (0, $exJuA.default).span({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'h1, h1 > span': {
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1
    }
});
const $2bb18904bf5a3163$export$7c4d2b536147788a = (0, $exJuA.default).div({
    display: 'flex',
    margin: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-0, 0px)"}`
});
const $2bb18904bf5a3163$export$364a989a35814102 = (0, $exJuA.default).div({
    flexBasis: '100%'
});
const $2bb18904bf5a3163$export$ab41bd356b0897d4 = (0, $exJuA.default).div({
    display: 'flex',
    alignItems: 'center'
});
const $2bb18904bf5a3163$export$3244ac263792ccd = (0, $exJuA.default).div({
    marginLeft: "var(--ds-space-100, 8px)"
});
const $2bb18904bf5a3163$export$99e3a663fb5d4ea4 = (0, $exJuA.default).div({
    marginTop: "var(--ds-space-100, 8px)"
});

});

parcelRegister("74PUT", function(module, exports) {

$parcel$export(module.exports, "onCopyClick", () => $52712dae7ca407ec$export$fc213dc576da1b1c);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $exJuA = parcelRequire("exJuA");

var $8uD7Y = parcelRequire("8uD7Y");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");


var $lPek2 = parcelRequire("lPek2");
const $52712dae7ca407ec$export$fc213dc576da1b1c = (formToCopy, projects, templateFormApi, showFlag, reloadProjectForms, onClose)=>{
    const projectsToCopyTo = projects.filter((project)=>project.selected);
    const promises = [];
    const projectsSucceeded = [];
    const projectsFailed = [];
    projectsToCopyTo.forEach((project)=>{
        promises.push(templateFormApi.copyTemplateForm(formToCopy.id, project.id, // project ID to copy the form to
        formToCopy.projectId, // project ID to copy the form from
        formToCopy.name).then(()=>{
            projectsSucceeded.push(project);
        }).catch(()=>{
            projectsFailed.push(project);
        }));
    });
    Promise.all(promises).finally(()=>{
        const formName = formToCopy.name;
        if (projectsFailed.length > 0) showFlag({
            appearance: 'error',
            id: 'copy-form-error-flag',
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: "error",
                secondaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52712dae7ca407ec$var$FlagHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).copyErrorTitle, {
                values: {
                    formName: formName
                }
            }))),
            isAutoDismiss: true
        });
        if (projectsSucceeded.length > 0) {
            const numberOfProjects = projectsSucceeded.length;
            if (numberOfProjects < 1) return; // Theoretically, not possible.
            const serviceProjects = projectsSucceeded.filter((project)=>project.projectTypeKey === 'service_desk');
            const numberOfServiceProjects = serviceProjects.length;
            const softwareProjects = projectsSucceeded.filter((project)=>project.projectTypeKey === 'software');
            const numberOfSoftwareProjects = softwareProjects.length;
            const businessProjects = projectsSucceeded.filter((project)=>project.projectTypeKey === 'business');
            const numberOfBusinessProjects = businessProjects.length;
            let titleMessage;
            let titleValues;
            let descriptionMessage;
            let descriptionValues;
            if (numberOfProjects !== numberOfServiceProjects + numberOfSoftwareProjects + numberOfBusinessProjects) {
                // There is at least one project with an unrecognised type.
                if (numberOfProjects > 1) {
                    titleMessage = (0, $lPek2.messages).copySuccessUnrecognisedProjectsTitle;
                    titleValues = {
                        numberOfProjects: numberOfProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessUnrecognisedProjectsDescription;
                    descriptionValues = {
                        formName: formName,
                        numberOfProjects: numberOfProjects
                    };
                } else {
                    // numberOfProjects === 1
                    titleMessage = (0, $lPek2.messages).copySuccessUnrecognisedProjectsTitle;
                    titleValues = {
                        numberOfProjects: numberOfProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessOneProjectDescription;
                    descriptionValues = {
                        formName: formName,
                        projectName: projectsSucceeded[0].name
                    };
                }
            } else if (numberOfServiceProjects > 0) {
                if (numberOfSoftwareProjects > 0) {
                    if (numberOfBusinessProjects > 0) {
                        titleMessage = (0, $lPek2.messages).copySuccessMultipleProjectTypesTitle;
                        titleValues = {
                            numberOfProjects: numberOfProjects
                        };
                        descriptionMessage = (0, $lPek2.messages).copySuccessServiceSoftwareAndBusinessProjectsDescription;
                        descriptionValues = {
                            formName: formName,
                            numberOfServiceProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfServiceProjects, {
                                values: {
                                    numberOfServiceProjects: numberOfServiceProjects
                                }
                            })),
                            numberOfSoftwareProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfSoftwareProjects, {
                                values: {
                                    numberOfSoftwareProjects: numberOfSoftwareProjects
                                }
                            })),
                            numberOfBusinessProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfBusinessProjects, {
                                values: {
                                    numberOfBusinessProjects: numberOfBusinessProjects
                                }
                            }))
                        };
                    } else {
                        titleMessage = (0, $lPek2.messages).copySuccessMultipleProjectTypesTitle;
                        titleValues = {
                            numberOfProjects: numberOfProjects
                        };
                        descriptionMessage = (0, $lPek2.messages).copySuccessServiceAndSoftwareProjectsDescription;
                        descriptionValues = {
                            formName: formName,
                            numberOfServiceProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfServiceProjects, {
                                values: {
                                    numberOfServiceProjects: numberOfServiceProjects
                                }
                            })),
                            numberOfSoftwareProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfSoftwareProjects, {
                                values: {
                                    numberOfSoftwareProjects: numberOfSoftwareProjects
                                }
                            }))
                        };
                    }
                } else if (numberOfBusinessProjects > 0) {
                    titleMessage = (0, $lPek2.messages).copySuccessMultipleProjectTypesTitle;
                    titleValues = {
                        numberOfProjects: numberOfProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessServiceAndBusinessProjectsDescription;
                    descriptionValues = {
                        formName: formName,
                        numberOfServiceProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfServiceProjects, {
                            values: {
                                numberOfServiceProjects: numberOfServiceProjects
                            }
                        })),
                        numberOfBusinessProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfBusinessProjects, {
                            values: {
                                numberOfBusinessProjects: numberOfBusinessProjects
                            }
                        }))
                    };
                } else if (numberOfServiceProjects > 1) {
                    titleMessage = (0, $lPek2.messages).copySuccessServiceProjectsTitle;
                    titleValues = {
                        numberOfServiceProjects: numberOfServiceProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessServiceProjectsDescription;
                    descriptionValues = {
                        formName: formName,
                        numberOfServiceProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfServiceProjects, {
                            values: {
                                numberOfServiceProjects: numberOfServiceProjects
                            }
                        }))
                    };
                } else {
                    // numberOfServiceProjects === 1
                    titleMessage = (0, $lPek2.messages).copySuccessServiceProjectsTitle;
                    titleValues = {
                        numberOfServiceProjects: numberOfServiceProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessOneProjectDescription;
                    descriptionValues = {
                        formName: formName,
                        projectName: serviceProjects[0].name
                    };
                }
            } else if (numberOfSoftwareProjects > 0) {
                if (numberOfBusinessProjects > 0) {
                    titleMessage = (0, $lPek2.messages).copySuccessMultipleProjectTypesTitle;
                    titleValues = {
                        numberOfProjects: numberOfProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessSoftwareAndBusinessProjectsDescription;
                    descriptionValues = {
                        formName: formName,
                        numberOfSoftwareProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfSoftwareProjects, {
                            values: {
                                numberOfSoftwareProjects: numberOfSoftwareProjects
                            }
                        })),
                        numberOfBusinessProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfBusinessProjects, {
                            values: {
                                numberOfBusinessProjects: numberOfBusinessProjects
                            }
                        }))
                    };
                } else if (numberOfSoftwareProjects > 1) {
                    titleMessage = (0, $lPek2.messages).copySuccessSoftwareProjectsTitle;
                    titleValues = {
                        numberOfSoftwareProjects: numberOfSoftwareProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessSoftwareProjectsDescription;
                    descriptionValues = {
                        formName: formName,
                        numberOfSoftwareProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfSoftwareProjects, {
                            values: {
                                numberOfSoftwareProjects: numberOfSoftwareProjects
                            }
                        }))
                    };
                } else {
                    // numberOfSoftwareProjects === 1
                    titleMessage = (0, $lPek2.messages).copySuccessSoftwareProjectsTitle;
                    titleValues = {
                        numberOfSoftwareProjects: numberOfSoftwareProjects
                    };
                    descriptionMessage = (0, $lPek2.messages).copySuccessOneProjectDescription;
                    descriptionValues = {
                        formName: formName,
                        projectName: softwareProjects[0].name
                    };
                }
            } else if (numberOfBusinessProjects > 1) {
                titleMessage = (0, $lPek2.messages).copySuccessBusinessProjectsTitle;
                titleValues = {
                    numberOfBusinessProjects: numberOfBusinessProjects
                };
                descriptionMessage = (0, $lPek2.messages).copySuccessBusinessProjectsDescription;
                descriptionValues = {
                    formName: formName,
                    numberOfBusinessProjectsMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $lPek2.messages).numberOfBusinessProjects, {
                        values: {
                            numberOfBusinessProjects: numberOfBusinessProjects
                        }
                    }))
                };
            } else {
                // numberOfBusinessProjects === 1
                titleMessage = (0, $lPek2.messages).copySuccessBusinessProjectsTitle;
                titleValues = {
                    numberOfBusinessProjects: numberOfBusinessProjects
                };
                descriptionMessage = (0, $lPek2.messages).copySuccessOneProjectDescription;
                descriptionValues = {
                    formName: formName,
                    projectName: businessProjects[0].name
                };
            }
            showFlag({
                id: 'copy-form-success-flag',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
                    label: "Success",
                    primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($52712dae7ca407ec$var$FlagHeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, titleMessage, {
                    values: titleValues
                }))),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, descriptionMessage, {
                    values: descriptionValues
                })),
                isAutoDismiss: true
            });
            if (projectsSucceeded.some((project)=>project.id === formToCopy.projectId)) reloadProjectForms();
        }
        onClose();
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $52712dae7ca407ec$var$FlagHeading = (0, $exJuA.default).h2({
    color: "var(--ds-text-subtle, #42526E)",
    fontSize: "var(--ds-font-body, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    lineHeight: "var(--ds-space-250, 20px)",
    letterSpacing: 'normal'
});

});


parcelRegister("25KqE", function(module, exports) {

$parcel$export(module.exports, "DeleteProjectFormModal", () => $1860102f115a604a$export$c0729566c6762eb2);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $f86rB = parcelRequire("f86rB");

var $aWvIp = parcelRequire("aWvIp");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");


var $lSi60 = parcelRequire("lSi60");

var $7ODmA = parcelRequire("7ODmA");

var $8KsJV = parcelRequire("8KsJV");

var $bu1Yj = parcelRequire("bu1Yj");

var $aXZh9 = parcelRequire("aXZh9");

var $57zhX = parcelRequire("57zhX");

var $gLOic = parcelRequire("gLOic");
const $1860102f115a604a$export$c0729566c6762eb2 = ({ isServiceProject: isServiceProject, form: form, onClose: onClose })=>{
    const { showFlag: showFlag } = (0, $f86rB.useFlags)();
    const { onOpenInProductHelpArticle: onOpenInProductHelpArticle } = (0, $lSi60.useInProductHelp)();
    const [, { load: load }] = (0, $bu1Yj.useProjectFormsControllerActions)();
    const projectFormApi = (0, $aXZh9.useProjectFormApi)();
    const uniqueRequestTypes = Object.values((0, $8KsJV.groupRequestTypes)(form.requesttypes)).map(([firstRequestType])=>firstRequestType);
    const typeFilter = isServiceProject ? (t)=>t.type === (0, $7ODmA.TicketType).RequestType : (t)=>t.type === (0, $7ODmA.TicketType).IssueType;
    const types = uniqueRequestTypes.filter(typeFilter);
    const handleDeleteForm = ()=>{
        projectFormApi.deleteProjectForm(form.id).then(()=>{
            showFlag({
                id: 'delete-form-success-flag',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
                    label: "Success",
                    primaryColor: `var(--ds-icon-success, ${(0, $73a5c9d720aa66e1$export$940e1f69e873f202)})`
                }),
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $57zhX.messages).deleteFormSuccessFlagTitle, {
                    values: {
                        formName: form.name
                    }
                })),
                isAutoDismiss: true
            });
            load();
            onClose();
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLOic.ModalTitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $57zhX.messages).heading, {
        values: {
            formName: form.name
        }
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, uniqueRequestTypes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), isServiceProject ? (0, $57zhX.messages).willRemoveRequestTypesMsg : (0, $57zhX.messages).willRemoveIssueTypesMsg)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, types.map((requestType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: requestType.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLOic.RequestTypeSpan), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gLOic.RequestTypeIcon), {
            src: requestType.iconUrl
        }), requestType.name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), isServiceProject ? (0, $57zhX.messages).futureRequestMessage : (0, $57zhX.messages).futureIssueMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $57zhX.messages).affectExistingIssues), "\xA0", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: ()=>onOpenInProductHelpArticle('2WUi6sHHMAhNDpaw0seJlj')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $57zhX.messages).learnMoreLink)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "default",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $57zhX.messages).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "warning",
        onClick: handleDeleteForm
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $57zhX.messages).delete))));
};

});
parcelRegister("57zhX", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ba8facdd8ae2e8f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $3ba8facdd8ae2e8f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    heading: {
        id: 'jira-common.ListProjectForms.Heading',
        defaultMessage: "Delete \u201C{formName}\u201D?"
    },
    cancel: {
        id: 'jira-common.ListProjectForms.Cancel',
        defaultMessage: 'Cancel'
    },
    delete: {
        id: 'jira-common.ListProjectForms.Delete',
        defaultMessage: 'Delete'
    },
    deleteFormSuccessFlagTitle: {
        id: 'jira-common.ListProjectForms.DeleteFormSuccess',
        defaultMessage: "\u201C{formName}\u201D deleted",
        description: 'The title for the flag shown on successful deletion of a form.'
    },
    willRemoveRequestTypesMsg: {
        id: 'jira-common.ListProjectForms.WillRemoveRequestTypesMsg',
        defaultMessage: 'Deleting this form will remove it from the following request types: '
    },
    willRemoveIssueTypesMsg: {
        id: 'jira-common.ListProjectForms.WillRemoveIssueTypesMsg',
        defaultMessage: 'Deleting this form will remove it from the following issue types: '
    },
    futureIssueMessage: {
        id: 'jira-common.ListProjectForms.FutureIssueMessage',
        defaultMessage: 'Future issues created using these issue types will no longer include this form:'
    },
    futureRequestMessage: {
        id: 'jira-common.ListProjectForms.FutureRequestMessage',
        defaultMessage: 'Future requests created using these request types will no longer include this form.'
    },
    affectExistingIssues: {
        id: 'jira-common.ListProjectForms.AffectExistingIssues',
        defaultMessage: "This won\u2019t affect existing issues that already use this form, or any copies of this form in other projects."
    },
    learnMoreLink: {
        id: 'jira-common.ListProjectForms.LearnMoreLink',
        defaultMessage: 'Learn more about deleting forms.'
    }
});

});

parcelRegister("gLOic", function(module, exports) {

$parcel$export(module.exports, "ModalTitleContainer", () => $c3580c2b86a2d117$export$8bbe98d958a85a9d);
$parcel$export(module.exports, "RequestTypeIcon", () => $c3580c2b86a2d117$export$92ecfe5a3fa8d686);
$parcel$export(module.exports, "RequestTypeSpan", () => $c3580c2b86a2d117$export$f22353c96e1f6af6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");
const $c3580c2b86a2d117$export$8bbe98d958a85a9d = (0, $exJuA.default).span({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'h1, h1 > span': {
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: 1
    }
});
const $c3580c2b86a2d117$export$92ecfe5a3fa8d686 = (0, $exJuA.default).img({
    width: "var(--ds-space-200, 16px)",
    marginRight: "var(--ds-space-100, 8px)"
});
const $c3580c2b86a2d117$export$f22353c96e1f6af6 = (0, $exJuA.default).span({
    display: 'flex',
    alignItems: 'center'
});

});


parcelRegister("64fao", function(module, exports) {

$parcel$export(module.exports, "DuplicateFormAction", () => $46aee19625417505$export$3b7b2efb9ac38f5d);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $hD6GJ = parcelRequire("hD6GJ");

var $kCDeN = parcelRequire("kCDeN");

var $81iYw = parcelRequire("81iYw");
const $46aee19625417505$export$3b7b2efb9ac38f5d = ({ form: form })=>{
    const { push: push } = (0, $lB25E.useRouterActions)();
    const intl = (0, $5JgJ2.default)();
    const templateFormApi = (0, $kCDeN.useTemplateFormApi)();
    const handleDuplicateForm = (formToCopy)=>{
        templateFormApi.copyTemplateForm(formToCopy.id, form.projectId, form.projectId, // duplicating to same project
        intl.formatMessage((0, $81iYw.messages).copyNewFormName, {
            formName: formToCopy.name
        })).then((response)=>{
            push(response.nextUrl);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>handleDuplicateForm(form)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $81iYw.messages).duplicateLabel));
};

});
parcelRegister("81iYw", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5d6d22d127e1cd93$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $5d6d22d127e1cd93$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    copyNewFormName: {
        id: 'jira-common.ListProjectForms.CopyText',
        defaultMessage: '{formName} copy',
        description: 'Adds the word copy to a duplicated form title'
    },
    duplicateLabel: {
        id: 'jira-common.ListProjectForms.Duplicate',
        defaultMessage: 'Duplicate',
        description: 'Label for the dropdown menu item, which duplicates a form'
    }
});

});


parcelRegister("74Bzd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $52660c200c37cdd8$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $52660c200c37cdd8$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    copyLabel: {
        id: 'jira-common.ListProjectForms.Copy',
        defaultMessage: 'Copy to project',
        description: 'Label for a dropdown item, which pops a modal to copy a form between projects.'
    },
    deleteLabel: {
        id: 'jira-common.ListProjectForms.Delete',
        defaultMessage: 'Delete',
        description: 'Text for a modal dialog title when prompting the user to delete a form'
    },
    downloadFlagCompleteTitle: {
        id: 'jira-common.ListProjectForms.FormActions.DownloadFlagCompleteTitle',
        defaultMessage: "\u201C{filename}\u201D downloaded"
    },
    downloadFlagErrorDescription: {
        id: 'jira-common.ListProjectForms.FormActions.DownloadFlagErrorDescription',
        defaultMessage: 'Refresh the page and try again.'
    },
    downloadFlagErrorTitle: {
        id: 'jira-common.ListProjectForms.FormActions.DownloadFlagErrorTitle',
        defaultMessage: "\u201C{filename}\u201D not downloaded"
    },
    downloadFlagPercentComplete: {
        id: 'jira-common.ListProjectForms.FormActions.DownloadFlagPercentComplete',
        defaultMessage: '{percentCount, plural, one {# % complete} other {# % complete}}'
    },
    downloadFlagTitle: {
        id: 'jira-common.ListProjectForms.FormActions.DownloadFlagTitle',
        defaultMessage: "Downloading \u201C{filename}\u201D"
    },
    edit: {
        id: 'form-system.general.Edit',
        defaultMessage: 'Edit',
        description: 'Text for a button that links to an editor for project forms'
    },
    exportInXlsx: {
        id: 'jira-common.ListProjectForms.FormActions.ExportInXlsx',
        defaultMessage: 'Export in XLSX',
        description: 'Label for a link to export forms into an Excel spreadsheet'
    },
    moreActions: {
        id: 'jira-common.ListProjectForms.FormActions.MoreActions',
        defaultMessage: 'More actions',
        description: 'Label for the dropdown menu that contains additional actions for a form'
    }
});

});

parcelRegister("ie2PP", function(module, exports) {

$parcel$export(module.exports, "FlagParagraph", () => $d44bbbc281bf364c$export$5d9bee1f7be2adf6);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");
const $d44bbbc281bf364c$export$5d9bee1f7be2adf6 = (0, $exJuA.default).p({
    margin: '0.5em 0'
});

});


parcelRegister("sQtW8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $056b5370f971dcc0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $056b5370f971dcc0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueTypesColumnHeader: {
        id: 'jira-common.ListProjectForms.AssociatedIssueTypes',
        defaultMessage: 'Issue type',
        description: 'A table column heading showing issue types associated with a project form.'
    },
    lastUpdatedColumnHeader: {
        id: 'jira-common.ListProjectForms.LastUpdated',
        defaultMessage: 'Last updated',
        description: 'A table column heading for the timestamp for the last update of a project form.'
    },
    nameColumnHeader: {
        id: 'form-system.general.Form',
        defaultMessage: 'Name',
        description: 'The Name column header in the Project Forms list.'
    },
    requestTypesColumnHeader: {
        id: 'jira-common.ListProjectForms.AssociatedRequestTypes',
        defaultMessage: 'Request type',
        description: 'A table column heading showing request types associated with a project form.'
    },
    emptyFormName: {
        id: 'jira-common.ListProjectForms.EmptyFormName',
        defaultMessage: 'Untitled Form',
        description: 'A placeholder for a form with an empty name.'
    }
});

});

parcelRegister("6AbVQ", function(module, exports) {

$parcel$export(module.exports, "RequestTypes", () => $4caf5c4c870338cc$export$e849aec7fe4f0a48);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $3MV1G = parcelRequire("3MV1G");

var $cnPHV = parcelRequire("cnPHV");

var $8KsJV = parcelRequire("8KsJV");

var $6Ogt8 = parcelRequire("6Ogt8");

var $b574G = parcelRequire("b574G");

var $1Xh71 = parcelRequire("1Xh71");
const $4caf5c4c870338cc$export$e849aec7fe4f0a48 = ({ isServiceProject: isServiceProject, projectKey: projectKey, requestTypes: requestTypes, requestTypeCategories: requestTypeCategories, simplifiedProject: simplifiedProject })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(false);
    const groupedRequestTypes = (0, $8KsJV.groupRequestTypes)(requestTypes);
    const ids = Object.keys(groupedRequestTypes);
    if (ids.length === 0) return null;
    if (ids.length === 1) {
        const rt = groupedRequestTypes[ids[0]][0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b574G.RequestTypeLink), {
            requestType: rt,
            isServiceProject: isServiceProject,
            projectKey: projectKey,
            requestTypeCategories: requestTypeCategories,
            simplifiedProject: simplifiedProject
        });
    }
    const uniqueRequestTypes = Object.values(groupedRequestTypes).map((rts)=>rts[0]);
    const buttonLabel = isServiceProject ? (0, $6Ogt8.messages).multipleRequestTypesLabel : (0, $6Ogt8.messages).multipleIssueTypesLabel;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.Popup), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom-start",
        shouldRenderToParent: true,
        content: ()=>uniqueRequestTypes.map((rt)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Xh71.PopupItem), {
                    key: rt.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b574G.RequestTypeLink), {
                    requestType: rt,
                    isServiceProject: isServiceProject,
                    projectKey: projectKey,
                    requestTypeCategories: requestTypeCategories,
                    simplifiedProject: simplifiedProject
                }))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
                inline: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), (0, $kU09D.default)({}, triggerProps, {
                appearance: "link",
                spacing: "compact",
                style: {
                    borderRadius: '12px'
                },
                isSelected: isPopupOpen,
                onClick: ()=>setIsPopupOpen(!isPopupOpen)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, buttonLabel, {
                values: {
                    count: uniqueRequestTypes.length
                }
            }))))
    });
};

});
parcelRegister("6Ogt8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f542ff6776905a2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4f542ff6776905a2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    multipleIssueTypesLabel: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleIssueTypesLabel',
        defaultMessage: '{count} issue types',
        description: 'The text displayed on the issue type label when there are multiple issue types in non-JSM projects.'
    },
    multipleRequestTypesLabel: {
        id: 'proforma-jira-project-forms.ui.project-forms.list.table.request-types-new.multipleRequestTypesLabel',
        defaultMessage: '{count} request types',
        description: 'The text displayed on the request type label when there are multiple request types in JSM projects.'
    }
});

});

parcelRegister("b574G", function(module, exports) {

$parcel$export(module.exports, "RequestTypeLink", () => $8115a637bf9028ac$export$93f2486fb3c795c6);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $7u4fN = parcelRequire("7u4fN");

var $9Amv1 = parcelRequire("9Amv1");

var $8KsJV = parcelRequire("8KsJV");

var $1CxlH = parcelRequire("1CxlH");
const $8115a637bf9028ac$export$93f2486fb3c795c6 = ({ requestTypeCategories: requestTypeCategories, simplifiedProject: simplifiedProject, projectKey: projectKey, requestType: requestType, isServiceProject: isServiceProject })=>{
    if (isServiceProject) {
        const id = (0, $8KsJV.extractTicketTypeId)(requestType.id);
        const category = requestTypeCategories === null || requestTypeCategories === void 0 ? void 0 : requestTypeCategories[parseInt(id, 10)];
        const requestTypeUrl = simplifiedProject ? `/jira/servicedesk/projects/${projectKey}/settings/issuetypes/${id}` : `/jira/servicedesk/projects/${projectKey}/settings/request-types/category/${category}/request-type/${id}/request-form`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "none",
            href: requestTypeUrl,
            component: (0, $lB25E.Link),
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CxlH.RequestTypeIcon), {
                src: requestType.iconUrl,
                alt: ""
            })
        }, requestType.name);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CxlH.RequestTypeIcon), {
        src: requestType.iconUrl,
        alt: ""
    }), requestType.name);
};

});
parcelRegister("1CxlH", function(module, exports) {

$parcel$export(module.exports, "RequestTypeIcon", () => $12e3357e1698e901$export$92ecfe5a3fa8d686);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");
const $12e3357e1698e901$export$92ecfe5a3fa8d686 = (0, $exJuA.default).img({
    width: '16px',
    height: '16px',
    marginRight: "var(--ds-space-100, 8px)"
});

});


parcelRegister("1Xh71", function(module, exports) {

$parcel$export(module.exports, "PopupItem", () => $16c893424764cd01$export$497d69bbe7e2cd54);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");

const $16c893424764cd01$export$497d69bbe7e2cd54 = (0, $exJuA.default).div({
    padding: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '& + &': {
        borderTop: `1px solid ${`var(--ds-border, ${(0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb)})`}`
    }
});

});


parcelRegister("75QHx", function(module, exports) {

$parcel$export(module.exports, "FormNameWrapper", () => $52a1e1669d61d893$export$f21e68efbab8f6ed);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");


var $lcnyw = parcelRequire("lcnyw");
const $52a1e1669d61d893$export$f21e68efbab8f6ed = (0, $exJuA.default).div({
    fontFamily: (0, $lcnyw.fontFamily)(),
    fontSize: (0, $lcnyw.fontSize)(),
    lineHeight: '24px',
    display: 'flex',
    alignItems: 'center',
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$7090862dc3038a9f)})`,
    whiteSpace: 'pre-wrap',
    textAlign: 'left'
});

});


parcelRegister("29dcw", function(module, exports) {

$parcel$export(module.exports, "TicketTypeDropdown", () => $1906a9795d00d253$export$13957c5df7f24d1c);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lB25E = parcelRequire("lB25E");

var $i9cD6 = parcelRequire("i9cD6");
var $iaZQY = parcelRequire("iaZQY");
var $deDZF = parcelRequire("deDZF");
var $jK36y = parcelRequire("jK36y");

var $7ODmA = parcelRequire("7ODmA");

var $8KsJV = parcelRequire("8KsJV");

var $bu1Yj = parcelRequire("bu1Yj");

var $7xXaN = parcelRequire("7xXaN");
const $1906a9795d00d253$var$byFormNameAndId = (a, b)=>a.name.localeCompare(b.name) || a.id.localeCompare(b.id);
const $1906a9795d00d253$export$13957c5df7f24d1c = ({ isServiceProject: isServiceProject, onChange: onChange })=>{
    const [{ forms: forms, loading: loading }] = (0, $bu1Yj.useProjectFormsController)();
    const intl = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [typeIds] = (0, $lB25E.useQueryParam)('typeIds');
    const [typeOptions, setTypeOptions] = (0, $eUqFw.useState)([]);
    (0, $eUqFw.useEffect)(()=>{
        if (!loading) {
            const typeFilter = isServiceProject ? (t)=>t.type === (0, $7ODmA.TicketType).RequestType : (t)=>t.type === (0, $7ODmA.TicketType).IssueType;
            const formTicketTypes = {};
            forms.forEach((item)=>item.requesttypes.filter(typeFilter).forEach((type)=>{
                    const ticketTypeId = (0, $8KsJV.extractTicketTypeId)(type.id);
                    formTicketTypes[ticketTypeId] = {
                        ...type,
                        id: ticketTypeId
                    };
                }));
            const sortedTicketTypes = Object.values(formTicketTypes).sort($1906a9795d00d253$var$byFormNameAndId).map((item)=>({
                    optionType: 'avatar',
                    label: item.name,
                    value: item.id,
                    avatar: item.iconUrl
                }));
            setTypeOptions(sortedTicketTypes);
        }
    }, [
        forms,
        isServiceProject,
        loading
    ]);
    const [selectedTypeOptions, setSelectedTypeOptions] = (0, $eUqFw.useState)([]);
    const updateSelectedTypeOptions = (0, $eUqFw.useCallback)((newTypeOptions)=>{
        setSelectedTypeOptions(newTypeOptions);
        onChange(newTypeOptions.map((option)=>option.value));
    }, [
        onChange
    ]);
    const onLoadOptions = (search, a, b, c, d, callback)=>{
        let optionsToDisplay = typeOptions;
        if (search) {
            const lowercaseSearch = search.toLocaleLowerCase();
            optionsToDisplay = typeOptions.filter((option)=>{
                var _option$label;
                return (_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.toLocaleLowerCase().includes(lowercaseSearch);
            });
        }
        callback({
            totalCount: (0, $i9cD6.countSingleOptions)(optionsToDisplay),
            options: optionsToDisplay
        });
    };
    (0, $eUqFw.useEffect)(()=>{
        if (typeOptions !== null && typeOptions !== void 0 && typeOptions.length && typeIds) {
            const typeIdsArray = typeIds.split(',');
            const preSelectedTypeOptions = typeOptions.filter((option)=>'value' in option && typeIdsArray.includes(option.value));
            if (preSelectedTypeOptions.length > 0) updateSelectedTypeOptions(preSelectedTypeOptions);
        }
    }, [
        typeOptions,
        typeIds,
        updateSelectedTypeOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iaZQY.Picker), {
        isOpen: isOpen,
        onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))),
        onClose: ()=>setIsOpen(false),
        value: selectedTypeOptions,
        fieldId: "proforma-ticket-type-dropdown",
        onChange: updateSelectedTypeOptions,
        onLoadOptions: onLoadOptions,
        onTrigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK36y.default), {
                hasValues: selectedTypeOptions.length > 0,
                onClick: ()=>setIsOpen(!isOpen),
                isSelected: isOpen,
                isInvalid: false,
                ref: ref
            }, (0, $deDZF.formatLabel)(intl.formatMessage(isServiceProject ? (0, $7xXaN.messages).requestType : (0, $7xXaN.messages).issueType), selectedTypeOptions)),
        onClearValues: ()=>updateSelectedTypeOptions([]),
        pagination: {
            enableFullList: false
        },
        ariaLabel: intl.formatMessage(isServiceProject ? (0, $7xXaN.messages).requestTypeAriaLabel : (0, $7xXaN.messages).issueTypeAriaLabel)
    });
};

});
parcelRegister("i9cD6", function(module, exports) {

$parcel$export(module.exports, "countSingleOptions", () => $6a5e7d8d9fab9658$export$54319cf8344f1691);
$parcel$export(module.exports, "default", () => $6a5e7d8d9fab9658$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k61d1 = parcelRequire("k61d1");

var $bCHHi = parcelRequire("bCHHi");
parcelRequire("hgTYM");
var $3IL7Z = parcelRequire("3IL7Z");

var $3A1We = parcelRequire("3A1We");

var $fc1r6 = parcelRequire("fc1r6");

var $6bDg0 = parcelRequire("6bDg0");

var $dQpIH = parcelRequire("dQpIH");

var $aZujh = parcelRequire("aZujh");

var $l6gXt = parcelRequire("l6gXt");
const $6a5e7d8d9fab9658$var$MAX_TOTAL_COUNT = 1000; // To be cleaned up in EM-3568
const $6a5e7d8d9fab9658$var$paginatedComponents = {
    ...(0, $dQpIH.selectComponents),
    MenuList: $fc1r6.MenuList
};
const $6a5e7d8d9fab9658$var$ProxyBaseSelect = ({ selectOptions: selectOptions, ...props })=>{
    return selectOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQpIH.LocalBaseSelect), {
        ...props,
        options: selectOptions
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQpIH.LocalBaseSelect), props);
};
const $6a5e7d8d9fab9658$var$AsyncSelect = (props)=>{
    const baseSelectProps = (0, $3IL7Z.u)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a5e7d8d9fab9658$var$ProxyBaseSelect, {
        ...props,
        ...baseSelectProps
    });
};
/**
 * Adds option to the list of options if its value isn't currently in the Set of keys
 */ const $6a5e7d8d9fab9658$var$addUniqueOptions = (keys, options, option)=>{
    if (option.optionType === 'group') {
        const groupOptions = [];
        option.options.forEach((groupOption)=>{
            $6a5e7d8d9fab9658$var$addUniqueOptions(keys, groupOptions, groupOption);
        });
        options.push({
            ...option,
            options: groupOptions
        });
        return;
    }
    // Add single options:
    if (!keys.has(option.value)) {
        keys.add(option.value);
        options.push(option);
    }
};
const $6a5e7d8d9fab9658$var$generateOptions = (selectedValues, newOptions, addSelectedFirst, previousOptions)=>{
    const optionKeys = new Set();
    const options = [];
    if (addSelectedFirst) selectedValues.forEach((option)=>{
        $6a5e7d8d9fab9658$var$addUniqueOptions(optionKeys, options, option);
    });
    previousOptions?.forEach((option)=>{
        $6a5e7d8d9fab9658$var$addUniqueOptions(optionKeys, options, option);
    });
    newOptions.forEach((option)=>{
        $6a5e7d8d9fab9658$var$addUniqueOptions(optionKeys, options, option);
    });
    return options;
};
const $6a5e7d8d9fab9658$var$getLastCursorOption = (options)=>(0, (/*@__PURE__*/$parcel$interopDefault($bCHHi)))(options, (option)=>'cursor' in option && !!option.cursor);
// Needed to disable filtering from react-select
const $6a5e7d8d9fab9658$var$noFilterOptions = ()=>true;
const $6a5e7d8d9fab9658$var$noLoadOptions = ()=>Promise.resolve();
const $6a5e7d8d9fab9658$export$54319cf8344f1691 = (options)=>options.map((option)=>option.optionType === 'group' ? option.options.length : 1).reduce((sumSoFar, count)=>sumSoFar + count, 0);
const $6a5e7d8d9fab9658$export$fccf54b4cac6e0b3 = ({ ariaLabel: ariaLabel, field: field, value: value, onChange: onChange, onClear: onClear, initiallyAddSelectedFirst: initiallyAddSelectedFirst, showFooter: showFooter, ...restProps })=>{
    const [page, setPage] = (0, $eUqFw.useState)(0);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(true);
    const [isPaginationLoading, setIsPaginationLoading] = (0, $eUqFw.useState)(false);
    const [inputValue, setInputValue] = (0, $eUqFw.useState)('');
    const [loadedOptions, setLoadedOptions] = (0, $eUqFw.useState)([]);
    const [enableFullList, setEnableFullList] = (0, $eUqFw.useState)(field.pagination?.enableFullList ?? false);
    const [totalCount, setTotalCount] = (0, $eUqFw.useState)(null);
    const [error, setError] = (0, $eUqFw.useState)({
        isError: false,
        error: null,
        onRetry: null
    });
    const getTotalCountWithFunctions = (0, $eUqFw.useCallback)((newTotalCount)=>{
        if (newTotalCount === null || !field.pagination?.keywordValues?.length) return newTotalCount;
        const { pagination: { keywordValues: keywordValues } } = field;
        const newTotalCountWithKeywords = newTotalCount + value.filter((option)=>keywordValues.includes(option.value)).length;
        return newTotalCountWithKeywords < $6a5e7d8d9fab9658$var$MAX_TOTAL_COUNT ? newTotalCountWithKeywords : $6a5e7d8d9fab9658$var$MAX_TOTAL_COUNT;
    }, [
        field,
        value
    ]);
    const checkIfError = (0, $eUqFw.useCallback)((search, options, onRetry)=>{
        if (options.some((option)=>option.optionType === 'error')) {
            setError({
                isError: true,
                error: null,
                onRetry: onRetry
            });
            setIsLoading(false);
            return true;
        }
        setError({
            isError: false,
            error: null,
            onRetry: null
        });
        return false;
    }, []);
    const handleLoadOptions = (0, $eUqFw.useCallback)((search)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        setIsLoading(true);
        loadOptions(search, enableFullList, false, false, undefined, ({ options: options, totalCount: newTotalCount })=>{
            if (checkIfError(search, options, ()=>handleLoadOptions(search))) return;
            setLoadedOptions($6a5e7d8d9fab9658$var$generateOptions(value, options, initiallyAddSelectedFirst));
            setTotalCount(search ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsLoading(false);
        });
    }, [
        field,
        enableFullList,
        checkIfError,
        value,
        initiallyAddSelectedFirst,
        getTotalCountWithFunctions
    ]);
    const handleShowMore = (0, $eUqFw.useCallback)((showFullList = false, isRetry = false)=>{
        const { loadOptions: loadOptions } = field;
        if (!loadOptions) return;
        let originalLoadedOptions;
        if (showFullList) {
            originalLoadedOptions = [];
            setIsLoading(true);
        } else {
            originalLoadedOptions = loadedOptions;
            if (isRetry) setIsLoading(true);
            else setIsPaginationLoading(true);
        }
        loadOptions(inputValue, false, showFullList, true, $6a5e7d8d9fab9658$var$getLastCursorOption(loadedOptions), ({ options: options, totalCount: newTotalCount })=>{
            if (checkIfError(inputValue, options, ()=>{
                handleShowMore(showFullList, true);
            })) return;
            setPage(page + 1);
            setEnableFullList(false);
            setLoadedOptions($6a5e7d8d9fab9658$var$generateOptions(value, options, showFullList, originalLoadedOptions));
            setTotalCount(inputValue ? newTotalCount : getTotalCountWithFunctions(newTotalCount));
            setIsPaginationLoading(false);
            setIsLoading(false);
        });
    }, [
        field,
        loadedOptions,
        inputValue,
        checkIfError,
        value,
        page,
        getTotalCountWithFunctions
    ]);
    const handleShowFullList = (0, $eUqFw.useCallback)(()=>{
        handleShowMore(true, false);
    }, [
        handleShowMore
    ]);
    const handleInputChange = (0, $eUqFw.useCallback)((newInputValue)=>{
        const { onInputChange: onInputChange } = field;
        setEnableFullList(false);
        setPage(0);
        setInputValue(newInputValue);
        setTotalCount(null);
        setLoadedOptions([]);
        handleLoadOptions(newInputValue);
        onInputChange && onInputChange();
    }, [
        field,
        handleLoadOptions
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)((options, action)=>{
        let selectData;
        if ('option' in action) {
            const actionOption = action.option;
            if (actionOption && 'value' in actionOption) selectData = {
                selectedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($k61d1)))(loadedOptions, (option)=>'value' in option && option.value === actionOption.value)
            };
        }
        onChange?.(options, action, selectData);
    }, [
        onChange,
        loadedOptions
    ]);
    // We only want to call this on init, so it's ok to disable react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>{
        handleLoadOptions('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedOptionsCount = totalCount === null ? 0 : $6a5e7d8d9fab9658$export$54319cf8344f1691(loadedOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a5e7d8d9fab9658$var$AsyncSelect, {
        ariaLabel: ariaLabel,
        cacheOptions: field.cacheOptions,
        components: $6a5e7d8d9fab9658$var$paginatedComponents,
        defaultOptions: field.defaultOptions,
        defaultOptionsLabel: field.defaultOptionsLabel,
        inputValue: inputValue,
        loadOptions: $6a5e7d8d9fab9658$var$noLoadOptions,
        onInputChange: handleInputChange,
        onMenuScrollToBottom: field.onMenuScrollToBottom,
        onMenuScrollToTop: field.onMenuScrollToTop,
        placeholder: field.placeholder,
        fieldKey: field.key,
        fieldLabel: field.label,
        fieldInvalidLabel: field.invalidLabel,
        selectOptions: loadedOptions,
        onFilterOption: $6a5e7d8d9fab9658$var$noFilterOptions,
        menuListProps: {
            error: error,
            type: field.key,
            handleShowMore: handleShowMore,
            isLoading: isLoading,
            isPaginationLoading: isPaginationLoading,
            showShowMoreButton: totalCount !== null && loadedOptionsCount < totalCount
        },
        onChange: handleOnChange,
        value: value,
        ...restProps
    }), (showFooter || !showFooter && !!value.length) && field.pagination && !isLoading && !!loadedOptions?.length && !error.isError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l6gXt.Footer), null, !value.length && enableFullList && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZujh.ShowFullListButton), {
        type: field.key,
        onShowFullList: handleShowFullList
    }), !!value.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3A1We.ClearSelectedItemsButton), {
        onClear: onClear,
        type: field.key
    }), showFooter && !enableFullList && totalCount !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6bDg0.PaginationDetails), {
        itemsCount: loadedOptionsCount,
        totalCount: totalCount
    })));
};
var $6a5e7d8d9fab9658$export$2e2bcd8739ae039 = $6a5e7d8d9fab9658$export$fccf54b4cac6e0b3;

});
parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});

parcelRegister("bCHHi", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $gJXdx = parcelRequire("gJXdx");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $876523ae23ec930f$var$findLast = $e5OGm($gJXdx);
module.exports = $876523ae23ec930f$var$findLast;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("gJXdx", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c2fec8a2b4cc30dc$var$nativeMax = Math.max, $c2fec8a2b4cc30dc$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $c2fec8a2b4cc30dc$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $hNahz(fromIndex);
        index = fromIndex < 0 ? $c2fec8a2b4cc30dc$var$nativeMax(length + index, 0) : $c2fec8a2b4cc30dc$var$nativeMin(index, length - 1);
    }
    return $9mB9u(array, $7qARj(predicate, 3), index, true);
}
module.exports = $c2fec8a2b4cc30dc$var$findLastIndex;

});


parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});
parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});



parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});

parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});


parcelRegister("3A1We", function(module, exports) {

$parcel$export(module.exports, "ClearSelectedItemsButton", () => $aa6309fb55f32b18$export$1d4b7cda9e589b53);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $dbwSt = parcelRequire("dbwSt");
const $aa6309fb55f32b18$export$1d4b7cda9e589b53 = ({ onClear: onClear /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClearSelectedItems = (0, $eUqFw.useCallback)(()=>{
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchClearSelectedItems',
        //   createAnalyticsEvent,
        //   type,
        // });
        onClear && onClear();
    }, [
        onClear
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClearSelectedItems,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.clear-selection-button.clear-selected-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $dbwSt.default).clearAllSelectedItemsButtonText));
};
var $aa6309fb55f32b18$export$2e2bcd8739ae039 = $aa6309fb55f32b18$export$1d4b7cda9e589b53;

});
parcelRegister("dbwSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $af1b3397a0c25a0a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $af1b3397a0c25a0a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clearAllSelectedItemsButtonText: {
        id: 'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text',
        defaultMessage: 'Clear selection',
        description: 'Clicking this button will unselect all the selected items in the dropdown'
    }
});

});


parcelRegister("fc1r6", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $59df74a8a80aa7bf$export$d4c4e98c5044dc8);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $4Bees = parcelRequire("4Bees");

var $dX1aB = parcelRequire("dX1aB");

var $jpEX5 = parcelRequire("jpEX5");

var $bDEJO = parcelRequire("bDEJO");

var $ilIKh = parcelRequire("ilIKh");
const $59df74a8a80aa7bf$export$d4c4e98c5044dc8 = (props)=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const [clickCount, setClickCount] = (0, $eUqFw.useState)(1);
    const { selectProps: { menuListProps: { error: { isError: isError, onRetry: onRetry }, handleShowMore: handleShowMore, isLoading: isLoading, isPaginationLoading: isPaginationLoading, showShowMoreButton: showShowMoreButton } } } = props;
    const handleOnShowMore = (0, $eUqFw.useCallback)(()=>{
        setClickCount(clickCount + 1);
        // sendAnalytics({
        //   actionSubjectId: 'filterSearchShowMore',
        //   createAnalyticsEvent,
        //   type,
        //   clickCount,
        // });
        handleShowMore();
    }, [
        clickCount,
        handleShowMore
    ]);
    if (isLoading && clickCount > 1) setClickCount(1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, props, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jpEX5.LoadingMessage), null) : isError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dX1aB.default), {
        onRetry: onRetry
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children, isPaginationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ilIKh.LoadingWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null)) : showShowMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bDEJO.default), {
        onShowMore: handleOnShowMore
    })));
};
var $59df74a8a80aa7bf$export$2e2bcd8739ae039 = $59df74a8a80aa7bf$export$d4c4e98c5044dc8;

});
parcelRegister("dX1aB", function(module, exports) {

$parcel$export(module.exports, "default", () => $57e3951dbf84041c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $96IgR = parcelRequire("96IgR");


var $doCGg = parcelRequire("doCGg");

var $6M0ok = parcelRequire("6M0ok");
const $57e3951dbf84041c$var$ErrorMessage = ({ onRetry: onRetry })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        onRetry?.();
    // fireOperationalAnalytics(
    //   createAnalyticsEvent({}),
    //   'refinementBarSelectRetry clicked',
    // );
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledBox), {
        height: 144
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledBox), {
        height: 72,
        iconSize: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: `var(--ds-icon-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6M0ok.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClick,
        appearance: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $6M0ok.default).retryMessage)));
};
var $57e3951dbf84041c$export$2e2bcd8739ae039 = $57e3951dbf84041c$var$ErrorMessage;

});
parcelRegister("doCGg", function(module, exports) {

$parcel$export(module.exports, "DropdownIndicatorWrapper", () => $d9092cb2966f8e29$export$30c615a45297e297);
$parcel$export(module.exports, "StyledBox", () => $d9092cb2966f8e29$export$d675f139b342d51a);
$parcel$export(module.exports, "StyledText", () => $d9092cb2966f8e29$export$31ea92f3997410dd);
$parcel$export(module.exports, "StyledControl", () => $d9092cb2966f8e29$export$5c7b7f0e517b89f8);
$parcel$export(module.exports, "CloseIconWrapper", () => $d9092cb2966f8e29$export$94756becb802e330);
$parcel$export(module.exports, "DisplayWrapper", () => $d9092cb2966f8e29$export$6833d6d22987ee7f);
$parcel$export(module.exports, "StyledInvalidCheckboxOption", () => $d9092cb2966f8e29$export$e786733cafde97b9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $4lTFP = parcelRequire("4lTFP");
const $d9092cb2966f8e29$export$30c615a45297e297 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12oo4m7-0"
})({
    marginRight: "var(--ds-space-025, 2px)",
    textAlign: 'center',
    width: '32px'
});
const $d9092cb2966f8e29$export$d675f139b342d51a = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12oo4m7-1"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${props.height || 128}px`,
        justifyContent: 'center'
    }), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ iconSize: iconSize })=>iconSize ? `svg {
          width: ${iconSize}px;
          height: ${iconSize}px;
        }` : '');
const $d9092cb2966f8e29$export$31ea92f3997410dd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12oo4m7-2"
})((0, $4lTFP.h400), {
    marginTop: "var(--ds-space-100, 8px)"
});
const $d9092cb2966f8e29$export$5c7b7f0e517b89f8 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12oo4m7-3"
})({
    boxShadow: `var(--ds-shadow-overlay, ${`0 2px 0 ${(0, $73a5c9d720aa66e1$export$920c0d5c49070351)}`})`,
    display: 'flex',
    padding: "var(--ds-space-050, 4px)"
});
const $d9092cb2966f8e29$export$94756becb802e330 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12oo4m7-4"
})({
    cursor: 'pointer',
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`,
    '&:hover, &:focus': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
    }
});
const $d9092cb2966f8e29$export$6833d6d22987ee7f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12oo4m7-5"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display: props.displayFlag ? 'block' : 'none'
    }));
const $d9092cb2966f8e29$export$e786733cafde97b9 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-12oo4m7-6"
})({
    backgroundColor: `var(--ds-background-danger, ${(0, $73a5c9d720aa66e1$export$4b84fd0e2c617bd)})`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > *': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        backgroundColor: 'inherit !important'
    }
});

});

parcelRegister("6M0ok", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eabc3829247c137$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3eabc3829247c137$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.error-message',
        defaultMessage: "Couldn't retrieve data",
        description: 'The text for when an error occurs when loading options'
    },
    retryMessage: {
        id: 'paginated-picker.async-select.menu-list.error-message.retry-message',
        defaultMessage: 'Click to retry',
        description: 'The text for button to reload options'
    }
});

});


parcelRegister("jpEX5", function(module, exports) {

$parcel$export(module.exports, "LoadingMessage", () => $d25c73425f51dd92$export$e928a71d039d3102);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4Bees = parcelRequire("4Bees");

var $doCGg = parcelRequire("doCGg");

var $7hcjS = parcelRequire("7hcjS");
const $d25c73425f51dd92$export$e928a71d039d3102 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledBox), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledBox), {
        height: 72
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $7hcjS.default).loadingMessage)));

});
parcelRegister("7hcjS", function(module, exports) {

$parcel$export(module.exports, "default", () => $952cb9dcbedc9ddf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $952cb9dcbedc9ddf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loadingMessage: {
        id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
        defaultMessage: 'Loading...',
        description: 'The text for when options are being loaded in dropdown'
    }
});

});


parcelRegister("bDEJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $317aeaec84374c0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $a6BLZ = parcelRequire("a6BLZ");
const $317aeaec84374c0f$var$ShowMoreButton = ({ onShowMore: onShowMore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onShowMore,
        appearance: "link",
        testId: "paginated-picker.ui.async-select.menu-list.show-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $a6BLZ.default).showMoreButtonText));
var $317aeaec84374c0f$export$2e2bcd8739ae039 = $317aeaec84374c0f$var$ShowMoreButton;

});
parcelRegister("a6BLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e320f770fa354efa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e320f770fa354efa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showMoreButtonText: {
        id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
        defaultMessage: 'Show more',
        description: 'Clicking this button will load more items into the dropdown'
    }
});

});


parcelRegister("ilIKh", function(module, exports) {

$parcel$export(module.exports, "LoadingWrapper", () => $0dc66e8af0a53328$export$43a792a870d28db2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $0dc66e8af0a53328$export$43a792a870d28db2 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-8ouqtd-0"
})({
    display: 'flex',
    justifyContent: 'center',
    margin: `${"var(--ds-space-050, 4px)"} 0`
});

});


parcelRegister("6bDg0", function(module, exports) {

$parcel$export(module.exports, "PaginationDetails", () => $2e94f516805fa3f5$export$33eb0288c0936a84);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $aRmsq = parcelRequire("aRmsq");

var $lVZa9 = parcelRequire("lVZa9");
const $2e94f516805fa3f5$export$33eb0288c0936a84 = ({ itemsCount: itemsCount, totalCount: totalCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lVZa9.PaginationDetailsStyled), {
        "data-testid": "paginated-picker.ui.async-select.pagination-details"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $aRmsq.default).ofTotalCount,
        values: {
            itemsCount: itemsCount,
            totalCount: totalCount
        }
    }));
var $2e94f516805fa3f5$export$2e2bcd8739ae039 = $2e94f516805fa3f5$export$33eb0288c0936a84;

});
parcelRegister("aRmsq", function(module, exports) {

$parcel$export(module.exports, "default", () => $db8b6d1fc001988d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $db8b6d1fc001988d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    ofTotalCount: {
        id: 'paginated-picker.async-select.pagination-details.of-total-count',
        defaultMessage: '{itemsCount} of {totalCount}',
        description: 'Total count of items.'
    }
});

});

parcelRegister("lVZa9", function(module, exports) {

$parcel$export(module.exports, "PaginationDetailsStyled", () => $141bbd686b11e512$export$fff9218028c24180);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $141bbd686b11e512$export$fff9218028c24180 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-2jljtl-0"
})({
    flex: 1,
    textAlign: 'right',
    margin: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #979797)"
});

});


parcelRegister("dQpIH", function(module, exports) {

$parcel$export(module.exports, "selectComponents", () => $5628ba469b82117b$export$c34d65c0f5a1c617);
$parcel$export(module.exports, "LocalBaseSelect", () => $5628ba469b82117b$export$51cc13ac81e51592);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $5wCDk = parcelRequire("5wCDk");

var $2O4Aa = parcelRequire("2O4Aa");

var $16IvL = parcelRequire("16IvL");

var $hyeBQ = parcelRequire("hyeBQ");

var $2jUq6 = parcelRequire("2jUq6");

var $ezlWK = parcelRequire("ezlWK");

var $dZXuB = parcelRequire("dZXuB");
const $5628ba469b82117b$export$c34d65c0f5a1c617 = {
    Control: $16IvL.Control,
    DropdownIndicator: $hyeBQ.DropdownIndicator,
    IndicatorSeparator: null,
    LoadingIndicator: null,
    Menu: $2jUq6.Menu,
    Option: $dZXuB.Option
};
const $5628ba469b82117b$var$onIsOptionDisabled = (option)=>'error' in option ? !!option.error : false;
const $5628ba469b82117b$export$51cc13ac81e51592 = ({ onFilterOption: onFilterOption, placeholder: placeholder, ...restProps })=>{
    const intl = (0, $5JgJ2.default)();
    const { ariaLabel: ariaLabelProp, onInputChange: onInputChangeProp, inputValue: inputValueProp } = restProps;
    const [inputValue, setInputValue] = (0, $eUqFw.useState)(inputValueProp || '');
    // useEffect(() => {
    //   if (options && !(isLoading ?? false)) {
    //     if (isJqlBuilderReportErrorTypeEnabled()) {
    //       let errorType = 'unknown';
    //       if (error instanceof ApolloError) {
    //         if (error.networkError != null) {
    //           errorType = 'networkError';
    //         } else if (error.graphQLErrors.length > 0) {
    //           errorType = 'graphQLError';
    //         }
    //       }
    //       const errorAttributes = error
    //         ? {
    //             errorType,
    //             message: error.message,
    //           }
    //         : null;
    //
    //       sendExperienceAnalytics({
    //         analyticsSource: 'refinement-bar-select',
    //         wasExperienceSuccessful: error == null,
    //         experience: 'showOptions',
    //         application: null,
    //         edition: null,
    //         additionalAttributes: {
    //           filter: fieldKey ?? 'unknown',
    //           ...errorAttributes,
    //         },
    //       });
    //     } else {
    //       sendExperienceAnalytics({
    //         analyticsSource: 'refinement-bar-select',
    //         wasExperienceSuccessful: !isError,
    //         experience: 'showOptions',
    //         application: null,
    //         edition: null,
    //         additionalAttributes: {
    //           filter: fieldKey ?? 'unknown',
    //         },
    //       });
    //     }
    //   }
    // }, [fieldKey, isError, error, isLoading, options]);
    const onInputChange = (0, $eUqFw.useCallback)((newValue, actionMeta)=>{
        /**
			 * Do not clear the filter input value when an input is selected or blurred.
			 * NOTE: We are also returning when 'menu-close' event are triggered,
			 * which happens when the input is clicked for some reason, but not when we click outside of the dropdown
			 * */ if ([
            (0, $2O4Aa.MetaActions).setValue,
            (0, $2O4Aa.MetaActions).inputBlur,
            (0, $2O4Aa.MetaActions).menuClose
        ].includes(actionMeta.action) && !newValue.length) return;
        onInputChangeProp?.(newValue, actionMeta);
        setInputValue(newValue);
    }, [
        onInputChangeProp
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        ...restProps,
        "aria-label": ariaLabelProp || intl.formatMessage((0, $ezlWK.default).searchPlaceholder),
        autoFocus: true,
        backspaceRemovesValue: false,
        blurInputOnSelect: false,
        closeMenuOnSelect: false,
        controlShouldRenderValue: false,
        hideSelectedOptions: false,
        isClearable: false,
        isMulti: true,
        inputValue: inputValue,
        menuIsOpen: true,
        menuShouldScrollIntoView: false,
        tabSelectsValue: false,
        noOptionsMessage: ()=>intl.formatMessage((0, $ezlWK.default).noOptionsMessage),
        onInputChange: onInputChange,
        isOptionDisabled: $5628ba469b82117b$var$onIsOptionDisabled,
        filterOption: onFilterOption,
        placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $ezlWK.default).searchPlaceholder)
    });
};

});
parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = "platform-pkg";
const $eb73e877c5661200$var$packageVersion = "0.0.0-use.local";
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});

parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $lT14u.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $e9T6i = parcelRequire("e9T6i");

var $exKxp = parcelRequire("exKxp");

var $9Amv1 = parcelRequire("9Amv1");
var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a14d8b5e9bff27a8$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.075'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($exKxp))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        as: "span",
        xcss: $a14d8b5e9bff27a8$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9T6i))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("exKxp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9683f39a4d9c20b$var$_react = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a9683f39a4d9c20b$var$_crossCircle = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("iOPxW")));

var $a9683f39a4d9c20b$var$_selectClear = $a9683f39a4d9c20b$var$_interopRequireDefault((parcelRequire("hUbUe")));
function $a9683f39a4d9c20b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9683f39a4d9c20b$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a9683f39a4d9c20b$var$_react.default.createElement($a9683f39a4d9c20b$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $a9683f39a4d9c20b$var$_selectClear.default
    }, props));
$a9683f39a4d9c20b$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $a9683f39a4d9c20b$var$_default = module.exports.default = $a9683f39a4d9c20b$var$CrossCircleIcon;

});
parcelRegister("iOPxW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db34e18c123e5251$var$_react = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $db34e18c123e5251$var$_UNSAFE_baseNew = $db34e18c123e5251$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $db34e18c123e5251$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db34e18c123e5251$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $db34e18c123e5251$var$_react.default.createElement($db34e18c123e5251$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db34e18c123e5251$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $db34e18c123e5251$var$_default = module.exports.default = $db34e18c123e5251$var$CrossCircleIcon;

});

parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d090e6e9cc89e346$var$_crossCircle = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("hsyGm")));
function $d090e6e9cc89e346$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $d090e6e9cc89e346$var$_crossCircle.default
    }));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = module.exports.default = $d090e6e9cc89e346$var$SelectClearIcon;

});



parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $hUbUe = parcelRequire("hUbUe");

var $adUQx = parcelRequire("adUQx");

var $XHGTv = parcelRequire("XHGTv");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.025'
});
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $XHGTv.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
            xcss: $7fda2332979a5c13$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($adUQx))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $1Yimi = parcelRequire("1Yimi");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $XHGTv = parcelRequire("XHGTv");

function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $73a5c9d720aa66e1$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $73a5c9d720aa66e1$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $73a5c9d720aa66e1$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $73a5c9d720aa66e1$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $73a5c9d720aa66e1$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $XHGTv.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $73a5c9d720aa66e1$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $XHGTv.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $73a5c9d720aa66e1$export$f563ee71e9ee74cd})`,
                ...(0, $XHGTv.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $7ccc5140c845bc58$export$8ee33f304118fce4);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $7ccc5140c845bc58$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("2O4Aa", function(module, exports) {

$parcel$export(module.exports, "MetaActions", () => $260adfc869d04b99$export$50531cf3046c5956);
const $260adfc869d04b99$export$50531cf3046c5956 = {
    setValue: 'set-value',
    inputChange: 'input-change',
    inputBlur: 'input-blur',
    menuClose: 'menu-close',
    selectOption: 'select-option',
    deselectOption: 'deselect-option',
    removeValue: 'remove-value',
    popValue: 'pop-value',
    clear: 'clear',
    createOption: 'create-option',
    clearOptions: 'clear-options',
    add: 'add',
    remove: 'remove',
    update: 'update'
};

});

parcelRegister("16IvL", function(module, exports) {

$parcel$export(module.exports, "Control", () => $cfd583ebc9a1d98f$export$7a7fa4424cb20976);

var $eUqFw = parcelRequire("eUqFw");

var $doCGg = parcelRequire("doCGg");
const $cfd583ebc9a1d98f$export$7a7fa4424cb20976 = ({ children: children, innerProps: innerProps, innerRef: innerRef })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledControl), {
        ...innerProps,
        ref: innerRef
    }, children);
};

});

parcelRegister("hyeBQ", function(module, exports) {

$parcel$export(module.exports, "DropdownIndicator", () => $8595416916b90f11$export$ec98719d3db7f2e4);

var $eUqFw = parcelRequire("eUqFw");

var $5k4ch = parcelRequire("5k4ch");

var $dsroq = parcelRequire("dsroq");

var $jQxSL = parcelRequire("jQxSL");

var $doCGg = parcelRequire("doCGg");
const $8595416916b90f11$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.DropdownIndicatorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.DisplayWrapper), {
        displayFlag: !!props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.CloseIconWrapper), {
        onClick: (event)=>{
            event.preventDefault();
            props.selectProps.onInputChange?.('', {
                action: 'input-change',
                prevInputValue: props.selectProps.inputValue
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k4ch))), {
        size: "small",
        label: ""
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.DisplayWrapper), {
        displayFlag: !props.selectProps.inputValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
        size: "small",
        label: ""
    }))));

});

parcelRegister("2jUq6", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $4ed3d732069de479$export$d9b273488cd8ce6f);

var $eUqFw = parcelRequire("eUqFw");
const $4ed3d732069de479$export$d9b273488cd8ce6f = ({ innerRef: innerRef, innerProps: innerProps, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "refinement-bar.common.ui.select.menu",
        ref: innerRef,
        ...innerProps
    }, children);

});

parcelRegister("ezlWK", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a389e41917bf21$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $95a389e41917bf21$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noOptionsMessage: {
        id: 'paginated-picker.async-select.select.no-options-message.no-options-message',
        defaultMessage: 'No matches found',
        description: 'The text for when no matches are found in dropdown'
    },
    searchPlaceholder: {
        id: 'paginated-picker.async-select.select.search-placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder text in search input indicating that the user can search'
    }
});

});

parcelRegister("dZXuB", function(module, exports) {

$parcel$export(module.exports, "Option", () => $9e5f257a0080f79b$export$36d18380658d5d20);

var $eUqFw = parcelRequire("eUqFw");

var $hBM4B = parcelRequire("hBM4B");

var $bVKeg = parcelRequire("bVKeg");


var $2eG9N = parcelRequire("2eG9N");

var $doCGg = parcelRequire("doCGg");
const $9e5f257a0080f79b$export$36d18380658d5d20 = (props)=>{
    if (props.data?.invalid) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $doCGg.StyledInvalidCheckboxOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bVKeg.CheckboxOption), props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2eG9N.default), {
        content: props.selectProps.fieldInvalidLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hBM4B))), {
        label: "Test",
        primaryColor: `var(--ds-icon-danger, ${(0, $73a5c9d720aa66e1$export$2010d0fb4295b346)})`
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bVKeg.CheckboxOption), props);
};

});
parcelRegister("hBM4B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd1b2ebba36782e9$var$_react = $cd1b2ebba36782e9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");
function $cd1b2ebba36782e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cd1b2ebba36782e9$var$JiraFailedBuildStatusIcon = (props)=>/*#__PURE__*/ $cd1b2ebba36782e9$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$cd1b2ebba36782e9$var$JiraFailedBuildStatusIcon.displayName = 'JiraFailedBuildStatusIcon';
var $cd1b2ebba36782e9$var$_default = module.exports.default = $cd1b2ebba36782e9$var$JiraFailedBuildStatusIcon;

});

parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hSJ9G = parcelRequire("hSJ9G");

var $c6Z6Z = parcelRequire("c6Z6Z");

function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $73a5c9d720aa66e1$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $73a5c9d720aa66e1$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $73a5c9d720aa66e1$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $73a5c9d720aa66e1$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $73a5c9d720aa66e1$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $73a5c9d720aa66e1$export$d6447c357493214f})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "35x0q3",
    styles: "display:flex ;align-items:center;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-linejoin:round;stroke-width:var(--ds-border-width, 1px);}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "16e0ede",
    styles: "flex-grow:1;overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});
parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $d04a81b304c826a5$var$_checkboxChecked = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("ejTfu")));
function $d04a81b304c826a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d04a81b304c826a5$var$_checkboxChecked.default
    }));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = module.exports.default = $d04a81b304c826a5$var$CheckboxIcon;

});
parcelRegister("ejTfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a6cdb252f5736633$var$_react = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a6cdb252f5736633$var$_UNSAFE_baseNew = $a6cdb252f5736633$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $a6cdb252f5736633$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a6cdb252f5736633$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $a6cdb252f5736633$var$_react.default.createElement($a6cdb252f5736633$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$a6cdb252f5736633$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $a6cdb252f5736633$var$_default = module.exports.default = $a6cdb252f5736633$var$CheckboxCheckedIcon;

});


parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $02468a1d390d1515$var$_radioChecked = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("a7ob3")));
function $02468a1d390d1515$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $02468a1d390d1515$var$_radioChecked.default
    }));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = module.exports.default = $02468a1d390d1515$var$RadioIcon;

});
parcelRegister("a7ob3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75dd4fef0eed872c$var$_react = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75dd4fef0eed872c$var$_UNSAFE_baseNew = $75dd4fef0eed872c$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $75dd4fef0eed872c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75dd4fef0eed872c$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $75dd4fef0eed872c$var$_react.default.createElement($75dd4fef0eed872c$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$75dd4fef0eed872c$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $75dd4fef0eed872c$var$_default = module.exports.default = $75dd4fef0eed872c$var$RadioCheckedIcon;

});





parcelRegister("aZujh", function(module, exports) {

$parcel$export(module.exports, "ShowFullListButton", () => $8b9f93164886b73f$export$bf0956d66cd7566b);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $7u4fN = parcelRequire("7u4fN");

var $4J6HL = parcelRequire("4J6HL");
const $8b9f93164886b73f$export$bf0956d66cd7566b = ({ onShowFullList: onShowFullList /*, type*/  })=>{
    // const { createAnalyticsEvent } = useAnalyticsEvents();
    const handleShowFullList = (0, $eUqFw.useCallback)(()=>{
        // const analyticsEvent = createAnalyticsEvent({
        //   eventType: 'UI',
        //   action: 'expanded',
        //   actionSubject: 'filterSearch',
        //   actionSubjectId: 'refinementBarFilterSearch',
        // });
        //
        // const attributes: Attributes = {
        //   fieldType: type,
        // };
        //
        // fireUIAnalytics(analyticsEvent, 'refinementBarFilterSearch', attributes);
        onShowFullList();
    }, [
        onShowFullList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleShowFullList,
        appearance: "subtle-link",
        testId: "paginated-picker.ui.async-select.show-full-list-button.show-full-list-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $4J6HL.default).showFullListButtonText));
};
var $8b9f93164886b73f$export$2e2bcd8739ae039 = $8b9f93164886b73f$export$bf0956d66cd7566b;

});
parcelRegister("4J6HL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c49dfdc3254acc58$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c49dfdc3254acc58$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showFullListButtonText: {
        id: 'paginated-picker.async-select.show-full-list-button.show-full-list-button-text',
        defaultMessage: 'Show full list',
        description: 'Initially we show the first few items on the list. Clicking this button will show the full list.'
    }
});

});


parcelRegister("l6gXt", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $4208da26cd29cf31$export$a06f1c675e846f6f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $4208da26cd29cf31$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bj6bqn-0"
})({
    borderTop: `${"var(--ds-border, #ebedf0)"} solid 2px`,
    paddingTop: "var(--ds-space-050, 4px)",
    paddingBottom: "var(--ds-space-050, 4px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
});

});


parcelRegister("iaZQY", function(module, exports) {

$parcel$export(module.exports, "Picker", () => $19a5649568f0fe37$export$ba25329847403e11);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $9JgMO = parcelRequire("9JgMO");

var $i9cD6 = parcelRequire("i9cD6");

var $3L2h8 = parcelRequire("3L2h8");

var $e6BeY = parcelRequire("e6BeY");
const $19a5649568f0fe37$export$ba25329847403e11 = ({ ariaLabel: ariaLabel, isOpen: isOpen, value: value, onClose: onClose, onClearValues: onClearValues, fieldId: fieldId, fieldLabel: fieldLabel, fieldInvalidLabel: fieldInvalidLabel, onChange: onChange, formatOptionLabel: formatOptionLabel = (0, $3L2h8.default), onLoadOptions: onLoadOptions, pagination: pagination, PopupComponent: PopupComponent, onTrigger: onTrigger, initiallyAddSelectedFirst: initiallyAddSelectedFirst = true, showFooter: showFooter = true, popupProps: popupProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JgMO.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        key: fieldId,
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        popupComponent: PopupComponent,
        shouldRenderToParent: true,
        trigger: onTrigger,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e6BeY.DialogInner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i9cD6.default), {
                field: {
                    isRemovable: false,
                    label: fieldLabel || '',
                    invalidLabel: fieldInvalidLabel,
                    type: 'Filter',
                    key: fieldId,
                    defaultOptionsLabel: 'defaultOptionsLabel',
                    defaultOptions: true,
                    cacheOptions: false,
                    inputValue: 'string',
                    enableShowMore: true,
                    pagination: pagination,
                    loadOptions: onLoadOptions
                },
                onChange: onChange,
                value: value,
                formatOptionLabel: formatOptionLabel,
                onClear: onClearValues,
                initiallyAddSelectedFirst: initiallyAddSelectedFirst,
                showFooter: showFooter,
                ariaLabel: ariaLabel
            })),
        ...popupProps
    }));

});
parcelRegister("9JgMO", function(module, exports) {

$parcel$export(module.exports, "PaginatedPickerIntlProvider", () => $1c7e95589f101ad1$export$b61655080b0a1f32);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $hw6rP = parcelRequire("hw6rP");
const $1c7e95589f101ad1$var$i18n = $hw6rP;
const $1c7e95589f101ad1$var$getCodesFromLocale = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale || '');
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        country: country.toUpperCase()
    };
};
const $1c7e95589f101ad1$export$b61655080b0a1f32 = ({ children: children })=>{
    const intl = (0, $5JgJ2.default)();
    const { language: language, country: country } = $1c7e95589f101ad1$var$getCodesFromLocale(intl.locale.toString());
    const messages = $1c7e95589f101ad1$var$i18n[`${language}_${country}`] || $1c7e95589f101ad1$var$i18n[language] || $1c7e95589f101ad1$var$i18n.en;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        messages: messages,
        locale: intl.locale
    }, children);
};

});
parcelRegister("hw6rP", function(module, exports) {

$parcel$export(module.exports, "cs", () => (parcelRequire("6HFCJ")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("iLbxN")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("7XKea")).default);
$parcel$export(module.exports, "en", () => (parcelRequire("506SP")).default);
$parcel$export(module.exports, "en_GB", () => (parcelRequire("2SOXA")).default);
$parcel$export(module.exports, "en_ZZ", () => (parcelRequire("3ns4s")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("3iQA2")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("er8f7")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("2F3Ae")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("bX13n")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("29Giq")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("9hqrS")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("2IJJT")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("7DbxO")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("jtBbq")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("fCEDU")).default);
$parcel$export(module.exports, "pt_BR", () => (parcelRequire("79ITx")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("53wXM")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("19fCn")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("aExwg")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("kcSr2")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("jaoAw")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("x1Trj")).default);
$parcel$export(module.exports, "zh", () => (parcelRequire("1aY7d")).default);
$parcel$export(module.exports, "zh_TW", () => (parcelRequire("QnVs0")).default);

var $6HFCJ = parcelRequire("6HFCJ");

var $iLbxN = parcelRequire("iLbxN");

var $7XKea = parcelRequire("7XKea");

var $506SP = parcelRequire("506SP");

var $2SOXA = parcelRequire("2SOXA");

var $3ns4s = parcelRequire("3ns4s");

var $3iQA2 = parcelRequire("3iQA2");

var $er8f7 = parcelRequire("er8f7");

var $2F3Ae = parcelRequire("2F3Ae");

var $bX13n = parcelRequire("bX13n");

var $29Giq = parcelRequire("29Giq");

var $9hqrS = parcelRequire("9hqrS");

var $2IJJT = parcelRequire("2IJJT");

var $7DbxO = parcelRequire("7DbxO");

var $jtBbq = parcelRequire("jtBbq");

var $fCEDU = parcelRequire("fCEDU");

var $79ITx = parcelRequire("79ITx");

var $53wXM = parcelRequire("53wXM");

var $19fCn = parcelRequire("19fCn");

var $aExwg = parcelRequire("aExwg");

var $kcSr2 = parcelRequire("kcSr2");

var $jaoAw = parcelRequire("jaoAw");

var $x1Trj = parcelRequire("x1Trj");

var $1aY7d = parcelRequire("1aY7d");

var $QnVs0 = parcelRequire("QnVs0");

});
parcelRegister("6HFCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a289f7089e035599$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $a289f7089e035599$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Zru\u0161it v\xfdb\u011Br",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Na\u010D\xedt\xe1n\xed\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Zobrazit v\xedce",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} z\xa0{totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nebyly nalezeny \u017E\xe1dn\xe9 shody",
    'paginated-picker.async-select.select.option.error-message': "Na\u010Dten\xed dat se nezda\u0159ilo.",
    'paginated-picker.async-select.select.option.retry-message': "Kliknut\xedm opakovat",
    'paginated-picker.async-select.select.search-placeholder': 'Vyhledat',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Zobrazit \xfapln\xfd seznam"
};

});

parcelRegister("iLbxN", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b923b8ca9fefe7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $32b923b8ca9fefe7$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Ryd valgte',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Indl\xe6ser ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mere',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} af {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ingen match fundet',
    'paginated-picker.async-select.select.option.error-message': 'Data kunne ikke hentes',
    'paginated-picker.async-select.select.option.retry-message': "Klik for at pr\xf8ve igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8g",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis hele listen'
};

});

parcelRegister("7XKea", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6aca31abe5f0bbd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $a6aca31abe5f0bbd$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Auswahl l\xf6schen",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4dt\xa0...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mehr anzeigen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} von {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Keine Treffer gefunden',
    'paginated-picker.async-select.select.option.error-message': 'Daten konnten nicht abgerufen werden.',
    'paginated-picker.async-select.select.option.retry-message': 'Klicken, um es erneut zu versuchen',
    'paginated-picker.async-select.select.search-placeholder': 'Suchen',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Vollst\xe4ndige Liste anzeigen"
};

});

parcelRegister("506SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $632cb9b4822e8970$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $632cb9b4822e8970$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};

});

parcelRegister("2SOXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $40aa8993ae73212d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $40aa8993ae73212d$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Clear selection',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Click to retry',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Loading...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Show more',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} of {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No matches found',
    'paginated-picker.async-select.select.option.error-message': "Couldn't retrieve data",
    'paginated-picker.async-select.select.option.retry-message': 'Click to retry',
    'paginated-picker.async-select.select.search-placeholder': 'Search',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Show full list'
};

});

parcelRegister("3ns4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4f4c084f2334d2d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a4f4c084f2334d2d$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u2063\u2062Clear selection\u206E\x9d\u206B\u2060\u206D\x8f\u206B\u200C\u200D\u206C\x9d\u206E\u200C\u206B\u206D\u200C\u206C\u206F\u206F\u206B\u206E\x81\u2060\u206F\u206A\u200D\x8d\u206D\u200C\x8d\u2060\u061C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u2063\u2062Couldn't retrieve data\x81\u206A\u206D\u2060\u2061\u206F\x8d\u206E\u2060\x8d\u2060\u206C\u206E\u2061\u206E\x90\u206E\u200C\u200D\x81\u200D\u206F\u206C\u206D\x8d\u206B\x81\u206A\x8d\u200D\u206A\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u2063\u2062Click to retry\u206A\u200C\u206C\x8d\x9d\u206D\u2060\u200C\u206C\u206F\u206A\u206B\u206D\u206B\x8f\u206F\u206F\u206D\u206F\x8f\u206B\u206C\u2061\u061C\u206F\u061C\x8f\u206F\u200D\u2060\u206D\u206D\u2063\u2064",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u2063\u2062Loading...\u200D\u206C\u206E\x8f\u061C\u206D\u206D\u206B\u206D\x9d\u200D\x9d\u2061\x8f\u061C\u200C\x9d\u2060\x90\u2060\x90\u200C\u2061\u2061\x8d\x8f\x81\x8f\u2060\u206E\u206C\u200C\u2063\u2064",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u2063\u2062Show more\u206E\x81\x8f\u2060\x8d\u206A\u2061\u2060\x8d\x8d\x90\x8f\x8f\u200C\x90\u061C\x8f\u206A\x9d\u206C\u206F\x8d\u206D\u206D\u206F\u061C\x8d\x9d\u206C\u206B\u200D\u206D\u2063\u2064",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u2063\u2062{itemsCount} of {totalCount}\u206D\u206B\u061C\u206C\x8f\u206F\u206F\x8d\x90\u061C\u2060\u061C\u206D\u206C\x8f\u200D\x9d\u2060\u206E\x8f\u200D\u200C\u200D\u206F\u206D\u206A\x8d\x8d\u206C\u2060\x81\x8d\u2063\u2064",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u2063\u2062No matches found\u061C\x9d\x81\u2060\u206E\u200C\u200D\u206E\u206F\x9d\x8f\u206F\u206A\u200C\u2061\u206A\u2060\u200C\u2060\x9d\u206E\x90\x8d\u206C\x8d\u206E\x9d\u200C\u206A\x81\x9d\u206C\u2063\u2064",
    'paginated-picker.async-select.select.option.error-message': "\u2063\u2062Couldn't retrieve data\u206C\u206E\x90\u2060\x8d\u200C\u061C\u2061\u2061\x90\u206F\u206B\u200D\u200D\x9d\u206C\u206E\u206D\u200D\x9d\u206B\u206D\u206B\u206D\u206E\u206F\x90\x81\u200C\u206A\u206C\u206D\u2063\u2064",
    'paginated-picker.async-select.select.option.retry-message': "\u2063\u2062Click to retry\x8f\u206C\u200C\x81\u061C\u206E\u061C\u206B\u206C\x9d\u206D\u206C\u206F\u206F\u206C\u206E\x8d\u200C\u200D\x90\u206D\x8d\u206F\u206B\x81\u2060\u206F\x8d\u206E\u206A\x90\u206A\u2063\u2064",
    'paginated-picker.async-select.select.search-placeholder': "\u2063\u2062Search\u200D\u206D\x90\u061C\u200D\u206A\u206E\x90\u206A\u206C\u206F\u061C\u200C\u206A\x90\u206D\x81\u206C\x9d\u061C\u200D\u200D\x8f\u206D\u206D\x8d\x8f\u206E\x9d\u2060\u206F\u2060\u2063\u2064",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u2063\u2062Show full list\x90\u206D\u2061\u206E\u206A\u206B\u061C\u206C\u206B\u206E\u206A\u206E\u206D\x9d\u2061\x8f\x9d\u206B\u2060\u200D\x9d\u2061\u206B\u206B\u206A\x90\x81\u206C\x81\u200C\u206D\u200D\u2063\u2064"
};

});

parcelRegister("3iQA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $835c971e3a4ce49f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $835c971e3a4ce49f$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Borrar selecci\xf3n",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Cargando\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Mostrar m\xe1s",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'No se han encontrado coincidencias',
    'paginated-picker.async-select.select.option.error-message': 'No se han podido recuperar los datos',
    'paginated-picker.async-select.select.option.retry-message': 'Haz clic para intentarlo de nuevo',
    'paginated-picker.async-select.select.search-placeholder': 'Buscar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};

});

parcelRegister("er8f7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1508b0c2f5ab5f0d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $1508b0c2f5ab5f0d$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Tyhjenn\xe4 valinta",
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Ladataan...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "N\xe4yt\xe4 lis\xe4\xe4",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Ei hakutuloksia',
    'paginated-picker.async-select.select.option.error-message': 'Tietoja ei voitu noutaa',
    'paginated-picker.async-select.select.option.retry-message': "Yrit\xe4 uudelleen napsauttamalla",
    'paginated-picker.async-select.select.search-placeholder': 'Hae',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "N\xe4yt\xe4 koko luettelo"
};

});

parcelRegister("2F3Ae", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb7abce364033083$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $fb7abce364033083$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Effacer la s\xe9lection",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Chargement en cours\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Afficher plus',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} sur {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "R\xe9sultats introuvables",
    'paginated-picker.async-select.select.option.error-message': "Impossible de r\xe9cup\xe9rer les donn\xe9es",
    'paginated-picker.async-select.select.option.retry-message': "Cliquez pour r\xe9essayer",
    'paginated-picker.async-select.select.search-placeholder': 'Rechercher',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Afficher toute la liste'
};

});

parcelRegister("bX13n", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7a073da7fd0804$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $1c7a073da7fd0804$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Kijel\xf6l\xe9s megsz\xfcntet\xe9se",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Bet\xf6lt\xe9s\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "T\xf6bb",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nincs egyez\xe9s",
    'paginated-picker.async-select.select.option.error-message': "Nem siker\xfclt lek\xe9rni az adatokat",
    'paginated-picker.async-select.select.option.retry-message': "Kattints az \xfajrapr\xf3b\xe1lkoz\xe1shoz",
    'paginated-picker.async-select.select.search-placeholder': "Keres\xe9s",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Teljes lista megjelen\xedt\xe9se"
};

});

parcelRegister("29Giq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c987dc9aec46553a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $c987dc9aec46553a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Cancella selezione',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Caricamento in corso...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Mostra altro',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} di {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Nessuna corrispondenza trovata',
    'paginated-picker.async-select.select.option.error-message': 'Impossibile recuperare i dati',
    'paginated-picker.async-select.select.option.retry-message': 'Clicca per riprovare',
    'paginated-picker.async-select.select.search-placeholder': 'Ricerca',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Mostra l'elenco completo"
};

});

parcelRegister("9hqrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6efb32438f95737$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $b6efb32438f95737$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u9078\u629E\u3092\u89E3\u9664",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u8AAD\u307F\u8FBC\u307F\u4E2D\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u8868\u793A\u3092\u5897\u3084\u3059",
    'paginated-picker.async-select.pagination-details.of-total-count': "{totalCount} \u4EF6\u4E2D {itemsCount} \u4EF6",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u4E00\u81F4\u3059\u308B\u3082\u306E\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.error-message': "\u30C7\u30FC\u30BF\u3092\u53D6\u5F97\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F",
    'paginated-picker.async-select.select.option.retry-message': "\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u518D\u8A66\u884C",
    'paginated-picker.async-select.select.search-placeholder': "\u691C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u30EA\u30B9\u30C8\u5168\u4F53\u3092\u8868\u793A"
};

});

parcelRegister("2IJJT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cac9f8181a1f932$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $4cac9f8181a1f932$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\uC120\uD0DD \uD56D\uBAA9 \uC9C0\uC6B0\uAE30",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\uB85C\uB4DC \uC911...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\uB354 \uBCF4\uAE30",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\uC77C\uCE58\uD558\uB294 \uD56D\uBAA9 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.error-message': "\uB370\uC774\uD130\uB97C \uAC80\uC0C9\uD560 \uC218 \uC5C6\uC74C",
    'paginated-picker.async-select.select.option.retry-message': "\uD074\uB9AD\uD558\uC5EC \uB2E4\uC2DC \uC2DC\uB3C4",
    'paginated-picker.async-select.select.search-placeholder': "\uAC80\uC0C9",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\uC804\uCCB4 \uBAA9\uB85D \uD45C\uC2DC"
};

});

parcelRegister("7DbxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a4c2ae838ecd74$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $45a4c2ae838ecd74$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Fjern valg',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Laster\xa0\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Vis mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Finner ingen treff',
    'paginated-picker.async-select.select.option.error-message': 'Kan ikke hente data',
    'paginated-picker.async-select.select.option.retry-message': "Klikk for \xe5 pr\xf8ve igjen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf8k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Vis fullstendig liste'
};

});

parcelRegister("jtBbq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28df44c6d17dd11$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $c28df44c6d17dd11$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Selectie wissen',
    'paginated-picker.async-select.menu-list.error-message.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Laden...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Meer tonen',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} van {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': 'Geen overeenkomsten gevonden',
    'paginated-picker.async-select.select.option.error-message': 'Gegevens konden niet worden opgehaald',
    'paginated-picker.async-select.select.option.retry-message': 'Klik om het opnieuw te proberen',
    'paginated-picker.async-select.select.search-placeholder': 'Zoeken',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Volledige lijst weergeven'
};

});

parcelRegister("fCEDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c7e93519eddf0c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $c2c7e93519eddf0c$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Wyczy\u015B\u0107 wyb\xf3r",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0141adowanie...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Poka\u017C wi\u0119cej",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} z {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nie znaleziono dopasowa\u0144",
    'paginated-picker.async-select.select.option.error-message': "Nie mo\u017Cna pobra\u0107 danych",
    'paginated-picker.async-select.select.option.retry-message': "Kliknij, aby spr\xf3bowa\u0107 ponownie",
    'paginated-picker.async-select.select.search-placeholder': 'Szukaj',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Poka\u017C pe\u0142n\u0105 list\u0119"
};

});

parcelRegister("79ITx", function(module, exports) {

$parcel$export(module.exports, "default", () => $271f676353bede92$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $271f676353bede92$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Limpar sele\xe7\xe3o",
    'paginated-picker.async-select.menu-list.error-message.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.menu-list.error-message.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Carregando...',
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Ver mais',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} de {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Nenhuma correspond\xeancia encontrada",
    'paginated-picker.async-select.select.option.error-message': "N\xe3o foi poss\xedvel recuperar os dados",
    'paginated-picker.async-select.select.option.retry-message': 'Clique para tentar de novo',
    'paginated-picker.async-select.select.search-placeholder': 'Pesquisar',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Mostrar lista completa'
};

});

parcelRegister("53wXM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd0183db520fa1a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $ffd0183db520fa1a$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043D\u044F\u0442\u044C \u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430\u2026",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0420\u0430\u0437\u0432\u0435\u0440\u043D\u0443\u0442\u044C",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0438\u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0421\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u043F\u044B\u0442\u043A\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0438\u0441\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});

parcelRegister("19fCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c5ca5261ff7ee2$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $35c5ca5261ff7ee2$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Rensa urval',
    'paginated-picker.async-select.menu-list.error-message.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "L\xe4ser in ...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Visa mer',
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} av {totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Inga tr\xe4ffar hittades",
    'paginated-picker.async-select.select.option.error-message': "Det gick inte att h\xe4mta data",
    'paginated-picker.async-select.select.option.retry-message': "Klicka f\xf6r att f\xf6rs\xf6ka igen",
    'paginated-picker.async-select.select.search-placeholder': "S\xf6k",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Visa fullst\xe4ndig lista"
};

});

parcelRegister("aExwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $e537ab9897434c18$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Thai (Thailand)
var $e537ab9897434c18$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0E25\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E42\u0E2B\u0E25\u0E14...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0E08\u0E32\u0E01 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19",
    'paginated-picker.async-select.select.option.error-message': "\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E44\u0E14\u0E49",
    'paginated-picker.async-select.select.option.retry-message': "\u0E04\u0E25\u0E34\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07",
    'paginated-picker.async-select.select.search-placeholder': "\u0E04\u0E49\u0E19\u0E2B\u0E32",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u0E41\u0E2A\u0E14\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
};

});

parcelRegister("kcSr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5361a0c4fafff205$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Turkish (Turkey)
var $5361a0c4fafff205$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "Se\xe7imi temizle",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "Y\xfckleniyor...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Daha fazla g\xf6ster",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "E\u015Fle\u015Fme bulunamad\u0131",
    'paginated-picker.async-select.select.option.error-message': "Veriler al\u0131namad\u0131",
    'paginated-picker.async-select.select.option.retry-message': "Yeniden denemek i\xe7in t\u0131klay\u0131n",
    'paginated-picker.async-select.select.search-placeholder': 'Ara',
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Tam listeyi g\xf6ster"
};

});

parcelRegister("jaoAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb308a35aca4f0fd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Ukrainian (Ukraine)
var $eb308a35aca4f0fd$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
    'paginated-picker.async-select.pagination-details.of-total-count': "{itemsCount} \u0437 {totalCount}",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    'paginated-picker.async-select.select.option.error-message': "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u0434\u0430\u043D\u0456",
    'paginated-picker.async-select.select.option.retry-message': "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438 \u0441\u043F\u0440\u043E\u0431\u0443",
    'paginated-picker.async-select.select.search-placeholder': "\u041F\u043E\u0448\u0443\u043A",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u043E\u0432\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A"
};

});

parcelRegister("x1Trj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fae111af27e5250$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Vietnamese (Vietnam)
var $7fae111af27e5250$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "X\xf3a m\u1EE5c \u0111\xe3 ch\u1ECDn",
    'paginated-picker.async-select.menu-list.error-message.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u0110ang t\u1EA3i...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "Hi\u1EC3n th\u1ECB th\xeam",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xf9 h\u1EE3p n\xe0o",
    'paginated-picker.async-select.select.option.error-message': "Kh\xf4ng th\u1EC3 truy xu\u1EA5t d\u1EEF li\u1EC7u",
    'paginated-picker.async-select.select.option.retry-message': "Nh\u1EA5p v\xe0o \u0111\u1EC3 th\u1EED l\u1EA1i",
    'paginated-picker.async-select.select.search-placeholder': "T\xecm ki\u1EBFm",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "Hi\u1EC3n th\u1ECB danh s\xe1ch \u0111\u1EA7y \u0111\u1EE7"
};

});

parcelRegister("1aY7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7858a90a35e9e24$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $a7858a90a35e9e24$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u7A7A\u9009\u62E9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u52A0\u8F7D...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u663E\u793A\u66F4\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount}/{totalCount}',
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u672A\u627E\u5230\u5339\u914D\u9879",
    'paginated-picker.async-select.select.option.error-message': "\u65E0\u6CD5\u68C0\u7D22\u6570\u636E",
    'paginated-picker.async-select.select.option.retry-message': "\u70B9\u51FB\u91CD\u8BD5",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u7D22",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u663E\u793A\u5B8C\u6574\u5217\u8868"
};

});

parcelRegister("QnVs0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2f4a52563a2b84$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $0f2f4a52563a2b84$export$2e2bcd8739ae039 = {
    'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': "\u6E05\u9664\u9078\u53D6\u5167\u5BB9",
    'paginated-picker.async-select.menu-list.error-message.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.menu-list.error-message.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.menu-list.loading-message.loading-message': "\u6B63\u5728\u8F09\u5165...",
    'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': "\u986F\u793A\u8F03\u591A",
    'paginated-picker.async-select.pagination-details.of-total-count': "\u7B2C {itemsCount} \u500B\uFF0C\u5171 {totalCount} \u500B",
    'paginated-picker.async-select.select.no-options-message.no-options-message': "\u627E\u4E0D\u5230\u76F8\u7B26\u9805\u76EE",
    'paginated-picker.async-select.select.option.error-message': "\u7121\u6CD5\u64F7\u53D6\u8CC7\u6599",
    'paginated-picker.async-select.select.option.retry-message': "\u6309\u4E00\u4E0B\u4EE5\u91CD\u8A66",
    'paginated-picker.async-select.select.search-placeholder': "\u641C\u5C0B",
    'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': "\u986F\u793A\u5B8C\u6574\u6E05\u55AE"
};

});



parcelRegister("3L2h8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7985025958b29c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $afcon = parcelRequire("afcon");

var $cVlyg = parcelRequire("cVlyg");

var $5EpoR = parcelRequire("5EpoR");
const $bf7985025958b29c$var$formatOptionLabel = (option)=>{
    if (option.optionType === 'option') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cVlyg.IconOptionLabel), {
        option: option
    });
    if (option.optionType === 'avatar') return option.hideAvatar === true ? option.label : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $afcon.AvatarOptionLabel), {
        avatarOption: option
    });
    if (option.optionType === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5EpoR.LozengeOptionLabel), {
        lozengeOption: option
    });
    // eslint-disable-next-line no-console
    console.error('`formatOptionLabel` was passed an unsupported `SelectOption`:', option);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null);
};
var $bf7985025958b29c$export$2e2bcd8739ae039 = $bf7985025958b29c$var$formatOptionLabel;

});
parcelRegister("afcon", function(module, exports) {

$parcel$export(module.exports, "AvatarOptionLabel", () => $ef3ba7572ed089db$export$fe00f602c942368a);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $kbvmn = parcelRequire("kbvmn");
const $ef3ba7572ed089db$export$fe00f602c942368a = ({ avatarOption: avatarOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        src: typeof avatarOption.avatar !== 'string' ? undefined : avatarOption.avatar,
        size: "xsmall",
        appearance: typeof avatarOption.square === 'boolean' && avatarOption.square ? 'square' : 'circle'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledChild), null, avatarOption.label));

});
parcelRegister("kbvmn", function(module, exports) {

$parcel$export(module.exports, "StyledChild", () => $49dae273c561e400$export$8133811dea85f484);
$parcel$export(module.exports, "StyledOption", () => $49dae273c561e400$export$844bee7de236d7ec);
$parcel$export(module.exports, "StyledItem", () => $49dae273c561e400$export$7c16ae7705e422c4);
$parcel$export(module.exports, "StyledChildIcon", () => $49dae273c561e400$export$c23e66fb1706d7dd);
$parcel$export(module.exports, "StyledOptionIcon", () => $49dae273c561e400$export$20da797b837461ca);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $49dae273c561e400$export$8133811dea85f484 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-3nijrx-0"
})({
    margin: "var(--ds-space-050, 4px)",
    minWidth: 0
});
const $49dae273c561e400$export$844bee7de236d7ec = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-3nijrx-1"
})({
    alignItems: 'center',
    display: 'flex'
});
const $49dae273c561e400$export$7c16ae7705e422c4 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-3nijrx-2"
})({
    display: 'flex'
});
const $49dae273c561e400$export$c23e66fb1706d7dd = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-3nijrx-3"
})({
    marginLeft: "var(--ds-space-100, 8px)"
});
const $49dae273c561e400$export$20da797b837461ca = /*#__PURE__*/ (0, $kwce8.default).img.withConfig({
    componentId: "sc-3nijrx-4"
})({
    borderRadius: '50%',
    height: '16px',
    width: '16px',
    display: 'flex',
    margin: "var(--ds-space-025, 2px)"
});

});


parcelRegister("cVlyg", function(module, exports) {

$parcel$export(module.exports, "IconOptionLabel", () => $f716e15df5f66385$export$914fa095fc1e0a45);

var $eUqFw = parcelRequire("eUqFw");

var $kbvmn = parcelRequire("kbvmn");
const $f716e15df5f66385$export$914fa095fc1e0a45 = ({ option: option })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledItem), null, option.icon !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledOptionIcon), {
        src: option.icon,
        alt: option.label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledChildIcon), null, option.label)));

});

parcelRegister("5EpoR", function(module, exports) {

$parcel$export(module.exports, "LozengeOptionLabel", () => $69f91415b853a267$export$5f70fe304106fcb1);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $kbvmn = parcelRequire("kbvmn");
const $69f91415b853a267$export$5f70fe304106fcb1 = ({ lozengeOption: lozengeOption })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledOption), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledChild), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kbvmn.StyledItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: lozengeOption.appearance,
        isBold: lozengeOption.isBold,
        maxWidth: lozengeOption.maxWidth
    }, lozengeOption.label))));

});


parcelRegister("e6BeY", function(module, exports) {

$parcel$export(module.exports, "DialogInner", () => $c2daf5396958a238$export$999ca5bf223f627);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $c2daf5396958a238$export$999ca5bf223f627 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "mzm5tv-0"
})({
    minWidth: '220px'
});

});


parcelRegister("deDZF", function(module, exports) {

$parcel$export(module.exports, "formatLabel", () => $6821d2220e383e22$export$957d7daebd899f12);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $1Yimi = parcelRequire("1Yimi");

var $3lB8J = parcelRequire("3lB8J");
const $6821d2220e383e22$export$96bdbc84526f3739 = (value)=>Array.isArray(value) ? value.length > 0 : !!value;
const $6821d2220e383e22$export$957d7daebd899f12 = (label = '', value)=>{
    if (!value || !$6821d2220e383e22$export$96bdbc84526f3739(value)) return label;
    const [firstValue, ...otherValues] = value.map((v)=>v.label ?? '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lB8J.Container), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "strong",
        color: "inherit"
    }, label, ":"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lB8J.LabelValueWrapper), null, firstValue, otherValues.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3lB8J.BadgeWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), null, `+${otherValues.length}`))));
};

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("3lB8J", function(module, exports) {

$parcel$export(module.exports, "BadgeWrapper", () => $f704a4760a9c4f79$export$1a37a8b7ddf809ac);
$parcel$export(module.exports, "Container", () => $f704a4760a9c4f79$export$42a852a2b6b56249);
$parcel$export(module.exports, "LabelValueWrapper", () => $f704a4760a9c4f79$export$8f3477ca2c4ba51a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $f704a4760a9c4f79$export$1a37a8b7ddf809ac = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1abwl2h-0"
})({
    display: 'inline-flex',
    marginLeft: "var(--ds-space-050, 4px)",
    opacity: 0.5
});
const $f704a4760a9c4f79$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1abwl2h-1"
})({
    display: 'inline-flex',
    alignItems: 'center'
});
const $f704a4760a9c4f79$export$8f3477ca2c4ba51a = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1abwl2h-2"
})({
    marginLeft: "var(--ds-space-050, 4px)",
    display: 'inline-flex',
    alignItems: 'center'
});

});


parcelRegister("jK36y", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a8cda6db3d67303$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $9JgMO = parcelRequire("9JgMO");

var $14dMb = parcelRequire("14dMb");

var $44GuB = parcelRequire("44GuB");

var $gslSl = parcelRequire("gslSl");
const $4a8cda6db3d67303$var$PickerTrigger = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, isInvalid: isInvalid, isSelected: isSelected, isLoading: isLoading, hasValues: hasValues, onClick: onClick, onClear: onClear, testId: testId }, ref)=>{
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JgMO.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44GuB.LoadingStateAnimationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        isSelected: true,
        testId: testId
    }, children, ":")));
    // TODO : fix spacing.. this is overlapping with the Chevron
    const iconAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $14dMb.ClearButton), {
        onClick: (e)=>{
            e.stopPropagation();
            onClear?.();
        },
        label: "Remove criteria"
    });
    const Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gslSl.ChildrenWrapper), null, children), onClear ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gslSl.StyledClose), null, iconAfter) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gslSl.StyledChevron), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: ""
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9JgMO.PaginatedPickerIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gslSl.ButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: isInvalid ? 'danger' : 'default',
        isSelected: isSelected || hasValues,
        onClick: onClick,
        ref: ref,
        testId: testId,
        "aria-expanded": isSelected
    }, Content)));
});
var $4a8cda6db3d67303$export$2e2bcd8739ae039 = $4a8cda6db3d67303$var$PickerTrigger;

});
parcelRegister("14dMb", function(module, exports) {

$parcel$export(module.exports, "ClearButton", () => $510ba2d41275e13b$export$13ec83e50bf04290);

var $eUqFw = parcelRequire("eUqFw");

var $je5kZ = parcelRequire("je5kZ");

var $cMKTA = parcelRequire("cMKTA");
const $510ba2d41275e13b$export$13ec83e50bf04290 = ({ label: label, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cMKTA.StyledClearButton), {
        ...props,
        "data-testid": "paginated-picker.ui.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: label
    }));
$510ba2d41275e13b$export$13ec83e50bf04290.defaultProps = {
    isSelected: false,
    type: 'button'
};
var $510ba2d41275e13b$export$2e2bcd8739ae039 = $510ba2d41275e13b$export$13ec83e50bf04290;

});
parcelRegister("cMKTA", function(module, exports) {

$parcel$export(module.exports, "StyledClearButton", () => $48fec5852206507a$export$969a0501aa28855a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");


var $lcnyw = parcelRequire("lcnyw");
const $48fec5852206507a$export$969a0501aa28855a = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "m9cwqf-0"
})({
    background: 0,
    border: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)() / 2}px`,
    color: `var(--ds-text-subtlest, ${(0, $73a5c9d720aa66e1$export$8754fc7e6d8b3000)})`,
    cursor: 'pointer',
    height: "var(--ds-space-300, 24px)",
    lineHeight: 1,
    outline: 0,
    padding: 0,
    position: 'absolute',
    right: "var(--ds-space-050, 4px)",
    top: '50%',
    marginTop: "var(--ds-space-negative-150, -12px)",
    transition: 'background-color 200ms opacity 200ms',
    width: "var(--ds-space-300, 24px)",
    '&:hover, &:focus': {
        color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$5f71e19f3a7ad9de)})`
    }
});

});


parcelRegister("44GuB", function(module, exports) {

$parcel$export(module.exports, "LoadingStateAnimationWrapper", () => $3cf41d8cd232204f$export$c7a90a9f6120efb7);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $3cf41d8cd232204f$export$c7a90a9f6120efb7 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-13besx7-0"
})({
    position: 'relative',
    animation: 'flickerAnimation 2s infinite',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes flickerAnimation': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 0.5
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 1
        }
    }
});

});

parcelRegister("gslSl", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $6161f6171df0c50f$export$d53c836cccbb0d90);
$parcel$export(module.exports, "ChildrenWrapper", () => $6161f6171df0c50f$export$d9eb77d8aa91d4c8);
$parcel$export(module.exports, "StyledChevron", () => $6161f6171df0c50f$export$d2e6432fd8e55c4f);
$parcel$export(module.exports, "StyledClose", () => $6161f6171df0c50f$export$cd8104a6ec6bb897);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");
const $6161f6171df0c50f$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bg0ktc-0"
})({
    position: 'relative'
});
const $6161f6171df0c50f$export$d9eb77d8aa91d4c8 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bg0ktc-1"
})({
    paddingRight: "var(--ds-space-200, 16px)"
});
const $6161f6171df0c50f$export$d2e6432fd8e55c4f = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bg0ktc-2"
})({
    background: 0,
    border: 0,
    height: "var(--ds-space-300, 24px)",
    lineHeight: 1,
    outline: 0,
    padding: 0,
    position: 'absolute',
    right: '0px',
    top: '50%',
    marginTop: "var(--ds-space-negative-150, -12px)",
    width: "var(--ds-space-300, 24px)"
});
const $6161f6171df0c50f$export$cd8104a6ec6bb897 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1bg0ktc-3"
})({
    background: 0,
    border: 0,
    height: "var(--ds-space-300, 24px)",
    lineHeight: 1,
    outline: 0,
    padding: 0,
    position: 'absolute',
    right: "var(--ds-space-negative-050, -4px)",
    top: '50%',
    marginTop: "var(--ds-space-negative-150, -12px)",
    width: "var(--ds-space-300, 24px)"
});

});


parcelRegister("7xXaN", function(module, exports) {

$parcel$export(module.exports, "messages", () => $57e9840a85c79f43$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $57e9840a85c79f43$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueType: {
        id: 'jira-common.ListProjectForms.IssueType',
        defaultMessage: 'Issue type',
        description: 'A button label for a dropdown listing issue types used for forms.'
    },
    requestType: {
        id: 'jira-common.ListProjectForms.RequestType',
        defaultMessage: 'Request type',
        description: 'A button label for a dropdown listing request types used for forms.'
    },
    issueTypeAriaLabel: {
        id: 'jira-common.ListProjectForms.IssueTypeAriaLabel',
        defaultMessage: 'Search issue types',
        description: 'Aria label for issue types picker'
    },
    requestTypeAriaLabel: {
        id: 'jira-common.ListProjectForms.RequestTypeAriaLabel',
        defaultMessage: 'Search request types',
        description: 'Aria label for request types picker'
    }
});

});



parcelRegister("gyqTW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c0d4b0606346063e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c0d4b0606346063e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    createFormLabel: {
        id: 'proforma-project-forms.CreateForm',
        defaultMessage: 'Create form',
        description: 'Label for a button for creating a new Jira form.'
    },
    description: {
        id: 'proforma-project-forms.Description',
        defaultMessage: 'Create, edit, export, and delete forms. Copy forms and use them in other projects.',
        description: 'A description of the actions available on the Jira project forms page.'
    },
    learnMoreLinkLabel: {
        id: 'proforma-project-forms.LearnMore',
        defaultMessage: 'Learn more about forms.',
        description: 'Label for a button with more information about Jira forms.'
    },
    loading: {
        id: 'proforma-project-forms.LoadingForms',
        defaultMessage: 'Loading...',
        description: 'The message for the primary loading spinner on the Jira project forms page.'
    },
    noFormsDescriptionJsm: {
        id: 'proforma-project-forms.NoFormsDescriptionJsm',
        defaultMessage: 'Add forms for customers to fill out when raising a request, or attach forms to existing issues to gather more information.',
        description: 'The description when there are no forms on the Jira project forms page in a JSM project.'
    },
    noFormsDescriptionJsw: {
        id: 'proforma-project-forms.NoFormsDescriptionJsw',
        defaultMessage: 'Add forms for customers to fill out when creating an issue, or attach forms to existing issues to gather more information.',
        description: 'The description when there are no forms on the Jira project forms page in a JSW project.'
    },
    noFormsDescriptionJwm: {
        id: 'proforma-project-forms.NoFormsDescriptionJwm',
        defaultMessage: 'Add forms for customers to fill out when creating an item, or attach forms to existing issues to gather more information.',
        description: 'The description when there are no forms on the Jira project forms page in a JWM project.'
    },
    noFormsHeading: {
        id: 'proforma-project-forms.NoFormsHeading',
        defaultMessage: 'All of your forms will show up here',
        description: 'The heading when there are no forms on the Jira project forms page.'
    },
    pageHeadingJwm: {
        id: 'proforma-project-forms.BusinessForms',
        defaultMessage: 'Advanced Forms',
        description: 'The heading of the Jira project forms (list) page for JWM projects.'
    },
    pageHeadingNonJwm: {
        id: 'proforma-project-forms.Forms',
        defaultMessage: 'Forms',
        description: 'The heading of the Jira project forms (list) page for non-JWM projects.'
    }
});

});

parcelRegister("cdCbx", function(module, exports) {

$parcel$export(module.exports, "Description", () => $8e5451b0d344338e$export$393edc798c47379d);
$parcel$export(module.exports, "HeadingContainer", () => $8e5451b0d344338e$export$9204afa15bdaec56);
$parcel$export(module.exports, "NoFormsColumn", () => $8e5451b0d344338e$export$ef6be50c6b1bf75d);
$parcel$export(module.exports, "NoFormsDescription", () => $8e5451b0d344338e$export$c4b08a3b2c9bb79b);
$parcel$export(module.exports, "NoFormsLearnMoreLink", () => $8e5451b0d344338e$export$2d4dc85665f08d27);
$parcel$export(module.exports, "NoFormsHeading", () => $8e5451b0d344338e$export$cab51723f6d096b6);
$parcel$export(module.exports, "ProjectFormsWrapper", () => $8e5451b0d344338e$export$e2eec2297409c511);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $exJuA = parcelRequire("exJuA");
const $8e5451b0d344338e$export$393edc798c47379d = (0, $exJuA.default).div({
    display: 'flex',
    alignItems: 'center',
    marginBottom: "var(--ds-space-400, 32px)"
});
const $8e5451b0d344338e$export$9204afa15bdaec56 = (0, $exJuA.default).span({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    'h1, h1 > span': {
        fontSize: '24px',
        fontWeight: 500
    }
});
const $8e5451b0d344338e$export$ef6be50c6b1bf75d = (0, $exJuA.default).div({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
});
const $8e5451b0d344338e$export$c4b08a3b2c9bb79b = (0, $exJuA.default).div({
    textAlign: 'center',
    width: '425px'
});
const $8e5451b0d344338e$export$2d4dc85665f08d27 = (0, $exJuA.default).div({
    marginBottom: "var(--ds-space-400, 32px)",
    textAlign: 'center'
});
const $8e5451b0d344338e$export$cab51723f6d096b6 = (0, $exJuA.default).h3({
    paddingBottom: "var(--ds-space-100, 8px)"
});
const $8e5451b0d344338e$export$e2eec2297409c511 = (0, $exJuA.default).div({
    maxWidth: '1000px'
});

});



parcelRegister("9b9Za", function(module, exports) {

$parcel$export(module.exports, "AsyncBenefitModal", () => $6463293396e5176b$export$efc5bc86e2f54c1c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

const $6463293396e5176b$var$LazyBenefitModal = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aeMh1")), {
    moduleId: "./src/packages/proforma/project-forms-settings/src/ui/benefit-modal/main.tsx"
});
const $6463293396e5176b$var$BenefitModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "proforma-forms-settings-benefit-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6463293396e5176b$var$LazyBenefitModal, null));
const $6463293396e5176b$export$efc5bc86e2f54c1c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "ProformaFormsSettings",
        packageName: "jiraProformaFormSettingsBenefitModal",
        teamName: "jsm-request-intake"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6463293396e5176b$var$BenefitModal, null));

});
parcelRegister("aeMh1", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("8nnAr")
]).then(()=>parcelRequire('3yFqg'));

});


parcelRegister("iosa4", function(module, exports) {

$parcel$export(module.exports, "FormSettingsTemplateLibrary", () => $cf6d58f15c25a64e$export$830400ba49ddf12b);

var $eUqFw = parcelRequire("eUqFw");

var $lp2wv = parcelRequire("lp2wv");

var $lB25E = parcelRequire("lB25E");

var $jeTGi = parcelRequire("jeTGi");
function $cf6d58f15c25a64e$export$830400ba49ddf12b({ projectId: projectId }) {
    const { callCreateForm: callCreateForm } = (0, $jeTGi.useCreateForm)(projectId);
    const [{ location: location }, { push: push }] = (0, $lB25E.useRouter)();
    const handleTemplateSelected = (0, $eUqFw.useCallback)(async (templateId, template)=>{
        const result = await callCreateForm({
            templateId: templateId,
            template: template
        });
        if (result) push(`${location.pathname}/form/${result.form.id}/edit`);
    }, [
        push,
        callCreateForm,
        location.pathname
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lp2wv.ProformaTemplateLibraryInDrawer), {
        onTemplateSelected: handleTemplateSelected
    });
}

});
parcelRegister("lp2wv", function(module, exports) {

$parcel$export(module.exports, "ProformaTemplateLibraryInDrawer", () => $f50ac62457184aba$export$8c06e3ce3a085ee);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $2rSXm = parcelRequire("2rSXm");

var $jvRd3 = parcelRequire("jvRd3");

var $9IbuV = parcelRequire("9IbuV");

var $iddOY = parcelRequire("iddOY");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f50ac62457184aba$var$LazyProformaTemplateLibrary = (0, $7rh0R.lazy)(()=>(parcelRequire("6cNDt")).then(({ ProformaTemplateLibraryWithAnalytics: ProformaTemplateLibraryWithAnalytics })=>ProformaTemplateLibraryWithAnalytics), {
    moduleId: "./src/packages/proforma/proforma-template-library/src/ui/main.tsx"
});
const $f50ac62457184aba$var$LazyProformaTemplateLibraryWithUFO = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $iddOY.proformaTemplateLibraryExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f50ac62457184aba$var$LazyProformaTemplateLibrary, props);
};
const $f50ac62457184aba$export$8c06e3ce3a085ee = (props)=>{
    const { isTemplateLibraryOpen: isTemplateLibraryOpen } = (0, $jvRd3.useTemplateLibraryState)();
    const { setIsTemplateLibraryOpen: setIsTemplateLibraryOpen } = (0, $jvRd3.useTemplateLibraryActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2rSXm.default), {
        testId: "proforma-template-library.ui.proforma-template-library-drawer",
        isOpen: isTemplateLibraryOpen,
        onClose: ()=>setIsTemplateLibraryOpen(false),
        width: "full",
        // eslint-disable-next-line @atlaskit/design-system/no-deprecated-apis
        overrides: {
            Content: {
                cssFn: (defaultStyles)=>({
                        ...defaultStyles,
                        marginTop: 0
                    })
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f50ac62457184aba$var$LazyProformaTemplateLibraryWithUFO, props)));
};

});
parcelRegister("2rSXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0a48bc8d72d6d66$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $eUqFw = parcelRequire("eUqFw");

var $kQ44K = parcelRequire("kQ44K");

var $lUFyV = parcelRequire("lUFyV");

var $knRXm = parcelRequire("knRXm");
var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $gmZvv = parcelRequire("gmZvv");

var $1QW6V = parcelRequire("1QW6V");

var $lCxnN = parcelRequire("lCxnN");
// escape close manager for layering
const $b0a48bc8d72d6d66$var$EscapeCloseManager = ({ onClose: onClose })=>{
    // wrap so that we can cast the event to a React.KeyboardEvent
    const handleClose = (0, $eUqFw.useCallback)((evt)=>{
        onClose && onClose(evt);
    }, [
        onClose
    ]);
    (0, $eN43R.useCloseOnEscapePress)({
        onClose: handleClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
};
const $b0a48bc8d72d6d66$export$4071300121a182f5 = ({ width: width = 'narrow', isOpen: isOpen, isFocusLockEnabled: isFocusLockEnabled = true, shouldReturnFocus: shouldReturnFocus = true, autoFocusFirstElem: autoFocusFirstElem = true, onKeyDown: onKeyDown, onClose: onClose, testId: testId, children: children, icon: icon, closeLabel: closeLabel, scrollContentLabel: scrollContentLabel, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, overrides: // eslint-disable-next-line @repo/internal/react/consistent-props-definitions
overrides, zIndex: zIndex = 'unset', label: label, titleId: titleId, enterFrom: enterFrom })=>{
    const body = (0, $kQ44K.canUseDOM) ? document.querySelector('body') : undefined;
    const handleClose = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose && onClose(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'escKey'
        }
    });
    const handleKeyDown = (0, $eUqFw.useCallback)((evt)=>{
        onKeyDown && onKeyDown(evt);
        if (!(0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p')) // when feature flag on, we will use the EscapeCloseManager instead
        {
            if (evt.key === 'Escape' && isOpen && onClose) handleClose(evt);
        }
    }, [
        handleClose,
        isOpen,
        onClose,
        onKeyDown
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleKeyDown,
        isOpen
    ]);
    const handleBlanketClick = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose && onClose(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'blanket'
        }
    });
    const handleBackButtonClick = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (evt, analyticsEvent)=>onClose && onClose(evt, analyticsEvent),
        action: 'dismissed',
        componentName: 'drawer',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: {
            trigger: 'backButton'
        }
    });
    if (!body) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gmZvv.default), {
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QW6V.default), {
        isOpen: isOpen,
        onBlanketClicked: handleBlanketClick,
        testId: testId && `${testId}--blanket`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lCxnN.default), {
        testId: testId,
        icon: icon,
        closeLabel: closeLabel,
        in: isOpen,
        onClose: handleBackButtonClick,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        width: width,
        enterFrom: enterFrom,
        label: label,
        titleId: titleId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        overrides: overrides,
        autoFocusFirstElem: autoFocusFirstElem,
        isFocusLockEnabled: isFocusLockEnabled,
        shouldReturnFocus: shouldReturnFocus,
        scrollContentLabel: scrollContentLabel
    }, isOpen && (0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $knRXm.UNSAFE_LAYERING), {
        isDisabled: false
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0a48bc8d72d6d66$var$EscapeCloseManager, {
        onClose: handleClose
    })) : children));
};
var $b0a48bc8d72d6d66$export$2e2bcd8739ae039 = $b0a48bc8d72d6d66$export$4071300121a182f5;

});
parcelRegister("1QW6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a36b58e6bd50959$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $51vNN = parcelRequire("51vNN");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");

var $b1Dsm = parcelRequire("b1Dsm");
function $0a36b58e6bd50959$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0a36b58e6bd50959$var$blanketStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
/**
 * A wrapper around `@atlaskit/blanket` that adds a fade in/out transition.
 */ const $0a36b58e6bd50959$var$Blanket = ({ isOpen: isOpen, onBlanketClicked: onBlanketClicked, testId: testId })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hYDGa.default), {
        /**
     * We double the duration because the fade in keyframes have
     * `opacity: 1` at `50%`.
     *
     * The fade out animation uses half the passed duration so it evens out.
     */ duration: (0, $b1Dsm.transitionDurationMs) * 2,
        /**
     * We don't expose this on `FadeIn` but it does get passed down.
     * TODO: figure out how we want to handle this...
     */ // @ts-ignore
        animationTimingFunction: (0, $b1Dsm.animationTimingFunction)
    }, ({ className: className })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $0a36b58e6bd50959$var$blanketStyles,
            className: className
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $51vNN.default), {
            isTinted: true,
            onBlanketClicked: onBlanketClicked,
            testId: testId && testId
        }))));
};
var $0a36b58e6bd50959$export$2e2bcd8739ae039 = $0a36b58e6bd50959$var$Blanket;

});
parcelRegister("b1Dsm", function(module, exports) {

$parcel$export(module.exports, "transitionDurationMs", () => $6978d4d7113b0ab0$export$614e920ab938d7a6);
$parcel$export(module.exports, "animationTimingFunction", () => $6978d4d7113b0ab0$export$aa1acbd7fbaf45a2);

const $6978d4d7113b0ab0$export$3105270315df0e7 = '0.22s';
const $6978d4d7113b0ab0$export$614e920ab938d7a6 = 220;
const $6978d4d7113b0ab0$export$5cc90842f5a0bf76 = (0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0);
const $6978d4d7113b0ab0$export$790206ddaae8bb6a = [
    'narrow',
    'medium',
    'wide',
    'extended',
    'full'
];
const $6978d4d7113b0ab0$export$8fc1e0a9d795944b = [
    'top',
    'right',
    'bottom',
    'left'
];
const $6978d4d7113b0ab0$export$aa1acbd7fbaf45a2 = ()=>(0, $d58b680a02f4d6a4$export$57636bb43b1ccbb0);
const $6978d4d7113b0ab0$export$95a69bf7d3b83292 = {
    isFocusLockEnabled: true,
    shouldReturnFocus: true,
    autoFocusFirstElem: true
};

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';



parcelRegister("lCxnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f17f6dc1070e86$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $gpZWO = parcelRequire("gpZWO");

var $lSV8Z = parcelRequire("lSV8Z");
var $2EVgw = parcelRequire("2EVgw");

var $b1Dsm = parcelRequire("b1Dsm");

var $kukku = parcelRequire("kukku");

var $iN5oW = parcelRequire("iN5oW");

var $8MC6T = parcelRequire("8MC6T");

var $30AqF = parcelRequire("30AqF");

var $74wVy = parcelRequire("74wVy");
// Misc.
// ------------------------------
const $37f17f6dc1070e86$var$defaults = {
    Sidebar: (0, $74wVy.default),
    Content: (0, $iN5oW.default)
};
/**
 * This wrapper is used to specify separate durations for enter and exit.
 */ const $37f17f6dc1070e86$var$CustomSlideIn = ({ children: children, onFinish: onFinish, enterFrom: enterFrom })=>{
    const { isExiting: isExiting } = (0, $lSV8Z.useExitingPersistence)();
    /**
   * The actual duration should be the same for both enter and exit,
   * but motion halves the passed duration for exit animations,
   * so we double it when exiting.
   */ const duration = isExiting ? (0, $b1Dsm.transitionDurationMs) * 2 : (0, $b1Dsm.transitionDurationMs);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2EVgw.default), {
        animationTimingFunction: (0, $b1Dsm.animationTimingFunction),
        duration: duration,
        enterFrom: enterFrom,
        exitTo: enterFrom,
        fade: "none",
        onFinish: onFinish
    }, children);
};
const $37f17f6dc1070e86$var$DrawerPrimitive = ({ children: children, icon: Icon, closeLabel: closeLabel = 'Close drawer', scrollContentLabel: scrollContentLabel, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, overrides: overrides, testId: testId, in: isOpen, shouldReturnFocus: shouldReturnFocus, autoFocusFirstElem: autoFocusFirstElem, isFocusLockEnabled: isFocusLockEnabled, width: width, label: label, titleId: titleId, enterFrom: enterFrom = 'left' })=>{
    const getOverrides = (0, $kukku.createExtender)($37f17f6dc1070e86$var$defaults, overrides);
    const { component: Sidebar, ...sideBarOverrides } = getOverrides('Sidebar');
    const { component: Content, ...contentOverrides } = getOverrides('Content');
    /**
   * A ref to point to our wrapper, passed to `onCloseComplete` and `onOpenComplete` callbacks.
   */ const drawerRef = (0, $eUqFw.useRef)(null);
    const onFinish = (0, $eUqFw.useCallback)((state)=>{
        if (state === 'entering') onOpenComplete?.(drawerRef.current);
        else if (state === 'exiting') onCloseComplete?.(drawerRef.current);
    }, [
        onCloseComplete,
        onOpenComplete
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), {
        appear: true
    }, isOpen && /*#__PURE__*/ (0, $byn9U.jsx)($37f17f6dc1070e86$var$CustomSlideIn, {
        onFinish: onFinish,
        enterFrom: enterFrom
    }, ({ className: className })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $30AqF.default), {
            autoFocusFirstElem: autoFocusFirstElem,
            isFocusLockEnabled: isFocusLockEnabled,
            shouldReturnFocus: shouldReturnFocus
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8MC6T.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            width: width,
            testId: testId,
            drawerRef: drawerRef,
            label: label,
            titleId: titleId
        }, /*#__PURE__*/ (0, $byn9U.jsx)(Sidebar, sideBarOverrides, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
            onClick: onClose,
            testId: testId && 'DrawerPrimitiveSidebarCloseButton',
            icon: Icon ? (iconProps)=>/*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
                    ...iconProps,
                    size: "large"
                }) : (0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))),
            label: closeLabel,
            shape: "circle",
            appearance: "subtle"
        })), /*#__PURE__*/ (0, $byn9U.jsx)(Content, {
            scrollContentLabel: scrollContentLabel,
            ...contentOverrides
        }, children)))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$37f17f6dc1070e86$export$2e2bcd8739ae039 = $37f17f6dc1070e86$var$DrawerPrimitive;

});
parcelRegister("gpZWO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf3f089e16becc19$var$_react = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $igPbh = parcelRequire("igPbh");

var $bf3f089e16becc19$var$_arrowLeft = $bf3f089e16becc19$var$_interopRequireDefault((parcelRequire("f4v4a")));
function $bf3f089e16becc19$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bf3f089e16becc19$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $bf3f089e16becc19$var$_react.default.createElement($igPbh.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $bf3f089e16becc19$var$_arrowLeft.default
    }));
$bf3f089e16becc19$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $bf3f089e16becc19$var$_default = module.exports.default = $bf3f089e16becc19$var$ArrowLeftIcon;

});
parcelRegister("f4v4a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af8f53d2717afebc$var$_react = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $af8f53d2717afebc$var$_UNSAFE_baseNew = $af8f53d2717afebc$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $af8f53d2717afebc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af8f53d2717afebc$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $af8f53d2717afebc$var$_react.default.createElement($af8f53d2717afebc$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$af8f53d2717afebc$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $af8f53d2717afebc$var$_default = module.exports.default = $af8f53d2717afebc$var$ArrowLeftIcon;

});


parcelRegister("kukku", function(module, exports) {

$parcel$export(module.exports, "createExtender", () => $7419d362e7f9799c$export$3f052dbd10b2d4da);
const $7419d362e7f9799c$export$3f052dbd10b2d4da = function createExtender(defaults, /**
	 * We're defaulting to an Object.create call here to circumvent
	 *  the fact that {} can't be reconciled
	 *  with a type that extends Record<string, any>
	 *
	 *  By doing this, we are intentionally disallowing users
	 *  from nullifying a particular component in the tree.
	 *  This can be reverted with additional logic,
	 *  at such a time as this nullification becomes an actual usecase.
	 */ overrides = Object.create(Object.prototype)) {
    if (!defaults) throw new Error('a default set of overrides *must* be passed in as the first argument');
    return function getOverrides(key) {
        const { cssFn: defaultCssFn, component: defaultComponent } = defaults[key];
        if (!overrides[key]) return {
            cssFn: defaultCssFn,
            component: defaultComponent
        };
        const { cssFn: customCssFn, component: customComponent } = overrides[key];
        const composedCssFn = (state)=>{
            return customCssFn(defaultCssFn(state), state);
        };
        return {
            cssFn: customCssFn ? composedCssFn : defaultCssFn,
            component: customComponent || defaultComponent
        };
    };
};

});

parcelRegister("iN5oW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4904d026a56ebc8e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $4904d026a56ebc8e$var$defaultStyles = {
    flex: 1,
    overflow: 'auto',
    marginTop: "var(--ds-space-300, 24px)"
};
const $4904d026a56ebc8e$var$contentCSS = ()=>$4904d026a56ebc8e$var$defaultStyles;
const $4904d026a56ebc8e$var$Content = ({ cssFn: cssFn, scrollContentLabel: scrollContentLabel = 'Scrollable content', ...props })=>{
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const setLazyContentFocus = ()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        };
        setLazyContentFocus();
    }, []);
    /**
   * I noticed the implementation at @atlaskit/checkbox would send the props to cssFn rather
   * than the defaultStyles as the overrides guide suggests. I went with what the overrides
   * guide suggested as it made more sense as a transformer of the current styles rather than
   * a complete override with no chance of partially changing styles.
   */ return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        css: (0, $byn9U.css)(cssFn($4904d026a56ebc8e$var$defaultStyles)),
        ref: scrollableRef,
        // tabindex is allowed here so that keyboard users can scroll content
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? scrollContentLabel : undefined,
        "data-testid": "drawer-contents",
        ...props
    });
};
const $4904d026a56ebc8e$var$contentDefaults = {
    component: $4904d026a56ebc8e$var$Content,
    cssFn: $4904d026a56ebc8e$var$contentCSS
};
var $4904d026a56ebc8e$export$2e2bcd8739ae039 = $4904d026a56ebc8e$var$contentDefaults;

});

parcelRegister("8MC6T", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0d4601692b44652$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kkWA2 = parcelRequire("kkWA2");


var $kyri3 = parcelRequire("kyri3");

var $dOmFS = parcelRequire("dOmFS");
const $f0d4601692b44652$export$f693ac40d0904cc2 = {
    full: {
        width: '100vw'
    },
    extended: {
        width: '95vw'
    },
    narrow: {
        width: 360
    },
    medium: {
        width: 480
    },
    wide: {
        width: 600
    }
};
const $f0d4601692b44652$var$wrapperStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    height: '100vh',
    position: 'fixed',
    zIndex: 500,
    backgroundColor: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    [(0, $kyri3.CURRENT_SURFACE_CSS_VAR)]: `var(--ds-surface-overlay, ${(0, $73a5c9d720aa66e1$export$29a4f05edc054374)})`,
    insetBlockStart: 0,
    insetInlineStart: 0,
    overflow: 'hidden'
});
/**
 * A wrapper that controls the styling of the drawer with a few hacks with refs to get our Touch±Scroll locks working.
 */ const $f0d4601692b44652$var$DrawerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, className: className, width: width = 'narrow', testId: testId, drawerRef: drawerRef, label: label, titleId: titleId }, scrollRef)=>{
    /**
   * We use a callback ref to assign the `<Content />` component to the forwarded `scrollRef`.
   * This ref comes from `react-scrolllock` to allow touch scrolling, eg.: `<ScrollLock><TouchScrollable>{children}</TouchScrollable><ScrollLock>`
   *
   * This is because we do not control the `<Content />` component in order to forward a ref to it (given it can be overriden via `DrawerPrimitiveProps['overrides']['Content']['component']`).
   * Additionally, we target the last child because with `props.overrides.Sidebar.component = () => null` you only have one child.
   * If both `Sidebar.component` and `Content.component` return null you will have no children and this will throw an error, but that doesn't seem valid.
   */ const assignSecondChildRef = (0, $eUqFw.useCallback)((node)=>{
        if (node?.children?.length && typeof scrollRef === 'function') scrollRef(node.children[node.children.length - 1]);
    }, [
        scrollRef
    ]);
    const ref = (0, $kkWA2.useMergeRefs)([
        drawerRef,
        assignSecondChildRef
    ]);
    (0, $dOmFS.default)();
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $f0d4601692b44652$var$wrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $f0d4601692b44652$export$f693ac40d0904cc2[width],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId,
        ref: ref,
        "aria-modal": true,
        role: "dialog",
        "aria-label": label,
        "aria-labelledby": titleId
    }, children);
});
var $f0d4601692b44652$export$2e2bcd8739ae039 = $f0d4601692b44652$var$DrawerWrapper;

});
parcelRegister("dOmFS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2aed1efdc61d3a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 * ⚠️ This is copied from `packages/design-system/modal-dialog/src/internal/hooks/use-prevent-programmatic-scroll.tsx`
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $d2aed1efdc61d3a7$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $d2aed1efdc61d3a7$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setScrollTopOffset($d2aed1efdc61d3a7$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $eUqFw.useCallback)(()=>{
        if ($d2aed1efdc61d3a7$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});


parcelRegister("30AqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6f069b28e45f88f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $1TUfP = parcelRequire("1TUfP");

var $8MHxr = parcelRequire("8MHxr");
parcelRequire("8ynlC");

var $XHGTv = parcelRequire("XHGTv");

var $2fFJv = parcelRequire("2fFJv");
const $b6f069b28e45f88f$var$ReactFocusLock = (0, $XHGTv.fg)('platform_dst_drawer-bump-react-focus-lock') ? (0, $1TUfP.default) : (0, $6Pq2D.default);
/**
 * __Focus lock__
 *
 * Thin wrapper over react-focus-lock. This wrapper only exists to ensure API compatibility.
 * This component should be deleted during https://ecosystem.atlassian.net/browse/AK-5658
 */ const $b6f069b28e45f88f$var$FocusLock = ({ isFocusLockEnabled: isFocusLockEnabled = true, autoFocusFirstElem: autoFocusFirstElem = true, shouldReturnFocus: shouldReturnFocus = true, children: children })=>{
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        if (typeof autoFocusFirstElem === 'function' && isFocusLockEnabled) {
            const elem = autoFocusFirstElem();
            if (elem && elem.focus) elem.focus();
        }
    }, [
        autoFocusFirstElem,
        isFocusLockEnabled
    ]);
    const getFocusTarget = ()=>{
        if (typeof shouldReturnFocus === 'boolean') return shouldReturnFocus;
        return false;
    };
    const onDeactivation = ()=>{
        if (typeof shouldReturnFocus !== 'boolean') window.setTimeout(()=>{
            shouldReturnFocus?.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b6f069b28e45f88f$var$ReactFocusLock, {
        disabled: !isFocusLockEnabled,
        autoFocus: !!autoFocusFirstElem,
        returnFocus: getFocusTarget(),
        onDeactivation: onDeactivation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null, children));
};
var $b6f069b28e45f88f$export$2e2bcd8739ae039 = $b6f069b28e45f88f$var$FocusLock;

});

parcelRegister("74wVy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce55c786fbf008e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

const $6ce55c786fbf008e$var$defaultStyle = {
    alignItems: 'center',
    boxSizing: 'border-box',
    color: `var(--ds-text-subtle, ${(0, $73a5c9d720aa66e1$export$c39c0fe0f26207ae)})`,
    display: 'flex',
    flexShrink: 0,
    flexDirection: 'column',
    height: '100vh',
    paddingBottom: "var(--ds-space-200, 16px)",
    paddingTop: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-800, 64px)"
};
const $6ce55c786fbf008e$var$sidebarCSS = ()=>$6ce55c786fbf008e$var$defaultStyle;
const $6ce55c786fbf008e$var$Sidebar = ({ cssFn: cssFn, ...props })=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @repo/internal/react/no-unsafe-spread-props, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $byn9U.css)(cssFn($6ce55c786fbf008e$var$defaultStyle)),
        ...props
    });
};
const $6ce55c786fbf008e$var$sidebarDefaults = {
    component: $6ce55c786fbf008e$var$Sidebar,
    cssFn: $6ce55c786fbf008e$var$sidebarCSS
};
var $6ce55c786fbf008e$export$2e2bcd8739ae039 = $6ce55c786fbf008e$var$sidebarDefaults;

});



parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("iddOY", function(module, exports) {

$parcel$export(module.exports, "proformaTemplateLibraryExperience", () => $2d2654818f9380ba$export$451a0e8b519ffce);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $2d2654818f9380ba$export$451a0e8b519ffce = new (0, $kDfSL.UFOExperience)('proforma.template-library', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("6cNDt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("92sUi"),
    $d1Cng("i5RRW"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("d2zTD")
]).then(()=>parcelRequire('8X4w4'));

});


parcelRegister("jeTGi", function(module, exports) {

$parcel$export(module.exports, "useCreateForm", () => $e0a0d19e4e299193$export$a78b09186b83ef5f);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $guiFP = parcelRequire("guiFP");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ivJJi = parcelRequire("ivJJi");

var $5vH7S = parcelRequire("5vH7S");

var $dWLk9 = parcelRequire("dWLk9");

var $hcI4J = parcelRequire("hcI4J");
const $e0a0d19e4e299193$export$a78b09186b83ef5f = (projectId)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFormSelectFailFlag: showFormSelectFailFlag } = (0, $ivJJi.useFormSelectedErrorFlag)();
    const request = (0, $eUqFw.useCallback)(async ({ templateId: templateId, template: template })=>{
        const isBlankTemplate = templateId === (0, $5vH7S.BLANK_TEMPLATE).id;
        try {
            const createdFormResponse = await (0, $hcI4J.createForm)(cloudId, projectId, template);
            if (isBlankTemplate) (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'blankTemplateForm created', {
                projectId: projectId,
                templateFormId: createdFormResponse.form.id
            });
            else (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'templateFormFromTemplate created', {
                projectId: projectId,
                templateId: templateId,
                templateFormId: createdFormResponse.form.id
            });
            return createdFormResponse;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (isBlankTemplate) (0, $guiFP.default)({
                meta: {
                    id: 'createBlankTemplateForm',
                    packageName: 'jiraProformaProjectFormsSettings',
                    teamName: 'jsm-request-intake'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    projectId: projectId
                }
            });
            else (0, $guiFP.default)({
                meta: {
                    id: 'createFormFromTemplate',
                    packageName: 'jiraProformaProjectFormsSettings',
                    teamName: 'jsm-request-intake'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                attributes: {
                    projectId: projectId,
                    templateId: templateId
                }
            });
            showFormSelectFailFlag();
            throw error;
        }
    }, [
        cloudId,
        createAnalyticsEvent,
        projectId,
        showFormSelectFailFlag
    ]);
    const { loading: loading, data: data, error: error, fetch: fetch } = (0, $eEzyV.useService)(request, {
        loading: true
    });
    return {
        loading: loading,
        data: data,
        error: error,
        callCreateForm: fetch
    };
};

});
parcelRegister("ivJJi", function(module, exports) {

$parcel$export(module.exports, "useFormSelectedErrorFlag", () => $e3c599a5b050d463$export$2fbea2fdae1f5e83);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $20LnL = parcelRequire("20LnL");
const $e3c599a5b050d463$export$2fbea2fdae1f5e83 = ()=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const showFormSelectFailFlag = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            id: 'proforma-template-library.ui.library.form-selected-error',
            type: 'error',
            title: formatMessage((0, $20LnL.messages).title),
            isAutoDismiss: true
        });
    }, [
        showFlag,
        formatMessage
    ]);
    return {
        showFormSelectFailFlag: showFormSelectFailFlag
    };
};

});
parcelRegister("20LnL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b5218fb9e004b9be$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b5218fb9e004b9be$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "proforma-template-library.common.utils.form-selected-failed-flag.title",
        "defaultMessage": "We couldn't open this form template. Select template to try again."
    }
});

});


parcelRegister("5vH7S", function(module, exports) {

$parcel$export(module.exports, "BLANK_TEMPLATE", () => $1ec72140f36c1484$export$6e9e11a7a8d6a7f3);
$parcel$export(module.exports, "BLANK_TEMPLATE_FORM", () => $1ec72140f36c1484$export$35b609282db432c6);

const $1ec72140f36c1484$export$6e9e11a7a8d6a7f3 = {
    group: null,
    subGroup: [],
    name: '',
    lang: null,
    faIcon: {
        faKey: ''
    },
    id: (0, $eb9db811550bc902$export$32ab81f39b57ddd2)
};
const $1ec72140f36c1484$export$35b609282db432c6 = {
    id: 0,
    updated: '',
    design: {
        settings: {
            templateId: 0,
            name: '',
            submit: {
                lock: false,
                pdf: false
            }
        },
        layout: [
            {
                version: 1,
                type: 'doc',
                content: []
            }
        ],
        conditions: {},
        sections: {},
        questions: {}
    },
    state: undefined
};

});
const $eb9db811550bc902$export$6109b18ad728eb9b = 'All';
const $eb9db811550bc902$export$e3b2d903e6c086dc = 'ADDED';
const $eb9db811550bc902$export$32ab81f39b57ddd2 = 'PROFORMA_BLANK_FORM_TEMPLATE';


parcelRegister("hcI4J", function(module, exports) {

$parcel$export(module.exports, "createForm", () => $06fb735b8cb2cf9c$export$f681a8129d2e9d28);

var $lRmyA = parcelRequire("lRmyA");
function $06fb735b8cb2cf9c$export$f681a8129d2e9d28(cloudId, projectId, template) {
    return (0, $lRmyA.performPostRequest)(`/gateway/api/proforma/cloudid/${cloudId}/api/cloud/project/${projectId}/form`, {
        body: JSON.stringify(template)
    });
}

});




parcelRegister("ifUq1", function(module, exports) {

$parcel$export(module.exports, "default", () => $75607b44b71bf2f5$export$2e2bcd8739ae039);
/* app-container.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j7bQJ = parcelRequire("j7bQJ");
var $6tahE = parcelRequire("6tahE");

var $7ehAr = parcelRequire("7ehAr");

var $c76ap = parcelRequire("c76ap");

var $1YMP9 = parcelRequire("1YMP9");

var $dpXKE = parcelRequire("dpXKE");

var $1ybV0 = parcelRequire("1ybV0");

var $bNe1g = parcelRequire("bNe1g");
const $75607b44b71bf2f5$var$AppContainer = ({ children: children, projectKey: projectKey, gridLayout: gridLayout, fullSize: fullSize = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, ({ data: projectData })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$ConditionalGrid, {
            gridLayout: gridLayout,
            fullSize: fullSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ehAr.BreadcrumbManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$BreadcrumbsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
            baseUrl: "",
            projectKey: projectKey,
            // Use projectKey as fallback display name to solve issues with projectData being unmocked in tests, projectData should never be undefined in the actual app as we are in the context of a project seeing as projectKey is a required prop
            projectName: projectData ? projectData.projectName : projectKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YMP9.default), {
            baseUrl: "",
            projectKey: projectKey,
            projectType: projectData ? projectData.projectType : undefined,
            isSimplified: projectData ? projectData.simplified : false
        }, children)))));
var $75607b44b71bf2f5$export$2e2bcd8739ae039 = $75607b44b71bf2f5$var$AppContainer;
const $75607b44b71bf2f5$var$ConditionalGrid = ({ children: children, gridLayout: gridLayout, fullSize: fullSize })=>{
    if (fullSize && (0, $1ybV0.ff)('com.atlassian.connect.change-jira-appcontainer-to-better-support-jira-project-admin-tab-panel')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$FullHeightWrapper, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($75607b44b71bf2f5$var$NormalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j7bQJ.default), {
        layout: gridLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6tahE.default), null, children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75607b44b71bf2f5$var$NormalWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1yt45gjp",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$FullHeightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $75607b44b71bf2f5$var$NormalWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4 _zulp1ejb",
            __cmplp.className
        ])
    });
});
const $75607b44b71bf2f5$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _otyrmgjw _18u0r5cr _1tkepxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j7bQJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cf405c5617943d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");

var $gw8fk = parcelRequire("gw8fk");

var $6tahE = parcelRequire("6tahE");

var $02LzD = parcelRequire("02LzD");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $21cf405c5617943d$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const { medium: medium } = (0, $eUqFw.useContext)((0, $6tahE.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $cuCEk.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $cuCEk.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $02LzD.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gw8fk.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $21cf405c5617943d$export$2e2bcd8739ae039 = $21cf405c5617943d$var$GridWrapper;

});
parcelRegister("cuCEk", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $63536614c324c20f$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $63536614c324c20f$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $63536614c324c20f$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $63536614c324c20f$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $63536614c324c20f$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $63536614c324c20f$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $63536614c324c20f$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $63536614c324c20f$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $63536614c324c20f$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $63536614c324c20f$export$936829b4511db3e4);
const $63536614c324c20f$export$3aaf3a78c909ea56 = 8;
const $63536614c324c20f$export$74797698e12f8baa = 12;
const $63536614c324c20f$export$b8241a1616ab1b96 = $63536614c324c20f$export$3aaf3a78c909ea56 * 10;
const $63536614c324c20f$export$2a89a65a43bab52d = {
    comfortable: $63536614c324c20f$export$3aaf3a78c909ea56 * 5,
    cosy: $63536614c324c20f$export$3aaf3a78c909ea56 * 2,
    compact: $63536614c324c20f$export$3aaf3a78c909ea56 * 0.5
};
const $63536614c324c20f$export$8ec7372efd74b753 = 'cosy';
const $63536614c324c20f$export$d77f83c3d17a7b8a = 52;
const $63536614c324c20f$export$f8725d21f81f3e01 = 0;
const $63536614c324c20f$export$2303d2bd9eeff99a = 'fixed';
const $63536614c324c20f$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $63536614c324c20f$export$8b7e31f391e6e681 = '--ds-column-span';
const $63536614c324c20f$export$936829b4511db3e4 = '--ds-grid-spacing';

});

parcelRegister("gw8fk", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $7946ba115b4da3a8$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
function $7946ba115b4da3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7946ba115b4da3a8$var$gridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $7946ba115b4da3a8$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $cuCEk.varColumnsNum)}) * ${(0, $cuCEk.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $7946ba115b4da3a8$var$nestedGridStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $cuCEk.varGridSpacing)}))`
});
const $7946ba115b4da3a8$export$ef2184bd89960b14 = ({ layout: layout = (0, $cuCEk.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $7946ba115b4da3a8$var$gridStyles,
            $7946ba115b4da3a8$var$gridLayoutStyles[layout],
            isNested && $7946ba115b4da3a8$var$nestedGridStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varGridSpacing)]: `${(0, $cuCEk.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("02LzD", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $abe6d6b3e91c4986$export$11cae3e04ab99fae);

var $eUqFw = parcelRequire("eUqFw");

var $cuCEk = parcelRequire("cuCEk");
const $abe6d6b3e91c4986$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $cuCEk.defaultSpacing),
    columns: (0, $cuCEk.defaultGridColumns)
});

});


parcelRegister("6tahE", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $384e4fce86f51330$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $384e4fce86f51330$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $cuCEk = parcelRequire("cuCEk");

var $02LzD = parcelRequire("02LzD");
var $384e4fce86f51330$var$ColumnVariant;
/**
 * Determines the method by which column width is calculated.
 */ (function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
})($384e4fce86f51330$var$ColumnVariant || ($384e4fce86f51330$var$ColumnVariant = {}));
const $384e4fce86f51330$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $cuCEk.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $384e4fce86f51330$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $384e4fce86f51330$var$singleColumnWidth = `(${$384e4fce86f51330$var$availableWidth} / var(${(0, $cuCEk.varColumnsNum)}))`;
const $384e4fce86f51330$var$gridColumnStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} - var(${(0, $cuCEk.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $cuCEk.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $384e4fce86f51330$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$384e4fce86f51330$var$singleColumnWidth} *  var(${(0, $cuCEk.varColumnSpan)}) - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $cuCEk.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $384e4fce86f51330$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    medium: (0, $cuCEk.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $384e4fce86f51330$var$GridColumn = ({ medium: medium = (0, $cuCEk.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $eUqFw.useContext)((0, $02LzD.GridContext));
    const contextValue = (0, $eUqFw.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $384e4fce86f51330$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)($384e4fce86f51330$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $384e4fce86f51330$var$gridColumnStyles,
            $384e4fce86f51330$var$gridColumnWidthStyles[variant]
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $cuCEk.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $384e4fce86f51330$export$2e2bcd8739ae039 = $384e4fce86f51330$var$GridColumn;

});


parcelRegister("1YMP9", function(module, exports) {

$parcel$export(module.exports, "default", () => $90e5325849889e8c$export$2e2bcd8739ae039);

var $giAhk = parcelRequire("giAhk");

var $7AJNu = parcelRequire("7AJNu");
var $90e5325849889e8c$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)((0, $7AJNu.default));

});
parcelRegister("7AJNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a78352310a6c306$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $aTgXo = parcelRequire("aTgXo");

var $5IARc = parcelRequire("5IARc");

var $jBULE = parcelRequire("jBULE");
const $8a78352310a6c306$var$ProjectSettingsBreadcrumb = ({ children: children, projectKey: projectKey, projectType: projectType, isSimplified: isSimplified = false, intl: { formatMessage: formatMessage } })=>projectType && // <- we need this first condition just to avoid Flow error at createProjectSettingsUrl
    (projectType === (0, $7ZZxN.CORE_PROJECT) || projectType === (0, $7ZZxN.SOFTWARE_PROJECT) || projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            href: (0, $5IARc.createProjectSettingsUrl)(projectKey, projectType, isSimplified),
            text: formatMessage((0, $jBULE.default).projectSettingsTitle),
            type: 'projectSettings'
        }
    }, children) : children;
var $8a78352310a6c306$export$2e2bcd8739ae039 = $8a78352310a6c306$var$ProjectSettingsBreadcrumb;

});
parcelRegister("jBULE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99c71c52f70e552$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b99c71c52f70e552$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectSettingsTitle: {
        "id": "platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title",
        "defaultMessage": "Project settings"
    }
});

});




parcelRegister("7GKdq", function(module, exports) {

$parcel$export(module.exports, "SharedSettingsDocumentTitle", () => $d1ebe0348166bb30$export$846e5bb7ce3ba3ec);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $2d7Sj = parcelRequire("2d7Sj");

var $31zEn = parcelRequire("31zEn");
const $d1ebe0348166bb30$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, action: action, intl: { formatMessage: formatMessage }, projectName: projectName, projectType: projectType } = props;
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2d7Sj.PageTitle), {
        DocumentTitle: DocumentTitle,
        section: section,
        intl: props.intl,
        projectName: projectName
    });
    const actionTitle = action && formatMessage((0, $31zEn.default)[action]);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; connectAppControls: MessageDescriptorV2; features: MessageDescriptorV2; ... 6 more ...; toolchain: MessageDescriptorV2; }'.
    const sectionTitle = formatMessage((0, $31zEn.default)[section]);
    const title = actionTitle ? `${actionTitle} - ${projectName} - ${sectionTitle}` : `${projectName} - ${sectionTitle}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $d1ebe0348166bb30$var$InjectedPage = (0, $knPb9.default)($d1ebe0348166bb30$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $d1ebe0348166bb30$export$846e5bb7ce3ba3ec = (0, $giAhk.injectIntlV2)($d1ebe0348166bb30$var$InjectedPage);
var $d1ebe0348166bb30$export$2e2bcd8739ae039 = $d1ebe0348166bb30$export$846e5bb7ce3ba3ec;

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("2d7Sj", function(module, exports) {

$parcel$export(module.exports, "PageTitle", () => $0653f34646647329$export$155581e8dc02007a);
$parcel$export(module.exports, "ServiceDeskDocumentTitle", () => $0653f34646647329$export$c7841d2c1c13065e);

var $eUqFw = parcelRequire("eUqFw");

var $knPb9 = parcelRequire("knPb9");

var $heNSb = parcelRequire("heNSb");

var $giAhk = parcelRequire("giAhk");

var $f9Osc = parcelRequire("f9Osc");
const $0653f34646647329$export$155581e8dc02007a = (props)=>{
    const { DocumentTitle: DocumentTitle, section: section, intl: { formatMessage: formatMessage }, projectName: projectName, subsection: subsection } = props;
    const title = subsection ? // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${subsection} - ${formatMessage((0, $f9Osc.default).serviceProject)}` : // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ proformaForms: MessageDescriptorV2; chat: MessageDescriptorV2; incidentManagementSettings: MessageDescriptorV2; ... 32 more ...; serviceProject: MessageDescriptorV2; }'.
    `${projectName} - ${formatMessage((0, $f9Osc.default)[section])} - ${formatMessage((0, $f9Osc.default).serviceProject)}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DocumentTitle, {
        title: title
    });
};
const $0653f34646647329$var$InjectedPage = (0, $knPb9.default)($0653f34646647329$export$155581e8dc02007a, {
    DocumentTitle: (0, $heNSb.DocumentTitle)
});
const $0653f34646647329$export$c7841d2c1c13065e = (0, $giAhk.injectIntlV2)($0653f34646647329$var$InjectedPage);
var $0653f34646647329$export$2e2bcd8739ae039 = $0653f34646647329$export$c7841d2c1c13065e;

});
parcelRegister("f9Osc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be746c19c254767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7be746c19c254767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    atlassianAnalytics: {
        "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
        "defaultMessage": "Atlassian Analytics"
    },
    serviceProject: {
        "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
        "defaultMessage": "Service project"
    },
    knowledge: {
        "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
        "defaultMessage": "Knowledge base"
    },
    itsmFeatures: {
        "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
        "defaultMessage": "Features"
    },
    queues: {
        "id": "servicedesk-spa-commons.common.utils.document-title.queues",
        "defaultMessage": "Queues"
    },
    customers: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customers",
        "defaultMessage": "Customers"
    },
    organizations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
        "defaultMessage": "Organizations"
    },
    customerServiceEscalations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
        "defaultMessage": "Developer escalations"
    },
    reports: {
        "id": "servicedesk-spa-commons.common.utils.document-title.reports",
        "defaultMessage": "Reports"
    },
    services: {
        "id": "servicedesk-spa-commons.common.utils.document-title.services",
        "defaultMessage": "Services"
    },
    oncall: {
        "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
        "defaultMessage": "On-call"
    },
    email: {
        "id": "servicedesk-spa-commons.common.utils.document-title.email",
        "defaultMessage": "Email request"
    },
    sla: {
        "id": "servicedesk-spa-commons.common.utils.document-title.sla",
        "defaultMessage": "Service level agreements"
    },
    csat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.csat",
        "defaultMessage": "Customer satisfaction"
    },
    details: {
        "id": "servicedesk-spa-commons.common.utils.document-title.details",
        "defaultMessage": "Details"
    },
    portal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal",
        "defaultMessage": "Customer portal"
    },
    externalLinks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
        "defaultMessage": "Links"
    },
    portalSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
        "defaultMessage": "Portal settings"
    },
    automation: {
        "id": "servicedesk-spa-commons.common.utils.document-title.automation",
        "defaultMessage": "Automation"
    },
    advanced: {
        "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
        "defaultMessage": "Advanced"
    },
    languageSupport: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
        "defaultMessage": "Language support"
    },
    languageTranslations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
        "defaultMessage": "Language translations"
    },
    notificationEmail: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    notifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
        "defaultMessage": "Notifications"
    },
    internalNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
        "defaultMessage": "Internal notifications"
    },
    customerNotifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
        "defaultMessage": "Customer notifications"
    },
    widget: {
        "id": "servicedesk-spa-commons.common.utils.document-title.widget",
        "defaultMessage": "Widget"
    },
    customerPermissions: {
        "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
        "defaultMessage": "Customer permissions"
    },
    people: {
        "id": "servicedesk-spa-commons.common.utils.document-title.people",
        "defaultMessage": "Internal access"
    },
    issueType: {
        "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
        "defaultMessage": "Request types"
    },
    connectAppControls: {
        "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    features: {
        "id": "servicedesk-spa-commons.common.utils.document-title.features",
        "defaultMessage": "Features"
    },
    calendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
        "defaultMessage": "Calendar"
    },
    changeCalendar: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
        "defaultMessage": "Change calendar"
    },
    changeManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
        "defaultMessage": "Change management"
    },
    incidentManagementSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
        "defaultMessage": "Incident management"
    },
    virtualAgentConversations: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
        "defaultMessage": "Conversations"
    },
    virtualAgentIntents: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
        "defaultMessage": "Intents"
    },
    virtualAgentStandardFlows: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
        "defaultMessage": "Standard flows"
    },
    virtualAgentSettings: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
        "defaultMessage": "Settings"
    },
    virtualAgentLanding: {
        "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
        "defaultMessage": "Virtual agent"
    },
    chat: {
        "id": "servicedesk-spa-commons.common.utils.document-title.chat",
        "defaultMessage": "Chat"
    },
    proformaForms: {
        "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    playbooks: {
        "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
        "defaultMessage": "Playbooks"
    },
    dataClassifications: {
        "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
        "defaultMessage": "Data classification"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
        "defaultMessage": "Fields"
    },
    workflowScheme: {
        "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
        "defaultMessage": "Workflows"
    },
    journeysNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
        "defaultMessage": "Journeys"
    },
    journeyConfigNonFinal: {
        "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
        "defaultMessage": "Journey configuration"
    }
});

});


parcelRegister("31zEn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0ebdf18cb5c11b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5f0ebdf18cb5c11b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    details: {
        "id": "spa-apps.project-settings.common.shared-document-title.details",
        "defaultMessage": "Details"
    },
    people: {
        "id": "spa-apps.project-settings.common.shared-document-title.people",
        "defaultMessage": "Access"
    },
    issueType: {
        "id": "spa-apps.project-settings.common.shared-document-title.issue-type",
        "defaultMessage": "Issue types"
    },
    configureIssue: {
        "id": "spa-apps.project-settings.common.shared-document-title.configure-issue",
        "defaultMessage": "Configure issue"
    },
    notifications: {
        "id": "spa-apps.project-settings.common.shared-document-title.notifications",
        "defaultMessage": "Notifications"
    },
    notificationEmail: {
        "id": "spa-apps.project-settings.common.shared-document-title.notification-email",
        "defaultMessage": "Notification email"
    },
    features: {
        "id": "spa-apps.project-settings.common.shared-document-title.features",
        "defaultMessage": "Features"
    },
    connectAppControls: {
        "id": "spa-apps.project-settings.common.shared-document-title.connect-app-controls",
        "defaultMessage": "Apps"
    },
    proformaForms: {
        "id": "spa-apps.project-settings.common.shared-document-title.proforma-forms",
        "defaultMessage": "Forms"
    },
    connections: {
        "id": "spa-apps.project-settings.common.shared-document-title.connections",
        "defaultMessage": "Connections"
    },
    toolchain: {
        "id": "spa-apps.project-settings.common.shared-document-title.toolchain",
        "defaultMessage": "Toolchain"
    },
    dataClassifications: {
        "id": "spa-apps.project-settings.common.shared-document-title.data-classifications",
        "defaultMessage": "Data classifications"
    },
    // EAX-256 - Finalise this string
    fieldsNonFinal: {
        "id": "spa-apps.project-settings.common.shared-document-title.fields-non-final",
        "defaultMessage": "Fields"
    }
});

});





//# sourceMappingURL=async-project-settings-proforma-project-forms.cbff0da2.js.map
